import { getImgUrl } from "../Utility/Utility";

// start live shows
// export const ShowsPostsData = [

// 	{
// 		id:1,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Tom Jones \n Tel Aviv ",
//         smltitle: "The one and only Tom Jones returns to Tel Aviv for one live performance",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											28.06.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.tomjones.com/">
// 												www.tomjones.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/1/1.jpg"} class="img-responsive" />
// 						</div>

// 						<p>
// 							At the request of the audience and after the success of his sold-out show in 2013, the legendary performer Tom Jones returns to Israel for one live performance, to be held in Tel Aviv on Wednesday, June 28, 2017.
// 						</p>

// 						<p>
// 							Tom Jones, a world-famous living legend, is known for not allowing the diverse audience that fills his halls to sit quietly for a moment. He is a performer who captures the hearts of men and women of all ages, crosses generations and genres with his infinite inherent talent and his powerful and unique voice.
// 						</p>
// 						<p>
// 							Tom Jones has had an amazing stage career and sold over 100 million records. He has been awarded many titles including the Brit Awards for his immense musical contribution and Lifetime Achievement Award for his many achievements in the world of music and live performances at the Silver Clef (annual British Music Awards). For his contribution to the music industry, he won a star on the Hollywood Walk of Fame. In 1999, Tom Jones was awarded the Order of the British Empire (OBE) and in 2006 His Royal Highness Queen Elizabeth gave him the title of nobility and he became Sir Tom Jones.
// 						</p>

// 						<p>
// 							Jones, recognized across the world as a "hit machine", will be hitting the 24/7 city this June for the second time. As he did in his last sold out show in Tel Aviv to the delight of his audience, will be performing his all-time greatest hits.
// 						</p>
// 						`
// 			}
// 		}

//     },

//     {

//       id:2,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Britney Spears \n  Live in Concert",
//         smltitle: "Britney Spears- performing all her greatest hits in the fabulous city of Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											03.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.britneyspears.com">
// 												www.britneyspears.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/2/1.jpg"} class="img-responsive" />
// 						</div>

// 						<p>
// 							Pop Icon Britney Spears is coming to Tel Aviv for the first time ever, for one show only, as part of her international tour of Asia. The show will take place in stunning Ha’Yarkon Park in central Tel Aviv and will include the Pop Princesses’ greatest hits.
// 						</p>

// 						<p>
// 							Pop Icon Britney Spears will be coming to Israel for the first time ever for one show only as part of her international tour of Asia. The show will take place in Ha’Yarkon Park in central Tel Aviv and will include the Pop Princesses’ greatest hits.
// 						</p>
// 						<p>
// 							Multi-platinum, Grammy Award-winning pop icon Britney Spears was born in Mississippi and raised in Louisiana, Spears became a household name as a teenager when she released her first single “…Baby One More Time,” a Billboard Hot 100 No. 1 smash and international hit that broke sales records with more than 20 million copies sold worldwide and is currently 14x Platinum in the U.S.
// 						</p>

// 						<p>
// 							Spears is one of the most successful and celebrated entertainers in pop history with nearly 150 million records worldwide. In the U.S. alone, she has sold more than 70 million albums, singles and songs, according to Nielsen Music.
// 						</p>

// 						<p>
// 							Britney’s live concerts are renowned for their amazing production and nonstop energy. Her first ever show in Tel Aviv is likely to feature some of her most recent songs from her Glory Album, including massive 2016 hit ‘Slumber Party’, and also some of her massive all-time hits such as ‘Baby One More Time’ and ‘Oops I Did It Again’!
// 						</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:3,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Tears for Fears",
//         smltitle: "Tear for Fears in Tel Aviv for the first time ever!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											05.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.tearsforfears.com">
// 												www.tearsforfears.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 						<p>
// 							This summer, the trendy city of Tel Aviv is embracing it’s 80s vibe for one performance only by the incomparable Tears for Fears. The legendary British pop/rock band that is responsible for many unforgettable hits is coming to the rocking city of Tel Aviv for a single awesome performance!
// 						</p>

// 						<p>
// 							Originally from Bath, Avon, Tears for Fears was founded in 1981 and was associated at first with the new wave synthesizer bands but later on became a part of mainstream rock and pop and hit international success. During the 80's the band released 3 albums that were a combination of pop, new wave and rock. Their first album from 1983, "The Hurting", reached number one in the UK albums chart and was a platinum-selling album. It included major hits such as "Pale Shelter", "Change", and "Mad World". Their second album, "Songs from the Big Chair", followed the same path and reached number one on the US Billboard 200, getting multi-platinum status in the UK and the US. It contained unforgettable hits such as "Shout", "Head Over Heels" and "Everybody Wants to Rule the World" which won the Brit Award for best British single in 1986. Their third successful album "The Seeds of Love" that came out in 1989 included the epic songs "The Seeds of Love", "Sowing Woman in Chains" and many more.
// 						</p>
// 						<p>
// 							In the early 90's, Curt Smith left the band and Roland Orzabal kept releasing more albums under the name of the band. In 2004 the two went back to working together under the name "Tears for Fears" and released the album "Everybody Loves Happy Ending". Since then, the band has been touring around the world to the delight of their fans
// 						</p>
// 						<p>
// 						Tears for Fears’ albums and singles were sold in tens of millions of copies and their songs were covered by other artists countless times. Last year the band announced they are working on a new album to be released during 2017. This July they will be gracing the nonstop city of Tel Aviv for the first time with a single performance, guaranteed to be a night to remember.
// 						</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:4,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: " Guns N' Roses  \"Not in this Lifetime\"",
//         smltitle: "Legendary Guns N' Roses is Coming Back to Rock Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											15.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.gunsnroses.com">
// 											www.gunsnroses.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/4/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								After their celebrated reunion tour last summer, which became the most profitable musical rock concert in 2016, Guns N' Roses, one of the world's most important and beloved rock bands, is coming to Tel Aviv as part of its successful tour with has already added more than 30 shows in the US and Europe.
// 							</p>

// 							<p>
// 								The concert in Tel Aviv will take place on Saturday, July 15 and, 17 at the Yarkon Park, and will close the European tour.
// 							</p>
// 							<p>
// 								Twenty-three years after standing together on the stage in Tel Aviv for the first time, the three original members of the ensemble will come back again: vocalist Axel Rose, guitarist Slash and bassist Duff McGinn, along with an impressive ensemble of musicians including drummer Frank Ferrer, keyboardist Dizzy Red (who was an integral part of the band in the 1990s) Guitarist Richard Fortus and keyboardist Melissa Reyes.
// 							</p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/4/2.jpg"} class="img-responsive" />
// 							</div>

// 							<h2>
// 							"Not in this Lifetime"
// 							</h2>
// 							<p>
// 							Since their first reunion concert at Cochlea Festival last April, the band's tour has become one of the most sought-after shows in America with more than 2 million tickets sold.
// 							</p>
// 							<p>
// 								The success and numbers of the current tour show more than anything else that the audience's love of the band's music and rock music is more relevant and bigger than ever. The historic tour last summer visited 21 cities (25 performances) in North America.
// 							</p>
// 							<p>
// 								The band has recently completed a successful tour in South America, Brazil, Argentina and Mexico. All of band's new tour dates are completely sold out, generating massive interest among audiences. In January, the band will continue to Japan and from there to Australia, Thailand, Singapore, Dubai and will arrive in the “nonstop city” of Tel Aviv in July.
// 							</p>
// 						`
// 			}
// 		}

// 	},

// 	{
//         id:5,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: " RADIOHEAD  \n Tel Aviv",
//         smltitle: "The trailblazing RADIOHEAD bringing their iconic repertoire to Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											19.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.radiohead.com">
// 											www.radiohead.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/5/1.jpeg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Preforming in Tel Aviv for the second time ever, Radiohead has managed to remain innovative, relevant and especially moving since first visiting here 17 years ago . It is a band blessed with superhuman ability to meld together distant musical influences to create a new identity for themselves and their listeners; A band whose compulsive tendency to experiment with groundbreaking sound echoed the impact of entire generations of artists and shattered it to the walls of superfluous genres; A band that changed the way we listen to music, make music, see music, think music and even buy music. Now, 17 years after they last visited here, Radiohead is coming to a concert in Tel Aviv.
// 							</p>

// 							<p>
// 								Watching Radiohead's show, it becomes clear that first and foremost, they are the authors and performers of a huge amount of unforgettable songs. Their repertoire manages to be on the one hand familiar, classical - most of us know it by heart - and on the other hand revolutionary, developing and surprising. The tight performance of the ensemble, along with the unique energy of the soloist, Tom York, transforms each performance into a one-time live experience that attracts huge audiences, to participate in the celebration of artistic evolution, to see how they grew, evolved and reinvented themselves time and time again.
// 							</p>

// 							<p>
// 								Today's Radiohead is a band with a more contemporary presence than ever before, with a glorious past and a variety that transcends all cataloging: a band that began with the Immortal Grange anthem of Creep; Slapped critics over the head with the alternative masterpiece The Bends and then committed commercial suicide - and reached heaven - twice! - with two of the best albums of all time, OK Computer and Kid A.
// 							</p>

// 							<p>
// 								The new generations who discover Radiohead through their new works - In Rainbows a favorite in Israel or the new and acclaimed album A Moon Shaped Pool - discover a band whose influences have permeated every musical genre today: rock, electronic, world, hip hop. Today's Radiohead is more than just another band, it is a world - with a unique visual language, exceptional imagery, an unreplaceable atmosphere and inner humor. Especially in Israel - a country that has always enjoyed an intimate and warm relationship with the band - Radiohead's performance is a cultural experience of the rarest kind.
// 							</p>
// 							<p>
// 							This concert will not have assigned seats, Golden Ring, VIP, unfair prices or any other division of class. Anyone who wants to sit is welcome to bring a blanket, and anyone who wants to stand close to the stage is welcome to arrive early, the ticket price is equal to all, and as many people as possible will be able to enjoy this momentous musical event.
// 							</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:6,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Pixies",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											25-26.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.pixiesmusic.com">
// 											www.pixiesmusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<p>
// 								The Israeli summer is always hot, but the Pixies are returning to Tel Aviv after 3 years to make it even hotter!
// 							</p>

// 							<p>
// 								The famous rock band was founded in 1986 in Boston and released its first EP "Come on Pilgrim" in 1987. A year later, when their first album "Surfer Rose" came out, they became a unique voice in the American Rock. 2 years later, they released their second album "Doolittle" that is considered one of the best rock albums of all times. Their third album "Bossanova" came out in 1990 and included unforgettable songs such as "Hang Wire", "Stormy Weather", and "All Over the World".
// 							</p>
// 							<p>
// 							A year later they released their fourth album "Trompe le Monde" that featured songs such as "Planet of Sound", "Distance Equals Rate Times Time" and many more. They fell apart in 1993 but went back to performing together in 2004. After a decade of touring the world, they released their fifth album "Indie Cindy" which included songs like "Another Toe in The Ocean", "Blue Eyed Hexe", and "Jaime Bravo". To this date they released six albums, the last one, "Head Carrier" came out last year. Their biggest hits include "Hey", "Where Is My Mind", "Monkey Gone to Heaven" and "Here Comes Your Man".
// 							</p>
// 							<p>
// 								The band that is known to influence artists such as PJ Harvey and Kurt Kobain will perform this summer in Tel Aviv, giving only 7000 lucky fans the opportunity to see them live and after the rave reviews of their 2014 performance, it’s shaping up to be an unmissable night!
// 							</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:7,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Regina Spektor – Back in Israel",
//         smltitle: "Regina Spektor – Back in Israel",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											19.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.reginaspektor.com">
// 											www.reginaspektor.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<p>
// 								Beloved pianist, songwriter and singer Regina Spektor is coming back to Tel Aviv for the third time, closing the worldwide tour of her recent 2016 album “Remember Us to Life” that has gotten excellent reviews.
// 							</p>

// 							<p>
// 								Regina Spektor, whose past concerts in Israel were sold out in 2007 and 2013, will perform again for one time only in Ra’anana Amphitheater on Saturday, August 19.
// 							</p>
// 							<p>
// 								Grammy and VMA nominee Regina Spektor was born in Russia, where she started her classical music training at the age of six and immigrated shortly after to the New York, where she began writing her own original songs. Her first Album came out in 2001 and a year later she already released her second album, “songs”, but her real success started after her third album, Soviet Kitsch, was out in 2004 and the fans started pouring in.
// 							</p>
// 							<p>
// 								Her international breakthrough came in 2006 with her album “Begin to Hope” that reached gold status and sold more than 500,000 copies (!!!). The album includes the single “Fidelity” that is very popular in Israel and in the rest of the world to this day and was used as part of the soundtrack of TV shows such as “Grey’s Anatomy”. Her success only became stronger when her fifth album “Far” and her sixth album “What We Saw From The Cheap Seats” got to the third place in Billboard's album chart.
// 							</p>

// 							<p>
// 								In 2013 Spektor created the theme song of the successful Netflix series “Orange Is the New Black”, called “You’ve Got Time” that also became a radio hit and got her her first Grammy Award nomination. The following year, she sang “Love Me or Leave Me” for the HBO historical crime series “Boardwalk Empire”.
// 							</p>
// 							<p>
// 								Regina Spektor is coming to the non-stop city of Tel Aviv after her sold-out tour in the United States and her old and new fans can’t wait for her show, guaranteed to light up the beautiful summer night of Tel Aviv with it’s amazing infectious energy.
// 							</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:8,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Nick Cave & The Bad Seeds",
//         smltitle: "Rock legend Nick Cave & The Bad Seeds returning to Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											19-20.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.nick-cave.com">
// 											www.nick-cave.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<p>
// 								19 years after his last performance in Tel Aviv, the prince of darkness returns once again with his band The Bad Seeds for two shows only to the joy of his fans in what are set to be intimate and unique performances.
// 							</p>

// 							<p>
// 								Australian musician, singer-songwriter, author, screenwriter, composer and film actor Nick Cave is well known as rock musics' "Prince of Darkness" because of his dark, intense tunes. His music is known to be emotionally intense and is characterized by a variety of influences such as death, religion, love and violence. He was called by NME "the grand lord of gothic lushness".
// 							</p>

// 							<p>
// 							In the early 90's, Curt Smith left the band and Roland Orzabal kept releasing more albums under the name of the band. In 2004 the two went back to working together under the name "Tears for Fears" and released the album "Everybody Loves Happy Ending". Since then, the band has been touring around the world to the delight of their fans.
// 							</p>
// 							<p>
// 								Cave started his musical path in the 1970's when he formed "the Boys Next Door" which became a huge success in Melbourne's post-punk scene. Their name was changed to "the Birthday Party" and the band's sound and shows took a rather violent direction and they became known as one of the darkest groups of the 1980's, they fell apart in 1983
// 							</p>
// 							<p>
// 								The end of the Birthday Party was the beginning of Nick Cave and the Bad Seeds in 1983 and they released their debut album the following year. In 1996 the band released its album "Murder Ballads" which featured "Where the Wild Roses Grow", a duet with Kylie Minogue that is also Cave's biggest commercial success to date.
// 							</p>
// 							<p>
// 								Many artists have covered Cave's songs over the years, including Metallica, Johnny Cash, and even the Arctic Monkeys.
// 							</p>

// 							<p>
// 								Nick Cave & The Bad Seeds will perform at the Menora Arena in Tel Aviv on November 19 and an additional date has been added on November 20 due to high demand. For the mere 7,000 fans who will get the chance to look the legendary Nick Cave in the eyes, this is guaranteed to be an unforgettable show!
// 							</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:9,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Justin Bieber",
//         smltitle: "Justin Bieber, is landing in Tel Aviv for a single breathtaking concert",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											03.05.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.justinbiebermusic.com">
// 											www.justinbiebermusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/9/1.png"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The artist with the most followers on Twitter 90,149,014
// 								The artist with the most watched official music channel online 13,518,849,954
// 								The artist with the most mentions on Youtube music channel
// 							</p>

// 							<p>
// 							Justin Bieber, the biggest international star of our day, arrives in Israel for just one concert as part of the PURPOSE WORLD TOUR, a tour bearing the name of his last album, which has sold 640,000 copies in just a week and became his bestselling album.
// 							</p>
// 							<p>
// 								Bieber, born in Ontario, Canada, learned to play piano, guitar and drums as a child. At the age of 13, with the help of his mother, he began posting videos on YouTube where he sang covers to artists such as Asher, Stevie Wonder, Chris Brown and others.
// 							</p>

// 							<p>
// 								Scooter Browne, a former marketing director at “So So Def”, was the first to spot Bieber’s talent and invited him and his mother to recordings in Atlanta.
// 							</p>

// 							<p>
// 								In 2008, Bieber was signed by Universal Records, and in 2009, "My World", the first mini-album by Bieber, including "One Time Lonely", "Love Me" and "Favorite Girl" topped the Canadian Billboard charts and the top 40 Billboard Hot 100 hits
// 							</p>
// 							<p>
// 								In 2010, he released his second album, "My World 2.0" with the single "Baby", which became a huge hit and was accompanied by the most watched YouTube video by November 24, 2012.
// 							</p>
// 							<p>
// 								In October 2015, Bieber released the second single from the album "Sorry". The dance clip for the song accumulated over 10 million views in the first 24 hours since its release.
// 							</p>

// 							<p>
// 								In November 2015 he released his fourth album "Purpose", which sold 640,000 copies in the first week and became Bieber’s best-selling album with hits such as "Love Yourself." That same month Bieber made history by placing 17 songs on the American charts and breaking the record held by the Beatles since 1964.
// 							</p>

// 							<p>
// 								In December 2015, Bieber and Skrillex won the Grammy Award for "Where are You Now".
// 							</p>

// 							<p>
// 								Justin Bieber will be performing in Israel on May 3 at Hayarkon Park, with his latest hits "love yourself" and "Sorry" and with the hits "Baby" and "As long as you love me".
// 							</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:10,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "AEROSMITH \n \"AERO-VEDERCI BABY\" ",
//         smltitle: " Aerosmith launching its tour in the rocking city of Tel Aviv  ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											28.06.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.aerosmith.com">
// 											www.aerosmith.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/10/1.png"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Aerosmith’s farewell concerts began several months ago in South America and will continue in 2017 in the United States and Europe. the European leg of the tour will begin in Tel Aviv and the band will go on to perform in Georgia, Russia, Germany, Poland, Denmark, Ireland, Italy, Portugal and Spain, including appearances in some of the world's leading rock festivals.
// 							</p>
// 							<p>
// 								For over 45 years, Aerosmith has been the quintessential Rock & Roll band, becoming one of the most influential and loved groups in the world. An endless list of amazing songs, many of them becoming massive worldwide hits, and their groundbreaking live shows have gained the band mass appeal for nearly half a century. Rock & Roll Hall of Fame inductees, Aerosmith, have sold over 100 million albums and won countless awards (including four Grammy Awards, eight American Music Awards, six Billboard Awards, and 12 MTV Awards).
// 							</p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/10/2.jpg"} class="img-responsive" />
// 							</div>

// 							<p>
// 								<strong>Steven Tyler</strong> – "Aerosmith just got done ripping through South America like true ambassadors of rock...The band is unstoppable right now and in Europe, we're going to keep doing what we do best... Let The Music Do The Talking...Living On The Edge, and living to rock another day."
// 							</p>

// 							<p>
// 								<strong>Joe Perry </strong> – “It’s been 3 years since we have been on tour in Europe and I can speak for my brothers that we can’t wait to get over there and take it up a few notches. Last tour in South America we were running on all cylinders and I can see no reason to let up now." ;
// 							</p>

// 							<p>
// 							This May, the city of Tel Aviv will be hosting Steven Tyler, Joe Perry, Joey Kramer, Tom Hamilton and Brad Whitford in the beautiful Ganei Yehoshua Park for what promises to be an unforgettable experience and the concert of a lifetime.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:11,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Frankie Valli & The Four Seasons  ",
//         smltitle: " An American Legend in the heart of Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											4.007.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.frankievallifourseasons.com/">
// 											www.frankievallifourseasons.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/11/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The American legend comes to the rocking city of Tel Aviv for the first time ever for an unforgettable 4th of July celebration with the best timeless classics!
// 							</p>
// 							<p>
// 								The original Jersey boy, musical legend Frankie Valli, comes Tel Aviv for the first time for one single performance. Back in the 50’s, Valli started singing in harmonies with different bands in New Jersey, but the success only struck him when he grabbed the microphone in the early 60’s as the lead singer for The Four Seasons that rocked the music world in the next decades with major hits such as “Big Girls Don’t Cry”, “Sherry”, “Walk Like a Man” and more. Valli scored 29 Top 40 hits with The Four Seasons and nine Top 40 hits as a solo artist. The band sold more than 175 million albums and Valli, Tommy DeVito, Nick Massi and Bob Gaudio – the original members of The Four Seasons – were inducted into the Rock and Roll Hall of Fame in 1990 and the Vocal Group Hall of Fame in 1999.
// 							</p>

// 							<p>
// 								At the same time, Valli also has a successful solo career with songs such as the theme song for Grease, and “Can’t Take My Eyes Off You” that was covered by hundreds of artists, from The Pet Shop Boys to Muse. Younger generations got to know Valli from the remarkable musical “Jersey Boys” that tell the story of the band that is responsible for songs that became a part of our life’s soundtrack for over four decades and was turned into a movie which was directed by Clint Eastwood.
// 							</p>

// 							<p>
// 								Ever since he began, Frankie has been performing all over the world, and soon the magic will come to Tel Aviv for one unforgettable show.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:12,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Unite With Tomorrowland",
//         smltitle: "The world’s number one leading EDM festival is coming to Tel Aviv! ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											29.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.tomorrowland.com/en/unite-israel/en/welcome">
// 											www.tomorrowland.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/12/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The famous Tomorrowland festival might take place in Belgium, but Tel Aviv is also up for the party! Unite with Tomorrowland brings the party to the hottest city in the Middle East with live connection from the Tomorrowland Mainstage, live local and international DJ’s on the UNITE stage and of course – the magical Tomorrowland atmosphere.
// 							</p>
// 							<p>
// 								The live connection with the Mainstage in Belgium will give the People of Tomorrow the chance to connect with the crowd in Israel and vice versa. 3 mainstage headliners will be broadcasted live on a unique UNITE with Tomorrowland stage and special effects will be synchronized with the show in Belgium, creating a special global connection.
// 							</p>

// 							<p>
// 								The main headliners in Belgium will be Armin Van Buuren who has won best trance DJ at the DJ Awards 9 years in a row, was ranked among the world’s top 4 DJ’s at DJ Magazine 13 years in a row, the known electro-house duo Dimitri Vegas & Like Mike and the house sensation KSHMR. On the UNITE stage in Israel the DJs will be Steve Angello who won the DJ award for best house in 2010, the Israeli trance artist Alien Project, DJ Tomer Maizner, Dor Dekel, Teamworx, and TRIPL.
// 							</p>

// 							<p>
// 								EUnite with Tomorrowland isn’t just a livestream, it’s a one of a kind show that allows you to escape reality and join the magical world of tomorrow.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:13,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "The Chainsmokers",
//         smltitle: "The world’s number one leading EDM festival is coming to Tel Aviv! ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											NEAR Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											3.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.thechainsmokers.com/">
// 											www.thechainsmokers.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/13/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Tel Aviv is known for its great dance scene, so it makes perfect sense that the hottest DJ/production duo that everyone is talking about to come to get the city on its feet! The duo is responsible for many current hits such as “Don’t let me go”, “Roses”, and their recent collaboration with Coldplay “Something Just Like This”, and they will perform in Israel as part of their international tour “Memories Do Not Open”.
// 							</p>
// 							<p>
// 								The Chainsmokers consists of Andrew Taggart and Alex Pall. The duo performed live for the first time as the opening for Timeflies in 2014, and their single "#Selfie" was re-released at the same year, leading to breakthrough success as "#Selfie" became a worldwide hit and peaked on the Dance/Electronic chart. In 2015 they released their first EP “Bouquet”, featuring “New York City”, “Until You Were Gone, “Good Intentions” and “Roses”, all of which climbed the international charts and became major hits.
// 							</p>

// 							<p>
// 								A year later, the duo released their singles “Don’t Let Me Down” featuring Daya, “Inside Out”, featuring Charlee, and “Closer” featuring Halsey. The latter peaked at number one in the United Kingdom and the United States. Their success didn’t stop there and after releasing “All We Know” featuring Phoebe Ryan, they were ranked 18th in DJ Magazine’s annual list of “Top 100 DJ’s” in 2016. The same year the duo won favorite electronic/dance music artist at the American Music Awards and top dance/electronic artist at the Billboard Music Awards. A year later “Closer” also won top hot 100 songs, top collaboration and top electronic/dance song at the same Awards ceremony.  “Don’t Let Me Down” also won best dance recording in 2017 at the Grammy awards.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:14,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Dire Straits Experience",
//         smltitle: "Get a shiver in the dark in Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											14.09.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.direstraitsexperience.com/">
// 											www.direstraitsexperience.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/14/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								25 years have passed since Dire Straits disbanded and we last heard that unmistakable sound of Mark Knopfler’s guitar…
// 							</p>
// 							<p>
// 								Close your eyes and get transported back to an original Dire Straits gig. Beautiful inspiring tracks, quality sound, amazing atmosphere, spine tingling riffs, vocals, instrumentals and an outstanding performance.
// 							</p>

// 							<p>
// 								After selling over 25,000 tickets in Israel within the past three years, and in light of the high demand for yet another show, The Dire Straits Experience are coming to Tel Aviv for only one night.  A single performance on the 14th of September at the Menora Mivtachim Arena.
// 							</p>

// 							<p>
// 							   The Dire Straits Experience was founded by saxophonist Chris White after their successful debut playing for a charity event at the Royal Albert Hall where members of the legendary band got back together on stage. News travelled fast, and an increasing global demand to hear the most dramatic songs in rock history played live eventually led to a worldwide tour.
// 							</p>

// 							<p>
// 							    Chris White, who recorded and performed with the rock legends for over a decade, joined Dire Straits for their record breaking “Brothers in Arms” world tour in 1985. This included their famous performance at Live Aid and later the renowned Nelson Mandela 70th birthday concert. White has played with some of the greatest rock stars the world has known, such as Paul Mccartney, Joe Cocker, Mick Jagger, Robbie Williams and many others. Joining Chris White is a stellar band consisting of some of the finest professional musicians the UK has to offer.
// 							</p>

// 							<p>
// 							   “When I was first approached to put together a band to play Dire Straits songs, I didn’t believe it would be possible to find someone who would be able to stand in Mark’s shoes without sounding like an imposter. I was wrong. In Terence Reis, I think we may have found the only person on the planet that is able to play and sing like Mark but maintain his own integrity and identity.”
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:15,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Alan Parsons",
//         smltitle: "The man that said no to Pink Floyd, live in TA",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											11.11.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.alanparsonsmusic.com/">
// 											 www.alanparsonsmusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/15/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The musical legend Alan Parsons and his band are coming to Israel for two shows, the first at the Congress Centre in Haifa and the second at the Menorah Mivtachim Arena in Tel Aviv.
// 							</p>
// 							<p>
// 								Parsons has a large following in Israel. In fact, this will be his third visit to the country in order to play on stage. This time they’ll be performing their new “I Robot” tour, commemorating 40 years for the release of the similarly titled mythological album in 1977. You can expect to hear all of their greatest hits of course.
// 							</p>

// 							<p>
// 								Alan Parsons is a renowned musician and one of the most influential musical producers in history. He started out as a sound technician working in the notorious Abbey Road recording studio. Alan became famous after helping to produce Pink Floyd’s masterpiece album “Dark Side of the Moon”. He has worked as a sound technician with others such as The Beatles, Wings, Al Stewart and many more.
// 							</p>

// 							<p>
// 							   In 1975, Pink Floyd invited him to work on their next album “Wish You Were Here”. Alan declined the offer in order to form his progressive rock band “The Alan Parsons Project”. The band succeeded immediately, receiving international acclaim for their huge hits “Eye in the Sky”, “Time” and “Old and Wise” to name a few.
// 							</p>

// 							<p>
// 							   An accomplished vocalist, keyboardist, bassist, guitarist and flautist receiving gold and platinum awards from many nations, Parsons also has ten Grammy Award nominations for engineering and production. Up until today The Alan Parsons Project is one of the most popular events in Europe, with tickets being sold out within hours.
// 							</p>

// 							<p>
// 							   Come indulge your ears and listen firsthand to some of the classics of our time. You can catch the concerts either in Haifa on the 9th of November or in Tel Aviv on the 11th of November.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:16,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Bryan Adams",
//         smltitle: "Bryan Adams to warm our winter with 3 shows",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv & Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											4+5+6.12.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.bryanadams.co.il/">
// 											 www.bryanadams.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/16/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								With the summer days way behind us and the days getting shorter, a little winter comfort is necessary. What better way to warm up from the inside than with some romantic ballads and timeless rock anthems. Treat yourself (and someone you love) to a throwback of nostalgia from our younger days, reminding us those sweet moments of slow dancing, first crushes and innocent youth.
// 							</p>
// 							<p>
// 								The Canadian pop rock icon with hits spanning over four decades is coming to Israel for three consecutive shows! Two will performances in Tel Aviv on the 4th and 5th of December at the Menora Mivtachim Arena and one more concert in Jerusalem on the 6th of December at the Pais Arena.
// 							</p>

// 							<p>
// 								Born in 1959 in Kingston, Ontario, Bryan Adams’ music career took off in the early 80’s with the release of his third album “Cuts Like A Knife” which included the hit “Straight From The Heart”. It was his following album “Reckless” that skyrocketed his career and brought his rise to stardom with the hits “Run To You”, “Heaven” and “Summer of ‘69”. Following these hits Adams later brought us the U.S. Billboard Hot 100 number-one singles "Heaven", "All for Love" and "Have You Ever Really Loved a Woman?".
// 							</p>

// 							<p>
// 							  Besides topping the charts in North America and Europe, his songs were nominated for several Grammy, Golden Globe and Academy Awards. His records have collectively sold over 100 million copies worldwide, making him one of the best-selling music artists of all time.
// 							</p>

// 							<p>
// 							   He’ll be performing songs from the “Get Up” tour being held for his similarly titled thirteenth (and most recent) album from 2015. No reason to worry though, we’re sure he’ll serenade us with his biggest hits and favorite crowd pleasers.
// 							</p>

// 							<p>
// 							   He’ll be performing songs from the “Get Up” tour being held for his similarly titled thirteenth (and most recent) album from 2015. No reason to worry though, we’re sure he’ll serenade us with his biggest hits and favorite crowd pleasers.
// 							</p>

// 							<p>
// 							   Make sure you don’t miss this time-defying legend.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {
//         id:17,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Chris Rock",
//         smltitle: "Coming to Tel Aviv to rock your world ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											8+9.01.18
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.chrisrock.com/">
// 											 www.chrisrock.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/17/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Chris Rock, one of the greatest standup comedians of all time and the funniest people in the world is going on a rare, highly awaited tour for the first time in 9 years. One of his few stops will be in Tel Aviv.
// 							</p>
// 							<p>
// 								The hilarious comedian has put on a new live act, after nearly a decade of focusing on television and film. Chris Rock will make his first ever live on stage appearance in Israel as part of his 2017 “Total Blackout” tour.
// 							</p>

// 							<p>
// 								Born in 1965, he made his breakthrough on SNL (Saturday Night Live) starring next to Adam Sandler, David Spade and Chris Farley. Eddie Murphy helped accelerate his stardom by giving him a role in Beverly Hills Cop 2. Since then it’s been a long line of success, from Lethal Weapon 4, Madagascar, Scary Movie, Nurse Betty and the list goes on. He’s hosted the Academy Awards twice and has also written, directed and produced several movies and TV shows. Despite all this, Chris Rock has and always will shine brightest where he truly belongs, on stage with a microphone.
// 							</p>

// 							<p>
// 							  His previous standup acts: Bigger and Blacker, Born Suspect, Bring the Pain and Kill the Messenger all broke records and are considered to be classics, with bits that are still quoted today.
//                               Rock is often compared to the greatest comedians in the field, alongside Jerry Seinfeld, Louis CK and Dave Chappelle (all of which he’s also collaborated with).

// 							</p>

// 							<p>
// 							   He made it to the top 5 in Rolling Stone magazine’s 50 greatest comedians of all time.
// 							</p>

// 							<p>
// 							   When he gets on stage it’s like seeing a boxer, a preacher and a poet all bundled together into one man. Chris delivers powerful, fast paced, side-splitting punches. His views on relationships, race and politics challenge his listeners and make them rethink everything they know. Rock dares to cross boundaries with his material and is not afraid to shock and surprise.
// 							</p>

// 							<p>
// 							   In an interview he recently gave to Rolling Stone magazine, he talked about his divorce after 18 years of marriage and how he decided to devote himself to standup again. According to him, these events gave rise to the world tour in which he will be performing in Tel Aviv.
// 							</p>

// 							<p>
// 							   Catch Chris live on January 8th at the Menorah Mivtachim Arena.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:18,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Patricia Kaas",
//         smltitle: "The great French singer returns to the white city once again",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											28.09.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.patriciakaas.net/">
// 											  www.patriciakaas.net
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/18/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The famous French singer and actress Patricia Kaas is coming back to Tel Aviv for the third time after her previous performance three years ago became a huge success and recieved incredible reviews. Kaas is considered one of the all-time most successful French singers and her music is a mix of pop, cabaret, jazz, and chanson. She started her career in the late 80’s and very quickly she climbed the charts in France.
// 							</p>
// 							<p>
// 								Kaas’s first single “Mademoiselle chante le blues” that came out in 1987 became a huge hit and got to the top 10 in the French chart. A year later she released her second single “D’Allemagne”, followed by her first album “Mademoiselle chante…” that was ranked number two at the French chart. The album sold over 100,000 copies within less than two months and became a gold album. It didn’t take long and within less than three months more than 350,000 copies were sold and it became a platinum album. Kaas received a platinum album status in Belgium, Switzerland and Canada as well, and at the same year she won the most important French music award – Victories de la Musique.
// 							</p>

// 							<p>
// 								Since then the French phenomenon sold more than 17 million albums worldwide. Her third album “Je te dis vous” brought her major success in Germany, Belgium, Switzerland, Canada, Russia, Finland, Ukraine and Korea. In 2002 she acted in a movie for the first time, it was “And now… Ladies and Gentlemen” in which she performed with the British actor Jeremy Irons. In 2009 she represented France at the Eurovision contest and got to the 8th place.
// 							</p>

// 							<p>

//                                    Patricia Kaas is responsible for many hits and her songs became a part of our lives. The talented musician is coming back to Tel Aviv to sing her famous repertoire and bring back the nostalgia to the nonstop city.

// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:19,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Blue Man Group",
//         smltitle: "The phenomenal musical group is returning to Tel Aviv once again for a show like no other!  ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											 7-23.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.blueman.com/">
// 											  www.blueman.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/19/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Blue Man Group is coming to Tel Aviv as a part of their 25 years of living in full-color tour! This is a show unlike anything you have ever seen before that combines music, theater, art and technology.
// 							</p>
// 							<p>
// 								Originally Formed in New York in 1988 by three close friends, Chris Wink, Matt Goldman and Phil Stanton, Blue Man Group originated as a celebration of the end of the 1980s. The three men wore blue masks and led a procession that included the burning of a Rambo doll and a piece of the Berlin Wall. They caught the eye of an MTV reporter and gained attention. They started with small acts on the streets of New York, growing into shows at downtown clubs, eventually becoming a full performance at the Astor Place Theatre in 1991.
// 							</p>

// 							<p>
// 								In 1999 the band released its first gold album “Audio” and it was nominated for the Grammy Award for Best Pop Instrumental Performance. Their second album, “The Complex” (2003), features collaborations with various musicians like Gavin Rossdale, Dave Matthews and many others. It charted four songs on the Billboard charts. In 2006 they released “Live at The Venetian – Las Vegas” which was an iTunes exclusive, and their most recent album, “THREE”, came out in 2016 and was also nominated for the Grammy Award.
// 							</p>

// 							<p>

//                                  Currently, the Blue Man Group is performing on a regular basis in five theaters around the world- in Vegas, New York, Boston, Orlando and Berlin. They recently launched their new book “Blue Man World” that tells the story of the blue man from their perspective.  Three blue people that will take you on a crazy adventure full of music, laughter and surprises. More than 35 million people worldwide have already seen them, not it’s your turn!

// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:20,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Sean Paul",
//         smltitle: "The international mega star is coming to make our summer sizzle!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv Outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											22.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.allseanpaul.com/">
// 											  www.allseanpaul.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/20/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The Grammy winner dancehall artist, Sean Paul will return to Tel Aviv for a single hot hot hot hot performance.
// 							</p>
// 							<p>
// 								Sean Paul will arrive in Tel Aviv for the third time as part of his new international tour. The artist is currently storming the international charts with a string of hits that including collaborations with some of the most popular names in music including Sia, Anne-Marie and more.
// 							</p>
// 							<p>
// 							    His extraordinary voice, rhythms, catchy songs and super-polished productions all combine the winning recipe of the Grammy winner and international star - Sean Paul. Originally known as Sean Paul Ryan Francis Henriques, Sean Paul was born in Jamaica in 1973. His musical career soared in 2002 with the tremendous success of his second studio album, "Dutty Rock," mainly for the songs "Gimmie The Light" and "Get Busy" Hot 100 chart toppers). Sean Paul has managed to maintain his relevance in the music industry since breaking into fame in the year 2000 until now with a string hits such as Cheap Thrills, Rockabye, No Lie, and Body.
// 							</p>

// 							<p>
// 							   Sean Paul studied at the University of Technology in Jamaica with aspirations for a career in the hotel industry, but his passion for music took over. The single ‘Baby Girl’ was the first to mark his successful career as a recording artist and led to his debut album ‘Stage One’ at VP Records. To date, he has released six studio albums; the last five were all nominated for the Grammy Award.
// 							</p>
// 							<p>
// 							   The album "Dutty Rock," 2002, earned him the Grammy Best Reggae Album. "The Trinity," 2005, reached platinum status in Europe and the Recording Industry Association in the United States. His albums, "Imperial Blaze" in 2009 "Tomahawk Technique" in 2012, and the last one was released in 2014 - "Recent Full Frequency" – were all warmly received and highly acclaimed.
// 							</p>

// 							<p>

//                                   His hard work, perseverance, and dedication over the years have earned him several nominations for the Grammy and Billboard awards. His most notable accomplishments include An American Music Award, Mobo Awards, Soul Train Awards, MTV Music Awards, ASCAP Rhythm and Soul Music Awards, a Source Award and a BET Award.

// 							</p>

// 							<p>
//                                 Sean Paul maintains a multinational presence thanks to his collaborations with artists in a wide variety of genres such as EDM, Soca, Pop, Afro-Beat and Latin music. His icon status allows him to maintain an immense fan base in Latin America, Japan, Europe and the US and his relationship with the Spanish audience received a serious boost, following his collaboration with the singer Farruko in the single Passion Whine and of course the legendary collaboration with Enrico Iglesias ‘Bailando’ which became no.1 in 33 (!) countries and gained millions of views on YouTube.
// 							</p>

// 							<p>
//                                Sean's collaborations throughout his career include numerous international collaborations with hip-hop stars such as Busta Rhymes, Beyoncé, Rihanna, Keyshia Cole, Kelly Rowland, Juicy J, 2Chainz and Nicki Minaj.
// 							</p>

// 							<p>
//                                Sean Paul performs regularly on the biggest most respectable venues in the world and enjoys a huge following from a worldwide audience of all ages.
// 							</p>

// 							<p>
//                                His last performance in Tel Aviv received fantastic revues from critics and fans alike, and he is back on popular demand, promising to make the hot summer scorch even more with a what is guaranteed to be a party like no other!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:21,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "The Pretenders",
//         smltitle: "The legendary rock band and Chrissie Hynde are coming to rock out Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											23.09.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.thepretenders.com/">
// 											  www.thepretenders.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/21/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								For the past three decades Chrissie Hynde and The Pretenders stayed at the top of the British rock and won the hearts of millions of fans. Hynde took a long break from writing and recording new materials but after the raving reviews the band’s most recent album, “Alone” got, she and The Pretenders are back on a world tour and are now coming for one unforgettable show in Tel Aviv!
// 							</p>
// 							<p>
// 								The band started its way in the music world in England in 1978 and experienced numerous subsequent personnel changes, with Chrissie Hynde being the only consistent member. The original band was active until 1982 and released its first album (Pretenders) that was a success in the United Kingdom and the United States both critically and commercially. The band got to No. 1 in the UK with its single "Brass in Pocket", which was also successful in the US, reaching No. 14 on the Billboard Hot 100.
// 							</p>

// 							<p>
// 								Later on the band released nine more albums - Pretenders II (1981), Learning to Crawl (1984), Get Close (1986), Packed! (1990), Last of the Independents (1994) which was rated gold in the US, Viva el Amor (1999), Loose Screw (2002), Break Up the Concrete (2008) which was among the Top 40 album in the US, and The Pretenders’ most recent album - Alone (2016). During March 2005, the Pretenders were inducted into the Rock and Roll Hall of Fame. Among their most famous song one can remember “Brass in pocket”, “Hymn to her”, “Don’t get me wrong”, “I’ll stand by you”, and many others.
// 							</p>

// 							<p>

//                                   The Pretenders worked carefully on their new show and started their new tour at the Royal Albert Hall in London, which was full with fans that showed how much they missed the incredible band. Hynde and The Pretenders performed in music festivals all over the world, and they’ll start the second part of their tour right here in the rocking city of Tel Aviv, make sure not to miss it!

// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:22,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Cliff Richard",
//         smltitle: "The incomparable Cliff Richard coming back to Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											10.10.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.cliffrichard.org/">
// 											  www.cliffrichard.org
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/22/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Cliff Richard, the beloved British artist who previously performed in the fabulous city of Tel Aviv more than 20 years back, is coming back to the delight of his local fans.
// 							</p>
// 							<p>
// 								Over his long and illustrious career, the 72-year-old Cliff Richard has sold more than 260 million records worldwide and is best known for his tunes "Fallen angel Woman," "We Don't Talk Anymore," "The Young Ones," "Summer Holiday," and "Congrats" .
// 							</p>

// 							<p>
// 								Richard has a long list of hits and is responsible for many worldwide beloved songs. He has sold over 21 million singles in the UK and has become an intrinsic part of the nation’s soundtrack.
// 							</p>

// 							<p>

//                                  Richard has had eight US Top 40 singles, including the million-offering "Demon Woman" and "We Don't Talk Anymore". In Canada, Richard made a real splash during the mid-1960s, and again in the late 1970s and mid-1980s with a few singles and collections achieving gold and platinum status. He has remained a prominent music, film, and TV character in Australia, New Zealand, South Africa, Northern Europe and Asia, and has a strong following.

// 							</p>

// 							<p>
// 							   Throughout his career, spanning over 50 years, Richard has amassed numerous gold and platinum records and awards, including three Brit Awards—winning Best British Male Singer twice and the Brit Award for Outstanding Contribution to Music, as well as two Ivor Novello Awards. He has had more than 130 singles, collections and EPs make the UK Top 20, more than any other artist.
// 							</p>

// 							<p>
// 							   Richard has had 67 UK top ten singles, including one written for the great Elvis Presley.  He has had 14 UK No. 1 singles and is the leading vocalist to have had a No. 1 single in the UK in five back to back decades: the 1950s through to the 1990s.
// 							</p>

// 							<p>
// 							   This October, after much anticipation, Cliff Richard is coming to Tel Aviv to sing his mind-blowing songs live, in his unmatchable performing style. Come watch the living legend himself on-stage in the exciting city of Tel-Aviv!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:23,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "DGTL Festival",
//         smltitle: "An awesome digital celebration in the one of the world’s Digital Capitals",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											05.10.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://tlv.dgtl.nl/en/?skip_portal=1">
// 											  www.tlv-digital.nl
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/23/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The first ever of its kind in the country, the DGTL festival is a dream come true for the music and nightlife scene of this buzzing metropolis. The DGTL festival is set to be by far the biggest electronic music event held in Tel Aviv, which is considered one of the nightlife capitals of the world.
// 							</p>
// 							<p>
// 								DGTL Festival, making its Tel Aviv debut this October originates in Holland and takes place each year in the most trendy capitals including Amsterdam, Sau Paulo, and Barcelona.
// 							</p>

// 							<p>
// 								The festival is an innovative technology centered event showcasing some of the world’s greatest biggest names in the digital scene alongside new hot up and comers from the industry. Tickets are often sold out in advance, and dozens of DJs and leading artists show off their talents in this a multi-sensory experience of art, music, lighting and uncompromising production standards throughout the:
// 							</p>

// 							<p>

//                                The festival has a unique and electrifying atmosphere, and audiences will also get to enjoy a variety of food stalls, art, and meticulous sound.

// 							</p>

// 							<p>
// 							   The festival will include three stages featuring excellent music at any given moment.
// 							</p>

// 							<p>
// 							   The fantastic international line up is set to include:
// 							</p>

// 							<p>
// 							  Maslow Flux, Marcel Dettman, John Talabot, Red Access, Jennifer Cardini, Avalon Emerson, Young Marko, Yotam Avni, Otarki, Joba Jobsa and many others.
// 							</p>

// 							<p>
// 							  This huge production will be launched for the first time in October 2017. In addition to being an innovative music festival, DGTL is held under the theme of environmental preservation and sustainability and is considered the greenest festival in Europe. Also, DGTL festival promotes vegetarian food only and develops a unique program for recycling materials. Alongside the local audience, the festival will be marketed in 50 countries, and thousands of music fans from all over the world are expected to arrive in Tel Aviv to take part in the party.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:24,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Richard Clayderman",
//         smltitle: "The famous pianist returns to perform in Israel with all his unforgettable hits!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											17.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.clayderman.co.uk/">
// 											  www.clayderman.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/24/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Romance lovers, prepare yourselves – after his last show in Israel three years ago, the famous French pianist Richard Clayderman returns to the holy land as a part of his new tour that marks 40 years of an outstanding career!
// 							</p>
// 							<p>
// 								Clayderman recently turned 63 and he is one of the world’s most successful pianists with a rich and diverse career that started four decades ago. He recorded over 1200 songs and his biggest hit ever is “Ballade Pour Adeline” that was sold in 22 million copies in 38 different countries. Clayderman is considered one of the world’s most successful instrumental artists along with others like Kenny G and more.
// 							</p>

// 							<p>
// 								During his career, Richard Clayderman sold more than 85 million albums and had more than 340 gold and platinum albums. He created a new romantic style through a repertoire that combines his original melodies with classics and pop standards. The phenomenal artist devoted much of his time to performing, going as far as playing 200 shows in 250 days. The Guinness Book of World Records noted him as “the most successful pianist in the world”.
// 							</p>

// 							<p>

//                                His previous visits in Israel were extremely successful with multiple sold out concerts. In his upcoming shows in Israel, Clayderman will play a selection of his best pieces, including the 12 minutes of the “Titanic Symphony”, “Don’t Cry for Me Argentina”, “Love Story”, “Ballade Pour Adeline”, and song from other famous movies such as “West Side Story”, “Harry Potter Melody” and “The Schindler List”. Come listen to the outstanding pianist who has touched the heart of millions around the world!

// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:25,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Smokie",
//         smltitle: "Smokie, coming to light up the stage this fall in Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv + Jerusalim
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											28+31.10.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//smokie.co.uk/Band">
// 											  www.smokie.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/25/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Smokie, the iconic British rock band is coming back to Tel Aviv to rock it out in the city this fall.
// 							</p>
// 							<p>
// 								Smokie initially rose to fame in the 1970's and is most know for its chart topping hits 'Living Next Door to Alice', 'Lay Back in the Arms of Someone', and "If You Think You Know How to Love Me.'
// 							</p>

// 							<p>
// 								The band has had 13 top twenty hits during the 1970s and has sold more than 30 million albums.
// 							</p>

// 							<p>

//                               Initially formed in Yorkshire, England, in 1966, Smokie hit the British pop charts a few times amid the late '70s with a fresh pop style.  The quartet recorded many singles amid the late '60s and mid '70s, and in 1975 hit number three in the U.K. with "If You Think You Know How to Love Me."

// 							</p>

// 							<p>
// 							   After another Top Ten hit, "Don't Play Your Rock’n’ Roll to Me,” the band made it big with three Top 20 hits, including "Living Next Door to Alice." Smokie hit number five both in 1977 ("It's Your Life") and 1978 ("Oh Carol(".
// 							</p>

// 							<p>
// 							   The band has performed in Tel Aviv several times and are returning shortly after their last visit to the non stop city with an extremely successful run two years ago. The Tel Aviv concert will be a part of the band’s new tour which includes England and many countries around Europe and which also includes musicians Martin Bullard, Mick McConnell, Mike Craft, Steve Pinnell and Terry Uttley.
// 							</p>

// 							<p>

// 							    Smokie’s songs have gained iconic status over the years and have been covered multiple times due to their catchy style. The band enjoys a strong fan base in the country and regularly fills every seat in the house in each of their performances. The band will be playing its greatest hits to the joy of their fans which will flock to see the rock legends in action in Tel Aviv.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:26,
//         bgImage :"/posts/bank/15/1.jpg",
//         mobBgImage :"/posts/bank/15/M.jpg",
//         title: "Foreigner",
//         smltitle: "The 80's are back to rock Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											02.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.foreigneronline.com/">
// 											  www.foreigneronline.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/26/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The 80's are coming back! The British-American hard rock group is returning once again to the amazing city of Tel Aviv. The band is returning to Israel again after 3 sold out concerts in the past – one in 2014 and two in 2016, which got incredible reviews.
// 							</p>
// 							<p>
// 								Foreigner was founded in New York in 1976 by veteran English musician Mick Jones, ex-King Crimson member Ian McDonald and American vocalist Lou Gramm. The band focused more on commercial rock and is remembered mostly for its soft ballads that topped the charts worldwide.
// 							</p>

// 							<p>
// 								The rock group released its debut album in 1977 which provided one of its most popular hits "Cold As Ice", but the band's real breakthrough happened in the early 1980's when they released the album "4". Their success continued as they released their next album "Agent Provocateur" in 1984, as well as in their last one- "Can't Slow Down", in 2009.
// 							</p>

// 							<p>

//                               The band has sold over 80 million records worldwide in the past 3 decades, out of them 37.5 were sold in the United States alone, making it one of the bestselling bands in the history. Their most memorable hits include "Waiting for a Girl Like You", "I Want to Know What Love Is", "Urgent", "Juke Box Hero", and "That Was Yesterday".

// 							</p>

// 							<p>
// 							  Come rock with the American-British legend and bring the 80's back to life in a one of a kind concert!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:27,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Carcass",
//         smltitle: "The British metal legends are coming <br>to rock the city that never sleeps!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											09.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.facebook.com/OfficialCarcass/">
// 											  facebook.com/OfficialCarcass
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/27/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The British extreme metal band was formed in 1985. They started as a school band by Bill Steer and Ken Owen, and the latter left the band soon after. Steer then joined the D-beat band Disattack and played with drummer Middie, bassist Paul and the lead singer Andrew Pek. The band later changed its name to Carcass as the members changed their musical direction. The band recorder only one album with Pek, who changed his name to Sanjiv, and shortly after "Flesh Ripping Sonic Torment" was released he left the group.
// 							</p>
// 							<p>
// 								The vocal duties were shared between Walker, Steer and Owen, and together they recorded a debut album in only four days.  The band wasn't pleased with the poor production of their album "Reek of Putrefaction" but it became a favorite of Radio 1 DJ John Peel. His interest in them made them participate in his first "Peel Session", in which they released materials for their second album.
// 							</p>

// 							<p>
// 								Carcass are considered to be the pioneers of the grindcore genre, although their early work is considered to be more splatter death metal, hardgore and goregrind. The band also became one of the pioneers of melodic death metal with their album "Heartwork" which was released in 1993. Their lyrics usually focus on animal rights issues, as both Jeff Walker and Bill Steer are vegetarians.
// 							</p>

// 							<p>

//                               In 2013 the band signed with Nuclear Blast, and in Japan they signed with Trooper Entertainment for the release of their new album. They released "Surgical Steel", which received extremely positive reviews and earned Top 50 position on the US Billboard 200 charts. Soon afterward they headlined Damnation Festival in Leeds and then performed at 70000 Tons of Metal in 2014 and headlined the Agglutination Festival the same year.

// 							</p>
// 							<p>
// 							   The band is coming to give only one show in the nonstop city of Tel Aviv, which is guaranteed to be an extraordinary experience for all the metal fans out there, make sure to get your ticket now!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:28,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Kygo",
//         smltitle: "The Norwegian house phenomena for the first time ever in Tal Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											02.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.kygomusic.com/">
// 											  www.kygomusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/28/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Kygo, originally a Norwegian pianist, became a tropical house music producer in no time. "Spotify" announced him as the biggest discovery of 2015 after his songs "Firestone" and "Stole the Show" were played over a billion times. Both of these songs also received gold and platinum status in 16 countries.
// 							</p>
// 							<p>
// 								His first album, "Cloud Nine", reached the top of the dance albums chart on "Itunes" and also on the electronic albums chart of Nielsen Soundscan. The house sensation preformed in the most popular TV shows in the United States such as "The Late Late Show" with James Corden, "The Tonight Show", "Good Morning America" with Jimmy Fallon and on Ellen Degeneres. Moreover, he was on the cover of the biggest magazines – "The Billboard", "Haute Living Magazine", "LA Times", "USA Today", "The Wall Street Journal", "The Rolling Stones", "Forbes" and more.
// 							</p>

// 							<p>
// 								Kygo started his musical journey at the age of 6 when he started learning how to play the piano. It took almost a decade for the classical music to step aside and for the new love in his life to take over – Electronic music. He only decided that he wants a career in the music industry a moment before he was about to graduate from his economics and business degree.
// 							</p>

// 							<p>

//                               His first significant breakthrough was with the hit "Firestone" that shortly grabbed the attention of tens of millions of listeners. Aviici played it in his sets and in festivals. Afterwards Coldplay's lead singer, Chris Martin, gave him permission to create a remix of their song "Midnight". Kygo's unique sound led him to incredible achievements, such as the hit "ID" that was featured in Ultra Festival's official trailer and in the playlist of FIFA 2016.

// 							</p>
// 							<p>
// 							  The extraordinary house sensation is coming to rock Tel Aviv for the first time ever, for one show only. His shows in New York and Hollywood were sold out, and the reviews were incredible. This is guaranteed to be a night to remember, you definitely want to be there!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:29,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Led Zeppelin 2",
//         smltitle: "Don’t Miss the Zeps in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv, Haifa and Be'er Sheva
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											07-10.01.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//zep2.com/">
// 											  www.zep2.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/29/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The tribute band from Chicago Led Zeppelin 2, which was named after the mythological band's second album, is coming to Israel for 4 shows only. Come feel the old Led Zeppelin vibes and kick it with the ultimate Led Zeppelin experience here in rocking Tel Aviv
// 							</p>
// 							<p>
// 								Led Zeppelin 2 have been performing  for over a decade and are considered to be the ultimate Led Zeppelin experience. The band consists of 4 musicians from the indie-rock, jazz and metal scene in Chicago. The lead singer, Bruce Lamont, who took the place of the legendary Robert Plant, is also a part of the avant-garde metal group "Yakuza", and he has collaborated with bands like "Dyslexic Apaches", and "Circle of Animals". His solo album "Feral Songs for The Epic Decline" was recently rated among SPIN magazine's top 20 metal albums.
// 							</p>

// 							<p>
// 								Greg Fundis, the group's drummer, is playing with leading musicians among which one can find the singer and jazz guitarist George Benson, the musician Joey De Francesco, the saxophonist Joe Lovano and more. The bassist Matthew Longbons participates in more than 200 shows a year next to leading international artists such as Alice Cooper and Matt Walker from the "Smashing Pumpkins". Paul Kamp, the group's guitarist, is known mostly from his collaboration with "Busker Soundcheck", a well-known alternative rock band.
// 							</p>

// 							<p>

//                              Led Zeppelin is considered until today to be one of the most revolutionary, influencing and successful bands in the history. They sold more than 300 million albums worldwide, with 'Led Zeppelin IV' alone selling over 37 million copies and being ranked as the third all-time best-selling album in the U.S. All 9 of the band's albums were rated in the top 10 in the U.S. chart, and 6 of them even top over the top 5. Their second album that was recorded during their first tour was a huge success both in the U.S. and in the UK, and it featured the hit 'Whole Lotta Love' that sold over a million copies.

// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:30,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Oh Wonder",
//         smltitle: "Live in Tel Aviv for the first time ever!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											16.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//ohwondermusic.com/">
// 											  www.ohwondermusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/30/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Oh Wonder consist of Josephine Vander Gucht and Anthony West. In 2014 they started releasing singles every month and then they combined all of them and released a debut album that's named after them and sold over 500 million copies. This year they released their second album, "Ultralife", which had even a bigger success and reached the Top 10 in the UK charts.
// 							</p>
// 							<p>
// 								In 2015 the duo was announced by Billboard as one of the 5 biggest breakthroughs. They come to Israel this year after a long tour and performing in the biggest festivals around the world as part of the promotion of their new album, which includes hits such as "Without You" and "Drive".
// 							</p>

// 							<p>
// 								Gutcht and West played sold out shows in New York, Los Angeles, Paris and London, and now they're coming for one show only to give the people of Tel Aviv a taste of their alt-pop hits. The successful duo is guaranteed to get you dancing and give the ultimate pop experience, this will be one night in Tel Aviv you are sure to remember.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:31,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Ott & The All Seeing I",
//         smltitle: "Electro explosion in the city that never sleeps",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											15.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//ottsonic.com/">
// 											  www.ottsonic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/31/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Ott and the All Seeing I are coming to take Tel Aviv by a storm this December.
// 							</p>
// 							<p>
// 								Ott is considered to be one of the pioneers of calm, groovy electronic music and likes to record the sounds of nature in his mobile studio, with which he tours England. The British record producer and musician has worked with Sinead O'Connor, The Orb, Brian Eno and Embrace, and has achieved recognition since 2002. He's known for psychedelic dub tracks and his collaborations with other artists. He has released two albums on Twisted Records – "Blumenkraft" in 2003 and "Skylon" in 2008, and two other albums on Ottsonic – "Mir" in 2011 and "Fairchildren" in 2015.
// 							</p>

// 							<p>
// 								The electro genius performed at the Glastonbury Festival in 2007, and then in 2011 he performed at Glade Festival, a show that was described as "the perfect opening act" in an article at Virtual Festivals. The same publication also called Ott a "Psy-dub maestro" and ranked his performance 10/10. The Israeli crowd was first exposed to Ott in the early 2000's with the album "Hallucinogen in Dub", the remix album he produced for Simon Posford. All the albums he released later only enhanced the effect he has with his powerful and addictive music.
// 							</p>

// 							<p>
// 							   The All Seeing I are an English electronic music group from Sheffield, consisting of Dean Honer, Jason Buckle and DJ Parrot. Their first single "I Walk" came out in 1997, but it was only in the following year that they gained mainstream commercial success with the song "Beat Goes On". The trio worked with artists such as Tony Christie, Jarvis Cocker, Babybird, Phillip Oakey and many others.
// 							</p>

// 							 <p>
// 							    Ott has performed Tel Aviv twice in the past and his shows received incredible reviews. This is guaranteed to be a one of a kind night that you definitely don't want to miss!
// 							 </p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:32,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Take That",
//         smltitle: "Take That – Taking Tel Aviv By Storm!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											27.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//takethat.com/">
// 											  www.takethat.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/32/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The legendary British pop band is this coming November to rock Tel Aviv for one show only!
// 							</p>
// 							<p>
// 								Take That started in Manchester in 1990 and currently includes Mark Owen, Gary Barlow, and Howard Donald. The original band also featured Robbie Williams and Jason Orange. Barlow is the band's lead singer and songwriter, while Owen and Donald act as backing vocals.
// 							</p>

// 							<p>
// 								Their most memorable songs include "Pray" which won The Guardian Music Award for Best Number 1 Single, "Back For Good" which won BRIT Award for Best British Single, "Everything Changes" and "Could It Be Magic." The band released 28 top 40 singles and 17 top 5 singles in the United Kingdom, out of which 12 reached number one, and they have 7 number one albums. Internationally, the band released 56 number one singles and 37 number one albums. They won 8 Brit Awards, including awards for Best British Live Act and Best British Group.
// 							</p>

// 							<p>
// 							   The British pop sensation set the record in 2011 for the fastest-selling tour of all time in the United Kingdom with "Progress Live", beating their own personal record from 2009 with their "Circus Live Tour". They were named as Amazon's top-selling music artist of all time, and in 2012 Forbes announced them as the fifth highest-earning music stars in the world. During the same year, the Official Charts Company announced the biggest-selling singles artists in the British music chart history with Take That being placed at 15th overall and having four of the best-selling albums of the millennium, which makes them the most successful boy band in the UK chart history.
// 							</p>

// 							 <p>
// 							   The band will come to Israel as a part of its international tour in order to promote its last album "Wonderland". Their previous tours have gotten raving reviews, with "Progress" winning Audio Pro International Awards for Best Live Sound Event and Audio Pro International Awards Grand Prix Award. Their performance in Tel Aviv will for sure be a one to remember, don't miss out!
// 							 </p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:33,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Kooks",
//         smltitle: "Getting it on with the Kooks in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											27-28.01.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.thekooks.com/">
// 											  www.thekooks.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/33/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The Kooks – one of the ultimate British rock/pop bands of the century are coming this January to rock Tel Aviv as a part of "The Best of The Kooks" tour that marks a decade to their existence.
// 							</p>
// 							<p>
// 								The band was formed in Brighton, UK, in 2004 by lead singer Luke Pritchard and consists of Hugh Harris the lead guitarist, drummer Alexis Nunez and bassist Peter Denton. The band released its debut album, "Inside In/Inside Out" in 2006, which included hits such as "Ooh La" and "She Moves in Her Own Way" and achieved quadruple platinum status in the UK within a year and also abroad in the form of a platinum certification in Australia and two times platinum in Ireland.
// 							</p>

// 							<p>
// 								The group released its second album "Konk" in 2008 which debuted at number one on the UK Albums Chart and recorded first week sales of 65000, achieving gold status in both the UK and Ireland, which continued to establish their reputation as one of the world's most beloved brit-pop and post-punk bands. In 2011 their third album "Junk of the Heart" came out, followed by "Listen" in 2014 which debuted at No. 16 on the UK Albums Chart. Besides the fact that they quickly signed with "Virgin Records" only 3 months after forming, they also won several awards, such as MTV's best band of 2006 award, Best UK & Ireland Act at the MTV Europe Music Awards 2006 and even a nomination for the famous Brits award.
// 							</p>

// 							<p>
// 							  The band's music is primarily influenced by the 1960s British Invasion movement and post-punk revival of the new millennium. The Kooks have experimented in genres such as pop, reggae, ska, Britpop, rock, funk and hip-hop, and released songs that were describes as "catchy as hell".
// 							</p>

// 							 <p>
// 							  The Kooks are known for their amazing sold out shows and this one is due to be no different, so make sure to get your ticket now!
// 							 </p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:34,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Willy William and Farruko",
//         smltitle: "The reggaetón superstars coming to get you movin’ in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											  Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											28.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.reggaetontelaviv.co.il/indexEN.php">
// 											  www.reggaetontelaviv.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/34/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The reggaetón superstars coming to get you movin’ in Tel Aviv!
// 							</p>
// 							<p>
// 								Willy William and Farruko, the reggaeton megastars are coming this fall to perform as a part of the "Reggaeton Tel Aviv" festival and get the people of Tel Aviv on their feet in one extraordinary show only!
// 							</p>

// 							<p>
// 								Farruko , the 26-year-old world famous reggaton singer comes from Puerto Rico. He started his professional career in 2009 through Myspace. Since then, he released six albums and collaborated with Sean Paul, Daddy Yankee, Maluma, Don Omar, Shaggy, Nicky Jam, Ky-Many Marley, Chino&Nacho, J Balvin, Ozuna and many other successful reggaeton legends, and he was nominated for the Latin Grammy awards in 2012. His hits got millions of views on Youtube, and among them, one can find the famous "6 AM", "Passion Wine", "Me Voy Enamorando", "Krippy Kush", "Sunset" and "Chillax".
// 							</p>

// 							<p>
// 							  The 36-year-old singer, producer and DJ, Willy William is coming to Tel Aviv all the way from France. He's known for his remixes and collaborations with dance artists. His big breakthrough was in 2003 when he collaborated with DJ Flex and released his hit "B Boyz Shake da Body" and right afterwards his next song "Tragedie" and the name "Lord William". His most famous hits are "EGO" and "Mi Gente" which topped the charts in many radio stations worldwide, including Israel.
// 							</p>

// 							 <p>
// 							  Come get the addictive reggaetón vibes in you and dance the night away in the city that just won't quit!
// 							 </p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:35,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Buena Vista",
//         smltitle: "The ultimate Cuban experience in Tel Aviv & Jerusalem!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv and Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											21-26.12.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.pasion-de-buena-vista.com/">
// 											  www.pasion-de-buena-vista.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/35/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   The ultimate Cuban experience in Tel Aviv & Jerusalem!
// 							</p>
// 							<p>
// 								After 600 shows worldwide -  the extraordinary Buena Vista Cuban sensation is coming for first time to give Tel Aviv and Jerusalem a taste of Cuba!
// 							</p>
// 							<p>
// 								The show is a one-of-a-kind experience that expresses love to the Cuban culture with all the known Cuban hits such as La Vida es un Carnaval. The Buena Vista Band includes 11 talented musicians, working together with a group of unbelievable dancers to provide an experience you never had before.
// 							</p>

// 							<p>
// 								The show will be held in two separate dates in Tel Aviv and Jerusalem, both awesome choices offering a huge host of activities and experiences in a unique unrivaled atmosphere. Jerusalem is known for its rich history, interesting architecture and incredible cultural diversity, while Tel Aviv is known for its fast tempo, warm exotic weather, amazing beaches and non-stop nightlife! Whatever city you'll choose- you visit is bound to be exciting and packed with unforgettable experiences!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:36,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Jerry Seinfeld",
//         smltitle: "Comedy King Closing 2017 in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											30.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.jerryseinfeld.com/">
// 											  www.jerryseinfeld.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/36/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Comedy King Closing 2017 in Tel Aviv!
// 							</p>
// 							<p>
// 								Jerry Seinfeld, the undisputed king of American comedy is returning to Tel Aviv for two performances which will be held on the same night in Tel Aviv.
// 							</p>
// 							<p>
// 								Home to incredible comedy venues a sought-after location for many international comedians such as Eddie Izzard, Jim Jeffries, Chris Rock and many others, Tel Aviv has a hedonistic vibe, incredible vibrancy and energy and a liberal loose spirit making in a comedy heaven.
// 							</p>

// 							<p>
// 								Seinfeld, hailed as one of the top comedians of his generation has without a doubt shaped the way we watch television and sitcoms, with his iconic show “Seinfeld” which ran from 1990-1998 and reigned over primetime TV for nearly a decade.
// 							</p>

// 							<p>
// 							   However, Seinfeld is a man loyal to his roots and has often declared that performing live is one of his favorites and he’s coming to Tel Aviv to do Just that.
// 							</p>

// 							<p>
// 							  This December, Seinfeld will strut his stuff onstage live in his hilarious laugh- a – second style, performing two consecutive shows in the nonstop city of Tel Aviv, and what better city is there to close the 2017 with a smile?
// 							</p>

// 							<p>
// 							   For visitors coming to check out Seinfeld’s show, the city of Tel Aviv, with its winter sunshine and world-famous nightlife is without a doubt THE place to spend a fantastic and absolutely unforgettable Tel Aviv Style New Year’s Eve.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:37,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Alt-J",
//         smltitle: "Comedy King Closing 2017 in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											29.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.altjband.com/">
// 											  www.altjband.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/37/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  The British indie band is returning to Tel Aviv once again after their last successful sold-out show in Israel two years ago. The band was formed in 2007 in England, and their debut album “An Awesome Wave” was released in 2012 and won the Mercury award the same year. The band is a combination of electro-pop, psychedelic folk, African beats, post-dubstep and rock n’ roll. The band members met through their mutual love for Radiohead while they were in college, and their sound was affected by the fact that they weren’t allowed to use a bass guitar and drums when they were students.
// 							</p>
// 							<p>
// 								The band comes to rock Tel Aviv this spring and invites fans from all over the world to come and enjoy the wonderful alternative music scene that the city that never sleeps can offer. From extraordinary art galleries to unique theatre shows to live music concerts – the cultural scene in Tel Aviv is one of a kind. It’s a home for many musicians and artists, and now it welcomes every culture lover.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:38,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Ozzy Osbourne",
//         smltitle: "Ozzy O -  coming to say goodbye to Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											08.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.ozzy.com/">
// 											  www.ozzy.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/38/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Ozzy O -  coming to say goodbye to Tel Aviv!
// 							</p>
// 							<p>
// 								Ozzy Osbourne, the world-famous metal legend returns to Tel Aviv for the last time as part of his farewell tour. While known to younger audiences mainly from the reality show “The Osbournes”, Ozzy was already a musical icon and a huge star since way before – from his role as the lead singer for Black Sabbath, to being the headliner in the international metal festival that was named after him, the “Ozzfest”.
// 							</p>

// 							<p>
// 							   After 2500 shows all around the world, the star comes to say goodbye to his fans in Tel Aviv, a city known around the world for its rich rock and metal scene. Being the most liberal city in Israel, Tel Aviv is always full of action and attracts both younger and older visitors who craving a taste of the underground culture. The rocking city is full of bars with rock themes, alternative clubs, live music venues and is known to attract music lovers from every country.
// 							</p>

// 							<p>
// 							   Don’t miss your chance to see the metal star for the very last time, make sure to get your ticket now and come rock it with ozzy in rockin’ Tel Aviv!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:39,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Jim Jefferies",
//         smltitle: "Jim Jefferies Kicks Off 2018 in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											16.01.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//jimjefferies.com/">
// 											  www.jimjefferies.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/39/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Jim Jefferies Kicks Off 2018 in Tel Aviv!
// 							</p>
// 							<p>
// 								One of the most popular comedians worldwide, Jim Jefferies, is returning to Tel Aviv after only a year. He will be kicking off 2018 and unleashing his famous humor with new material in a new show, “The Unusual Punishment Tour”.
// 							</p>

// 							<p>
// 							  The show will take place on a special 360-degree platform at the Menorah Mivtachim Hall in Tel Aviv, the perfect location for a comedian of his stature. Catching the show with the hilarious Australian performer is just the right excuse to come visit Tel Aviv, renowned for its exciting atmosphere and diverse nightlife scene.
// 							</p>

// 							<p>
// 							  Take the opportunity to visit one of the exciting bars or clubs which attract top International DJs, or visit one of the smaller neighborhood bars or cafes with its atmospheres to suit all tastes. Whether it’s food, drink or dancing you are after, Tel Aviv has it all.
// 							</p>

// 							<p>
// 							    After creating, writing, producing and starring in the critically acclaimed FX series, Legit, Jefferies and his material have gained a cult following. His voice has become well-known in late-night entertainment, making his show a must-see in Tel Aviv. Those coming to the Tel Aviv for Jefferies’ show will enjoy some good laughs, set on a background of stunning warm winters and an exciting night vibe.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:40,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Gerard Depardieu & Isabelle Adjani",
//         smltitle: "“Love Letters” Coming to Tel Aviv from France!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											05.03.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/40/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 “Love Letters” Coming to Tel Aviv from France!
// 							</p>
// 							<p>
// 								From France with love! French actors, Gerard Depardieu and Isabelle Adjani, will be performing “Love Letters” in March in Tel Aviv. Written by the late A.R. Gurney, the show has been performed on and off-Broadway by actors and actresses around the world.
// 							</p>

// 							<p>
// 							 The Pulitzer Prize-nominated show is now coming to Israel and will be performed by Gerard Depardieu and Isabelle Adjani in French, with Hebrew and Russian subtitles. With the performance taking place in Tel Aviv, visitors to the city will have the chance to enjoy some of the exotic and exciting nightlife that makes Tel Aviv so popular.
// 							</p>

// 							<p>
// 							  With restaurants to suit all palettes, dinner is just the thing for before the show, and with a nightlife that just starts to come alive around midnight, those who are looking for some adventure after the show will have plenty of options open to them. Anyone visiting the city especially for the show is sure to come away dazzled, both by the liveliness of the atmosphere and from the two well-known French stars.
// 							</p>

// 							<p>
// 							   While this is Adjani’s first trip to Israel, Depardieu has been here a number of times, and this occasion is sure to be memorable.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:41,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "A-HA",
//         smltitle: "An Electric Summer with A-HA!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											21.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://a-ha.com/">
// 											  www.a-ha.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/41/1.gif"} class="img-responsive" />
// 							</div>

// 							<p>
// 							 An Electric Summer with A-HA!
// 							</p>
// 							<p>
// 								Israel will be treated to an exciting performance from Norwegian band, A-HA, in June, 2018. Coming to Israel as part of their Electric Summer Tour 2018, the band will perform in Tel Aviv at the Exhibition Grounds in a show that promises to be a hit.
// 							</p>

// 							<p>
// 							 Formed in Oslo in 1982, A-HA has been talked about for more than three decades, and since their hit “Take On Me” in 1985, they have grown to be one of the most popular Scandinavian bands in the world. While they originally split up in 2010, they have come back together again for a number of tours and Tel Aviv is honored to be among their stops this time around.
// 							</p>

// 							<p>
// 							 Fans of the band will be treated to an exciting performance by the well-known group, while having the chance to enjoy some of the best entertainment venues in the country. From museums to theatres, restaurants to clubs, there is something to suit everyone in the bustling city of Tel Aviv.
// 							</p>

// 							<p>
// 							  Take the opportunity to enjoy a walk along the brilliant beachfront as the city’s locals get ready for the summer sun, and enjoy the vibe as diverse cultures come together for the band’s latest show.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:42,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Ringo Starr",
//         smltitle: "Ringo’s All Starr Band Headed to Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											23-24.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.ringostarr.com/">
// 											 www.ringostarr.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/42/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Ringo’s All Starr Band Headed to Tel Aviv!
// 							</p>
// 							<p>
// 								It’s been a year of stars in Tel Aviv and the latest concert to come to the dynamic city, has everyone talking! Ringo Starr will be coming to Israel as part of his European Tour and will be performing two concerts with his All Starrs Band at the Menorah Mivtachim Arena in June 2018.
// 							</p>

// 							<p>
// 							Starr, an English songwriter, singer and actor, first became famous as the drummer for the Beatles; however, since 1989, he has toured with his All Starr Band. The 77-year old released his 19th studio album in September, known as “Give More Love.”
// 							</p>

// 							<p>
// 							Tel Aviv is the ideal location for a concert with such a big name. Known as the New York City of Israel, Tel Aviv is the center of excitement, fun and initiatives in the country. As the city that attracts over a million tourists each year, whether for business or pleasure, Tel Aviv offers a beautiful beach, unique restaurants, theatres, museums and pulsing bars.
// 							</p>

// 							<p>
// 							  If you are joining the many fans who are coming to Tel Aviv to hear Ringo and his All Starrs Band perform, make sure not to miss out on the rest of what Tel Aviv has to offer and come away with an experience to remember.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:43,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "The Scorpions",
//         smltitle: "Tel Aviv to Go Crazy in July with The Scorpions!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											19.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.the-scorpions.com/">
// 											 www.the-scorpions.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/43/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Tel Aviv to Go Crazy in July with The Scorpions!
// 							</p>
// 							<p>
// 								One of the most well-known heavy metal bands in history, The Scorpions, will be coming to the Menorah Mivtachim Arena in Tel Aviv in July 2018, as part of their Crazy World Tour.
// 							</p>

// 							<p>
// 							One of the most well-known heavy metal bands in history, The Scorpions, will be coming to the Menorah Mivtachim Arena in Tel Aviv in July 2018, as part of their Crazy World Tour.
// 							</p>

// 							<p>
// 							Those looking to make a day of it in Tel Aviv, will have their pick of food and entertainment venues. The spirited city has become a melting pot of cultures and this is reflected in the museums, restaurants and street stalls that can be found all around the city. Enjoy cuisine to suit every palate, stroll around the interesting streets or pop into one of the many unique exhibitions that can be found around the city.
// 							</p>

// 							<p>
// 							  With the show scheduled for the beginning of the summer, it will be daylight until late and the locals will be out enjoying the sunshine. Soak up the vibe before you go on to rock the night away with The Scorpions!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:44,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Natalia Oreiro",
//         smltitle: "Natalia to Wow Tel Aviv in March",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											20.03.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.nataliaoreiro.com/">
// 											 www.nataliaoreiro.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/44/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							Natalia to Wow Tel Aviv in March
// 							</p>
// 							<p>
// 								South American singer and actress, Natalia Oreiro, is headed to Israel in March, where she will be performing a live concert at Menora Mivtachim Arena in Tel Aviv. Coming back to Tel Aviv, straight from Argentina, fans are looking forward to seeing the Latin star once again.
// 							</p>

// 							<p>
// 							Having performed in numerous daily series, including telenovelas and movies, and after producing 3 CDs, she will bring some of her biggest hits to the show, such as Cambio dolor, Corazon Valiente, Me Muero de Amor and Rio de la Plata y más, as she opens her new World Tour.
// 							</p>

// 							<p>
// 							Tel Aviv, which attracts celebrity singers, actors and performers from around the world, is the perfect location for the Grammy-nominated singer from Uruguay. The pumping city offers entertainment beyond the walls of the Menora Mivtachim Arena, with its trendy restaurants, upscale bars, and clubs.
// 							</p>

// 							<p>
// 							 Natalia, who has performed in Israel many times in the last 20 years, already has a following here. The show is sure to attract a large audience. Join the excitement before the performance by satisfying your taste buds in one of the many highly-acclaimed restaurants in the area or continue the celebration after the curtains have closed with a drink at a pub. Whatever your tastes, Tel Aviv is a great complement to Natalia Oreiro.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:45,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "André Rieu",
//         smltitle: "Tel Aviv to Be Treated to Rieu in 2018",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											04-05.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.andrerieu.com/">
// 											 www.andrerieu.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/45/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Tel Aviv to Be Treated to Rieu in 2018
// 							</p>
// 							<p>
// 								World-class Dutch composer and violinist, André Rieu, is coming to Tel Aviv with his Johann Strauss Orchestra for a performance that promises to be unforgettable. The two events, which are Rieu’s first in Israel, will be held at the Menora Mivtachim Arena in Tel Aviv.
// 							</p>

// 							<p>
// 							Rieu will be conducting his 60-piece orchestra while playing his famous Stradivarius violin, treating the audience to their repertoire of renowned ballads and waltzes. The event will be particularly captivating as Rieu will be presenting his new album, “Amore,” which includes a unique interpretation of Naomi Shemer’s “Jerusalem of Gold.”
// 							</p>

// 							<p>
// 							Tel Aviv, with its many facets, is just the right location for the range of musical pieces that Rieu and the Johann Strauss Orchestra will be performing. From the beach to the theater, classy restaurants to lively pubs, Tel Aviv has it all. Sit down to a posh dinner, visit a charming cafe, or enjoy a drink at a chic bar, before you end off your evening with a concert that promises no shortage of exquisite music.
// 							</p>

// 							<p>
// 							  André Rieu has become one of the most popular live acts around the world and Tel Aviv is about to find out why! Make sure you don’t miss out on the experience!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:46,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Foreigner",
//         smltitle: "Foreigner Returning to Israel in May!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											05.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.foreigneronline.com/">
// 											 www.foreigneronline.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/46/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Foreigner Returning to Israel in May!
// 							</p>
// 							<p>
// 								Popular British hard rock band, Foreigner, is returning to Tel Aviv in May 2018. After recently playing 2 concerts in Caesarea, the band will now be performing in the entertainment capital of the country, Tel Aviv.
// 							</p>

// 							<p>
// 							Since being founded in 1976 by Mick Jones, Foreigner has sold nearly 80 million albums across the globe. It reached the height of its popularity in the 1980s, with some of its most well-known hits including “I Want to Know What Love Is,” “I Don’t Want to Live Without You,” “That Was Yesterday” and “Waiting for a Girl Like You.”
// 							</p>

// 							<p>
// 							With the band performing at the Menora Mivtachim Arena in Tel Aviv, fans and visitors will be able to make the most of the concert and enjoy the vibe and energy of the city. Soak up the rays on the beach as the summer sun starts to make an appearance or spend the day in one of the many museums or exhibitions of the city.
// 							</p>

// 							<p>
// 							 You will be transported back to the 80’s with this popular band, while enjoying the best that Tel Aviv has to offer. Don’t miss out on the great nightlife of the clubs and pubs after the show, as you complete your evening with style!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:47,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Don Mclean",
//         smltitle: "Enjoy a Piece of “American Pie” in June!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											16.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://don-mclean.com/">
// 											 www.don-mclean.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/47/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Enjoy a Piece of “American Pie” in June!
// 							</p>
// 							<p>
// 								Famous American songwriter, Don McLean, will perform in the outskirts of Tel Aviv in June, 2018. After almost 60 years of career, McLean remains most famous for his hit song, American Pie, which came out in 1972 and is still covered by big names in the industry, such as Madonna.
// 							</p>

// 							<p>
// 							   McLean has released 40 gold and platinum records, but it is his attachment to Israel that makes him so popular here. This is particularly clear with his song, Jerusalem, which he wrote in support of the country. This time, he will be performing closer to the entertainment capital of Israel, Tel Aviv.
// 							</p>

// 							<p>
// 							    With the show taking place only 10 minutes from the hustle and bustle of the lively city, there are plenty of options for fans to make a full day of the concert. Visit one of a number of world-class museums or take in one of the many temporary exhibitions that come to the city. If you’re looking for food, there is certainly no shortage in Tel Aviv with a range of styles and tastes to suit all visitors. Soak up the sun as summer begins to arrive or enjoy the sounds and scenes of the nightlife that Tel Aviv is famous for.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:48,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Enrique Iglesias",
//         smltitle: "Tel Aviv to Host Spanish Pop Legend!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											28.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://enriqueiglesias.com/">
// 											 www.enriqueiglesias.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/48/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Tel Aviv to Host Spanish Pop Legend!
// 							</p>
// 							<p>
// 								Spanish pop legend, Enrique Iglesias, will be returning to Israel for his fourth visit, this time to perform at the Yarkon Park in Tel Aviv. While this won’t be his first time in the entertainment capital of the country, it is expected to be his largest performance to date.
// 							</p>

// 							<p>
// 							  This visit comes close on the heels of the Hebrew remix of his popular piece, “Subleme La Radio,” together with Israeli singer, Rotem Cohen. Concert-goers can look forward to hearing some of Iglesias’ hit songs which may include “Bailamos,” “Hero,” “Be With You” and “I Like It.” He is expected to perform together with his long-time guitarist, Israeli Sean Hurwitz.
// 							</p>

// 							<p>
// 							   Iglesias is predicted to be one of the most popular concerts of the year judging by the fact that it will be held in the Yarkon Park venue which can accommodate up to 100,000 people. Those looking to make a whole evening of the event will find plenty to keep them entertained in Tel Aviv before the concert starts.
// 							</p>

// 							<p>
// 							    With a wide range of eateries and pubs, there is something to suit all tastes. Enjoy the limitless choices when it comes to restaurants and pick up the vibe of the city before heading off to the main event.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:49,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Blood Sweat and Tears",
//         smltitle: "Blood, Sweat & Tears Headed to Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											22.10.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//bloodsweatandtears.com/">
// 											 www.bloodsweatandtears.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/49/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Blood, Sweat & Tears Headed to Tel Aviv!
// 							</p>
// 							<p>
// 								Legendary rock band, Blood, Sweat & Tears, is heading to Israel for one concert to be held in Hangar 11 in Tel Aviv. The band was last in Israel 10 years ago when they played in Tel Aviv and Caesarea.
// 							</p>

// 							<p>
// 							  Established in 1967 in New York City, their best-known hits include “I Love You More than You’ll Ever Know,” “I Cannot Quit Her,” “When I Die” and “You’ve Made Me So Very Happy.” There are no original members of the band left, but seven current members will take to the stage when they perform in March. These include lead vocalist and popular runner-up to American Idol in 2005, Bo Bice.
// 							</p>

// 							<p>
// 							   Tel Aviv promises a full day of excitement for concert-goers with the opportunity to enjoy the beautiful beaches, parklands and entertainment options that the city offers before the concert even begins. Make sure to eat in one of the many restaurants scattered around the city and immerse yourself in the character of Tel Aviv by visiting one of the popular pubs or clubs that make up its charming nightlife.
// 							</p>
//                             <p>
//                                 Create the perfect night out as you combine the atmosphere of Tel Aviv with jazz and rock in a unique concert from Blood, Sweat & Tears.
//                             </p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:50,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Jamiroquai",
//         smltitle: "Jamiroquai Heads to Israel in May!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											02.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.jamiroquai.com/">
// 											 www.jamiroquai.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/50/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Jamiroquai Heads to Israel in May!
// 							</p>
// 							<p>
// 								British band, Jamiroquai, is heading to Israel in May 2018, where they will perform in the outskirts of the bustling city of Tel Aviv. With only one performance in Israel, the popular band from the 90s is expected to attract a large crowd.
// 							</p>

// 							<p>
// 							  The band has published 8 studio albums, with “Automaton” being their latest from 2017. The hip city of Tel Aviv is the ideal location for a concert that promises an exciting performance by the group that introduced “future funk” and took the world by storm. Founded in 1992 by Jay Kay, Jamiroquai holds the Guinness Book of World Records listing for “Best Selling Funk Album” of all time.
// 							</p>

// 							<p>
// 							   Anyone looking for a lively night out will do well to head to this concert. Being held a short drive from the center of Tel Aviv, concert-goers will be able to begin the party early at one of the city’s top-notch restaurants, clubs or pubs. Start your evening with a quality dinner at any one of dozens of stylish restaurants and then move onto one of Tel Aviv’s famous clubs before making your way to the concert for an unforgettable night out.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:51,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Backstreet Boys",
//         smltitle: "The Backstreet Boys are Back and Larger Than Life",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											22.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.backstreetboys.com/">
// 												www.backstreetboys.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/51/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    The Backstreet Boys are Back and Larger Than Life
// 							</p>
// 							<p>
// 									The Backstreet Boys will be back in Israel this year for a concert. To be held in the outskirts of Tel Aviv in April, concert-goers will be able to enjoy the incredible vibe of the city together with some of the greatest hits in history.
// 							</p>

// 							<p>
// 									Tel Aviv is one of the most sought-after locations for big names in the entertainment industry, with its energy, vitality and spirit. There is no shortage of eateries, pubs and coffee shops for those looking for a culinary experience. Or, if you prefer to make a full day of it, you can visit some of the world-class museums, theaters or galleries around the city.
// 							</p>

// 							<p>
// 									Formed almost 20 years ago, the Backstreet Boys have produced 7 multi-platinum albums and sold more than 130 million records worldwide, with some of their most popular hits such as “I Want It That Way,” “As Long as You Love Me” and “Larger Than Life”.
// 							</p>
// 							<p>
// 									Visitors heading to the concert will be able to enjoy Tel Aviv at its best with beautiful Spring weather enticing locals and guests to the beach, before making their way to hear the best-selling boy band of all times!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:52,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Alice in Chains",
//         smltitle: "Alice in Chains Announces Debut Show in Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											17.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.aliceinchains.com/">
// 												www.aliceinchains.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/52/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Alice in Chains Announces Debut Show in Tel Aviv
// 							</p>
// 							<p>
// 									Making their debut appearance in Israel, rock band and grunge pioneer, Alice in Chains, will perform in July, north of Tel Aviv, in what promises to be an electrifying concert.
// 							</p>

// 							<p>
// 									Having come together in the late 80’s, Alice in Chains is one of four major groups that led the grunge revolution, and they became one of the most influential bands of all time. With music that combines rock, alternative rock and metal, the band was nominated for 9 Grammy awards and sold more than 20 million albums.
// 							</p>

// 							<p>
// 									Taking place in the middle of summer, Tel Aviv is the perfect location to start the day’s activities. If you’re looking for some indoor entertainment, visit one of the city’s world-class museums or galleries, or head over to one of the many restaurants around the city. For something a bit different, soak up the rays walking along the promenade of a beautiful beach or pop into a club or pub in the area before heading north for the concert.
// 							</p>
// 							<p>
// 									This show is part of the first European tour the band has been on in four years, and being its first appearance ever in Israel, it promises to be a night full of excitement.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:53,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Hardwell",
//         smltitle: "Hardwell Headed to Israel in April",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											06.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.djhardwell.com/">
// 												www.djhardwell.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/53/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Hardwell Headed to Israel in April
// 							</p>
// 							<p>
// 									Number 1 ranking DJ, Hardwell, is coming to Israel in April where he will thrill crowds just outside Tel Aviv. This will be his third concert in the country, after performing to sell-out audiences in 2013 and 2017.
// 							</p>

// 							<p>
// 									Robbert van de Corput, better known as DJ Hardwell, first made a name for himself at the young age of 14, but it was at age 25 when he truly became famous, named World’s #1 DJ by the 2013 DJ Mag. Hardwell has become an International name, hosting his own radio show which is broadcast around the world, and producing a consistently top 10 iTunes podcast. He is also well known for his remix of The Wanted’s “Chasing the Sun”.
// 							</p>

// 							<p>
// 									Tel Aviv is the ideal location for a concert of this type with the natural vibe and energy of the city adding to the excitement that will be in the air. Tel Aviv in Spring is full of blue skies and warm weather, attracting crowds to the beach and the outdoor cafes and restaurants that can be found throughout the city. Enjoy a full day out or join the gathering of people at one of the city’s world-class restaurants before heading to the concert.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:54,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Jethro Tull",
//         smltitle: "Jethro Tull’s 50th Anniversary Tour Heads to Israel",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv and Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											27-28.10.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.jethrotull.com/">
// 												jethrotull.com/
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/54/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Jethro Tull’s 50th Anniversary Tour Heads to Israel
// 							</p>
// 							<p>
// 									Ian Anderson, vocalist, flutist, and guitarist of the popular British rock band, Jethro Tull, is coming to Israel for the band’s 50th anniversary tour. Performances will take place at Heichal Hatarbut in Tel Aviv on October 27, followed by the International Convention Center in Jerusalem on October 28.
// 							</p>

// 							<p>
// 									Formed in 1967, the band initially played blues rock, but later evolved and developed elements of hard rock. Their greatest success came in the 1970s with hit songs such as “Bungle In The Jungle,” “Living In The Past,” and “The Witch’s Promise.” The band has performed in Israel numerous times in the past, and Anderson who is the only remaining member of the band who is coming on tour, is expected to receive a warm welcome.
// 							</p>

// 							<p>
// 									Performing in both Tel Aviv and Jerusalem will appeal to a wide audience. Join the energy and vibe of the lively city of Tel Aviv with its nightlife, culinary experiences and beautiful beaches, or enjoy the concert in the cultural and historic center of the country, which is Jerusalem. No matter which flavor of the region you prefer, there are plenty of restaurants, cafes, museums or galleries to visit in each of the cities before the venues open their doors.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:55,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Israel Calling",
//         smltitle: "Good Evening Europe, This is Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											08-10.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 						<!--	<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>-->

// 							<h2>
// 							   Good Evening Europe,<br class="show-on-mobile"> This is Tel Aviv!
// 							</h2>
// 							<p>
// 								Eurovision fever is sweeping over Tel Aviv as it confirms hosting the star and glitter studded event - “Israel Calling”, for the 3rd consecutive year!
// 							</p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/55/1.jpg"} class="img-responsive" />
// 							</div>

// 							<p>
// 								About 30 delegates from Eurovision participating countries worldwide will be gathering at the beginning of April in the nonstop city of Tel Aviv, for the largest Eurovision promo-event to ever take place in front of a crowd of thousands from Israel and around Europe.
// 							</p>

// 							<p>
// 								This unique and exciting event, held only in Tel Aviv, will give Eurovision fans from far and wide an amazing and completely free of charge opportunity to take part in the glamour of the Eurovision right here in the beautiful city of Tel Aviv.

// 						</p>

// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/55/2.jpg"} class="img-responsive" />
// 						</div>

// 						<p>
// 						The event will be held for three days starting on the 8th of April. The main stage will be set in Rabin Square, Tel Aviv’s main square and one of the city’s favorite outdoor venues, located at the heart of the buzzing city.
// 						</p>

// 						<p>
// 						The main event will take place on Tuesday and will include a mini Eurovision show in front of a live audience, featuring performances by the various Eurovision contenders performing the songs they will be competing with on the main event in May.

// 						</p>

// 						<p>
// 						This much anticipated pre-Eurovision event is set to take place just a few minutes’ walk from the stunning Tel Aviv beach. Fans and music lovers coming to see the show will get to take in all the city has to offer, including the excellent bars, restaurants and the awesome nightlife in this world-famous ultimate vacation destination called Tel Aviv.
// 						</p>

// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/55/3.jpg"} class="img-responsive" />
// 						</div>

// 						`
// 			}
// 		}

//     },

//     {

//       id:56,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Clean Bandit",
//         smltitle: "Clean Bandit Announces First Visit to Israel",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											26.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//cleanbandit.co.uk/">
// 												cleanbandit.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/56/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Clean Bandit Announces First Visit to Israel
// 							</p>
// 							<p>
// 									British electro-pop group, Clean Bandit, which has become one of the leading dance acts around the world, has announced their debut performance in Israel. Visiting as part of their European tour, the band will play on the outskirts of Tel Aviv on June 26.
// 							</p>

// 							<p>
// 									Formed in 2008, they became well-known for merging classical instruments and pop with a unique and masterful outcome and they became a sensation with their smash hits “Rather Be,” “Real Love,” “Rockabye,” and “Symphony.” Since its release in 2016, “Rockabye” has been viewed almost 2 billion times on YouTube, while they won a Grammy for “Rather Be” in 2015.
// 							</p>

// 							<p>
// 									The band has been together for ten years and has seen incredible success in the that time. Join the throngs of people heading to Tel Aviv for the group’s first visit.
// 						    </p>

// 						    <p>
// 									Tel Aviv is just the venue for the unforgettable night that this concert offers. With cafes, bars, clubs, and pubs throughout the city, there is no shortage of activities in Tel Aviv. Known as “the city that doesn’t stop”, you can take advantage of the buzz of the nightlife and enjoy the vibe of the bustling beachfront at any hour before or after the concert.
// 						    </p>

// 						`
// 			}
// 		}

//     },

//     {

//        id:57,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Alanis Morissette",
//         smltitle: "Alanis Morissette to Turn Up The Heat with Summer Performance in Israel",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											30.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//alanis.com/">
// 												alanis.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/57/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Alanis Morissette to Turn Up The Heat with Summer Performance in Israel
// 							</p>
// 							<p>
// 									Canadian singer and songwriter, Alanis Morissette, will return to Israel in the summer for one show which will take place on the outskirts of the lively city of Tel Aviv. Morissette has performed in Israel a number of times, including in 2000 and 2012, since she released her first album, “Jagged Little Pill” in 1995.
// 							</p>

// 							<p>
// 									The popular alternative rock singer is expected to rock Tel Aviv with some of her top hits, including “All I Really Want,” “Hand in My Pocket,” “Head Over Feet,” “Ironic,” “You Learn,” and “You Ought to Know.” Having taken home seven Grammy Awards and with eight albums having sold more than 60 million copies across the globe, her upcoming visit is already causing much excitement.
// 							</p>

// 							<p>
// 									The Tel Aviv area is the perfect location for a concert of this calibre, with visitors to the city given an exceptional choice of wining, dining and entertainment options. Begin your night at one of the many world-class restaurants or head out to one of the quaint coffee shops or bustling bars to end off your evening. The music scene will be hotter than ever with Alanis Morissette this July!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//        id:58,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Marc Almond",
//         smltitle: "Marc Almond’s Amazing Summer Concert",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											14.08.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.marcalmond.co.uk/news/index.html">
// 												marcalmond.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/58/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Marc Almond’s Amazing Summer Concert
// 							</p>
// 							<p>
// 									English musician, Marc Almond, will be heading to Israel in the summer for a much-awaited concert. The singer, who is most famous for his part in the new wave duo Soft Cell, will be playing north of Just north of the nonstop city of Tel Aviv in August.
// 							</p>

// 							<p>
// 									Soft Cell became famous for its 80’s hits “Tainted Love,” “Torch,” “Say Hello, Wave Goodbye,” and others, while Almond’s solo career took off when the duo split in the mid-80’s with hits including “Jacky” and “Something’s Gotten Hold of My Heart.” In another tribute to the decade, the Israeli rock group, Tattoo, which broke up in 1989, will open the concert in a historic reunion.
// 							</p>

// 							<p>
// 									Fans have been waiting for this performance since 2011, when his planned concert was canceled due to technical reasons. The 2018 concert promises to be an experience to remember.
// 							</p>

// 						    <p>
// 									From music to art, culture to fun, Tel Aviv has something for everyone. Spend the day wandering the vibrant streets of the city or pop into one of the many museums, theatres or galleries downtown. Make sure to stop off for a bite to eat at any of the city’s many world-class restaurants so you’ll be energized for what is sure to be an awesome concert.
// 							</p>

// 						`
// 			}
// 		}

//     },
//     {

//         id:59,
//         bgImage:"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title : "Shakira",
//         smlTitle : "Shakira to heat up the summer in sizzling Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											09.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.shakira.com/">
// 												shakira.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/59/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Shakira to heat up the summer in sizzling Tel Aviv
// 							</p>
// 							<p>
// 									The worldwide sensation Shakira is set to perform for the first time on the big stage in Tel Aviv this coming July and the city’s a buzz. The 41-year-old Colombian superstar who has sold close to 200 million albums and has won over 250 awards including three Grammys is just the perfect fit for a summertime concert in Tel Aviv.
// 							</p>

// 							<p>
// 									With a long and illustrious list of hit songs, including “Waka-Waka”, “Chantage” and “Whenever, whenever” Shakira is one of the most celebrated artists in the world today and nearly every song she records tops the international charts and receives hundreds of millions of Youtube views.
// 							</p>

// 							<p>
// 									Shakira’s concert is due to be held on July 9th in Yarkon Park, Tel Aviv’s massive park also dubbed the city’s “Green Lung”, which boasts, in addition to beautiful greenery, a stunning lake and excellent bike trails, a huge outdoor live music venue.
// 							</p>
// 							<p>
// 							        The party atmosphere of the nonstop city in July, the beautiful beaches and amazing nightlife and cool street vibe, all set the scene for perfectly Shakira’s show-stopping style and what is guaranteed to be an explosive musical celebration in the heart of cool city of Tel Aviv.
// 							</p>

// 	                    `
// 			}
// 		}
//       },
//   //     {

//   //     id: 60,
//   //     bgImage:"/posts/bank/16/1.jpg",
//   //     mobBgImage:"/posts/bank/16/M.jpg",
//   //     title: "White Night TLV",
//   //     smlTitle: "A “White Night” Rager In the Non-Stop City!",
//   //     html: function(){
// 		// 	return {
// 		// 		__html: `

// 		// 					<h2 class="align-center">
// 		// 					   16.05.2019
// 		// 					</h2>
// 		// 					<h1 class="align-center">
// 		// 					   A “White Night” Rager In the<br class="show-on-mobile"/> Non-Stop City!
// 		// 					</h1>
// 		// 					<div class="responisve-iframe">
// 		// 						<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 		// 					</div>
// 		// 					<p>
// 		// 						When a city renowned across the world as the “City that never sleeps” holds an event like “White Night” – you know you’re in for a treat. “White Night”, one of Tel Aviv’s biggest events of the year, is a traditional annual citywide celebration which keeps the city up all night – everything is open and everything is happening across the city at the same time…
// 		// 					</p>

// 		// 					<p>
// 		// 						From the early evening and until dawn, the city becomes packed with tourists and locals, high on life and enjoying everything on offer, from shops and eateries to cinemas and culture venues – free of charge or at reduced rates, all night long!
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/1.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo By: Adam Primer
// 		// 					</small>
// 		// 					<p>
// 		// 						The origin of this now world-famous event dates back to 2003 when UNESCO declared the "White City", Tel Aviv’s largest architectural collection of Bauhaus style buildings a world cultural heritage site, giving it a unique status in the architectural heritage of the modern era.
// 		// 					</p>
// 		// 					<p>
// 		// 						This historic declaration has been celebrated yearly ever since by Tel Aviv-Jaffa in a series of white night events, named after the "White City" and Tel Aviv’s other well-known characteristic: being “The City That Doesn’t Stop”.
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/2.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo By: Kfir Sivan
// 		// 					</small>
// 		// 					<p>
// 		// 						The White Night is a celebration of numerous events held throughout the city, which seems to expand with every passing year. In recent years, the celebrations  included (to name just a few): a unique midnight public picnic, an epic headphones party in the city’s main square, countless live music concerts, amazing indoor as well as street theatre performances, fascinating nighttime tours, night sports classes , Yoga at sunrise, and of course countless epic parties, all taking place all night across the city at the same time.
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/3.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo by Moshik Lindenbaum
// 		// 					</small>
// 		// 					<p>
// 		// 						So you better get your rest on- you’re gonna need all your energy to keep up with “White Night” in the awesome city of Tel Aviv!
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/4.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo by: Guy Yechiely‎.
// 		// 					</small>

// 		// 			               `
// 		// 	}
// 		// }
//   //   },
//       {
//       id: 60,
//       bgImage:"/posts/bank/16/1.jpg",
//       mobBgImage:"/posts/bank/16/M.jpg",
//       title: "White Night TLV",
//       smlTitle: "All Night Citywide party in Tel Aviv on Eurovision Semifinal!",
//       html: function(){
// 			return {
// 				__html: `

// 							<h2 class="align-center">
// 							   16.05.2019
// 							</h2>
// 							<h1 class="align-center">
// 							   All Night Citywide party in Tel Aviv on Eurovision Semifinal!
// 							</h1>
// 							<div class="responisve-iframe">
// 								<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 							</div>
// 							<p>
// 								When a city renowned across the world as the “City that never sleeps” holds an event like “White Night” – you know you’re in for a treat, and this year the treat is going to be especially epic!
// 							</p>

// 							<p>
// 								As part of the warm and exciting welcome awaiting visitors during Eurovision week, the powers that be have decided to combine Tel Aviv’s annual “White Night” extravaganza with the Eurovision Semifinal set to be held on 16.05.2019.
// 							</p>
// 							<p>
// 								“White Night”, one of Tel Aviv’s biggest events of the year, is a traditional annual citywide celebration which keeps the city up all night – everything is open, and everything is happening throughout the city simultaneously.
// 							</p>
// 							<p>
// 								The origin of this now world-famous event dates back to 2003 when UNESCO declared the "White City as a world cultural heritage site, setting off annual citywide celebration in a series of white night events in the city that (truly) doesn’t sleeps.
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/1.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo By: Adam Primer
// 							</small>
// 							<p>
// 								From the early evening and until dawn, the city becomes packed with tourists and locals, high on life and enjoying everything on offer, from shops and eateries to cinemas and culture venues – free of charge or at reduced rates, all night long!
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/2.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo By: Kfir Sivan
// 							</small>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/3.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo by Moshik Lindenbaum
// 							</small>
// 							<p>
// 								So you better get some rest - you’re gonna need all your energy to keep up with “White Night” in the awesome city of Tel Aviv!
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/4.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo by: Guy Yechiely‎.
// 							</small>

// 					               `
// 			}
// 		}
//     },
//     {

//         id:61,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Brian Wilson",
// 	    smlTitle: "The legendary Brian Wilson returning to rock Tel Aviv!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											07.08.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.brianwilson.com/">
// 												brianwilson.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/61/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 The legendary Brian Wilson returning to rock Tel Aviv!
// 							</p>
// 							<p>
// 									He returns to the white city with Al Jardine and Blondie Chaplin as a part of his world tour that celebrates his biggest hits from the last 54 years. The Beach Boys is one of the world’s most successful bands, the band has won many Grammy awards, got their own star in Hollywood and entered the Rock N’ Roll hall of fame.
// 							</p>

// 							<p>
// 									The band sold over 100 million records over the years and produced more hits than any other American band. They’re known especially for their hits “God Only Knows”, “Get Around”, “California Girls” and “Good Vibrations”. Wilson’s solo career is also successful, he recorded 11 albums and won 2 Grammy awards.
// 							</p>

// 							<p>
// 									Wilson’s concert will take place in Tel Aviv on August’s 7th. The summertime provides long daylight hours that give visitors the perfect opportunity to see what Tel Aviv has to offer; from an incredible art scene to fantastic theatres, to phenomenal live music shows and world-class restaurants – there are so many options in the spectacular city of Tel Aviv for  everyone will to find their brand of fun and excitement in the nonstop city.

//                             </p>

// 					               `
// 			}
// 		}
//     },
//     {

//         id: 62,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Jason Derulo and Rita Ora",
// 	    smlTitle: "Jason Derulo and Rita Ora to raise it up in Tel Aviv!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											The outskirts of Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											01.08.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.jasonderulo.com/">
// 												jasonderulo.com
// 											</a><br>
// 											<a target="_blank" href="//ritaora.com/">
// 												ritaora.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/62/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						         	Jason Derulo and Rita Ora to raise it up in Tel Aviv!
// 							</p>
// 							<p>
// 									The two mega pop stars will perform at the “Lollipop” festival that will take place at the outskirts of Tel Aviv on the first of August. Derulo, that made his big breakthrough in 2009 with the hit “Whatcha Say”, became over the last decade one of the biggest stars in the international music industry with his huge hits such as “Wiggle”, “Want to Want Me”, “Swalla”, “Tip Toe” and “Talk Dirty”. The popular British Pop star, Rita Ora, is known especially for her famous hits “I Will Never Let You Down”, “Anywhere”, “R.I.P” and “Hot Right Now”.
// 							</p>

// 							<p>
// 									The festival provides a great opportunity to explore the city that never sleeps and enjoy its famous nightlife scene – from world-class bars, to secret underground clubs, to live music shows and various culinary options and even alternative art galleries, Tel Aviv for sure has something for everyone to enjoy. Whether you’re following a map or letting yourself get lost in the streets, you’re sure to fall in love with Tel Aviv!
// 							</p>

// 					               `
// 			}
// 		}
//     },
//     {

//         id: 63,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Julio Iglesias",
// 	    smlTitle: "The Latin legend returning to wow Tel Aviv!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											06.10.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.julioiglesias.com/">
// 												julioiglesias.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/63/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						             The Latin legend returning to wow Tel Aviv!
// 							</p>
// 							<p>
// 									Tel Aviv can’t wait for the return of the beloved Spanish star! With a great cultural scene, incredible culinary options, amazing beaches, phenomenal museums and galleries and plenty of unique spots to explore – those who come to enjoy Iglesias’s concert have plenty of different ways to spend their time in the cultural capital.
// 							</p>

// 							<p>
// 									The hot climate and long daylight hours just reminiscent of the phenomenal singer’s origin country, Tel Aviv offers a variety of options that suit all ages and therefore attracts a big amount of visitors all around the year.
// 							</p>
// 							<p>
// 							        Iglesias has an ongoing love affair with the nonstop city and his past shows were sold out. He’s one of the most successful singers in the history and during his career became a phenomenal success story all around the world. He has 77 different albums that sold over 300 million copies!
// 							</p>

// 							<p>
// 							         Many of the Spanish phenomenon’s hits have reached the top of the charts and he won numerous awards, such as the Grammy. His fans are incredibly excited about his return and tickets are selling like hot falafels. This is guaranteed to be a show to remember!
// 							</p>

// 					               `
// 			}
// 		}
//     },
//     {

//         id: 64,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Maluma",
// 	    smlTitle: "The Reggaeton sensation returns to the white city!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											28.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//fame.malumaofficial.com/">
// 												fame.malumaofficial.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/64/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						           The Reggaeton sensation returns to the white city!
// 							</p>
// 							<p>
// 									After winning over the crowd’s hearts during his last visit, the Colombian reggaetón singer and songwriter Juan Luis Londoño Arias, better known by his stage name Maluma returns to the city that never stops for one show only!
// 							</p>

// 							<p>
// 									Maluma has several singles that have charted within the top 10 on Billboard Hot Latin Songs, including "Felices los 4", "Borro Cassette", "El Perdedor" and "Corazón". During his career he won several awards, among which there is MTV Europe’s award for best world tour. The phenomenal performer is known among his fans as “the Latin lover” despite being only 24 years old.
// 							</p>
// 							<p>
// 							       His show will be held on June’s 28th in HaYarkon Park, located in the heart of Tel Aviv. Fans from all over the world who come to the show can enjoy the lovely beaches the city has to offer, the variety of restaurants and cafes, the remarkable art scene, the world-class bars and clubs, the various shopping venues spread all across the city – Tel Aviv has something for everyone.
// 						    </p>

// 							<p>
// 							         The Latin superstar is known to be quite a charmer and win everyone over in his shows – don’t miss this fantastic mix of Maluma and Tel Aviv -  come see the legend live in the hot hot city!
// 						    </p>

// 					               `
// 			}
// 		}
//     },
//     {

//         id: 65,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Martin Garrix",
// 	    smlTitle: "The 1# DJ comes to the nonstop city!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											10.09.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.martingarrix.com/">
// 												martingarrix.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/65/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						           The 1# DJ comes to the nonstop city!
// 							</p>
// 							<p>
// 									Martin Garrix , hailed as “the world’s best DJ” by DJMag is coming to get the party going in the nightlife capital of the middle east! With tons of world known clubs, bars, pubs and a one of a kind atmosphere, Tel Aviv is known for its vibrant vibe and incredible night scene.
// 							</p>

// 							<p>
// 									At 20 years old, the Dutch wonderkid is coming at the height of his career for one unforgettable show in Tel Aviv! The international hits machine became famous when he was only 17 and since then has released many loved tracks and climbed the charts all over the world.
// 							</p>
// 							<p>
// 							       Garrix is considered by many is the undeniable king of the industry. With remarkable hits such as “Animals”, “Tremor”, “In the Name of Love” and “Scared to Be Lonely”, the phenomenal DJ is one of the most popular performers in the world and is a must-have headliner for every well-known festival.
// 							</p>

// 							<p>
// 							        The show will be held in HaYarkon Park, in the heart of the awesome city, on September 10th. The international vibe, gorgeous location and great nightlife scene attract an extraordinary crowd that comes from different corners of the world and is guaranteed to make this show a once in a lifetime experience!
// 						    </p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 66,
// 	    bgImage:"/posts/bank/59/1.jpg",
// 	    mobBgImage:"/posts/bank/59/M.jpg",
// 	    title: "Eurovision Tel Aviv",
// 	    smlTitle: "Epic song contest in the Non-Stop City",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											14-18.05.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<!--<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>-->

// 							<h2>A once in a lifetime opportunity to visit Tel Aviv as it hosts the Eurovision song contest.</h2>
// 							<p>
// 						     Epic song contest in the Non-Stop City
// 							</p>
// 							<p>Semi-final 1: 14 May 2019</p>
//                             <p>Semi-final 2: 16 May 2019</p>
//                             <p>Grand Final: 18 May 2019</p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/67/1.svg"} class="img-responsive" />

// 							</div>
//                             <p>It’s getting hot hot hot in Fabulous Tel Aviv! The nonstop city is teaming with excitement as it is getting ready to host the 2019 Eurovision Song Contest in what promises to be one of the most epic events ever held in the famous party city. </p>
//                             <p>Tel Aviv, known for its amazing energy, stunning beaches, great year round weather and gorgeous people, is the perfect destination for an unforgettable citybreak.  Tel Aviv is known world over for its open mindedness and liberal spirit, making it the ideal host for the Eurovision song contest, offering visitors from far and wide the perfect opportunity to enjoy this vibrant and energetic city at its finest. </p>
//                             <div class="img-wrapper">

// 							    <img src=${getImgUrl() + "/Concerts/67/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>Major productions centered around the Eurovision contest month are already well on their way. Some of the exciting events planned include an amazing opening ceremony, a prestigious red-carpet event, and even a mega “Euro Village” which will be situated merely a minutes’ walk from the awesome Tel Aviv baordwalk and beach. The Euro Village will be open for 10 days and will include live performances from past and present mega stars as well as live screenings of the Eurovision contest’s semifinal and final. The contest itself will take place in the Expo Tel Aviv. </p>

//                             <p>The Eurovision Song contest in Tel Aviv is guaranteed to be an event of a lifetime, so make sure to book your trip now to the most amazing Eurovision contest yet, in the most amazing city of all! </p>

// 					               `
// 			}
// 		}
//     },

//    {

//         id: 68,
// 	    bgImage:"/posts/bank/68/1.jpg",
// 	    mobBgImage:"/posts/bank/68/M.jpg",
// 	    title: "",
// 	    smlTitle: "36 Years of Cinema Magic!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											25.07-04.08.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.jff.org.il/en">

// 												www.jff.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
// 							<h2>Jerusalem Film Festival (JFF)</h2>
// 							<p>Time to start preparing your Summer 2019 checklist: Buy suntan lotion, pick wildflowers, host a barbeque, make plans to attend the 36th Annual Jerusalem Film Festival! It’s 11 days, over 200 films, prizes awarded to the very best, and you’ll be a part of it all! From star-studded international features to independent productions and the best of Israeli cinema, this unique film fest showcases excellence from various genres. </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/68/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>Take advantage of the opportunity to meet festival guests, including world-renown stars, writers, directors, cinematographers and other movie-making professionals. Film enthusiasts will enjoy Jerusalem’s many cinema spaces and be delighted by JFF on the Go, which presents films under the stars throughout the festival, and Cinema Park, which includes a 300 square meter pool with rubber boats, a giant LED screen, and a concert stage featuring live musical performances nightly. </p>
//                             <p>As you travel across the city to attend screenings, workshops, master classes, parties, musical shows and other festival events, you’ll experience how ancient cultures give modern spice to the contemporary vibe and personality of this global city. Fill your spare time strolling through neighborhood streets, exploring local shops, and taking your pick of Jerusalem’s wide variety of restaurants and cafes. You may have attended other film fests, but you won’t find one quite like this and, certainly, none other can boast the grandeur of the eternal City of Peace! </p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 69,
// 	    bgImage:"/posts/bank/69/1.jpg",
// 	    mobBgImage:"/posts/bank/69/M.jpg",
// 	    title: "",
// 	    smlTitle: "Jerusalem Wine Festival (JWF)",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											01-31.08.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.imj.org.il/en/events/wine-festival-1">
// 												www.imj.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Jerusalem Wine Festival (JWF)</h2>
// 							<p>
// 								Relaxing summer evenings were made for an exquisite glass of fine wine! And for four days in August, you can enjoy world class selections and award-winning food at the 16th Annual JWF. Hosted in the beauty of the Japanese Art Garden of the Israel Museum, this is considered by many to be Jerusalem’s premiere social event. It’s a wine festival unlike any other, whose ambiance and stunning views of this historic city combine to make the JWF a not-to-be-missed experience.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/69/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Hundreds of wines will be served by dozens of well-known and boutique wineries. There’ll be free wine tasting opportunities, along with a culinary oasis of stalls offering cheeses, chocolates, olive oils, exceptional sauces, and tasty jams. And speaking of tasty jams, the festival will get your party started every night with two different live music concerts.
// 							</p>
//                            <p>
// 								Every year, the JWF welcomes a diverse and refined crowd of over 20,000 wine and culture lovers to Jerusalem. Many attend over multiple evenings simply to soak in the atmosphere. You could even build your stay in the city around the festival! Certainly, your days will be filled with sightseeing, shopping, and loads of walking about. The perfect way to unwind after your busy days might well be several fun-filled nights at the Jerusalem Wine Festival!
// 							</p>
// 					               `
// 			}
// 		}
//     },

//     {

//         id: 70,
// 	    bgImage:"/posts/bank/70/1.jpg",
// 	    mobBgImage:"/posts/bank/70/M.jpg",
// 	    title: "OPEN RESTAURANTS TLV",
// 	    smlTitle: "Feed Your Curiosity!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											2019 y.
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://open-restaurants.co.il/?lang=en">
// 												open-restaurants.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Feed Your Curiosity!</h2>
// 							<p>
// 								Ever wanted to get more than a taste of what gets created in a truly fine restaurant? Have you ever fantasized about what it would be like to be a top chef? Well, now’s your chance!
// 							</p>
// 							<p>
// 								OpenRestaurants is more than a culinary event, it’s a cultural happening that showcases Tel Aviv’s wide array of restaurants, chefs, and local culinary personalities. Guests get to meet with chefs from around the city, wander through open markets, and try their hands at cooking up flagship dishes under the supervision of first-class professionals. It’s your opportunity to experience a day in the life of the sophisticated chefs, line cooks, restaurateurs, food vendors, and others who make gastronomy in Tel Aviv as palate pleasing as it is.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/70/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Beyond peeking behind many kitchen curtains, OpenRestaurants hosts a range of events that include curated dinners, history presentations, and exhibitions of culinary-themed art, design, music, and technology!
// 							</p>
//                            <p>
// 								Many events are available at no charge, including the Culinary Innovation Summit, the Food & Hospitality Hackathon, and various food talks. There are also family-oriented events that focus on cooking activities for children and several market tours.
// 							</p>
//                            <p>
// 								Everyone’s gotta eat and there’s no one who doesn’t enjoy good food that’s well prepared. So, whether you like to understand the process behind the preparation, you like to do the preparing, or you just have a hearty appetite, there’ll be plenty to delight your senses at OpenRestaurants: Tel Aviv!
// 							</p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 71,
// 	    bgImage:"/posts/bank/71/1.jpg",
// 	    mobBgImage:"/posts/bank/71/M.jpg",
// 	    title: "CULINARY FESTIVAL",
// 	    smlTitle: "Round Tables Culinary Festival",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											09-23.11.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://open-restaurants.co.il/?lang=en">
// 												open-restaurants.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Round Tables Culinary Festival</h2>
// 							<p>
// 								The 4th edition of this celebrated culinary experience that brings renowned chefs from around the globe and invites them to take over the kitchens of several of Tel Aviv’s most notable restaurants.
// 							</p>
// 							<p>
// 								This year offers a new twist: The eight visiting chefs are all women – hailing from Mexico, South Korea, Italy, Switzerland, Colombia, Slovenia, Spain, and the United States. They’ll work with their local counterparts in the creation of culture crossover chowdowns featuring signature dishes from the guest chefs alongside flavors offered by the local chefs from the host restaurants.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/71/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Everyone involved agrees that creative cooking is always intensely steeped cultural context and a deeply felt sense of place. All of them are passionate about using local ingredients. Of course, each of these chefs has received accolades and awards from international critics and guides.
// 							</p>
//                            <p>
// 								There’s no better way to showcase Tel Aviv’s growing prominence on the global stage of gastronomy than the annual Round Table event. Seats get reserved quickly and must be made in advance. So, don’t miss your chance for a place at these prestigious tables – your taste buds will never forgive you!
// 							</p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 72,
// 	    bgImage:"/posts/bank/72/1.jpg",
// 	    mobBgImage:"/posts/bank/72/M.jpg",
// 	    title: "TEL AVIV FASHION WEEK",
// 	    smlTitle: "Tel Aviv Fashion Week (TAFW)",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//fashionweektelaviv.com/">
// 												fashionweektelaviv.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Tel Aviv Fashion Week (TAFW)</h2>
// 							<p>
// 								Fashion events are always occasions for the celebration of elegance, imagination, creativity, and style. But the TAFW has been making its mark in the international fashion industry with its recent attention to changing ideals of beauty, featuring models, both male and female, of different ages, sizes, heights, colors, and religions. The 4-day event showcases uncommon displays from around the world and those close to home in and around Tel Aviv’s vibrant design scene.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/72/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								TAFW also embraces leading edge fashion concepts by exhibiting innovative uses of technology and textiles. And it’s especially proud of the support it provides to young designers. As in past editions, this 7th annual event will feature an Upcoming Designers show in which new talent will have an opportunity to share their wares with you!
// 							</p>
//                            <p>
// 								In 2019, Tel Aviv Fashion Week will once again take place in the historic Tachana complex. Formerly the final stop of the old Jaffa-to-Jerusalem railway, the station has been transformed into one of Tel Aviv’s coolest and most lively public spaces. Located in a trendy neighborhood of pastel-colored homes, unique boutiques, and numerous cafes, you’ll want to explore the entire area while you’re getting your vogue on at the TAFW!
// 							</p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 73,
// 	    bgImage:"/posts/bank/73/1.jpg",
// 	    mobBgImage:"/posts/bank/73/M.jpg",
// 	    title: "DGTL FESTIVAL",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://tlv.dgtl.nl/en/dgtl-tel-aviv-returns-to-israel/">

// 												tlv.dgtl.nl/en
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
//                             <p>After its stellar debut in Tel Aviv, DGTL Festival is back, bringing yet another excellent musical program to Yarkon Park, accompanied by the latest sustainable and technological innovations and fresh art projects.</p>

//                             <p>The DGTL festival is a global event at the forefront of the music and festivals scene, showcasing in an exclusive list of cities around the world: Amsterdam, Sao Paulo, Barcelona, Santiago and now Tel Aviv and bringing together the worlds of music, technology and art, as well as the latest discoveries in production and sound. </p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/73/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>The DGTL festival will be held in an expanded edition with a huge lineup and will include three stages which will operate simultaneously at any given moment.</p>
//                             <p>In addition to being an innovative music festival, DGTL champions environmental protection and sustainability and has won prizes for being the greenest festival in Europe. The festival has a revolutionary program for saving electricity, vegetarian food only, a recycling plan and more. </p>
//                             <p>The Festival will be held in the fabulous Yarkon Park in the heart of the buzzing city of Tel Aviv, a hub of innovation, trendiness and exciting nightlife scene, making it the host for DGTL. </p>
//                             <p>Come and get your groove on in the most cutting-edge festival on the planet, held in heart of the most exciting city in the world! </p>

// 					               `
// 			}
// 		}
//     },
//     {

//         id: 74,
// 	    bgImage:"/posts/bank/74/1.jpg",
// 	    mobBgImage:"/posts/bank/74/M.jpg",
// 	    title: "Tel Aviv Marathon",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											22.02.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>

// 											<a target="_blank" href="https://www.tlvmarathon.co.il/MenuDefault.aspx?id=5418">
// 												www.tlvmarathon.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                             <h2  class="ac-margin-bottom-20 ac-margin-top-20">Run and fun in the city that doesn’t stop</h2><br/>
//                             <p>Tel Aviv Marathon is the country’s biggest international sports event and a unique and exciting celebration for runners worldwide. The Marathon is held in the heart of the fabulous city of Tel Aviv, giving participants the opportunity to take in its awesome sites and views and feel their heart beat become one with the pulse of this adrenaline charged metropolis. </p>
//                             <p>The Tel Aviv Marathon is city wide celebration stretching along the stunning beachfront, the amazing sites of the white city - a UNESCO World Heritage Site, and the city’s many buzzing stylish streets, packed with over 150,000 people taking part in the many side events, cheering the runners along the race’s flat and friendly course.   </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/74/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>Around 40,000 runners come from far and wide to take part in this multi-course annual even. Allowing runners in all levels and styles, from professional long-distance runners to beginners, to take part.</p>
//                             <p>Much more than just a run, the marathon is in fact a huge festival featuring a host of dedicated lively events before and after the race, full of live music, dancing and many other attractions to the delight of runners and supporters alike.  </p>
//                             <p>Dubbed ‘The Mediterranean Capital of Cool’ By the New York Times and among Lonely Planet’s ‘Top 10 Action-Packed Cities’. Tel Aviv offers a host of fascinating attractions from all walks of life including dazzling stretches of golden beaches, colorful markets, cutting edge culture and entertainment, outstanding nightlife & an exciting culinary scene. </p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 75,
// 	    bgImage:"/posts/bank/75/1.jpg",
// 	    mobBgImage:"/posts/bank/75/M.jpg",
// 	    title: "Jerusalem Marathon",
// 	    smlTitle: "The Ultimate Race against time in this spectacular Marathon held in the 3,000-Year-old magnificent city of Jerusalem",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											15.03.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://jerusalem-marathon.com/Register.aspx">

// 												jerusalem-marathon.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                             <h2>The Ultimate Race against time in this spectacular Marathon held in the 3,000-Year-old magnificent city of Jerusalem</h2>
//                             <p>The International Jerusalem Winner Marathon is one of Israel's largest marathons, with 30,000 participants including hundreds of elite runners from Israel and around the world.</p>
//                             <p>The marathon offers a variety of tracks, from professional to family friendly, which pass by fascinating historical sites that illuminate 3,000 years of the history of Jerusalem, Israel's capital guaranteeing a challenging, thrilling and unforgettable experience for all runners. </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/75/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>With a series of cultural happenings planned around the central event, the Jerusalem International Marathon provides international runners with the perfect opportunity to visit the ancient city while participating in a truly modern and excitement-filled competitive sporting event. </p>
//                             <p>The Jerusalem marathon allows runners the chance to compete in a setting of unparalleled natural and cultural beauty unlike any other international marathon course. The topography of the city lends itself to a challenging route that will test even the most experienced of runners.</p>
//                             <p>The course takes the runner on a unique path through Jerusalem’s 3,000-year historical narrative, on the cobblestones of the ancient and holy walled city of Jerusalem and through the modern city center of Israel’s capital. The course includes the city’s best known sites including, among others, the Knesset, the Old City, Sultan's Pool, Mount Zion, the German Colony, the Jerusalem Promenade and the Mount of Olives.</p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 76,
// 	    bgImage:"/posts/bank/76/1.jpg",
// 	    mobBgImage:"/posts/bank/76/M.jpg",
// 	    title: "Bon Jovi",
// 	    smlTitle: "Bon Jovi are Back to take over the hot hot hot Tel Aviv Summer!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											HaYarkon Park, TLV
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											25.07.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.bonjovi.com/">

// 												bonjovi.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                             <h2>Bon Jovi are Back to take over the hot hot hot Tel Aviv Summer!</h2>

//                             <p>Bon Jovi, all-time favorites in Tel Aviv, are making their way back to the city, famed for its lively music scene once more to appear in the famous Yarkon Park, the beautiful green lung of the city.
//                             <p>Currently touring America to sold out venues, Bon Jovi will arrive here as part of a new European tour in the summer of 2019, entitled "This House is not for Sale". The tour is set will begin on May 31, 2019 in Moscow and will probably end on July 25, 2019 with their show in Tel Aviv.
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/76/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>The band, considered e one of the most successful American bands of all times has sold more than 100 million copies, performed in over 2700 concerts in 50 different countries to more than 34 million viewers worldwide.
//                             <p>This is not Bon Jovi's first stint in the city. The band gave a truly memorable performance about three years ago at the Hayarkon Park in Tel Aviv to 50,000 adoring fans, singing along to every lyric .
//                             <p>Those coming to see the band play in Tel Aviv are in for a special treat as they will get to experience Tel Aviv in July, the city’s summer finest,  sunbathe on the fabulous beaches, enjoy the awesome culinary options, take in  the epic hot night life and best of all see Bon Jovi raise it live on stage in the city that doesn’t stop!

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 77,
// 	    bgImage:"/posts/bank/77/1.jpg",
// 	    mobBgImage:"/posts/bank/77/M.jpg",
// 	    title: "TAG 2019",
// 	    smlTitle: "Tel Aviv Games are Back!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											TAG 2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											27-30.3.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.bonjovi.com/">
// 												www.telavivgames.org
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                            <h2>
//                             	Tel Aviv Games are Back!
//                           	 </h2>

//                             <p>
// 								Tel Aviv, declared one of the best gay travel destinations in the world, is joining a list of renowned capitals such as Paris, New York, Berlin and Rome, organizing its own LGBT multinational sports event – Tel Aviv Games – TAG2019. TAG 2019 offering the LGBT+ traveler a unique and exciting sports experience.
//                             </p>
//                             <p>
// 								With over 250 athletes from all over the world already signed up, and an estimated 500 more expected, Tel Aviv Games 2019 is anticipated to become the biggest LGBT+ Sports event in the middle east and one of the biggest in Europe.
//                             </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/77/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>
// 								LGBT+ athletes from more than 17 countries (including France, Germany, UK, US, Australia, Canada, Belgium, Czech Rep., Greece, Netherlands, Norway, Spain, Russia, Surnami and more) will come together for a 3-day multi-national celebration of participation, inclusion and personal best.
//                             </p>
//                             <p>
// 								The tournament will include individual and team events in 7 sporting categories: Swimming, Tennis, Basketball, Soccer, Volleyball, Same Sex Dance, and 5K and 10K Competitive Running.
//                             </p>
//                             <p>
// 								This year Tel Aviv Games will also introduce the city’s first ever “Pride Run - Running for the youth”, supporting Healthy LGBT+ Youth lifestyle in a 5K race along Tel Aviv’s beautiful shore.
// 							 </p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 78,
// 	    bgImage:"/posts/bank/100/1.jpg",
// 	    mobBgImage:"/posts/bank/100/M.jpg",
// 	    title: "Purim 2019",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv and Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											20-22.03.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.tel-aviv.gov.il/en/Pages/MainItemPage.aspx?WebID=9336473c-1537-4ab6-8a69-d299b5db8bcc&ListID=0ac6b290-896c-4fcb-bb36-0c5252101eff&ItemId=123">
// 												Tel Aviv Purim 2019
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                            <p>Every year in March, the people of Tel Aviv & Jerusalem dress up in costumes, the cities are a party and it’s all because of Purim – the most colorful and fun holiday of them all!
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/78/1.jpg"} class="img-responsive" />
// 							</div>

//                             <p>As expected, the party capital doesn’t disappoint, as there are tons of events to choose from – the annual street party is Tel Aviv’s biggest event. Thousands of dressed up people will gather together in “Kikar Hamedina” (State’s Square)  to enjoy performances from top musicians and dance together! The best part? It’s free of charge! If you won’t be too exhausted, you can also participate in Tel Aviv’s Zombie Walk. The name is self-explanatory, as the walk features hundreds of zombies walking through the streets of the city that never sleeps. Other events include Tel Aviv Street Party in Rothschild boulevard and many more.
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/78/2.jpg"} class="img-responsive" />
// 							</div>
//                             <p>If your prefer to spend the holiday in the city of gold, have no fear as there are plenty of events taking place across Jerusalem – from carnivals to parties there is something for everyone: The official Jerusalem Purim events is at Safra Square, featuring activities and performances for kids. Another option is the event at the Israel Museum that’s meant for the whole family. There’s also a Purim Rave Party at The Tower of David, the traditional parade at Nachlaot street, a party at Downtown Jerusalem building, a Purim party at the Shuka and more events to be confirmed!
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/78/3.jpg"} class="img-responsive" />
// 							</div>
//                             <p>So choose your costume and come celebrate with us!
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/78/4.jpg"} class="img-responsive" />
// 							</div>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: "J_Lo",
// 	    bgImage:"/posts/bank/J_Lo/1.jpg",
// 	    mobBgImage:"/posts/bank/J_Lo/M.jpg",
// 	    title: "J.LO",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Hayarkon Park
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											01.08.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
// 							<h2>
// 								J.LO HEADING TO TEL AVIV TO SET THE SUMMER ON FIRE!
// 							</h2>
// 							<p>
// 								Yes, it's true! after weeks of rumors flying around it is officially confirmed the J.Lo, AKA Jeniffer Lopes, AKA Jenny from the block, the hottest name worldwide as queen of pop for the past 2 decades, is coming to light up your summer in Tel Aviv!
// 							</p>
//                          <p>
// 								Performing for the first time in this country, J.Lo will be getting loud on the floor on August 1st at the Yarkon Park. The show, part of the maga star’s “It’s My Party” worldwide tour is expected to be one of the summer’s biggest concerts, along with Bon Jovi’s highly anticipated performance on the very same Tel Aviv stage on the 25th July.
// 							</p>
// 							<p>
// 								Hayarkon park is Tel Aviv’s green lung. This is the perfect place to get some respite after spending a wild night in Tel Aviv. Here you can spend the day cycling, walking or relaxing in the beautiful outdoor scenery and even enjoy flying high on a hot air balloon before heading to take your place in the stunning amphitheater. Whatever you choose, make sure to come packed with energy for J.Lo’s once in a lifetime performance in sunny awesome Tel Aviv!
// 							</p>
// 					               `
// 			}
// 		}
//     },

//     {

//         id: "Pride_Parade_2019",
// 	    bgImage:"/posts/bank/Pride_Parade_2019/1.jpg",
// 	    mobBgImage:"/posts/bank/Pride_Parade_2019/M.jpg",
// 	    title: "Pride Parade 2019",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											14.6.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
// 							<h2>
// 								The  most fabulous event of the Year
// 							</h2>
// 							<p>
// 								<strong>
// 									Tel Aviv 2019 Pride Celebrations – guaranteed to blow your mind!
// 								</strong>
// 							</p>
// 							<p>
// 								Tel Aviv, one of the most celebrated gay capitals in the world, is famous for its round the clock energy and extravagant nonstop parties. One of the biggest and hottest events, by far in the city is the ‘Gay Pride Week’ parties ending with the awesome Friday Pride Parade.
// 							</p>
//                          <p>
// 								The parade, a tradition which began as early as 1998, draws a huge crowd of the coolest people and thousands of participants from around the world. All them come together to celebrate and support freedom and embrace all lifestyles and genres in an open minded, off the charts, celebration.
// 							</p>
// 							<p>
// 								The parade is the highlight of a week of gay pride events which take place around the city of Tel Aviv and include pride-themed parties, exhibitions, movie festivals, music concerts and so much more.
// 							</p>
// 							<p>
// 								The parade itself takes place along the buzzing main streets of marvelous Tel Aviv, and features, in the tradition of pride parades from across the world, fantastic extravagant floats, live music, dance performances and revelers dressed in a colorful festival dress.
// 							</p>
// 							<p>
// 								The parade stops and rests at the stunning Tel Aviv promenade by the shores of the beautiful coastline, where it turns into an epic adrenaline-charged beach party featuring leading DJs and live performances, lasting well into the small hours of the night.
// 							</p>
// 							<p>
// 								The 2019 parade will take place on June 14th 2019 and participation, as always, will be completely free of charge.
// 							</p>
// 					               `
// 			}
// 		}
//     },

//     {

//         id: "Open_Restaurants_Jerusalem",
// 	    bgImage:"/posts/bank/Open_Restaurants_Jerusalem/1.jpg",
// 	    mobBgImage:"/posts/bank/Open_Restaurants_Jerusalem/M.jpg",
// 	    title: "Open Restaurants Jerusalem",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											19-23.11.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://open-restaurants.co.il/?lang=en">
// 												www.open-restaurants.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>

// 							<h2>
// 								Open Restaurants Jerusalem
// 							</h2>
// 							<p>
// 								Taking place in the iconic city of Jerusalem at varying hours, \‘Open Restaurants\’ is a unique culinary festival giving visitors a glimpse into the fascinating cultural and culinary diversity of Jerusalem.
// 							</p>
// 							<p>
// 								The festival includes about 100 different events held all over the city of Jerusalem, even in places which are less culinary oriented, as well as in culinary adequate venues and combine food with art, culture, innovation and technology.
// 							</p>
//                          <p>
// 								Festival-goers will also have a chance to participate in a series of meetings, workshops and lectures by prominent local personalities, and visits to the city\'s famous restaurant kitchens.
// 							</p>
// 							<p>
// 								As part of the festival program, day and night tours will be held at various culinary centers throughout Jerusalem including flavors tours in the Old City,Ein Kerem and more. You are encouraged to take at least one of them!
// 							</p>
// 							<p>
// 								In addition, FoodTalks meetings will be held with leading culinary experts (we can’t reveal who they are, so keep guessing…), photographers and chefs. The top hotels in Jerusalem will also collaborate with their private chefs at special prices.
// 							</p>
// 							<p>
// 								Whether you’re a foodie or just a curious visitor, you are sure to enjoy this unique taste of magical Jerusalem’s culinary side happening between the 19th -23rd , November,2019.
// 							</p>
// 					               `
// 			}
// 		}
//     },

//     {

//                   id: "Jerusalem_Beer_Festival",
// 	              bgImage:"/posts/bank/jerusalem-beer-festival/1.jpg",
// 	              mobBgImage:"/posts/bank/jerusalem-beer-festival/M.jpg",
// 	              title: "Jerusalem Beer Festival",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Time</h2>
// 											<div class="text">
// 												<p>
// 													18:00 – 00:00
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Даты</h2>
// 											<div class="text">
// 												<p>
// 													28 - 29.08.2019
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 	                                <p>The city of Jerusalem is proud to host, for the 15th(!) year in a row – the fabulous and hugely popular ‘Beer Festival’.</p>
// 	                                <p>The Jerusalem Beer Festival is an internationally recognized celebration of good music, good food and of course, you guessed it, great beer. </p>

// 	                                <p>Held in the magical 3000-year-old city of Jerusalem, the festival boasts an incomparable atmosphere, guaranteeing an unforgettable experience. </p>

// 	                                <p>The iconic festival has become over the years, a symbol of Jerusalem's entertainment culture and creates a unique opportunity for visitors from around the globe, to enjoy a delicious variety of cold beers, food and people in open air of Jerusalem.</p>

// 	                                <p>During the festival you will have the opportunity to taste any (or all) of the variety special flavors of beers from around the country and the world (and we have over 120 of them), served in pop up bars, built specifically for the festival. </p>
// 	                                <p>The Jerusalem Beer Festival is the only festival of its kind in Israel, hosting a huge variety of large and international beer brands every year alongside a distinguished presence of local breweries. </p>

// 	                                <p>So make your way and join more than 15,000 visitors coming to enjoy the unique atmosphere, the fantastic live shows, the great food and the awesome people, and to celebrate the global love of Beer.</p>
//                                     <a href="https://www.jerusalembeer.com/en" target="_blank" class="jerusalem-link">www.jerusalembeer.com</a>
// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "DGTL_Festival",
// 	              bgImage:"/posts/bank/dgtl-festival2019/1.jpg",
// 	              mobBgImage:"/posts/bank/dgtl-festival2019/M.jpg",
// 	              title: "DGTL FESTIVAL",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Город</h2>
// 											<div class="text">
// 												<p>
// 													Hayarkon Park Tel Aviv
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Даты</h2>
// 											<div class="text">
// 												<p>
// 													14.10.19
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Сайт</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://tlv.dgtl.nl/en/dgtl-tel-aviv-returns-to-israel/">

// 														www.tlv.dgtl.nl
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 							        <p>After its stellar debut in Tel Aviv, DGTL Festival is back, bringing yet another excellent musical program to the Yarkon Park, accompanied by the latest sustainable and technological innovations and fresh art projects.</p>

//                                    <p>The DGTL festival is a global event at the forefront of the music and festivals scene, showcasing in an exclusive list of cities around the world: Amsterdam, Sao Paulo, Barcelona, Santiago and now, Tel Aviv. DGTL brings together the worlds of music, technology and art, as well as the latest discoveries in production and sound.</p>
//                                    <p>The DGTL festival will be held in an expanded edition with a huge lineup and will include four stages which, will operate simultaneously at any given moment.</p>
//                                    <p>In addition to being an innovative music festival, DGTL champions environmental protection and sustainability and has won prizes for being the greenest festival in Europe. The festival has a revolutionary program for reducing electricity consumption, vegetarian food only, a recycling plan and more. </p>
//                                    <p>The Festival will be held in the fabulous Yarkon Park,  situated in the heart of the buzzing city of Tel Aviv. As a hub of innovation, trendiness and exciting nightlife scene, it is the perfect host for DGTL festival. </p>
//                                    <p>Come and get your groove on in the most cutting-edge festival on the planet, held in heart of the most exciting city in the world! </p>

// 	                            `
// 			}
// 		}
//     },

//     {
// 	              id: "The_International_Arts",
// 	              bgImage:"/posts/bank/international-arts/1.jpg",
// 	              mobBgImage:"/posts/bank/international-arts/M.jpg",
// 	              title: "The International Arts",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Город</h2>
// 											<div class="text">
// 												<p>
// 													Jerusalem
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Даты</h2>
// 											<div class="text">
// 												<p>
// 													12 - 24.08.2019
// 												</p>
// 											</div>
// 										</div>
// 									</div>

//                                     <h2>The International Arts and Crafts Festival 2019<br>
//                                     <small>Hutzot Hayotzer Jerusalem<small></h2>
//                                     <p>Jerusalem is packed with fantastic events throughout the summer. One of the most celebrated events is the colorful “Hutzot Hayotzer -International Art and Crafts Festival”. </p>
//                                     <p>This large-scale annual festival takes place in the Hutzot Hayotzer lane and the Sultan’s Pool, opposite the Tower of David and at the foot of the walls of the Old City. </p>
//                                     <p>The iconic Hutzot Hayotzer festival has been held for over 35 consecutive years. It has long since became a hugely popular tourist and artistic attraction for visitors from around the world. Visitors will enjoy more than 150 local artists who showcase their art including paintings, prints, ceramics, jewelry and more, as well as an international exhibition, showcasing the work of overseas artists.  They will be able to engage in fascinating art conversations and enjoy unique workshops, live performances, an Irish pub, huge sculptures, live Jazz music, all wrapped up in an authentic European carnival atmosphere. </p>
//                                     <p>The festival is open every evening (except Fridays) between 18:00 and 23:00 and on Saturday night from 21:00 until midnight, at the Hutzot Hayotzer, Mitchell Park and the Merrill Haasenfeld Amphitheater at the Sultan’s Pool.</p>
//                                     <p>Last but definitely not least, don’t miss the “Food around the world” - an Israeli and international food fair, which will include food stalls of various tastes from different world kitchens: Thai, Israeli, Chinese, Korean, and more.</p>
//                                     <a href="https://artfair-jer.com/english/" target="_blank" class="artfair-link">www.artfair-jer.com</a>
// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Jerusalem_Marathon",
// 	              bgImage:"/posts/bank/jer-marathon2019/1.jpg",
// 	              mobBgImage:"/posts/bank/jer-marathon2019/M.jpg",
// 	              title: "Иерусалимский марафон",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Город</h2>
// 											<div class="text">
// 												<p>
// 													Иерусалим
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Даты</h2>
// 											<div class="text">
// 												<p>
// 													20.03.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Сайт</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://jerusalem-marathon.com/default.aspx">

// 														jerusalem-marathon.com
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>

//                                     <div class="responisve-iframe">
// 									<iframe width="560" height="315" src="https://www.youtube.com/embed/7wMT5mKOwYk?autoplay=1&amp;controls=0&amp;loop=1&amp;rel=0&amp;playlist=7wMT5mKOwYk&amp;modestbranding=1&amp;autohide=1&amp;showinfo=0" frameborder="0" allowfullscreen=""></iframe>
// 									</div><br/>
//                                     <h2 class="ac-margin-bottom-20 ac-margin-top-20">Бег по городу, которому 3000 лет.</h2>
//                                     <p>Международный Иерусалимский марафон, в котором принимают участие 30 000 человек, в том числе сотни известных стайеров со всего мира - это фантастический праздник души и тела в самом сердце одного из самых чарующих городов мира.</p>

//                                      <p>Иерусалимский международный марафон предоставляет бегунам прекрасную возможность посетить знаменитый древний город, и одновременно, принять участие в самом современном и азартном спортивном соревновании. Кроме того, марафону будут сопутствовать многочисленные культурные мероприятия, организованные специально по этому случаю.</p>

//                                      <p>Маршруты многочисленных трасс иерусалимского марафона рассчитаны как на профессионалов, так и на любителей бега, от мала до велика. Вас ждут необыкновенные исторические памятники, улицы священного города-крепости и современный центр столицы Израиля. Вы познакомитесь с самыми знаменитыми достопримечательностями Иерусалима:  Старый город, бассейн Султана, гора Сион, здание Кнессета, Немецкая колония, Иерусалимский променад и Масличная гора. </p>

//                                      <p>Бегуны получат редкую возможность соревноваться на фоне уникального природного и архитектурного пейзажа, не похожего ни на одно место в мире. Сложная топография города станет увлекательным испытанием даже для наиболее опытных любителей бега. </p>
//                                      <p>Все это превратит ваше участие в Иерусалимском марафоне в захватывающее и незабываемое приключение!</p>

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Open_Houses_Festival",
// 	              bgImage:"/posts/bank/openhf/1.jpg",
// 	              mobBgImage:"/posts/bank/openhf/M.jpg",
// 	              title: "Open Houses Festival",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Город</h2>
// 											<div class="text">
// 												<p>
// 													Tel Aviv, City -Wide
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Даты</h2>
// 											<div class="text">
// 												<p>
// 													19 - 21.09.2019
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Сайт</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="//www.batim-il.org/DefaultEng.aspx?batim=">

// 														www.batim-il.org
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div><div class="clear"></div>
//                                     <h2>An amazing experience for design lovers everywhere</h2>
//                                     <p>This September, the nonstop city of Tel Aviv will be hosting for the 14th year, the fantastic ‘Open Houses’ Architecture and Design Festival. </p>

//                                     <p>The ‘Open Houses’ opens a one-time door to allow a glimpse into the forms of design, style of living, history, culture, technology, ecology and houses of added value that makes them intriguing and attractive</p>
//                                     <p>The event will include an exciting program of fascinating visits and tours to some of the most intriguing buildings in the city including private homes, apartments, historical as well as urban buildings. The Festival will also include special guided tours and attractions in unusual places -  from tours of residential apartments to tours of  new buildings. </p>
//                                     <p>Among the many buildings and structures open to the public, some of which have never been opened before are:  Tel-Aviv Velodrome, opened for the first time, a ship from within, a synagogue from 1840 in Old Jaffa and some fan favorites including the helipad on the Azrieli roof and a glimpse of the atomic shelter at Dizengoff Center. </p>
//                                      <p>"Open Houses” is part of the Open House World Wide's international organization, operating in New York, London, Chicago, Rome, Barcelona, Melbourne, Dublin, Helsinki, and more. </p>
//                                     <p>Be sure to check out what is guaranteed to be a unique and unforgettable urban celebration in the awesome city of Tel Aviv!</p>

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "TelAviv_Marathon",
// 	              bgImage:"/posts/bank/tlv-marathon2020/1.jpg",
// 	              mobBgImage:"/posts/bank/tlv-marathon2020/M.jpg",
// 	              title: "Тель-Авивский Марафон",
// 	              smlTitle: "",
// 	              html: function(){
// 			              return {
// 				              __html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Город</h2>
// 											<div class="text">
// 												<p>
// 													Тель-Авив
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Даты</h2>
// 											<div class="text">
// 												<p>
// 													28.02.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Сайт</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://www.tlvmarathon.co.il/MenuDefault.aspx?id=6607">

// 														www.tlvmarathon.co.il
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>

// 									<div class="responisve-iframe">
// 					                    <iframe width="560" height="315" src="https://www.youtube.com/embed/7wMT5mKOwYk" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 				                    </div><br/>
//                                     <h2 class="ac-margin-bottom-20 ac-margin-top-20">Бежать и кайфовать в городе без перерыва</h2>
//                                     <p>Тель-Авивский марафон – крупнейшее в стране международное спортивное событие, уникальный и захватывающий праздник для бегунов со всего мира. Марафон проводится в самом сердце сказочного города Тель-Авив, предоставляя его участникам возможность по ходу маршрута познакомиться с его удивительными достопримечательностями и видами, и почувствовать, как их сердца бьются в унисон с сердцем этого наполненного адреналином мегаполиса.</p>

//                                     <p>Около 40 тысяч бегунов приезжают со всех концов света, чтобы принять участие в этом ежегодном мероприятии, рассчитанном на все уровни и стили бега - от профессиональных бегунов на длинные дистанции до начинающих любителей бега. </p>

//                                     <p>Тель-Авивский марафон – это общегородской праздник, который проходит по прекрасной набережной, вдоль неповторимых мест Белого города – объекта всемирного наследия ЮНЕСКО, по оживленным колоритным улицам, где более 150 000 человек принимают участие во многих  мероприятиях, приуроченных к марафону, приветствуя бегунов на протяжении всего маршрута. Нелишне отметить, что рельеф всего маршрута марафона плоский и потому очень удобен для многокилометровой беговой дистанции. </p>

//                                     <p>Марафон – это еще и масштабный фестиваль, наполненный живой музыкой, танцами, многочисленными развлечениями и вечеринками, как для бегунов, так и для болельщиков.</p>

//                                     <p>«Нью-Йорк Таймс» назвал Тель-Авив «Самой потрясающей Средиземноморской столицей», а знаменитый путеводитель «Lonely Planet» поместил его в свой престижный список «Топ-10 самых активных городов». Тель-Авив предлагает множество развлечений на любой вкус и кошелек, здесь вас ждут ослепительные золотые пляжи, колоритные шумные рынки, кипящая ночная жизнь и незабываемый кулинарный опыт. </p>

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Night_Run_TelAviv",
// 	              bgImage:"/posts/bank/tlv-nightrun2019/1.jpg",
// 	              mobBgImage:"/posts/bank/tlv-nightrun2019/M.jpg",
// 	              title: "Night Run Tel Aviv",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											30.10.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.tlvnightrun.co.il/MenuDefault.aspx?id=6571">

// 												www.tlvnightrun.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <h2>The most exhilarating 10km you will ever experience</h2>
//                                     <p>A lot has been said about the world-renowned city of Tel Aviv. Named among Lonely Planet’s 'Top 10 Action-Packed Cities’, this city is a truly trendy buzzing metropolis that doesn’t rest. While its official slogan is the Non Stop City, it truly gives NYC a run for its money for the title the City that doesn’t sleep. </p>
//                                     <p>This is especially the case when it comes to the amazing Night Run Tel Aviv annual race. </p>
//                                     <p>With around 25,000 runners and tens of thousands of cheering spectators, this upbeat adrenaline-charged race is more of a full-blown night time party for the scores of participants and spectators who come from all around the world to take part.</p>
//                                     <p>Taking place during the autumn, the 10KM night run begins well after sundown and follows a fantastic urban route along the streets of Tel Aviv, starting at  Rabin Square in the center of town, and south along Rothschild Boulevard, before continuing along Dizengoff Street, Nordau Boulevard, and into Park Hayarkon, reaching the finish line alongside the river. </p>
//                                     <p>You will be passing all the trendy,, fascinating attractions and renowned Bauhaus architecture the "White City" of Tel Aviv has been declared a UNESCO World Heritage Site for. </p>
//                                     <p>Best of all, The TLV Night Run ends with a celebratory finish line festival at Hayarkon park in the heart of the city where thousands more come to join the runners and spectators in an all-night rager of music, dancing and nonstop fun.</p>

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Celine_Dion",
// 	              bgImage:"/posts/bank/Celine_Dion/1.jpg",
// 	              mobBgImage:"/posts/bank/Celine_Dion/M.jpg",
// 	              title: "Селин Дион",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											HaYarkon Park, Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											04.08.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.celinedion.com">

// 												www.celinedion.com

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <h2 class="ac-margin-bottom-20 ac-margin-top-20">Our Heart Goes On – for Celine Dion in Tel Aviv!</h2>
// 										<p>The Diva is coming! Now it’s official: Celine Dion will perform in Tel Aviv on August 4th of next summer and it’s going to be a hot one! This will be Dion’s first ever concert here, and boy are we excited.</p>

//                                         <p>The 6 Grammy award-winner will visit Tel Aviv, the city that never sleeps, to keep the party going all Night. Dion’s countless hits, “Because you Loved Me”, “Just Walk Away” and of course her all-time greatest hit – “My Heart Will Go On” – will hopefully make their debut live in Tel Aviv.</p>

//                                         <p>Tel Aviv has also hosted some of the largest art exhibitions, live shows and festivals, making it one of the liveliest cities in the world. With a combination of sun, rich nightlife scene, spectacular sights in every corner and the Dion’s first appearance – Tel Aviv is the place to be next summer.</p>

//                                         <p>Ticket sales have yet to open, but it’s never too early to start planning your next visit to Tel Aviv!

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Nickcave_Badseeds",
// 	              bgImage:"/Concerts/bank/nickcave_badseeds/1.jpg",
// 	              mobBgImage:"/Concerts/bank/nickcave_badseeds/M.jpg",
// 	              title: "NICK CAVE & BAD SEEDS",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Bloomfield Stadium, Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											17.06.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">

// 												Update Soon

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <h2 class="ac-margin-bottom-20 ac-margin-top-20">NICK CAVE AND THE BAD SEEDS LIVE IN TEL AVIV!</h2>
//                                     <p>Nick Cave is coming to Tel Aviv to blow the roof off! Returning to the city that never sleeps in June 2020, the Australian pop-punk musician is coming to rock you.</p>

//                                     <p>Having recorded no less than 17 studio albums with his band, the talented musician is excited about his visit – which will be hotter than ever.</p>

//                                     <p>Coming back just a little more than two years after his previous performance here, this time, lighting up the newly renovated Bloomfield Stadium (which has hosted a long line of international artists). Judging by the last performance, this one should be truly sensational.</p>

//                                     <p>Tel Aviv has been known to attract and feature some of the biggest names in the world, making it one of the hottest cities when it comes to live concerts and the nightlife scene. This performance shouldn’t be any different and is a great opportunity to catch Nick Cave live, as part of his summer tour.</p>

//                                     <p>Warm summer nights, soft sand beaches and the mesmerizing music of a world-renowned artist – what more could you ask for? Tel Aviv has it all!</p>

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Louis_CK",
// 	              bgImage:"/posts/bank/Louis_CK/1.jpg",
// 	              mobBgImage:"/posts/bank/Louis_CK/M.jpg",
// 	              title: "He’s coming back! Louis CK in Tel Aviv",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Hangar 11, Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											23.11.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.facebook.com/events/%D7%A4%D7%99%D7%A1-%D7%90%D7%A8%D7%A0%D7%94-%D7%9E%D7%9C%D7%97%D7%94-%D7%99%D7%A8%D7%95%D7%A9%D7%9C%D7%99%D7%9D/%D7%9C%D7%95%D7%90%D7%99%D7%A1-%D7%A1%D7%99-%D7%A7%D7%99%D7%99-%D7%91%D7%94%D7%95%D7%A4%D7%A2%D7%94-%D7%91%D7%99%D7%A9%D7%A8%D7%90%D7%9C-louis-ck-live-in-israel/554683431359536/">

// 												Louis CK

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <p>Back for the second time, Louis CK will preform at the Hangar 11 in Tel Aviv, this upcoming November.</p>

//                                     <p>After his tremendous success in Jerusalem in 2016, Louis CK is about to return for another exclusive show; this time, right here in Tel Aviv, one of the hottest cities for live shows.</p>

//                                     <p>The talented, hilarious comedian is back in action after a two-year break making this show, bigger, better and funnier than ever. Having a wide following audience in Tel Aviv alone, the sharp comedian is sure to light up the stage.</p>

//                                     <p>Tel Aviv has hosted dozens of comedians from all over the world, including Jerry Seinfeld and Chris Rock, Jim Jefferies and many others, is the ultimate city for having a good time. The city is known for its art and culture as well as its exciting club scene and trendy bars and restaurants.</p>

//                                     <p>So book your trip now and get ready for an unforgettable time in the city that doesn’t stop!</p>
// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Cycle_Tel_Aviv",
// 	              bgImage:"/Concerts/bank/cycle-tlv-2019/1.jpg",
// 	              mobBgImage:"/Concerts/bank/cycle-tlv-2019/M.jpg",
// 	              title: "Cycle Tel Aviv",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											All Around Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											18.10.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <p>The mild to warm October weather, combined with the energetic vibe of Tel Aviv, provide the perfect setting for the biggest cycling event in the country.</p>

//                                     <p>Thousands of cycling enthusiasts flock to Tel Aviv to ride through the vibrant city, on a scenic course showing you everything Tel Aviv has to offer:</p>

//                                     <p>From the beautiful Yarkon Park, along the coast, past the city’s many dazzling beaches and back up to the park through the city center, you’ll get a glimpse of every characteristic place, the “Mediterranean capital” has to offer.</p>

//                                     <p>Everyone can experience the thrill and excitement of the event, from the 60 km course for professional riders to the 8 km course for families and beginners, there is even a rollerblades course for those who prefer to make their way through the city on foot.</p>

//                                     <p>With the locals coming out in droves to cheer on the event, you’ll see a colorful and diverse crowd, adding to the fun and excitement in the air.</p>

//                                     <p>Whether you’re looking for a personal challenge to compete against some of the top riders in the country, or you’re hoping to enjoy a family day out with the crowds, you’re sure to experience the beauty and energy that makes up the unique atmosphere of Tel Aviv.</p>
// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "DGTL_Festival_2020",
// 	              bgImage:"/posts/bank/dgtl-festival2019/1.jpg",
// 	              mobBgImage:"/posts/bank/dgtl-festival2019/M.jpg",
// 	              title: "Фестиваль DGTL",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Город</h2>
// 											<div class="text">
// 												<p>
// 													Парк Ха-Яркон в Тель-Авиве
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Даты</h2>
// 											<div class="text">
// 												<p>
// 													08.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Сайт</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://tlv.dgtl.nl/en/dgtl-tel-aviv-returns-to-israel/">

// 														www.tlv.dgtl.nl
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>

//                                     <p>Фестиваль DGTL возвращается! </p>
// 									<p>Мы приглашаем вас в парк Ха-Яркон, чтобы своими глазами увидеть и принять участие в удивительном музыкальном представлении, в рамках которого будут использованы последние технологические достижения, а также представлены современные проекты в области искусства.</p>

// 									<p>Стоит отметить, что фестиваль DGTL является известным международным событием, которое проводится в избранных городах по всему миру: Амстердам, Сан-Паулу, Барселона, Сантьяго, а теперь и Тель-Авив объединяют мир музыки, технологий и искусства, предлагая своим гостям новейшие технологические достижения в сфере качественного звука и современной обработки. </p>
// 									<p>Фестиваль DGTL будет проходить в расширенном формате с большим количеством приглашенных гостей, поэтому одновременно будут работать четыре сцены. </p>
// 									<p>Помимо того, что DGTL является инновационным музыкальным фестивалем, он считается одним из ключевых мероприятий в области охраны окружающей среды и устойчивого развития. Кроме того, фестиваль DGTL неоднократно получал почетное звание самого зеленого фестиваля в Европе. Фестиваль предлагает революционную программу в сфере экономии электроэнергии, использования вегетарианской пищи, утилизации, а также ряд других важных решений, которые позволят сохранить нашу планету. </p>
// 									<p>Стоит отдельно отметить, что сам фестиваль проводится во всемирно известном парке Ха-Яркон, расположенном в самом центре Тель-Авива, который считается одним из крупнейших мегаполисов, а также главным центром инновационного развития, современных технологий и ночной жизни. Именно поэтому Тель-Авив был выбран для проведения фестиваля DGTL. </p>
// 									<p>Приходите и получите заряд энергии, приняв участие в самом инновационном фестивале на планете, оказавшись в сердце самого захватывающего города в мире! </p>

// 	                            `
// 			}
// 		}
//     },

//     {

//         id: "Pride_Week_2020",
// 	    bgImage:"/posts/bank/Pride_Parade_2019/1.jpg",
// 	    mobBgImage:"/posts/bank/Pride_Parade_2019/M.jpg",
// 	    title: "Pride Week 2020",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Тель-Авив
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											12.6.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
// 							<div class="responisve-iframe">
// 					             <iframe width="560" height="315" src="https://www.youtube.com/embed/U8KwXVP3Xng" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 				             </div>
// 				             <div class="ac-cradit" style="margin-top: -15px;margin-bottom: 40px;">
// 							<span class="ac-cradit-text">Credits:</span>

// 								<span class="ac-cradit-text-1"><a href="https://www.youtube.com/channel/UCWN-mUP4IzdHLH7gaXHEKVw" target="_blank">Basti Hansen</a><br/>
// 							</div>
// 							<p></p>
// 							</div>

//                             <h2 class="ac-margin-bottom-20 ac-margin-top-20">The  most fabulous event of the Year</h2>
//                             <p class="ac-align-center"><strong>Tel Aviv 2020 Pride Celebrations – guaranteed to blow your mind!</strong></p>
//                             <p>Tel Aviv, one of the most celebrated gay capitals in the world, is famous for its round the clock energy and extravagant nonstop parties, but by far one of the biggest and hottest events in the city are the Gay Pride Week festivities culminating in the awesome Friday Pride Parade. </p>
//                             <p>The parade, a tradition which began as early as 1998 draws a huge crowd of the coolest people from around the world who come together to celebrate and support freedom and the embracing of all lifestyles and genres in an open-minded off the charts celebration.</p>
//                             <p>The parade is the highlight of a week of gay pride events that take place around the city and include nonstop pride-themed parties, exhibitions, movie festivals, music concerts and so much more. </p>
//                             <p>The parade itself takes place along the buzzing main streets of amazing Tel Aviv, and features, in the tradition of pride parades from across the world, fantastic floats, live music, dance performances and revelers dressed in a colorful festival dress.</p>
//                             <p>The parade culminates at the stunning Tel Aviv promenade by the shores of the beautiful Tel Aviv coastline where it turns into an epic adrenaline-charged beach party featuring leading DJs and live performances, lasting well into the small hours of the night.  </p>
//                             <p>The 2020 parade will take place on June 12th 2020 and participation, as always, will be completely free of charge. </p>

// 					               `
// 			}
// 		}
//     },

//     {
// 	              id: "Hutzot_Hayotzer_Jerusalem_2020",
// 	              bgImage:"/posts/bank/international-arts/1.jpg",
// 	              mobBgImage:"/posts/bank/international-arts/M.jpg",
// 	              title: "Хуцот Ха-Йоцер в Иерусалиме",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Город</h2>
// 											<div class="text">
// 												<p>
// 													Бассейн Султана, Иерусалим
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Даты</h2>
// 											<div class="text">
// 												<p>
// 													08.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 							        <div class="clear"></div>

//                                     <h2 class="ac-margin-bottom-20 ac-margin-top-20">Международный фестиваль декоративно-прикладного искусства </h2>
//                                     <p>Иерусалим буквально переполнен фантастическими событиями в течение всего лета, но одним из самых известных событий является красочный Международный фестиваль искусств и ремесел Хуцот Ха-Йоцер. </p>
// 									<p>Этот масштабный ежегодный фестиваль проходит в районе Хуцот Ха-Йоцер и Бассейна Султана, прямо напротив Башни Давида и у подножия стен старого города. </p>
// 									<p>Культовый фестиваль Хуцот Ха-Йоцер проводится более 35 лет подряд и стал чрезвычайно популярным среди туристов и поклонников современного искусства со всего мира.</p>
// 									<p>В фестивале принимают участие более 150 местных художников, которые демонстрируют свое искусство, включая картины, гравюры, керамику, ювелирные изделия и многое другое. Кроме того, фестиваль включает в себя международную выставку, демонстрирующую работы зарубежных художников.</p>
// 									<p>Посетители могут погрузиться в увлекательный мир искусства и насладиться уникальными мастер-классами, живыми выступлениями, ирландским пабом, огромными скульптурами, живой джазовой музыкой в аутентичной атмосфере европейского карнавала. </p>
// 									<p>Фестиваль открывается каждый вечер (кроме пятницы) и работает с 18:00 до 23:00. Кроме того, в субботу он работает для гостей с 21:00 и до полуночи. Фестиваль проходит в районе Хуцот Ха-Йоцер, парке Митчелла и амфитеатре Меррилл Хассенфельд недалеко от бассейна Султана.</p>
// 									<p>Обязательно посетите израильскую и международную гастрономическую ярмарку "Еда со всего света", в рамках которой будут работать представители разных стран, чтобы вы могли насладиться кулинарными шедеврами со всего света: вас ждут блюда </p>

// 	                            `
// 			}
// 		}
//     },

//     {

//                   id: "Jerusalem_Beer_Festival_2020",
// 	              bgImage:"/posts/bank/jerusalem-beer-festival/1.jpg",
// 	              mobBgImage:"/posts/bank/jerusalem-beer-festival/M.jpg",
// 	              title: "Иерусалимский фестиваль пива",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Время</h2>
// 											<div class="text">
// 												<p>
// 													18:00 – 00:00
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Даты</h2>
// 											<div class="text">
// 												<p>
// 													08.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>
// 							        <p>Иерусалим с гордостью принимает 16-й Фестиваль пива, который прославился по всему миру и обрел невиданную популярность среди местных жителей. </p>
// 									<p>Иерусалимский фестиваль пива - это всемирно известный праздник хорошей музыки, качественной еды и, как вы уже догадались, отличного пива. </p>

// 									<p>Фестиваль проводится в волшебном городе Иерусалим, который насчитывает более трех тысяч лет истории и отличается непревзойденной атмосферой, гарантирующей незабываемые впечатления. </p>

// 									<p>Культовый фестиваль стал символом развлекательной культуры Иерусалима и создает уникальную возможность для посетителей со всего мира насладиться разнообразием превосходного холодного пива, еды, а также пообщаться и завести новые знакомства под открытым небом Иерусалима.</p>

// 									<p>Во время фестиваля у вас будет возможность попробовать любой (или даже все) из более чем 120 сортов пива со всех уголков страны и мира, которое продается в особых мобильных барах, построенных специально для фестиваля. </p>
// 									<p>Иерусалимский фестиваль пива является единственным в своем роде фестивалем в Израиле. В рамках фестиваля выставляется как продукция всемирно известных брендов и торговых марок, так и пиво, произведенное небольшими пивоварнями. </p>

// 									<p>Приглашаем вас присоединиться к 15 000 гостей, которые приезжают сюда, чтобы насладиться уникальной атмосферой, фантастическими живыми шоу, отличной едой, а также показать свою любовь к пиву, получив возможность общения с удивительными людьми.</p>

// 	                            `
// 			}
// 		}
//     },

//     {

//         id: "Jerusalem_Wine_Festival_2020",
// 	    bgImage:"/Concerts/bank/jer-wine-festival-2020/1.jpg",
// 	    mobBgImage:"/Concerts/bank/jer-wine-festival-2020/M.jpg",
// 	    title: "Иерусалимский фестиваль вина",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Иерусалим
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											08.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.imj.org.il/en/events/wine-festival-1">
// 												www.imj.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/69/1.jpg"} class="img-responsive" />
// 							</div><br/>

// 							<h2 class="ac-margin-bottom-20 ac-margin-top-20">Лучшие вина в священном городе!</h2>
//                             <p>Расслабляющие летние вечера были созданы специально для того, чтобы вы могли насладиться бокалом изысканного вина! В течение четырех дней в августе вы можете насладиться лучшими сортами вин, отобранными в ходе 16-го ежегодного фестиваля JWF. </P>
// 							<p>Обратите внимание, что фестиваль JWF проходит в прекрасном японском саду израильского музея искусств, и по праву считается главным светским мероприятием Иерусалима. Вас ждет не похожий ни на что другое фестиваль, который создает уникальное сочетание атмосферы и потрясающих видов на исторический город.</P>
// 							<p>Сотни сортов вин будут подаваться десятками известных и небольших виноделен. Вы сможете продегустировать вино, а также посетить кулинарный оазис, где вас встретит радушный персонал, а также сыры, шоколад, оливковое масло, отменные соусы и вкусное варенье. Кстати, нельзя забывать и о том, что каждый вечер будет начинаться двумя музыкальными концертами в разных стилях.</P>
// 							<p>Каждый год JWF посещают более 20 000 гостей и любителей вина из самых разных уголков планеты. Все они направляются в Иерусалим только ради участия в JWF. Многие посещают JWF несколько дней подряд только для того, чтобы вновь окунуться в эту уникальную атмосферу. </P>
// 							<p>Более того, некоторые строят свои планы с учетом расписания мероприятий фестиваля JWF. Мы уверены в том, что ваша поездка будет насыщена достопримечательностями, приятными покупками и множеством освежающих прогулок. Идеальный способ расслабиться после загруженных дней - это провести несколько веселых вечеров на фестивале вина в Иерусалиме!</P>

// 					     `
// 			}
// 		}
//     },

//     {

// 	              id: "Open_Houses_Festival_2020",
// 	              bgImage:"/posts/bank/openhf/1.jpg",
// 	              mobBgImage:"/posts/bank/openhf/M.jpg",
// 	              title: "Фестиваль \"Открытые дома\"",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Город</h2>
// 											<div class="text">
// 												<p>
// 													Тель-Авив
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Даты</h2>
// 											<div class="text">
// 												<p>
// 													09.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Сайт</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="//www.batim-il.org/DefaultEng.aspx?batim=">

// 														www.batim-il.org
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div><div class="clear"></div>

//                                     <h2 class="ac-margin-bottom-20 ac-margin-top-20">Удивительное мероприятие для любителей дизайна </h2>
//                                     <p>В этом году в Тель-Авиве - городе, который никогда не спит, пройдет 14-й по счету фестиваль архитектуры и дизайна "Открытые дома". </p>
// 									<p>Это необычное мероприятие включает в себя увлекательную программу экскурсий и прогулок по некоторым из самых невероятных зданий в городе, включая частные дома, квартиры, исторические здания и городские сооружения. Вы сможете посетить жилые дома, квартиры и новые строения. Кроме того, в рамках фестиваля будут проводиться специальные экскурсии, в ходе которых вы сможете посетить лучшие достопримечательности и самые необычные места в городе.</p>
// 									<p>Фестиваль "Открытые дома" раздвигает границы и позволяет заглянуть в дома местных жителей, открывая историю, культуру, технологии, экологию и местные традиции, что делает его особенно чарующим и привлекательным.</p>
// 									<p>Среди многих зданий и строений, открытых для посещения, стоит выделить несколько фаворитов: Тель-авивский велодром, который будет открыт для общественности в первый раз, синагогу 1840 года в старом Яффо, а также такие избранные места, как вертолетная площадка на крыше Центра Азриэли и бомбоубежище в Центре Дизенгофа. </p>
// 									<p>Фестиваль "Открытые дома" является одним из проектов международной организации Open House World Wide, которая работает в Нью-Йорке, Лондоне, Чикаго, Риме, Барселоне, Мельбурне, Дублине, Хельсинки и других городах.</p>
// 									<p>Обязательно примите участие в этом событии! Фестиваль "Открытые дома"</p>
// 									<p>гарантированно станет самым незабываемым мероприятием, которое вы можете посетить в рамках своего путешествия в Тель-Авиве!</p>

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Purim_2020",
// 	              bgImage:"/Concerts/bank/purim2020/1.jpg",
// 	              mobBgImage:"/Concerts/bank/purim2020/M.jpg",
// 	              title: "Пурим 2020",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Город</h2>
// 											<div class="text">
// 												<p>
// 													Тель-Авив и Иерусалим
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Даты</h2>
// 											<div class="text">
// 												<p>
// 													09-10.03.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									</div><div class="clear"></div>

// 		                            <p>Каждый год в марте в Тель-Авиве и Иерусалиме проходит фестиваль, во время которого люди наряжаются в костюмы, а в городах проходят костюмированные вечеринки. Речь конечно идет о Пуриме - самом красочном и веселом празднике на свете!
// 									</p>
// 									<div class="img-wrapper">
// 												<img src=${getImgUrl() + "/Concerts/purim2020/1.jpg"} class="img-responsive" />
// 											</div>

// 		                            <p>Мы уверены в том, что "город без перерыва" не разочарует вас. Вы сможете насладиться сотнями мероприятий, которые проводятся в рамках фестиваля Пурим - крупнейшего события Тель-Авива. Тысячи разодетых людей соберутся вместе на площади Ха-Медина, чтобы насладиться выступлениями лучших музыкантов! </p>
// 		                            <div class="img-wrapper">
// 												<img src=${getImgUrl() + "/Concerts/purim2020/2.jpg"} class="img-responsive" />
// 											</div>
// 		                            <p>Что будет самым интересным? Всё будет совершенно бесплатно! Если вы не устанете от суматохи в течение дня, примите участие в шествии зомби по улицам Тель-Авива. Название шествия говорит само за себя. Тысячи людей переодеваются в зомби и отправляются в шествие по городу, который никогда не спит. Среди других событий стоит выделить уличную вечеринку на бульваре Ротшильда и многое другое.</p>
// 		                            <div class="img-wrapper">
// 												<img src=${getImgUrl() + "/Concerts/purim2020/4.jpg"} class="img-responsive" />
// 											</div>
// 		                            <p>Если вы хотите провести свой отпуск в Золотом Иерусалиме, это отличное время для того, чтобы посетить один из самых знаменитых городов в мире. По всему Иерусалиму проходит множество мероприятий: от карнавалов до вечеринок. </p>
// 		                            <p>Официальные мероприятия Пурима проходят на площади Сафра, где проводятся праздники и представления для детей. Еще один вариант провести праздничные дни - это мероприятие в Израильском музее, которое предназначено для всей семьи. </p>
// 		                            <p>Кроме того, вас ждет рейв-вечеринка в Башне Давида, традиционный парад на улице Нахлаот, вечеринка в старом центре Иерусалима, Пурим-вечеринка на иерусалимском рынке и другие мероприятия, полный перечень которых будет известен позднее.</p>
// 		                            <p>Так что подберите себе костюм и приходите праздновать с нами!</p>

// 	                            `
// 			}
// 		}
//     },

//     {

//         id: "TelAviv_Fashion_Week_2020",
// 	    bgImage:"/Concerts/bank/fashion-week-2020/1.jpg",
// 	    mobBgImage:"/Concerts/bank/fashion-week-2020/M.jpg",
// 	    title: "Тель-авивская неделя моды",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Тель-Авив
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											03.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//fashionweektelaviv.com/">
// 												fashionweektelaviv.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2 class="ac-margin-bottom-20 ac-margin-top-20">C'est chic, magnifique!</h2>
//                             <!--<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/72/1.jpg"} class="img-responsive" />
// 							</div>-->
//                             <p>Модные события - это праздник элегантности, воображения, творчества и стиля. Тем не менее, Тель-авивская неделя моды TAFW оставляет свой след в международной индустрии моды, обращая внимание на изменение идеалов красоты, показывая моделей (как мужчин, так и женщин) разных возрастов, размеров, высоты, рас и религий. </p>
// 							<p>Мероприятие, которое продлится четыре дня, демонстрирует самые интересные новшества в мире моды, авторы которых также будут находиться в Тель-Авиве, чтобы окунуться в атмосферу этого удивительного мероприятия.</p>
// 							<p>Тель-авивская неделя моды показывает передовые достижения в мире моды, активно используя новые технологии и варианты тканей. Организаторы мероприятия особо гордятся тем, какую поддержку они оказывают начинающим дизайнерам. Как и в прошлые годы, в рамках 7-й недели моды в Тель-Авиве будет проведено шоу начинающих дизайнеров, в рамках которого молодые таланты получают возможность показать свои творения широкой аудитории!</p>
// 							<p>В 2020 году тель-авивская неделя моды вновь пройдет в историческом комплексе Ха-Тахана. Когда-то это место было конечной остановкой старой железной дороги Яффо-Иерусалим. Позднее вокзал был преобразован в одно из самых крутых и оживленных общественных пространств Тель-Авива. Это место расположено в модном районе среди уникальных бутиков и многочисленных кафе. Вы обязательно захотите изучить весь район, одновременно получая удовольствие от Недели моды в Тель-Авиве!</p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: "The_Jerusalem_March_2020",
// 	    bgImage:"/Concerts/bank/jerusalem-march/1.jpg",
// 	    mobBgImage:"/Concerts/bank/jerusalem-march/M.jpg",
// 	    title: "Иерусалимский марш",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Иерусалим
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											30.09.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
// 							<p>Проходящий в октябре иерусалимский марш по праву считается одним из самых красочных и захватывающих событий в городе, собирая десятки тысяч участников со всего мира.</p>
// 								<p>Иерусалимский марш включает в себя три мероприятия: утреннюю прогулку по природным тропам, встречу в парке Сакер и праздничный парад, который проходит на улицах в центре Иерусалима.</p>
// 								<p>Для того, чтобы гарантировать возможность участия всем желающим, город предлагает множество маршрутов с разной длиной и уровнем сложности. </p>
// 								<p><strong>Утренние маршруты</strong><br/>
// 								<u>Маршрут А</u>: для тех, кто предпочитает ходить пешком, около 12 км (с 07:00 до 09:00)</p>
// 								<p><strong>От Арсенальной горки до парка Захер</strong><br/>
// 								<u>Маршрут B</u>: средний уровень сложности, около 9 км (с 07:30 до 09:30)</p>
// 								<p><strong>От горы Скопус до парка Сакер</strong><br/>
// 								<u>Маршрут C</u>: легкий уровень сложности (для семей), около 4 км (с 08:00 до 10:00)</p>
// 								<p><strong>От площади Сафра до парка Сакер.</strong><br/>
// 								Фестиваль в парке Сакер </p>
// 								<p>С 10 до 16 часов на территории парка Сакер проводятся праздничные мероприятия, выступления, концерты живой музыки, а также представления для детей, организованные в отдельной части парка. </p>
// 								<p>Праздничный парад начнется в 15:00 и пройдет по улицам Бецалель, Хиллель и улице Короля Давида. Маршрут закончится рядом с парком Ха-Паамон, в котором будут представлены коллекционные автомобили, а также выступят музыкальные группы из Израиля и других стран. Вас ждут выступления различных оркестров, танцевальных групп, солдатов Армии обороны Израиля и многое другое.</p>
// 								<p>Не упустите свой шанс принять участие в этом прекрасном празднике в Иерусалиме! </p>

// 				`
// 			}
// 		}
//     },

//     {

//         id:"The_Pixies_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Pixies",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 										    Тель-Авив
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											14.07.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.pixiesmusic.com">
// 											www.pixiesmusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>

// 							<h2 class="ac-margin-bottom-20 ac-margin-top-20">The Pixies возвращаются, чтобы раскачать Тель-Авив!</h2>

// 										<p>Никто не ставит под сомнение то, что летом в Израиле очень жарко, но мы хотим сообщить, что группа The Pixies возвращается в Тель-Авив, спустя целых 3 года, и это будет настоящая жара!</p>
// 										<p>Знаменитая американская группа, известная своим фирменным стилем и смешением агрессивного панк-рока и поп-музыки, стала автором нескольких действительно культовых композиций в истории музыки. Самой известной работой стала песня "Where is my mind". The Pixies возвращаются в Тель-Авив в третий раз в рамках промо-тура для своего нового альбома "Beneath The Eyrie". </p>
// 										<p>Группа The Pixies даст один концерт в Тель-Авиве - городе, который никогда не спит. Концерт The Pixies - это уникальная возможность разбавить ваш пляжный отдых и от души повеселиться. </p>
// 										<p>Концерт состоится в июле, поэтому вы сможете насладиться знаменитым Тель-Авивским летом, наполненным вечеринками, удивительной гастрономией и потрясающими пляжами. </p>
// 										<p>Билеты распродаются быстро, так что поторопитесь сделать бронь и распланировать вашу поездку уже сегодня!  </p>

// 						`
// 			}
// 		}
// 	},

// 	{

//         id:"White_Night_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Белая ночь",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Тель-Авив
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											06.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>

//                                             <div class="responisve-iframe">
// 												<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 											</div><br/>
// 											<h2 class="align-center ac-margin-bottom-20 ac-margin-top-20">
// 											    "Белая ночь" в городе, который никогда не спит!
// 											</h2>
//                                             <p>Когда в городе, который никогда не спит, проходит такое мероприятие как "Белая ночь", вы просто не можете его не посетить. "Белая ночь" - одно из крупнейших событий года в Тель-Авиве. "Белая ночь" считается традиционным праздником, который заставляет Тель-Авив шуметь целую ночь напролет, пока вы наслаждаетесь сказочным отдыхом и получаете незабываемые впечатления.</p>
//                                             <p>С раннего вечера и до рассвета город наполняется туристами и местными жителями, которые ценят жизнь и наслаждаются отдыхом. Вы сможете посетить лучшие магазины, кафе, рестораны и культурные мероприятия совершенно бесплатно или по сниженной цене. К тому же, все заведения работают до раннего утра!</p>

// 											<div class="img-wrapper">
// 								                <img src=${getImgUrl() + "/Concerts/60/1.jpg"} class="img-responsive" />
// 								                <small>
// 												Автор фото: Адам Праймер
// 											</small>
// 							                </div>

// 											<p>Начало этого всемирно известного мероприятия было положено в 2003 году, в котором организация ЮНЕСКО признала "Белый город" в Тель-Авиве объектом культурного наследия. Это решение придало особый статус архитектурным строениям в стиле Баухаус, которые стали неотъемлемой частью облика современного города.</p>
//                                             <p>С тех пор это историческое событие отмечается в Тель-Авиве и Яффо серией вечеринок, получивших название в честь "Белого города" и уникального статуса Тель-Авива, который называют "городом, который никогда не спит".</p>

// 											<div class="img-wrapper">
// 								                <img src=${getImgUrl() + "/Concerts/60/2.jpg"} class="img-responsive" />
// 								                <small>
// 												Автор фото: Кфир Сиван
// 											</small>
// 							                </div>

// 											<p>Белая ночь - это череда многочисленных мероприятий, которые охватывают весь город. Многим кажется, что его границы расширяются с каждым годом. В последние годы празднование включало в себя (мы приводим лишь несколько примеров): уникальный полуночный пикник, удивительную вечеринку в наушниках на главной площади города, бесчисленные концерты живой музыки, удивительные представления, а также уличные театры, увлекательные ночные экскурсии, ночные спортивные тренировки, йогу на рассвете и, конечно же, бесчисленные вечеринки, которые проходят всю ночь по всему городу. </p>
// 											<div class="img-wrapper">
// 								                <img src=${getImgUrl() + "/Concerts/60/3.jpg"} class="img-responsive" />
// 								                <small>
// 												Автор фото: Мошик Линденбаум
// 											</small>
// 							                </div>

// 											<p>Поэтому хорошенько отдохните! Вам потребуется мощный заряд энергии, чтобы пережить "Белую ночь" в незабываемом Тель-Авиве! </p>

// 											<div class="img-wrapper">
// 								                <img src=${getImgUrl() + "/Concerts/60/4.jpg"} class="img-responsive" />
// 								                <small>
// 												Автор фото: Гай Йехиэли
// 											</small>
// 							                </div>

// 						`
// 			}
// 		}
// 	},

// 	{

//         id:"Piano_Competition_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Международный конкурс пианистов имени Рубинштейна 2020",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											05-21.05.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://arims.org.il/">
// 											www.arims.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<p>Международный конкурс пианистов имени Рубинштейна 2020.<br/>
// 							В Тель-Авиве нет недостатка в масштабных мероприятиях в области искусства и культуры, но Международный конкурс им. Рубинштейна - это настоящее событие в культурной жизни города.</p>
// 							<p>39 чрезвычайно талантливых исполнителей были номинированы для участия в 16-ом Международном конкурсе пианистов имени Артура Рубинштейна. 15 участников прибудут на конкурс из Азии, 10 из Восточной Европы, 7 из Европы, 2 музыканта из Грузии, 2 из США. Порадуют своими выступлениями и 3 израильских исполнителя. Тель-Авив с радостью примет гостей культурной столицы.  </p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/piano-competition-2020/1.jpg"} class="img-responsive" />
// 							</div>

//                             <p>Первые два этапа этого престижного конкурса пройдут в Тель-Авивском художественном музее, одном из ведущих художественных и культурных учреждений страны. Всего в 10 минутах ходьбы от музея находится крупнейший крытый рынок Израиля —Сарона Маркет.</p>
// 							<p>Заключительные этапы конкурса будут проходить в аудитории имени Чарльза Бронфмана, также известной как Дворец культуры (Гейхал ха-Тарбут), расположенной на площади Габима, рядом с одноименным национальным театром. Неподалеку от площади расположены одни из лучших кафе и ресторанов Тель-Авива, а также любимый всеми бульвар Ротшильд.</p>
// 							<p>Вы можете заказать билеты на это удивительное культурное событие с 16 февраля 2020 года.</p>

// 						`
// 			}
// 		}
// 	},

// 	{

//         id:"Red_Hot_Chili_Peppers_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Red Hot Chili Peppers",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Город</h2>
// 									<div class="text">
// 										<p>
// 											Тель-Авив, парк ха-Яркон
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Даты</h2>
// 									<div class="text">
// 										<p>
// 											10.06.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Сайт</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://redhotchilipeppers.com/">
// 											www.redhotchilipeppers.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<p  class="ac-margin-bottom-20 ac-margin-top-20"><b>Острые и горячие Red Hot Chili Peppers возвращаются в Тель-Авив впервые с 2012 года!</b></p>
// 								<p>
// 								Имея в послужном списке 11 альбомов, 16 номинаций на Грэмми и шесть наград, эта мега-успешная группа заставит ваше сердце, тело и душу полностью раскрыться музыке на новом фестивале Funkyard, который пройдет в самом большом зеленом оазисе Тель-Авива — парке ха-Яркон.
// 								</p>
// 								<p>
// 								В декабре прошлого года группа объявила о возвращении легендарного гитариста Джона Фрушанте в состав во второй раз, и мы уверены, что фанк-рок-иконы Лос-Анджелеса снова покажут нам, что такое настоящий рок-н-ролл.
// 								</p>
// 								<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/red-hot-chili-peppers-2020/1.jpg"} class="img-responsive" />
// 							</div>
// 								<p>
// 								Red Hot Chili Peppers даст всего один концерт в "городе без перерыва". Именно в Тель-Авиве вы можете начать день на пляже с бокалом ледяного пива и закончить в одном из оживленных баров, открытых до утра. «Перцы» выступят в самом начале лета, когда температура еще не зашкаливает, но вечеринки уже зажигают клубы по всему городу.
// 								</p>
// 								<p>
// 								Сегодня вы уже можете заказать билеты, но, скорее всего, уже очень скоро все они будут распроданы, так что закажите билеты и правильно спланируйте свою поездку пока билеты еще в продаже!
// 								</p>

// 						`
// 			}
// 		}
// 	},

// ];

// End live shows
export const ShowsPostsData = [];

export const newPostdata = [
  //         {
  // 	      id:"eurovision",
  //               bgImage: "/posts/bank/eurovision/1.jpg",
  //               mobBgImage: "/posts/bank/eurovision/M/1.jpg",
  //               title :"EUROVISION TEL AVIV",
  //               ctg:"eurovision",
  //               isVid:false,
  //               smlTitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  //                    	<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/eurovision/logo.png"} class="img-responsive" />
  // 					</div>
  // 					<h2>
  // 						A ONCE IN A LIFETIME OPPORTUNITY TO VISIT TEL AVIV AS IT HOSTS THE EUROVISION SONG CONTEST
  // 					</h2>
  // 					<p>
  // 						Epic song contest in the Non-Stop City
  // 					</p>
  // 					<p>
  // 						Semi-final 1: 14 May 2019
  // 					</p>
  // 					<p>
  // 						Semi-final 2: 16 May 2019
  // 					</p>
  // 					<p>
  // 						Grand Final: 18 May 2019
  // 					</p>
  // 					<p>
  // 						It’s getting hot hot hot in Fabulous Tel Aviv! The nonstop city is teaming with excitement as it is getting ready to host the 2019 Eurovision Song Contest in what promises to be one of the most epic events ever held in the famous party city.
  // 					</p>
  // 					<p>
  // 						Tel Aviv, known for its amazing energy, stunning beaches, great year round weather and gorgeous people, is the perfect destination for an unforgettable citybreak. Tel Aviv is known world over for its open mindedness and liberal spirit, making it the ideal host for the Eurovision song contest, offering visitors from far and wide the perfect opportunity to enjoy this vibrant and energetic city at its finest.
  // 					</p>
  //                    	<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/eurovision/1.jpg"} class="img-responsive" />
  // 					</div>
  // 					<p>
  // 						Major productions centered around the Eurovision contest month are already well on their way. Some of the exciting events planned include an amazing opening ceremony, a prestigious red-carpet event, and even a mega “Euro Village” which will be situated merely a minutes’ walk from the awesome Tel Aviv baordwalk and beach. The Euro Village will be open for 10 days and will include live performances from past and present mega stars as well as live screenings of the Eurovision contest’s semifinal and final. The contest itself will take place in the Expo Tel Aviv.
  // 					</p>
  // 					<p>
  // 						The Eurovision Song contest in Tel Aviv is guaranteed to be an event of a lifetime, so make sure to book your trip now to the most amazing Eurovision contest yet, in the most amazing city of all!
  // 					</p>

  //             	`   }
  //   }
  // },

  // {
  // 	      id:"Get_ready_to_party",
  //               bgImage: "/posts/bank/Get_ready_to_party/1.jpg",
  //               mobBgImage: "/posts/bank/Get_ready_to_party/M/1.jpg",
  //               title :"The best Eurovision parties to be at",
  //               ctg:"eurovision",
  //               isVid:false,
  //               smlTitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  //                <h2>
  //                	Your Total Guide to Tel Aviv Eurovision parties
  //                </h2>
  //                <p>
  // 					From the Eurovision Village to the EXPO Centre, these are all the key places you need to know about for Eurovision 2019 in Tel Aviv…
  // 				</p>
  // 				<h2>
  // 					CHARLES CLORE PARTY VENUE
  // 				</h2>
  // 				<h2>
  // 					Charles Clore Park: home to the largest Eurovision Village to have ever been made.
  // 				</h2>
  // 				<p>
  // 					Charles Clore Park is located on the sea-front in the south-west of Tel Aviv. It’s a beautiful green space overlooking Old Jaffa, one of the most ancient places in Tel Aviv.
  // 					During Eurovision week it will be home to the Eurovision Village, where free concerts from the biggest Eurovision stars will take place. Highlights include Dana International and Conchita Wurst, plus parties and screenings of the live Eurovision TV shows will take place outside, right in-front of the beautiful Mediterranean sea!
  // 				</p>
  // 				<p>
  // 					Also, some of Israel’s best chefs will be opening food stalls for the public to get first-hand experience of-mouth-watering Israeli and Middle-Eastern cuisine.
  // 				</p>
  // 				<p>
  // 					Charles Clore is easy to get to: It’s a five minute walk from the Carmelit bus terminal, so any bus terminating there is a good choice. Then you can just walk towards the sea and you’ll see the village. If coming by foot, walk along the beach promenade. Or you can cycle or scoot along the sea front to get there.
  // 					It’s a big park and will be having a Eurovision makeover, so you won’t be able to miss it! In fact, this is the largest village to ever have been made for the Eurovision!
  // 				</p>
  // 				<h2>
  // 					TEL AVIV PORT VENUE (“The Namal”)
  // 				</h2>
  // 				<h2>
  // 					Home to 2019’s official Eurovision Euro Club
  // 				</h2>
  // 				<p>
  // 					With its huge venues, gorgeous decking and sea-side views, Tel Aviv Port is the perfect place to party the night away on Eurovision week!
  // 				</p>
  // 				<p>
  // 					With its huge venues, gorgeous decking and sea-side views, Tel Aviv Port is the perfect place to party the night away on Eurovision week!
  // 				</p>
  // 				<p>
  // 					The club will feature theme parties, live performances, screenings of the Eurovision live shows and many more surprises to be revealed. Former Eurovision acts and winners, both Israeli and international, are set to perform there during the Eurovision week, so the venue will offer much more than just a traditional night-club. Entry to the Euroclub is free for accredited fans, journalists, delegations and artists. Members of the general public can get in to the Euroclub by purchasing a special weekly bracelet, here:
  // 					<a href="https://www.eventer.co.il/euroclub?fbclid=IwAR37-d_19OE7bsq0rQ_gPHAW-sRfn1QAMi-cxp_ID2pFtDODBYzbf5NB6S0" target="_blank">https://www.eventer.co.il</a>
  // 				</p>
  // 				<h2>
  // 					EUROVISION VENUE
  // 				</h2>
  // 				<h2>
  // 					Expo Tel Aviv: home to the Eurovision Song Contest itself
  // 				</h2>
  // 				<p>
  // 					The 2019 Eurovision Song Contest will be held at the Tel Aviv Expo center on the14th, 16th and 18th May. If you’ve got tickets, this is the place you’ll need to get to.
  // 					It’s located on Rokach Boulevard in the north of the city, past HaYarkon Park and near to Tel Aviv University. To get there, use a journey planning app to find a bus route that will drop you right outside. Or, if travelling by train, get off at Tel Aviv University Train Station which is just a few minutes’ away from the convention centre.
  // 				</p>
  // 				<p>
  // 					Don’t forget about the White Night, all the details are in the next article.
  // 				</p>

  //          	`   }
  //   }
  // },

  {
    id: "Dead_Sea2",
    bgImage: "/posts/bank/deadsea2/1.jpg",
    mobBgImage: "/posts/bank/deadsea2/M.jpg",
    title: "ПРЕЛЕСТИ МЁРТВОГО МОРЯ",
    smltitle: "",
    isVid: true,
    vidId: "9aDP-jV6soE",
    ctg: "deadsea",
    html: function() {
      return {
        __html: `
                     
                     <br/>
					 <h2 class="ac-margin-bottom-20 ac-margin-top-20">
                             Мёртвое море
                      </h2>
              		<p>
			Мёртвое море – это геологическое чудо, расположенное в уникальном и лишённом суеты месте, и  чрезвычайно популярное среди туристов достопримечательность. Вы испытаете расслабляющее и умиротворяющее влияние воды, обладающей отличными целебными свойствами, наслаждаясь непревзойденной красотой окружающего пейзажа. <strong>Мертвое море, также известное как самый старый природный курорт в мире, обладает чрезвычайно высокой концентрацией соли - 31,5%, что позволяет туристам со всего света с удивительной легкостью плавать и держаться на воде в самом низком места Земли. Здесь Вы сможете</strong> искупаться в полезной черной грязи или отправиться в увлекательное путешествие по близлежащей исторической местности.
              		</p>

              		<p>
			Роскошные отели, разнообразная кухня из ресторанов для гурманов и кафе быстрого питания, великолепные магазины сувениров, необычайная история расположенной рядом крепости «Масада» и множество культурных мероприятий круглый год делают Мертвое море популярным местом как среди местных, так и среди иностранных туристов.
              		</p>
              		<p>
								Больше информации: <br>
								<a href="//visit.tel-aviv.gov.il/home" target="_blank">http://www.visit-tel-aviv.com/</a><br>
								<a href="//www.itraveljerusalem.com/" target="_blank">http://www.itraveljerusalem.com/</a>
							</p>
				
				<!--<div class="img-wrapper">
								   <img src=${getImgUrl() + "/posts/next-level/1.jpg"} class="img-responsive" />
				</div>
				
				<div class="img-wrapper">
								   <img src=${getImgUrl() + "/posts/next-level/2.jpg"} class="img-responsive" />
				</div>-->
				      


           `,
      };
    },
  },

  {
    id: "Tourist_info",
    bgImage: "/posts/bank/Tourist_info/1.jpg",
    mobBgImage: "/posts/bank/Tourist_info/M/1.jpg",
    title: "Информация для туристов: транспорт",
    ctg: "telaviv",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `

					            <h3>
									Как попасть в Тель-Авив из аэропорта:
								</h3>
								<p>
									Наиболее дешевый способ попасть в центр Тель-Авива из аэропорта Бен-Гурион – на поезде. Следуя за указателями, вы легко найдете расположенную в непосредственной близости от аэропорта железнодорожную станцию. Найдите поезд, следующий до станций «Тель-Авив Ха-Хагана» (южный Тель-Авив), «Тель-Авив Ха-Шалом» (центральная часть Тель-Авива), «Тель-Авив Савидор» («Старый Север» Тель-Авива), или «Тель-авивский Университет» (поблизости от этой станции и будет проходить «Евровидение»). Обратите внимание, что станция «Тель-Авив Ха-Шалом» закрыта по пятницам до сентября 2019 года.
									Проезд в одну сторону на поезде стоит 13.50 шекелей, поездка займет около 25 минут. Выйдя из поезда, вы можете взять такси до места, в котором вы остановились. Попросите таксиста включить счетчик («монэ»). Расплачиваются с таксистом наличными. Заказать такси можно и с помощью специальных приложений (см. ниже). Для дополнительной информации и планирования поездки зайдите на сайт <a href="https://www.rail.co.il/en" target="_blank">https://www.rail.co.il/en</a> (на английском).
								</p>
								<p>
									Если вы предпочитаете взять такси прямо в аэропорту, сразу за залом прилета вас будут ожидать официально зарегистрированные такси. Распорядитель выяснит, куда вы направляетесь, сколько вас человек и сколько у вас багажа, и затем даст вам специальный билетик, который нужно передать таксисту. Вы можете попросить его включить счетчик или согласиться на фиксированную оплату. Как правило, поездка обходится в 150-170 шекелей с человека.
								</p>
								<h3>
									Как попасть из Тель-Авива в Иерусалим:
								</h3>
								<p>
									<b>На автобусе</b><br/>
							
									На автовокзале, расположенном рядом с железнодорожной станцией «Тель-Авив Савидор», сядьте в автобус номер 480. Поездка займет около 45 минут. Автобус прибывает на Центральный автовокзал Иерусалима (ул. Яффо). Там вы сможете пересесть на трамвай или автобус и добраться до места назначения.
								</p>
                				<p>
									<b>Поездом</b><br/>
							
									Теперь до Иерусалима можно доехать и на поезде! Если вы едете сразу из аэропорта Бен-Гурион, вам нужно будет выйти на станции «Навон» в Иерусалиме. Поездка займет около 25 минут. Если вы едете из Тель-Авива, сядьте на поезд, следующий в аэропорт Бен-Гурион, а там пересядьте на поезд до станции «Навон» в Иерусалиме.
								</p>            
								<p>
									<b>Транспорт в Тель-Авиве</b><br/>
								
									На время «Евровидения» (в пятницу 17 мая и в субботу 18 мая) тель-авивский муниципалитет сделал поездки в общественном транспорте бесплатными. Вместе с тем следует помнить, что с вечера пятницы до вечера субботы общественный транспорт в Тель-Авиве обычно не работает (за исключением такси).
									Для поездок в другие дни вам понадобится транспортная карта «Рав-Кав» (аналог «Тройки» или «Подорожника»). Это пополняемый «электронный кошелек», который позволит вам ездить на автобусах, не заботясь о наличных. Более того, на данный момент водители автобусов уже не принимают наличные, поэтому очень важно обзавестись «Рав-Кавом», как только вы окажетесь в Тель-Авиве. 
									Чтобы купить транспортную карту, просто сядьте на автобус на любой остановке и попросите у водителя «Рав-Кав» - он стоит 5 шекелей. (Вам понадобится точная сумма без сдачи). Пополнить «Рав-Кав» можно в некоторых круглосуточных магазинах и киосках. 50 шекелей вам скорее всего хватит на одну неделю – это примерно 10 поездок (стоимость каждой поездки – 5.90 шекелей).
									Кроме того, приобрести «Рав-Кав» можно в специальном офисе, расположенном по адресу ул. Ибн Гвироль, 35, который работает с 8:00 до 20:00 с воскресенья по четверг, а по пятницам и в канун праздников – с 8:00 до 13:00, а также на железнодорожной станции «Тель-Авив Савидор» и автовокзале «Кармелит». Пополнить «Рав-Кав» можно и на любой железнодорожной станции.
								</p>
								<p>
									<b>Велосипеды</b><br/>
							
									Велосипеды в Тель-Авиве чрезвычайно популярны. По всему городу проложены специальные велодорожки. Одна из них идет вдоль набережной от Яффы на юге до Северного Тель-Авива. Это отличная возможность впитать атмосферу Тель-Авива и полюбоваться местной архитектурой. Если у вас есть велосипедный шлем, захватите его с собой.
								</p>
								<p>
									<b>Электросамокаты</b><br/>
							
									Электросамокаты в Тель-Авиве в последнее время пользуются бешеной популярностью. Это удобный и прикольный способ передвигаться по городу. Свои услуги в этой области предоставляют несколько компаний. Вам всего лишь нужно скачать соответствующее приложение и следовать инструкциям. Вместо сумки лучше взять рюкзак – так легче сохранять равновесие. Не забывайте следить за дорожным движением и не слушайте музыку, когда едете на электросамокате. Если у вас есть шлем, стоит его надеть.
								</p>
								<p>
									<b>Пешие прогулки</b><br/>
						
									Гулять по Тель-Авиву пешком – это тоже отличная идея. После нескольких дней в «городе, который никогда не спит» ваш шагомер будет зашкаливать! Обзаведитесь картой города, головным убором и бутылкой воды – и вперед!
								</p>
								<p>
									<b>Транспортные приложения</b><br/>
							
									Транспортные приложения помогут вам лучше планировать свои перемещения по городу. Вы можете скачать их еще до приезда в Тель-Авив. Рекомендуем вам скачать приложения для заказа такси, аренды велосипедов и электросамокатов, а также приложение для планирования маршрута. Кроме того, консьерж гостиницы или хозяева вашей квартиры с радостью помогут вам сориентироваться в Тель-Авиве.
								</p>
								<p>
									<b>Wifi</b><br/>
							
									В Тель-Авиве существует бесплатная сеть Wi-Fi. Поищите в своем смартфоне сеть «Free TLV» - она действует в 80 локациях по всему городу. В большинстве кафе и баров тоже есть бесплатный Wi-Fi – просто спросите пароль, когда делаете заказ. В гостиницах тоже есть бесплатный Wi-Fi – спросите пароль при регистрации.
								</p>
								<a href="//visit.tel-aviv.gov.il/move/airport" target="_blank" class="transportation">Transportation.</a>

         	`,
      };
    },
  },

  // {
  // 	      id:"White_night",
  //               bgImage: "/posts/bank/White_night/1.jpg",
  //               mobBgImage: "/posts/bank/White_night/M/1.jpg",
  //               title :"White night",
  //               ctg:"eurovision",
  //               isVid:false,
  //               smlTitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  // 							<h1 class="align-center">
  // 							  White Night Lights Up Tel Aviv on 16th May
  // 							</h1>
  //         					<div class="responisve-iframe">
  // 								<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  // 							</div>

  // 							<p>What do you get when you cross a Eurovision Semi-Final with an all-night party in a city that is famous for its 24/7 party energy? The answer is White Night, which will hit Tel Aviv this year on Thursday 16th May, just two days before the 2019 Eurovision Song Contest grand final.</p>
  //                             <p>Featuring pop-up art installations, live music, dance parties, cultural events, food and drink, all fused together with Tel Aviv’s eclectic atmosphere, White Night is one of the biggest cultural events of the year. </p>
  //                             <p>And for 2019, it’s taking place a month earlier than usual, so that visitors coming for the Eurovision Song Contest can also experience this magical experience in the White City of Tel Aviv.</p>

  // 							<div class="img-wrapper">
  // 								<img src=${getImgUrl() +  "/posts/White_night/1.jpg"} class="img-responsive" />
  // 							</div>
  // 							<small>
  // 								Photo By: Adam Primer
  // 							</small>

  // 							<p>From sunset until sunrise, the city will be wide-awake with cultural activities. Locals and visitors alike are invited to explore the city and soak up all the activities on offer. Many bars, restaurants and shops will be offering experiences free of charge or at reduced rates, so it’s definitely worth stocking up on sleep so you’re ready to party all night long!</p>
  //                             <p>And at the Eurovision Village in Charles Clore Park, there’ll be an extra sparkle of Eurovision magic, as several icons of the competition take to the stage to entertain visitors during the night. </p>
  //                             <p>Last year’s runner-up, Eleni Foureira, who narrowly missed out to Tel Aviv’s own Neta Barzilai with her smash-hit song “Fuego”, will be performing, as will 2014 winner, Conchita Wurst from Austria, who will most likely perform his iconic winning song, “Rise Like a Phoenix” while showcasing his new-look for 2019!</p>
  //                             <p>They’ll be joined by three more Queens of Eurovision, in the form of 1970s pop icon Anne-Marie David, who won for Luxembourg in 1973, Swedish pop star Carola Häggkvist, who won the contest in 1991, and Loreen, who also won for Sweden in 2012 with her song Euphoria. The performances will take place on the coast, overlooking the Mediterranean; the live semi-final will also be shown on big-screens in the Eurovision Village, off-set by jaw-dropping light compositions, created by the competition’s official lighting partner OSRAM.</p>
  //                             <p>All in all, White Night is a night not to be missed. So make the 15th May your duvet day and get-set to party all night long on Thursday 16th May 2019. Tel Aviv is ready and waiting to celebrate with you!</p>

  // 							<div class="img-wrapper">
  // 								<img src=${getImgUrl() +  "/posts/White_night/2.jpg"} class="img-responsive" />
  // 							</div>
  // 							<small>
  // 								Photo By: Kfir Sivan
  // 							</small>

  // 							<div class="img-wrapper">
  // 								<img src=${getImgUrl() +  "/posts/White_night/3.jpg"} class="img-responsive" />
  // 							</div>
  // 							<small>
  // 								Photo by Moshik Lindenbaum
  // 							</small>

  // 							<div class="img-wrapper">
  // 								<img src=${getImgUrl() +  "/posts/White_night/4.jpg"} class="img-responsive" />
  // 							</div>
  // 							<small>
  // 								Photo by: Guy Yechiely‎.
  // 							</small>

  //          	`   }
  //   }
  // },

  // {
  // 	      id:"Tel_Aviv_Street_Food",
  //               bgImage: "/posts/bank/street-food/1.jpg",
  //               mobBgImage: "/posts/bank/street-food/M/1.jpg",
  //               title :"TEL AVIV STREET FOOD",
  //               ctg:"telaviv",
  //               isVid:true,
  //               vidId:"JQD9JpMaw9g",
  //               smlTitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  //                      <h2>It is no wonder that Tel Aviv was named one of Saveur Magazine’s “Outstanding Culinary Destinations</h2>

  //                         <p>Tel Aviv, home to sandy beaches, non-stop action and a raging nightlife, is also chock-full of unique restaurants and bars, making the seaside city a trendy foodie destination. The Tel Aviv food industry is truly the city’s heart and soul and while plenty of high-end eateries can be found throughout Tel Aviv, it is fresh local street food that has taken the city by storm.</p>

  //                         <h2>Taking traditional street food to a whole new level</h2>

  //                         <p>Say goodbye to the days where Tel Aviv street food was mostly limited to the scrumptious, yet singular concept of crisply fried falafel stuffed into a freshly baked pita. Today, the Tel Aviv street food scene is just that - a scene, with gourmet and specialty treats being served to the masses on local street corners. Take a walk down Ibn Gvirol, Ben Yehuda or Carmel streets and choose from a myriad of high-end meats, fish, prepared vegetables and sauces, all artfully inserted inside pita bread, between slices of toast or other casings. Nibble on the succulent delicacies inspired by the four corners of the world - sabich and tahini in laffa bread, unique herring sandwiches and more, as you continue to wander throughout the city, a taste of Israeli culture on your tongue and a pleasant sense of satisfaction in your belly.</p>

  //                         <h2>Restaurant quality meals for the foodie on the go</h2>

  //                         <p>What more could a bustling city full of hurried business professionals and excited tourists want than easy access to flavorful and trendy dishes that can be eaten on the go? With more and more unique streetside quick-stop eateries popping up throughout the city and serving dishes like entrecote-stuffed ciabatta bread and cornflour arepas, it is no wonder that Tel Aviv was named one of Saveur Magazine’s “Outstanding Culinary Destinations.” </p>

  //                         <p>Foodies delight: Tel Aviv and its hip street food scene, with countless delectable choices on every corner, is the ultimate culinary travel destination and a must-visit stop on your next Israel trip.</p>

  //          	`   }
  //   }
  // },

  // {
  // 	      id:"Jerusalem_Old_City",
  //               bgImage: "/posts/bank/jerusalem-old-city/1.jpg",
  //               mobBgImage: "/posts/bank/jerusalem-old-city/M/1.jpg",
  //               title :"JERUSALEM’S OLD CITY",
  //               ctg:"jerusalem",
  //               isVid:false,
  //               smlTitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  //                      <h2>
  //                          Sensational sites of Ancient Times
  //                      </h2>
  //                      <p>No other place offers as many attractions and emotionally inspiring sites in a single square kilometer. A tour of the Old City of Jerusalem is an opportunity to get lost among the magical walkways and connect with the city’s resplendent past, history, culture and spirituality. </p>

  //                              <h2>The Western Wall</h2>
  //                              <p>Thousands of years old, the Western Wall is the last remaining relic of the Second Jewish Temple and the most important Jewish prayer site in the world, where millions of visitors from around the world place notes with requests and prayers into its cracks.</p>
  //                              <div class="img-wrapper">
  // 								<img src=${getImgUrl() +  "/posts/jerusalem-old-city/1.jpg"} class="img-responsive" />
  // 							 </div>
  //                              <h2>Western Wall Tunnels</h2>
  //                              <p>Located beneath the Western Wall, the tunnels provide a glimpse of the various periods in the history of Jerusalem and are as close as you'll probably get to travelling back in time.</p>

  //                              <h2>City of David</h2>
  //                              <p>Discover the story of Jerusalem during the reigns of Kings David, Solomon and Hezekiah in this captivating archeological site, where many treasures have been unearthed. A visit to the site will enable you to take a flashlight and wade through the flowing water of the Siloam Tunnel, which was carved during the reign of King Hezekiah.</p>

  //                              <h2>The Old City Market</h2>
  //                              <p>A must-see attraction made up of a series of alleyways, with numerous stalls offering a staggering variety of products of every imaginable kind. This lively bustling market (or shuk) is a perfect place to pick up a unique souvenir (haggling is a
  //                              must) or try one of the many local delicacies.</p>
  //          	`   }
  //   }
  // },

  {
    id: "Jerusalem_Journey_In_Time",
    bgImage: "/posts/bank/25/1.jpg",
    mobBgImage: "/posts/bank/25/M.jpg",
    vidId: "7fT4dBioVi4",
    ctg: "jerusalem",
    isVid: true,
    title: "Иерусалим зовет",
    smltitle: "",
    html: function() {
      return {
        __html: `

				<br/>

				   <h2 class="ac-margin-bottom-20 ac-margin-top-20">Самый волшебный и сияющий город на Земле</h2>

                             <p>
                          Что еще можно сказать о самом уникальном городе мира?  А если перефразировать это  предложение, то получится: «Добро пожаловать в Иерусалим, где великая история переплетается с современной и динамичной жизнью».
                        <br/>
                            В Иерусалиме вы сможете найти уникальные исторические места, множество пешеходных дорожек, роскошные закаты, большой выбор развлекательных заведений и ресторанов, которые предлагают новые кулинарные впечатления, энергичную ночную жизнь и широкий выбор центров культуры и искусства.
                        </p>
                        <h3>
                          <u> Старый город</u>
                        </h3>

                        <p>
                           Ни одно другое место на земле не предлагает столько достопримечательностей и эмоционально насыщенных мест на на площади в один квадратный километр. Старый город Иерусалима  дает возможность прикоснуться к блистательным событиям прошлого, познакомиться с историей, культурой и пережить духовный подъем от соприкосновения с сокровенными тайнами. В Старом городе вы найдете археологические сокровища,  возраст которых насчитывает тысячи лет, увидите современное искусство и шумные восточные рынки, где вы сможете приобрести изысканные сувениры на память.
                        </p>

                        <h3>
                           Западная стена – Стена Плача:
                        </h3>
                        <p>
                           Cчитается, что это единственный сохранившийся фрагмент стены Второго Храма. Стена стала символом и синонимом Иерусалима.  Древняя Стена Плача является одним из самых важных и значимых молитвенных мест для иудаизма. Тринадцатилетние мальчики празднуют здесь бар-мицву, а миллионы путешественников со всего мира закладывают в стену маленькие  записки со своими самыми сокровенными просьбами.
                        </p>
                        <h3>
                           Туннели Стены Плача:
                        </h3>
                        <p>
		Это настоящая машина времени. Расположенные под Стеной Плача и под мусульманским кварталом туннели показывают посетителям разные слои иерусалимской истории.
                        </p>

                        <h3>
                           Город Давида:
                        </h3>
                        <p>
                           Это настоящая машина времени. Расположенный рядом с Мусорными воротами город Давида представляет собой историю Иерусалима времени царствования царя Соломона и царя Хизкиягу (Езекии). Многочисленные исторические предметы были найдены во время раскопок на этом месте, включая двухтысячелетние золотые сережки. Посещение этого места позволит вам, взяв фонарик, пройти через ручей, текущий по Силуамскому туннелю, который был построен во время правления царя Езекии.
                        </p>


                        <h3>
                           Виа Долороза:
                        </h3>
                        <p>
                            Верующие христиане считают, что здесь можно пройти по следам Иисуса все 14 остановок его Крестного Пути,  следуя вниз по улице Виа Долороза и восстанавливая все этапы этого судьбоносного для всего человечества пути.
                        </p>
                        <h3>
                           Храм Гроба Господня:
                        </h3>
                        <p>
                           Согласно христианской традиции,  эта церковь является местом распятия  Иисуса Христа. Там же находится место, где Он был  похоронен и где Он, по преданию, воскрес из мертвых. Уже много веков эта церковь является одним из основных центров  паломничества для христиан всего мира.
                        </p>

                        <h3>
                            Рынок Старого Города:
                        </h3>
                        <p>
                            Это необходимая к посещению достопримечательность состоит из множества переулков с многочисленными магазинчиками, которые предлагают невероятное разнообразие сувениров, одежды, продуктов питания (хлебобулочные изделия, специи, сладости и многое другое), свежевыжатые соки всех видов, армянскую керамику, барабаны и другие музыкальные инструменты, глиняные кувшины и многое другое. Красочный рынок дарит вам незабываемые ощущения и переживания, которые просто невозможно пропустить.
                        </p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/4/2.jpg"} class="img-responsive" />
					</div>

					 <h3>
                           <u> Достопримечательности</u>


                        </h3>

                        <h3>
                           Сигвей–туры:
                        </h3>

                        <p>
                           Это особый  полный адреналина  способ увидеть город с совершенно иной точки зрения  и заново влюбиться в его  красоту. Туры Segway отправляются из различных мест в центре города, в том числе с пешеходной тропы в Армон Ха-Нацив (Восточный Тальпиот), из квартала Ямин Моше и Старого города, а также поблизости от Кнессета и музейного городка.
                        </p>


                        <h3>
                            Первая станция (Hatachana):
                        </h3>

                        <p>
                            Первая железнодорожная станция находится на месте бывшей немецкой колонии в самом центре Иерусалима – между Старым городом , административным центром и кварталом Ямин Моше. Первая железнодорожная станция в Иерусалиме была построена в 1892 году, а после реконструкции была вновь открыта для широкой публики.
                        </p>

                        <h3>
                           «Лифт времени»:
                        </h3>

                        <p>
                            Если вы любите развлечения, любите испытывать новые ощущения и пощекотать себе нервы, то «Лифт времени» – это то, что вам надо. Это интерактивный опыт, который дает посетителям уникальную возможность совершить сказочное путешествие по увлекательным местам. Вы будете находиться в специально оборудованном зале с подвижными креслами и специальными эффектами.
                        </p>

                        <h3>
                            Рынок Махане Иегуда:
                        </h3>
                        <p>
                            Для того, чтобы по-настоящему прочувствовать город, ваш маршрут должен обязательно пройти через рынок Махане Иегуда. Это место, где вчера, сегодня и завтра встречаются в одной точке. Огромный выбор фруктов и овощей, необыкновенно вкусная еда, специи, ароматы и вибрирующая жизненная энергия, которая захватит и вас.
                        </p>

                        <h3>
                           <u> Музеи</u>
                        </h3>
                        <p>
                           Город предлагает вам большое количество самых разнообразных музеев. У вас есть уникальная возможность прикоснуться к событиям прошлых веков и посетить современные выставки.
                        </p>

                        <h3>
                           Музей Израиля:
                        </h3>
                        <p>
                            Музей Израиля является крупнейшим культурным учреждением в стране. У музея много тематических направлений –  обширные коллекции предметов искусства, археологических находок и культовых объектов иудаизма (иудаики). Одним из центральных мест для посещения является так называемый Храм Книги. Уникальный дизайн музея сделал его здание еще одной иерусалимской достопримечательностью.
                        </p>

                        <h3>
                            Музей «Башня Давида»:
                        </h3>
                        <p>
	            Тысячи лет тому назад Иерусалим был маленьким городом, а на его узких улочках можно было встретить библейских царей и пророков. Еще с того времени Башня Давида, гордо возвышающаяся над старой крепостью, стала одним из самых известных символов города. Сегодня это место является одним из самых интересных музеев города.
                        </p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/4/3.jpg"} class="img-responsive" />
					</div>

					<h3>
                           <u>Рестораны</u>
                        </h3>
                        <p>
                            Многочисленные иерусалимские рестораны открывают перед вами свои двери. Вы можете шикарно пообедать, составив свое меню из местных и экзотических деликатесов. Если Вы настоящий гурман, Вы можете посетить эксклюзивные рестораны лучших шеф-поваров Израиля, при этом заранее зарезервировав места. Мы приводим короткий список пяти лучших и одних их самых популярных ресторанов Иерусалима
                        </p>
                        <h3>
                           Кафе Кадош:
                        </h3>
                        <p>
                            очень популярное место. Предлагает широкий выбор кошерных блюд. Все приготовлено на месте и все необычайно вкусно.
                        </p>

                        <h3>
                           Этмоль Шильшом:
                        </h3>
                        <p>
                           Молочное кафе – книжный магазин, расположенный в самом центре города. С очень вкусной едой и дружелюбным обслуживанием. Не пропустите его шакшуку или филе лосося в фиговом соусе.
                        </p>

                        <h3>
                            Эвкалиптус:
                        </h3>
                        <p>
                            Кошерный ресторан, расположенный в Квартале художников. Свои блюда по мотивам библейской кухни предлагает вам шеф-повар Моше Бассон. Каждое блюдо имеет за собой историю из Библии, а травы и пряности, которыми приправлены все блюда, использовались еще в древние времена. Это именно те травы, которые росли на холмах, окружающих Иерусалим и Иудею. Незабываемые впечатления гарантированы.
                        </p>
                        <h3>
                             Дарна:
                        </h3>
                        <p>
                             Настоящий аутентичный марокканский ресторан с глат-кошер (особый вид строго ортодоксального кашрута). Расположен в самом центре города. Приходите, чтобы понять, что такое настоящее марокканское гостеприимство и замечательная марокканская кухня. Вас ждет уникальная кухня Магреба.
                        </p>

                        <h3>
                              Ресторан Има:
                        </h3>
                        <p>
                              вниз по улице, идущей от рынка Махане Иегуда, вас ждет еще один кошерный ресторан восточно-европейской кухни. Милая и  приятная домашняя атмосфера.
                        </p>

                        <p>
                               И, конечно же, невозможно представить себе путешествие в Иерусалим без того, чтобы попробовать его уникальный хумус с питой, только что снятой с огня и еще обжигающей ваши пальцы. Вот несколько основных мест, где вы можете попробовать иерусалимский хумус:
                        </p>

				    	<div class="cradit">
					  		<p>
					     		<strong>Азура</strong>, <small>в иракской части рынка Махане Иегуда</small><br/>
                                <strong>Линав,</strong> <small>в христианском квартале Старого города</small><br/>
                                <strong>Хуммус Акрамави, </strong> <small>в мусульманском квартале Старого города</small> <br/>
                                <strong>Хуммус Бен Шира</strong> <small>в центре города, около гостиницы Мамила</small><br/>
                                <strong>Абу Шукри</strong>, <small>в мусульманском квартале Старого города</small><br/>
							</p>
				        </div>

				        <h3>
                           <u> Ночная жизнь</u>
                        </h3>

                        <p>
                            Иерусалим богат многочисленными ресторанами и развлекательными заведениями, которые открыты также и в пятницу вечером (после наступления шаббата – иудейской субботы – когда, согласно религиозному закону, любые работы запрещены) . Все развлекательные заведения имеют специальные программы для приятного времяпрепровождения.  – вы можете провести спокойный  вечер с бутылочкой холодного пива в руке или потанцевать под замечательную музыку.
                         <br/>
                            Ниже приведен небольшой выбор баров и клубов, которые работают в пятницу и субботу.
                        </p>

                        <h3>
                            Мантра:
                        </h3>
                        <p>
                            модный ресторан и винный бар с приятной дружеской атмосферой и замечательной кухней.
                        </p>

                        <h3>
                            Гетсби коктейль рум (зал для коктейлей «Гетсби») –
                        </h3>

                        <p>
                             уникальная атмосфера 20-х годов и кабаре.
                        </p>

                        <h3>
                            Ха-Таклит:
                        </h3>

                        <p>
                            с таким именем , которое в переводе с иврита значит «рекорд», неудивительно, что это место  с замечательным дизайном стало одним из самых популярных. Бар с неограниченным выбором напитков, живая музыка, выступления диджеев и независимых исполнителей.
                        </p>

                        <h3>
                            Ха-цаацуа (Игрушка):
                        </h3>
                        <p>
                            расположенный в самом центре города, бар «Ха-цаацуа» предлагает замечательные напитки, чудесную музыку от лучших местных диджеев и танцы. Вы будете очень довольны!
                        </p>
                        <h3>
                            Шира:
                        </h3>
                        <p>
                            один из самых эклектичных подземных пабов города с особой архитектурой и танцевальной площадкой. В пабе также проводятся особые мероприятия и представления.
                        </p>

                        <h3>
                            Even / Juke:
                        </h3>

                        <p>
                         музыкальный клуб, который представляет широкой публике молодые креативные израильские группы. Джаз, блюз.
                        </p>

                        <p>
                             Иерусалим является обязательным местом для посещения! В нем столько всего, что надо посмотреть, и столько всего, что можно сделать. Он пробуждает чувства и дразнит ваше любопытство. Поездка в Иерусалим обещает незабываемые впечатления! Не ждите! Закажите поездку сейчас!
                        </p>
                         <h3> <u>Ежегодные  мероприятия</u> </h3>

                        <p>

                           Каждый год Иерусалим проводит огромное количество самых разнообразных мероприятий. Для получения дополнительной информации обязательно зайдите на наш интернет сайт.
                        </p>

                        <h3>
                            Фестиваль Света:
                        </h3>
                        <p>
                           проводится в Старом Городе  с 25 мая по 2 июня 2016 . Приходите, чтобы стать частью незабываемой игры света и цвета и оказаться среди многочисленных экранов, транслирующих выступления израильских и международных артистов. Следуйте специальным указаниям, которые будут вести вас от одной чарующей работы к другой.
                        </p>

				    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/4/4.jpg"} class="img-responsive" />
					</div>

					 <h3>
                            Ярмарка художественных изделий (Хуцот Ха-Йоцер):
                        </h3>
                        <p>
                            с 15 по 29 августа 2016. Проводится на фоне стен Старого города, чтобы посетители могли полюбоваться замечательным видом, а также рассмотреть все, что представлено на стендах, где художники из Израиля и со всего мира представляют свои художественные работы, принты, керамику, работы по металлу и ювелирные изделия, ткацкие работы и текстиль, поделки и многое другое.
                        </p>
                        <h3>
                            Фестиваль Израиля –
                        </h3>
                        <p>
                            с  24 мая до 11 июня 2016. Фестиваль Израиля стал началом нового мультидисциплинарного подхода в проведении международных фестивалей в Израиле. Он проводится ежегодно в весенний период, представляя яркие театральные спектакли, современные танцевальные представления, концерты классической музыки и выступления актеров и художественных коллективов со всего мира наряду с наиболее интересными работами артистов Израиля. Многочисленные мероприятия фестиваля проводятся в уникальных местах Иерусалима, которые имеют глубокие исторические связи с событиями, происходившими сотни, если не тысячи, лет тому назад. Есть также много уличных спектаклей, которые открыты для широкой публики.
                        </p>
                        <p>
                            Jerusalem plays host to a variety of unique annual events. Check the Internet for dates and further information.
                        </p>
                        <h3>
                            Иерусалимский кинофестиваль Израиля–
                        </h3>
                        <p>
                            проводится с 7 по 17 июля 2016. Фестиваль оставляет свои звездные следы по всему городу. Можно посмотреть качественные фильмы с замечательной актерской игрой, а также поучаствовать во встречах со сценаристами мирового уровня, приезжающими на фестиваль в качестве гостей. Ежегодно многочисленные звезды мирового кинематографа приезжают на фестиваль в качестве гостей. В этом году более 200 израильских и зарубежных фильмов различных жанров будут показаны во время фестиваля в рамках соревнования за получение почетных призов. Фестиваль предлагает многочисленные возможности для встреч с актерами, семинары, вечеринки и музыкальные события.


                        </p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/4/5.jpg"} class="img-responsive" />
					</div>


         `,
      };
    },
  },

  {
    id: "Old_City_Jerusalem",
    bgImage: "/posts/bank/jerusalem6/1.jpg",
    mobBgImage: "/posts/bank/jerusalem6/M.jpg",
    vidId: "7fT4dBioVi4",
    ctg: "jerusalem",
    isVid: true,
    title: "СТАРЫЙ ГОРОД ИЕРУСАЛИМА",
    smltitle: "",
    html: function() {
      return {
        __html: `

				<br/>
				<h2 class="ac-align-center ac-margin-top-20">Город неземного великолепия</h2>
				<p class="ac-align-center ac-margin-bottom-20"><strong>Ощутите духовное сияние, исходящее от величественных каменных стен</strong></p>
				<p>Побывать в Старом городе Иерусалима — это словно совершить путешествие в мистический, волшебный и неизведанный мир. Иерусалим давно признан одним из самых святых и наиболее посещаемых мест мира. Его древние здания и руины имеют огромное значение для трех крупнейших монотеистических религий: иудаизма, христианства и ислама. Прогулка по священным местам города — волнующее и незабываемое переживание, способное подарить историческое, культурное и духовное вдохновение; не пропустите его!</p>
				
				<p><strong>Атмосфера духовного просветления</strong></p>
				<p>Влейтесь в пеструю толпу туристов, ежедневно наполняющую улицы Старого города, и совершите вместе с ними путешествие в прошлое. Понаблюдайте, как живут по соседству евреи, мусульмане, христиане и армяне; посетите бесчисленные, вызывающие благоговение и духовный трепет местные достопримечательности. Они притаились в тени извилистых иерусалимских переулков и как будто прячутся за обманчивым однообразием прохладного иерусалимского камня. Пройдите Крестным путем и загляните в богато украшенные местные церкви, среди которых — Храм Гроба Господня; посетите Садовую могилу, прошепчите молитву у Стены Плача, совершите экскурсию по Тоннелю Стены Плача или прогуляйтесь по оживленному арабскому рынку. Древние здания поражают своим великолепием и словно протягивают связующую нить между вами и давно минувшими днями.</p>
				<p><strong>Современная прогулка по местам древней истории</strong></p>
				<p>Войдя в Старый город через одни из его огромных и величественных ворот, вы мгновенно перенесетесь в давние времена — даже сам воздух здесь наполнен все теми же вечными ароматами восточных пряностей, а местные жители по-прежнему облачены в традиционные одежды. Маленькие повозки, запряженные осликами, велосипеды и специальные миниатюрные транспортные средства заполняют узкие улочки и переулки Иерусалима, рождая трогательную атмосферу. Колоритные продавцы зазывают в оживленные местные лавочки, ларьки и закусочные, наперебой расхваливая свой товар.</p>
				<p>Посетив Старый город, обязательно пройдитесь вдоль древних каменных стен, полюбуйтесь захватывающими историческими видами, посетите местные достопримечательности и понаблюдайте за увлекательными сценами повседневной иерусалимской жизни. Прогулка по стенам Старого города и посещение расположенного по соседству музея «Башня Давида», где история оживает посредством звука и света, только подчеркнет возвышенную красоту и величие мостовых, по которым ступают ваши ноги.</p>

				  


         `,
      };
    },
  },

  // {
  // 	id:"Outdoor_Adventures",
  //         bgImage : "/posts/bank/40/1.jpg",
  //         mobBgImage : "/posts/bank/40/M.jpg",
  //         title : "Outdoor Adventures",
  //         ctg : "telaviv",
  //         vidId : '88OV6xU0vPI',
  //         isVid : true,
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                 <h2>An action-packed city that’s perfect for active people</h2>
  // 			<p>
  // 				People in Tel Aviv live life to the fullest – and they do it outside. This city is chock-full with outdoor activities, and you can pick and choose your favorites. It’s an action packed city – perfect for active people.
  // 			</p>
  // 			<h2>
  // 				Hayarkon Park
  // 			</h2>
  // 			<p>
  // 				Known as the “Central Park” of Tel Aviv, Hayarkon Park is visited by approximately sixteen million people annually. Attractions range from picnics on the huge lawns, pedal boating on its beautiful manmade lake to cycle tracks and tours of the many amazing gardens, portraying nature at the heart of the city.
  // 			</p>
  // 			<h2>
  // 				The Cycling Scene
  // 			</h2>
  // 			<p>
  // 				One of the ultimate ways to discover Tel Aviv is via its 100km of dedicated bike lanes, where you can enjoy the Tel-O-Fun public bike hire system that lets residents and visitors pick up and drop off sleek green bicycles in 150 stations citywide. If you enjoy spending your time on wheels, you should also check out the many dedicated skating parks, where you can watch the local daredevils do their thing, or get your own skateboard or rollerblades and join the action.
  // 			</p>

  //          `
  //     }
  //   }
  // },

  {
    id: "Port_Pleasures",
    bgImage: "/posts/bank/23/1.jpg",
    mobBgImage: "/posts/bank/23/M.jpg",
    ctg: "telaviv",
    isVid: true,
    //  vidId : "FRmgXjfVPoE",
    vidId: "V0Acsw3Hf_M",
    title: "«РАЗВЛЕЧЕНИЯ В ПОРТУ»",
    smltitle: "",
    html: function() {
      return {
        __html: `

        			
                    <br/>
                    <h2  class="ac-margin-bottom-20 ac-margin-top-20">«Очарование портов Тель-Авива и Яффо»</h2>
					<p>
						Яффский порт – это древняя история, здания из камня и мощеные дорожки, а Тель-авивский порт – это современная зона отдыха с культурными заведениями и ресторанами.
					</p>

					<h3>
					   Яффский порт
					</h3>
					<p>
						Современный Тель-Авив берет свое скромное начало с Яффского порта, где причаливали корабли с иммигрантами, армией и торговцами на борту. Это один из самых древних в мире портов. Сегодня его используют в основном местные рыбаки, в то время как историческое окружение порта стало популярным местом отдыха для туристов.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/3/2.jpg"} class="img-responsive" />
						<div class="cradit">
								<small>Хаим Яфим</small>
					    </div>
					</div>


					<p>
						Навесы, обращенные к воде, превратились в галереи и в культурные заведения, такие как центр «Налагаат» – культурный центр для глухонемых и слепых, и галерея «Двир». Древние мощеные улочки тянутся от набережной к каменным зданиям, построенным в тот же период, что и дома Старого Города в Иерусалиме. В исторических зданиях расположены галереи, специализированные магазины и замечательные рестораны. А поднявшись на верхний уровень Старого порта, вы увидите церковь Святого Петра, Мост Желаний, Музей Старого Яффо и музей Иланы Гур.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/3/1.jpg"} class="img-responsive" />
					</div>

					<h3>
						 Тель-авивский порт
					</h3>
					<p>
						В отличие от Яффского порта, Тель-авивский порт более современный и коммерческий. Порт действовал с 1938 по 1965 год, а в последние годы он был отреставрирован и превратился в торгово-развлекательный центр. Площадь порта состоит из бывших доков и широкого променада вдоль линии моря. Сюда очень любят приезжать семьи, которые посещают детский центр «Даяда», центр йоги, женский центр, конференц-зал, Институт дизайна и архитектуры «Кавим». На набережной всегда очень весело, выступают уличные артисты, проводятся музыкальные мероприятия, ярмарки. Порт – очень современное, динамичное место для творческих людей и для любителей культурного отдыха. После захода солнца Тель-авивский порт становится популярным местом среди любителей ночной жизни, которые приезжают в местные бары и клубы.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/3/3.jpg"} class="img-responsive" />
						<div class="cradit">
								<small>Dana Friedlander</small>
					    </div>
					</div>

         `,
      };
    },
  },

  // {
  // 	id:14,
  // 	bgImage : "/posts/videos/deadsea/1/1.jpg",
  // 	mobBgImage : "/posts/videos/deadsea/1/M.jpg",
  // 	title: "The Dead Sea",
  // 	vidId: "ixFocykfYHo",
  // 	ctg : "deadsea",
  // 	isVid:true,
  // 	smlTitle: "",
  // 	html: function(){
  // 		return {
  // 			__html:`
  // 			<h2>Time to bask in nature’s glory</h2>
  // 			<p>
  // 					A geological wonder in a uniquely serene setting, the Dead Sea is an extremely popular tourist attraction. Experience the calm tranquility of the water with its distinct healing properties while enjoying the unparalleled beauty of the surrounding landscape. <strong>The Dead Sea, also known as the oldest natural spa in the world, is blessed with an extremely high salt concentration of 31.5%, allowing tourists from far and wide the amazing experience of effortlessly floating on the waters of the lowest place on Earth. While here, you can bathe</strong> in the healthy black mud of the area or explore the fascinating and historically rich nearby landscapes.
  // 			</p>
  //            <p>
  // 					Luxury hotels, varied cuisine from gourmet restaurants to fast food eateries, great souvenir shops, the extraordinary history of the nearby Masada, and many cultural activities throughout the year, make the Dead Sea a popular destination for local tourists as well as International visitors.
  //            </p>
  // 			`
  // 		}
  // 	}

  // },

  // {
  // 	id:3,
  //         bgImage : "/posts/bank/23/1.jpg",
  //         mobBgImage : "/posts/bank/23/M.jpg",
  //         vidId : "LLOUxE-K_9Y",
  //         player_id_post :"3",
  //         title : "Port Pleasures",
  //         isVid:true,
  //         ctg:"telaviv",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  // 				<h2>The different charms of Tel Aviv and Jaffa Ports</h2>
  // 					<p>
  // 						Jaffa Port offers an ancient history, stone buildings and cobbled lanes while Tel Aviv Port is a contemporary cultural, recreational and commercial hub.
  // 					</p>

  // 					<h2>
  // 					    Jaffa Port
  // 					</h2>
  // 					<p>
  // 						The modern city of Tel Aviv had its humble beginnings in the port of Jaffa where immigrants, armies and traders docked their ships. The port is famed as one of the oldest in the world and today it is still used by local fishermen while the historic surrounding area has become a popular tourist destination.
  // 					</p>

  // 					<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/posts/3/2.jpg"} class="img-responsive" />
  // 						<div class="cradit">
  // 								<small>Dana Friedlander</small>
  // 					    </div>
  // 					</div>

  // 					<p>
  // 						The waterside hangers have been converted into galleries and cultural spaces like the Nalaga’at Center operated by the deaf and blind community and the Dvir Gallery. From the waterfront the ancient cobbled alleyways wend their way up through stone buildings reminiscent of old Jerusalem. In among the historic buildings are galleries, specialty stores and excellent restaurants. As you reach the upper levels of the Old Port area you can see St. Peter’s Church, the Wishing Bridge, the Old Jaffa Museum and the Ilana Goor Museum.
  // 					</p>

  // 					<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/posts/3/1.jpg"} class="img-responsive" />
  // 					</div>

  // 					<h2>
  // 						Tel Aviv Port
  // 					</h2>
  // 					<p>
  // 						In contrast to Jaffa Port Tel Aviv has a more commercial and contemporary feel. The port operated from 1938 to 1965 and has undergone renewal and restoration to convert it into a shopping and entertainment district. The port area consists of converted hangers and a long wide waterfront promenade. It is popular with families visiting the Dyada Center for children’s activities and others visiting the yoga center, center for women, conference venue and the Cavim Institute of Design and Architecture. The promenade is always alive with street performers, musical events and outdoor markets. The port is a contemporary and dynamic area for creative and cultural expression. When the sun goes down the Tel Aviv Port becomes a popular nightlife destination with bars and clubs.
  // 					</p>

  // 					<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/posts/3/3.jpg"} class="img-responsive" />
  // 						<div class="cradit">
  // 								<small>Dana Friedlander</small>
  // 					    </div>
  // 					</div>

  //          `
  //     }
  //   }
  // },

  {
    id: "TelAviv_By_The_Sea",
    bgImage: "posts/bank/17/1.jpg",
    mobBgImage: "posts/bank/17/M.jpg",
    title: "ПРИМОРСКИЙ ТЕЛЬ-АВИВ",
    vidId: "PdTkXbiBpFs",
    isVid: true,
    ctg: "telaviv",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<br/>
			<h2 class="ac-margin-bottom-20 ac-margin-top-20">
				Потому что Тель-Авив <Br/>невозможно представить без пляжей
			</h2>
			<p>
				Не сомневайтесь, вы получите огромное удовольствие на солнышке. <br/><b>Журнал National Geographic: «Один из десяти лучших пляжных городов мира»</b>
			</p>
			
			
            <p>
               У каждого из 16 пляжей Тель-Авива, с чистыми водами и наполненными развлечениями, есть собственный стиль, который привлекает определенных личностей – от случайных хиппи до пляжных красавиц. Развлекаться время на пляже днем или ночью – это лучший способ провести время в Тель-Авиве.
            </p>
            <p>Лучший способ познакомиться с новым городом — это пройти его вдоль и поперек, но в Тель-Авиве по городу лучше ехать, и лучше всего на велосипеде.&nbsp; За последние несколько лет в Тель-Авиве появилось много двухколесного транспорта, чему способствовало развитие сети велосипедных дорожек и организация парковок.&nbsp;&nbsp; Для туристов это просто здорово: теперь передвигаться по городу - одно удовольствие.</p>
				<p>Двухколесный транспорт Тель-Авива</p>
				<p>В городе созданы все условия для велосипедистов и даже перепад высот небольшой, что делает езду приятной и неутомительной, к тому же велосипед помогает избежать ставших уже легендарными пробок на автодорогах.&nbsp; Велосипед - это отличный способ для жителей и туристов передвигаться по городу в собственном темпе. От спокойного зеленого парка Яркон до центральной площади Рабина вы можете добраться всего за семь минут, то есть примерно за то же время, как если бы вы ехали на машине!</p>
				<p>Вдоль центральной линии бульвара Ротшильда в тени деревьев проложена велосипедная дорожка, и, совершая велосипедную прогулку, вы можете любоваться знаменитыми зданиями в стиле Баухаус. Обновленный бульвар в порту Тель-Авива и приморская набережная в Тель-Авиве и Яффо также привлекают велосипедистов. Велосипедная прогулка вдоль прекрасного побережья Средиземного моря - это одно из самых романтичных туристических впечатлений от посещения Тель-Авива, особенно, если делать это на закате солнца, когда с моря начинает дуть легкий бриз.</p>
				<h2>Объехать Тель-Авив на двух колесах</h2>
				<p>В 2011 году в центре Тель-Авива была организована система проката велосипедов Тель-O-Фан.&nbsp; Эта система работает аналогично тому, как работают подобные схемы в Нью-Йорке, Лондоне и Париже.&nbsp; Туристы и гости города могут приобрести прокатные карточки на один день или на неделю, которые принимаются в любом из 206 терминалов проката велосипедов, установленных в разных районах города. Проведите карточкой в терминале, возьмите велосипед - и весь город в вашем распоряжении!</p>
				<p>Еще один интересный способ передвижения на двух колесах - это сегвеи. Экскурсии на сегвеях вместе с гидом по оживленной припортовой зоне Тель-Авива, по дорожкам природного парка Яркон, по живописным старым районам Яффо и очаровательным старым кварталам в стиле Баухаус предлагаются для тех туристов, кто хочет заглянуть туда, куда не проложены автобусные маршруты.</p>

			`,
      };
    },
  },

  {
    id: "Sarona_TelAviv",
    bgImage: "posts/bank/36/1.jpg",
    mobBgImage: "posts/bank/36/M.jpg",
    title: "Сарона в Тель-Авиве",
    isVid: true,
    ctg: "telaviv",
    // vidId: "bWY_8bHq3as",
    vidId: "MJ-gsGs1tqA",
    smlTitle: "",
    html: function() {
      return {
        __html: `    

			<br/>
			            <h2 class="ac-margin-bottom-20 ac-margin-top-20">На тель-авивском рынке Сарона – неограниченный выбор продуктов </h2>
						<p>В зданиях, построенных 150 лет назад обществом темплеров в центре Тель-Авива, и вокруг них, разместился рынок Сарона — настоящий «котел» израильской кухни. Сарона служит отражением неповторимой тель-авивской кулинарной атмосферы и стоит несколько особняком среди других, традиционных рынков Тель-Авива. Сарона удовлетворит любую вашу прихоть — вы сможете отведать и оценить кулинарные идеи самых разных народов, вдохновляющие шумный приморский город.</p>
						
						<p><strong>Посетите крупнейший крытый продуктовый рынок Израиля</strong></p>
						<p>От изысканных деликатесов со всего мира до множества традиционных местных блюд — в Сарона есть все, и она подарит настоящее удовольствие даже самым взыскательным гурманам. Более 90 ресторанов, торговых рядов, пабов и кулинарных бутиков открыты здесь семь дней в неделю, и все, что вам нужно — это выбрать: соблазнительную тарелку супа рамен, поднос острых эмпанадас, пикантный сэндвич «Субмарина» или сладкую выпечку. Не можете решить? Не беда, закусочные расположены одна за другой, так что составить меню будет проще простого: например, отведав морепродуктов, вы сможете продолжить трапезу острой лапшой пад тай и сочным гамбургером.</p>
						<p>Хотите немного отдохнуть между блюдами? На рынке Сарона множество магазинов сопутствующих товаров, музеев, различных развлечений, а также центр посетителей.</p>
						<p><strong>Зеленая кухня</strong></p>
						<p>Вот и конец недели! Пятница в Сарона — особое время, когда на рынок привозят свежие продукты с ферм. И тогда привычный процесс покупки превращается в захватывающее действо. После того как вы выбрали основные продукты — не останавливайтесь, купите еще пикантные импортные сыры, итальянский бальзамический уксус высшего качества, элитное пиво и сладости. И ваша домашняя трапеза на выходных превратится в настоящее пиршество.</p>
						<p>Рынок Сарона станет вашим надежным гидом в мире современной израильской кухни. Возможность узнать все секреты уникальной кулинарной жизни Тель-Авива делают рынок Сарона особым местом: здесь смогут удовлетворить самый прихотливый вкус самого требовательного гурмана.</p>
								
			`,
      };
    },
  },

  {
    id: "Neve_Tzedek",
    bgImage: "posts/bank/4/1.jpg",
    mobBgImage: "posts/bank/4/M.jpg",
    title: "Неве Цедек",
    // vidId: "F6n-WK0RHk0",
    vidId: "9l04RfZ95J0",
    smlTitle: "",
    isVid: true,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `

                      	<br/><h2 class="ac-align-center ac-margin-top-20">Шик и уникальность.</h2>
                        <p class="ac-align-center ac-margin-bottom-20"><b>Множество уютных кафе, бутиков, художественных галерей и расслабленной атмосферы.<br class="hide-on-mobile"/> Оазис искусства в сердце шумного Тель-Авива</b></p>
                 
                      	
						<p>  Отдохните от бурного темпа Тель-Авива; этот район – скрытая жемчужина, которая может похвастаться очаровательным восточным архитектурным стилем и чарующими узкими улочками, которые делают Неве-Цедек, что буквально означает «оазис правды», настоящим оазисом в самом сердце шумного города.</p>
						<p><strong>Насладитесь волшебной атмосферой тенистых двориков ресторанов и кафе Неве-Цедек</strong></p>
                        <p>Внутри одного из старейших районов Тель-Авива скрывается настоящая архитектурная жемчужина с живым бьющимся сердцем. Основанный в 1887 году район Неве-Цедек, первое еврейское поселение за пределами старого яффского порта, в последнее время стал излюбленным местом для художников самых разных направлений. Их творения прекрасно дополняют причудливый архитектурный ансамбль района, созданный в восточном стиле и полностью отреставрированный.</p>
	
                        <p><strong>Оазис в центре Тель-Авива</strong></p>
                        <p>Если вы ищете керамику ручной работы, уникальный предмет одежды или ювелирное изделие, созданное в традиционной технике – к вашим услугам бесчисленные бутики, галереи, ателье и магазины модной одежды, расположенные в зданиях восточного стиля вдоль улицы Шабази и близлежащих переулках. Легкий морской бриз охладит вас во время изучения окрестностей, и вы сполна ощутите радость жизни и умиротворение, столь гармонирующие с особым духом этого района.</p>
                        <p>Насладитесь волшебной аурой тенистых двориков ресторанов и кафе Неве-Цедек и легкой, но сытной едой. Множество закусочных, расположенных в причудливых исторических зданиях, предложат вам отведать настоящие кулинарные шедевры. Вкусная еда и умиротворение узеньких улочек позволят ощутить неповторимую богемную атмосферу.</p>
                        <p><strong>Творчество без границ</strong></p>
                        <p>Визит в Неве-Цедек будет неполным без посещения Музея искусств Нахума Гутмана. Его постоянные экспозиции и интерактивные мероприятия укрепят ваше желание подробнее ознакомиться с произведениями искусства в других местных галереях и студиях керамики.</p>
                        <p>Посетите тель-авивский Центр театра и балета им. Сюзан Далаль, где вы сможете увидеть одно из многочисленных театральных представлений. Также здесь проводятся различные фестивали, включая этнические песенно-танцевальные. Центр им. Сюзан Далаль — это своего рода мост, связывающий самобытную культуру Израиля и мировое культурное наследие.</p>
                        <p>Поднимитесь по улице Шабази и погрузитесь в ее творческую атмосферу, которая охватывает и центр А-Тахана. Это старая железнодорожная станция Яффо, перестроенная в еще один уникальный центр развлечений, где магазины и кафе размещаются в самых неожиданных исторических объектах.</p>
						<p><a href="https://info.goisrael.com/en/attractions#/specFilters=6m!#-!19&amp;pageSize=24&amp;viewMode=grid&amp;orderBy=0&amp;pageNumber=1" rel="nofollow" target="_blank">View attractions in Tel Aviv &amp; Center at Tourist Information site</a><br><a href="https://info.goisrael.com/en/accomodations#/specFilters=6m!#-!19" rel="nofollow" target="_blank">View accommodations in </a><a href="https://info.goisrael.com/en/attractions#/specFilters=6m!#-!19&amp;pageSize=24&amp;viewMode=grid&amp;orderBy=0&amp;pageNumber=1" rel="nofollow" target="_blank">Tel Aviv &amp; Center</a><a href="https://info.goisrael.com/en/accomodations#/specFilters=6m!#-!19" rel="nofollow" target="_blank"> at Tourist Information site</a></p>
                        
						
              
			`,
      };
    },
  },

  // {
  // 	id:9,
  // 	bgImage : "posts/bank/5/1.jpg",
  // 	mobBgImage : "posts/bank/5/M.jpg",
  // 	title: "Jerusalem Old and new ",
  // 	isVid:true,
  // 	ctg:"jerusalem",
  // 	vidId: "MXtcTm_JXus",
  // 	smlTitle: "",
  // 	html: function(){
  // 		return {
  // 			__html:`
  // 			<h2>Ancient treasures and modern luxuries.</h2>

  // 			<p>
  // 				Downtown Jerusalem is the heart of the modern metropolis, bursting with nightlife, dining and cultural options to rival any major city in the world.
  // 			</p>
  // 			<p>
  // 				The area is made up of several neighborhoods and appealing locations such as charming Nachlat Shiva, the bustling Yafo Street and Ben Yehuda Street, with its own unique personality and atmosphere not to be missed.
  // 			</p>
  // 			<p>
  // 				The center of Jerusalem includes some of the city’s most charming neighborhoods and fascinating attractions. For an unbeatable cultural experience, check out Jerusalem’s variety of fascinating museums, including the world class Israel Museum, the Bible Lands Museum and Jerusalem’s Science Museum.
  // 			</p>
  // 			<h2>
  // 				Machane Yehuda Market
  // 			</h2>
  // 			<p>
  // 				Discover this market's unrivaled atmosphere and variety which draw thousands of tourists every day. Once the shopping is done and the food vendors close up, join the young trendy crowds, foreign and locals alike, who descend on the market to drink and party until the small hours, in the bars, restaurants and alleyways.
  // 			</p>
  // 			<h2>
  // 				Nahalat Shiv’a
  // 			</h2>
  // 			<p>
  // 				This charming cobblestone neighborhood at the heart of the city offers an excellent selection of shops, restaurants, bars and outdoor cafés. Nahalat Shiva is home to Kikar Hamusica (Music Square) – a lively and trendy outdoor space that offers live music every day throughout the week.
  // 			</p>
  // 			<h2>
  // 				Yemin Moshe
  // 			</h2>
  // 			<p>
  // 				This lovely neighborhood facing the Old City walls was originally built to escape overcrowding in the 19th Century. Home to artists, writers and academics, Yemin Moshe is known for its beautiful windmill and oriental style houses, green parks, lively music center and stunning views.
  // 			</p>
  // 			<h2>
  // 				Ein Kerem
  // 			</h2>
  // 			<p>
  // 				Nestled in a peaceful valley between the mountains and the terraced hills southwest of Jerusalem, Ein Kerem is one of Jerusalem’s most picturesque neighborhoods. With its winding paved lanes, their charming stone houses adorned with arches, churches whose bells chime in the clear air, Ein Kerem radiates charm and beauty like an island in a sea of green forest
  // 			</p>

  // 			`
  // 		}
  // 	}

  // },

  {
    id: "Market_Madness",
    bgImage: "posts/bank/10/1.jpg",
    mobBgImage: "posts/bank/10/M.jpg",
    title: "ИЕРУСАЛИМСКИЙ БАЗАР",
    vidId: "2CSCe2WC7Ns",
    isVid: true,
    ctg: "culinaryjerusalem",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                    <br/>
                    <h2 class="ac-margin-bottom-20 ac-margin-top-20">Ночная жизнь на рынке Махане Иегуда</h2>
					<p>


                          Толпы местных жителей и туристов стекаются сюда в течение дня, чтобы окунуться в колоритную атмосферу рынка и, конечно же, кое-что купить, а когда продуктовые магазины закрываются, здесь собираются вновь, но уже для вечернего отдыха и развлечений в барах, ресторанах и на узких улочках Шука.
                    </p>
                    <p>
                           В течение всей недели Шук работает практически без выходных, но если вам хочется провести по-настоящему интересный вечер, приходите сюда в четверг. Для местных это единственный вечер, когда они могут развлечься, не беспокоясь о том, что назавтра нужно рано вставать на работу. Еще недавно Шук был всего лишь местом, где можно было купить продукты и перекусить в местной закусочной, но примерно 5 лет назад здесь открылось несколько модных баров и ресторанов, а за ними стали открываться все новые и новые места, и стало уже трудно уследить за ежедневно возникающими ресторанчиками, спрятанными в укромных закоулках, о которых известно только местным жителям.
                    </p>
                    <p>
                           «Глядя на вечеринки на Шуке в четверг вечером, трудно поверить, что всего несколько лет назад здесь ночью не было ни души», – говорит местный экскурсовод Джоель Хабер, – «но, по правде говоря, это не просто следующий логичный этап в постоянном историческом развитии Махане Иегуда, сегодня это самая интересная достопримечательность ночной жизни Иерусалима. Шук всегда был тем местом, где иерусалимцы смешивались в единую толпу. Сегодня  молодые и не очень, светские и религиозные, все сидят вместе, пьют пиво и наслаждаются неповторимой атмосферой Шука».

                    <br>

                            Вот лишь некоторые заведения, которые получили статус «ол-стар», и в которых всегда можно замечательно провести время.

                             вино, вкусная еда и танцы
                    </p>
                    <h3>
                          WINE, DINE AND DANCE
                    </h3>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "posts/7/1.jpg"} class="img-responsive" />
					</div>

				    <h3>
                        «Казино Париж»
                    </h3>

                    <p>
                         У спрятавшегося в глубине Грузинского базара бара «Казино Париж» богатая история. Когда-то в здании, где сегодня находится бар, располагалось казино, затем гостиница и клуб британских офицеров, а сегодня это один из самых шикарных баров на Шуке. Посетители бара в основном люди от до 30 до 40 лет, но в четверг здесь много молодежи, бар открыт до 2 – 3 ночи, подают в нем замечательные фирменные коктейли, бочковое пиво, вполне приличное вино и замечательные молочные блюда, приготовленные из продуктов, которыми так богат Шук.
                    </p>

                    <h3>
                          CINCO DE MAYO
                    </h3>
                   
                    <p>
                          Если вы ищете приятную атмосферу, Cinco De Mayo – неплохое место для начала отдыха. Публика начинает собираться после 10 вечера, так что не удивляйтесь, если не найдете свободный столик ближе к полуночи. Вы всегда можете, как это делают местные, взять напиток в баре и выпить его, прогуливаясь по переулкам Шука.
                    <br/>
                          Несмотря на свое название, у Cinco de Mayo ничего общего с Мексикой или с 5 мая. Компания друзей, которая открыла этот бар, взяла это название из жизни коммуны недалеко от Иерусалима, где они жили раньше, и где 5 мая был нерабочим днем.
                    </p>

                    <h3>
                          «Бар Шука»
                    </h3>
                    <p>
                          Несмотря на место своего расположения и относительно небольшие размеры «Бар Шука» на улице Эгоз – одно из самых популярных заведений на Шуке. Подают здесь местное пиво, ликеры и небольшие закуски, но в четверг вечером из крошечного заведения бар превращается в огромную вечеринку.
                    </p>

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "posts/7/2.jpg"} class="img-responsive" />
						
					</div>



					<h3>
                          QUE PASA
                    </h3>
                    <p>
                          В то же время по соседству расположен ресторан Que Pasa, в котором его хозяин Янив Ковенштейн постарался воссоздать культуру тапас, которая так полюбилась ему в Испании.
                    <br/>
							Совладелец и шеф-повар Ави Бетито Голанский привнес свое видение идеального меню, где есть множество молочных и рыбных блюд размера тапас, включая вкуснейшую Bruschetta Cuca (хрустящая лепешка с сардинами, луком, острым красным перцем и оливковым маслом) и Porcini Bruschetta (боровики, обжаренные в масле с чесноком, миндальным маслом и петрушкой), артишок с трюфелями, филе сардин, фаршированное сыром Saint Moor и жаренное в масле шалфея, салат из помидоров, жареные кольца кефали с перцем и многое другое. А для любителей больших порций есть блюда и посерьезней – ньоки, филе морского окуня или барабулька.
				    <br/>
							И хотя девиз бара – «выпей пиво в полдень, и нет проблем», стоит заглянуть сюда и в четверг вечером, потому что по четвергам в Que Pasa всегда звучит живая музыка.
                    </p>
                    <h3>
                         Шем Тов
                    </h3>

                   <p>
                         Расположенный на улице Эшколь, ресторан «Шем Тов» предлагает богатое ближневосточное меню, обширный выбор израильского пива, вин и ликеров и музыку со всего мира, благодаря которой посетители задерживаются здесь до поздней ночи.
                    <br/>
						Здесь также подают самый лучший на Шуке сахлеб, который обычно подается горячим, он приготовлен из измельченных клубней орхидей с розовой водой, молоком и корицей. Пальчики оближешь!
					<br/>
						где можно поесть поздно ночью
					<br/>
						Если ближе к полуночи вам захочется вкусно перекусить, то на Шуке вы найдете богатый выбор закусочных.
                    </p>
                    <h3>
                          «Сорамело»
                    </h3>
                    <p>
                         Если выпитый алкоголь разбудил у вас аппетит, идите в «Сорамело» на входе с улицы Агрипас, здесь подают вкуснейшие вафли.
                    <br/>
                        В «Сорамело» всю ночь много посетителей, которые заходят сюда на рюмочку,  чашечку кофе или чтобы съесть десерт, но еще более тесно здесь становится поздно ночью, когда люди переходят от алкоголя к ночному «перекусу». Если вы один из них, поторопитесь, вам нужно успеть до 3 часов ночи в четверг, чтобы вафлей смягчить все то пиво и арак, который вы выпили. Попробуйте вафлю с шоколадом и тхиной – она вас не разочарует!
                    </p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "posts/7/3.jpg"} class="img-responsive" />
					</div>

						<h3>
                          «Мичис»
                    </h3>
                    <p>
                         Концепция «Мичис» проста: это идеальная ночная забегаловка – прекрасные гамбургеры и сэндвичи по доступной цене. Здесь вы сможете попробовать  гамбургер  всего за 17 шекелей. А если вы действительно голодны, закажите большую порцию мяса или сэндвич с ростбифом или курятиной. «Мичис» открыт до 24:00.
                    </p>

                    <h3>
                          «Меурав Йерушалми»
                    </h3>

                    <p>
                        Это, пожалуй, самое лучшее место, где можно поесть знаменитый иерусалимский микс-гриль, приготовленный из различных видов мяса и потрошков в пите с чипсами и салатами. Кроме традиционного мясного «меурав йерушалми» можно заказать рыбный. Порции очень большие, они идеально подходят для тех, кто нагулял аппетит. Только постарайтесь добраться туда до полуночи.
                    </p>

                    <h3>
                         «Паста Баста»
                    </h3>

                    <p>
                         «Паста Баста» – одно из самых популярных мест на Шуке. Сюда приходят, чтобы поесть свежей домашней пасты по вполне доступной цене. Все, что вам нужно сделать – это выбрать тип пасты и соус, и ваша еда готова. Цена зависит от типа соуса и варьируется от 19 до 26 шекелей за порцию. Ньоки, равиоли и добавки  – за дополнительную плату. «Паста Баста» открыта до полуночи, и не удивляйтесь, если увидите очередь.
                    </p>
                    <p>Фотография: Бэри Каплан</p>

              
			`,
      };
    },
  },

  {
    id: "Market_Madness_Post",
    bgImage: "posts/bank/10/1.jpg",
    mobBgImage: "posts/bank/10/M.jpg",
    title: "МАХАНЕ ЙЕГУДА ВКУС ИЗРАИЛЬСКОЙ КУЛЬТУРЫ",
    vidId: "2CSCe2WC7Ns",
    isVid: true,
    ctg: "culinaryjerusalem",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                    
                    <Br/><h2 class="ac-margin-bottom-20 ac-margin-top-20">Праздник красок, вкусов и запахов на иерусалимском рынке </h2>
					<p>Рынок под открытым небом Махане Йегуда считается одним из самых колоритных и оживленных в Израиле. Здесь вас ждут приветливые продавцы, свежие продукты, необычные закусочные и уникальные развлечения. Рынок постоянно обновляется, предлагая гармоничное сочетание вековых традиций и современности. А вид и запах деликатесов, наполняющих бесконечные прилавки, просто завораживает!</p>
				     <div class="img-wrapper">
						<img src=${getImgUrl() + "posts/7/1.jpg"} class="img-responsive" />
					</div>
					<p><strong>Познакомьтесь с культурой и кухней</strong></p>
					<p>Прогуляйтесь по длинным, узким улочкам, и вы обнаружите широкий выбор ресторанов, кафе, пабов, веганских закусочных и небольших магазинчиков. Переступив порог любого из них, вы внезапно окажетесь в тишине. А буквально за порогом будет шуметь рынок, где торговцы, зазывая покупателей, расхваливают свой товар: только что испеченный хлеб, свежие фрукты и овощи, салаты, сладости, ароматные пряности, мясо и рыбу. От одних только запахов у вас закружится голова, и они словно перенесут вас в самые удивительные уголки мира. Свежие фрукты, теплый фалафель в пиите, халва с различными добавками… Невозможно устоять!</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "posts/7/2.jpg"} class="img-responsive" />
						
					</div>
					<p><strong>Прогулка и дегустация</strong></p>
					<p>Закажите кулинарную экскурсию, во время которой вы сможете как познакомиться с рынком поближе, так и отведать рыночных деликатесов. Послушайте рассказы об истории рынка и посетите магазинчики и киоски, которые помогли Махане Йегуда стать самым известным рынком Израиля. А когда наступает вечер – посмотрите, как рынок превращается в оживленное и стильное место развлечений для местной молодежи и туристов. &nbsp; &nbsp;</p>
                      <div class="img-wrapper">
						<img src=${getImgUrl() + "posts/7/3.jpg"} class="img-responsive" />
					</div>
					`,
      };
    },
  },

  // {
  // 	id:"13",
  // 	bgImage : "posts/bank/24/1.jpg",
  // 	mobBgImage : "posts/bank/24/M.jpg",
  // 	title: "The old city ",
  // 	vidId: "k4OwoEk5wMw",
  // 	smlTitle: "",
  // 	html: function(){
  // 		return {
  // 			__html:`
  // 			<h2>Feel the story come alive</h2>
  // 			<p>
  // 			   Become inspired by the world renowned treasures of the ancient city of Jerusalem.
  // 			</p>

  // 			`
  // 		}
  // 	}

  // },

  // {
  // 	id:14,
  // 	bgImage : "posts/bank/32/1.jpg",
  // 	mobBgImage : "posts/bank/32/M.jpg",
  // 	title: "The Dead Sea ",
  // 	vidId: "DzEJxjnC_UQ",
  // 	isVid:true,
  // 	ctg:"deadsea",
  // 	smlTitle: "",
  // 	html: function(){
  // 		return {
  // 			__html:`
  // 			<h2>Time to bask in nature’s glory</h2>
  // 			<p>
  // 			   Get high on life in the lowest place on earth.
  // 			</p>

  // 			`
  // 		}
  // 	}

  // },

  // {
  // 	id:3,
  // 	bgImage : "posts/bank/58/1.jpg",
  // 	mobBgImage : "posts/bank/58/M.jpg",
  // 	title: "The Dead Sea ",
  // 	vidId: "DzEJxjnC_UQ",
  // 	isVid:true,
  // 	ctg:"deadsea",
  // 	smlTitle: "",
  // 	html: function(){
  // 		return {
  // 			__html:`
  // 			<h2>Time to bask in nature’s glory</h2>
  //               <p>
  // 						The Dead Sea is one of the most unique natural phenomena on the planet. A crevice in the earth’s crust that is part of the Great Rift Valley allows the waters of the River Jordan to flow south into a lozenge-shaped lake at the lowest point on our planet. With no outlet, the rays of the blazing sun evaporates the Jordan water to a point where its mineral content is highly concentrated; and it is this density of minerals and salt that makes it impossible to sink in the sea: bathers float effortlessly on the water’s surface. Because the sun has to travel an additional 1,200 feet to reach the shore, ultra-violet rays are filtered out and oxygen is enriched to a point where even the fairest skins tan but do not burn.
  //               </p>
  //               <p>
  //               		This is why a visit to the Dead Sea enables sufferers of rheumatic diseases to breathe better, and why victims of psoriasis and other serious skin ailments receive temporary cures by bathing in the Dead Sea, slathering themselves with Dead Sea mud and baking in the non-burning sun.
  //               </p>
  //               <p>
  //               		The Dead Sea is lined with spas, bathing beaches and spa hotels.
  //               </p>
  // 			`
  // 		}
  // 	}

  // },

  {
    id: "Go_To_Guide",
    bgImage: "/posts/bank/gotoguide/1.jpg",
    mobBgImage: "/posts/bank/gotoguide/M/1.jpg",
    title: "Иерусалим и Тель-Авив",
    ctg: "telaviv",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `
 
				     <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/gotoguide/2.jpg"} class="img-responsive" />
					</div>
					<BR/>
                    <h2 class="ac-margin-bottom-20 ac-margin-top-20">
                    Менее чем в одном часе путешествия!
                    </h2>
					
			        
					<p>Добраться в и из Иерусалима и Тель-Авива легко, существует несколько способов в зависимости от ваших предпочтений и бюджета:</p>
                    <p><strong>Автомобилем:</strong> если вы решите взять в аренду авто, вы найдете маршрут 1, который непосредственно соединяет два города, дорожные знаки на котором яркие и дублируются на трех языках. Однако, вы можете использовать одно из местных навигационных приложений, которое покажет вам путь и поможет избежать пробок. </p>
                    <p><strong>Автобусом:</strong> есть несколько общественных автобусов, которые едут в и из Тель-Авива и Иерусалима. Это, безусловно, один из самых удобных и бюджетных способов путешествия. </p>
                    
                    <p><strong>Поездом:</strong> удобный железнодорожный сервис работает на нескольких основных станциях в и из Тель-Авива и Иерусалима. В настоящее время ведутся работы и в ближайшее время начнет работать новый прямой быстрый маршрут между двумя городами. </p> 
                    <p><strong>На такси: </strong>такси для междугородних поездок можно поймать на улице, забронировать по телефону или через специальные приложения, такие как Gett (GetTaxi).</p>
                    <p><strong>Шерут такси:</strong> «шерут» (услуга) такси – это 10-12-местные фургоны, которые в целом следуют по основным автобусным маршрутам и между основными городами. Тарифы такси Шерут умеренны с фиксированной ценой, как и в общественном автобусе. Такси «Шерут» также предоставляют замену автобусам в обслуживании по пятницам.</p>
                    <p>Информацию о железнодорожных станциях, маршрутах и расписанях ищите на www.rail.co.il</p>
                    <p>Информацию о автобусных маршрутах и расписаниях ищите на www.bus.co.il</p>
                    <p>Служба поддержки общественного транспорта *8787</p>
                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/gotoguide/1.jpg"} class="img-responsive" />
					</div>
                    <p>Мобильное приложение местного общественного транспорта – «Moovit»</p>
                    <p>Итак, посетите невероятный Тель-Авив и незабываемый Иерусалима, расположенные в менее часа езды друг от друга!</p>

            	`,
      };
    },
  },

  {
    id: "Day_IsTrippin",
    bgImage: "/posts/bank/48/1.jpg",
    mobBgImage: "/posts/bank/48/M/1.jpg",
    title: "ОДИН ДЕНЬ В ТЕЛЬ-АВИВЕ",
    isVid: false,
    ctg: "telaviv",
    smltitle: "",
    html: function() {
      return {
        __html: `

				

				<p>Начните свой день в парке склонов Яффа, с прекрасным панорамным видом на большую часть израильской береговой линии, и исторической отправной точкой метрополии, которая была создана около 4000 лет назад. Возьмите чашку кофе в отреставрированном старинном порту и направляйтесь на север гуляя по набережной и наслаждаясь фантастическими пляжными развлечениями. </p>
                    
                    <div class="img-wrapper">
					     <img src=${getImgUrl() +
                 "/thingsToDo/posts/37/2.jpg"} class="img-responsive" />
				     </div>
					<p>Пересеките улицу к зданию «Тахана Компаунд» – прекрасно отремонтированного торгового центра на открытом воздухе, расположенного на неработающем историческом железнодорожном вокзале, построенном в 1890-х годах, который служил в Тель-Авиве и Яффе в качестве центрального железнодорожного вокзала. </p>
                    <p>Следуйте к живописному району Неве-Цедек и переходите красивыми переулками. Побалуйте себя в бутиках, пока не дойдете до яркой суеты рынка Хакармел. Остановитесь ради прекрасной уличной еды, и, если это вторник или пятница, – считайте себя счастливым и совершайте покупки на выставке традиционных изделий Нихлат Биньямин, где местные ремесленники представляют свои работы. </p>
                    
                    <div class="img-wrapper">
					    <img src=${getImgUrl() +
                "/thingsToDo/posts/37/1.jpg"} class="img-responsive" />
				    </div>
					<p>Продолжайте путь к роскошному бульвару Ротшильда, который является сердцем Баухауз-архитектуры и площадкой международного наследия ЮНЕСКО. Это место где стоит взять напрокат велосипед и присоединиться к местному потоку на площадь Хабима, которая является домом национального театра и израильского филармонического оркестра. Следуйте к модной, оживленной улице Дизенгофф или перекусите в одной из кофеен на площади и продолжайте ехать или идти вдоль бульвара Хен к площади Рабин. </p>
                    <p>Познакомьтесь с улицей Эбен Габироль, модным центром замечательного города, домом множества ресторанов, а также замечательных пабов и баров, где можно попробовать блюда или выпить и зависнуть с местными жителями.</p>
                    <p>Садитесь на 5-й маршрут, который сам по себе является городской иконой, и выходите в порту Тель-Авива. Наслаждайтесь закатом солнца и посмотрите на юг в направлении горизонта Джаффе, где начинался день. Проведите свой вечер в этом районе и наблюдайте, как он превращается в самую горячую сцену ночной жизни города, заполненную сказочными барами и ночными клубами для грандиозных ночей. </p>


            	`,
      };
    },
  },

  {
    id: "Non_Stop_Culture",
    bgImage: "/HomeSlider/desktop/6.jpg",
    mobBgImage: "HomeSlider/M/3.jpg",
    title: "Время культуры",
    isVid: false,
    // vidId:"MXtcTm_JXus",
    ctg: "telaviv",
    smltitle: "",
    html: function() {
      return {
        __html: `
				<br/>
                    <h2  class="ac-margin-bottom-20 ac-margin-top-20">Разнообразные увлекательные музеи и уникальные галереи</h2>
                    
				    <h3>
                          Тель-Авивский музей изобразительных искусств
                    </h3>
                    <p>
                        Тель-Авивский музей изобразительных искусств предлагает большой спектр постоянных и временных выставок в павильоне Елены Рубинштейн, который находится на бульваре Шауль Хамелех рядом с концертным залом «Mann Auditorium». Постоянные выставки включают в себя несколько лучших работ израильских художников, а также скульптурные работы, созданные в период с 20-х годов прошлого века и по сегодняшний день. Кроме того, в музее выставлены работы европейских художников  живших с 16 по 20 вв., включая импрессионистов и постимпрессионистов, а также европейские и американские работы 20 века. Коллекция графики музея составляет более 20.000 гравюр и миниатюр. Среди выдающихся шедевров в музее представлены уникальная коллекция ранних рельефов Александра Архипенко и работы Шагала, которые художник пожертвовал музею еще до его основания. Знаменитая коллекция миниатюрных комнат Елены Рубинштейн представлена в постоянной экспозиции в павильоне, носящем ее имя.
                    </p>
                    <h3>
                          Часы работы:
                    </h3>
                    <p>
                         Воскресенье: закрыто <br/>

						 Понедельник, среда, суббота: 10:00-18:00
			        <br/>
						Вторник, четверг: 10:00-22:00
				    <br/>
						Пятница: 10:00-14:00
					<br/>
						Суббота: 10:00-16:00 (В июле и в августе в субботу закрыто)
                    </p>

                    <p><a href="//www.tamuseum.org.il/en/default.aspx" target="_blank">www.tamuseum.org.il</a></p>

                    <h3>
                          «Бейт ха-тфуцот» – Музей Диаспоры
                    </h3>

                   <p>
                        Музей Еврейской Диаспоры, расположенный на территории кампуса Тель-Авивского университета, получил почетное признание еврейских общин всего мира как первый музей истории еврейского народа. Музей демонстрирует вклад евреев в творчество и культуру человечества на протяжении более двух тысячелетий. Постоянная выставка музея рассказывает об истории евреев в диаспоре посредством рисунков, видеороликов, фильмов, архитектурных моделей и других техник. Выставка концентрируется на различных темах, включая «Еврейский жизненный цикл», «Община», «Вера»» и «Возвращение в Сион».
                    </p>

                    <div class="img-wrapper">
					    <img src=${getImgUrl() +
                "/posts/non-stop-culture/1.jpg"} class="img-responsive" />
				    </div> 

					<p>
                          <a href="//www.bh.org.il/" target="_blank">www.bh.org.il</a>
                    </p>

                    <h3>
                          Музей Эрец-Исраэль
                    </h3>
                    <p>
                          Тель-Авивский Музей Эрец-Исраэль – это многоплановое учреждение, повествующее об истории и культуре этой страны посредством богатой постоянной экспозиции и разнообразных временных выставок на такие темы, как археология, этнография, фольклор, иудаизм, история культуры, традиционные ремесла и прикладное искусство. Выставочные залы музея расположены в просторном дворе, в центре которого находятся археологические раскопки древнего Тель-Касиле («Tel Qasile»), где были обнаружены ценные артефакты. В музее представлены многочисленные реконструкции производственных приспособлений, среди них винный пресс, пресс для оливкового масла, а также мельница. На ремесленном рынке посетители музея смогут увидеть традиционные орудия труда, использовавшиеся когда-то на территории Израиля и по всему региону. Тут же есть и современный планетарий с программой «Путешествие по Вселенной», и сувенирный магазин, предлагающий большой выбор сувениров и орнаментов местного производства.
                          <br/>
                          Часы работы: <br/>
                          Воскресенье – среда: 10:00-16:00 <br/>
                          Четверг: 10:00-20:00 <br/>
                          Пятница – Суббота: 10:00-14:00<br/>

                    </p>
                    <p> <strong>&nbsp;</strong><a href="//www.eretzmuseum.org.il/e/" target="_blank">www.eretzmuseum.org.il</a></p>
                    <h3>
                        Бейт ха-Ир
                    </h3>
                    <p>
                        Отреставрированное городом старое здание муниципалитета «Тель Авив – Яффо» на улице Бялик считается сегодня живым экспонатом истории города. Новая выставка «Бейт ха-Ир» включает в себя собрание фотографий и историй, которые запечатлели события, места и жизненный опыт жителей за многие годы – этот проект был частью мероприятий, проводившихся в честь столетия города. В главном холле проходит виртуальная экскурсия, охватывающая сотни документальных фильмов и тысячи редких фотографий и документов, которые демонстрируют основные события в годы становления города. В «Бейт ха-Ир» вы можете также посетить дом Дизенгоффа («Dizengoff House») – отреставрированную резиденцию Меира Дизенгоффа, первого мэра Тель-Авива-Яффо, в котором находится постоянная выставка.
                          <br/>
                          Часы работы: <br/>
                          Воскресенье: закрыто

                          Понедельник – четверг: 9:00-17:00 <br/>

						Пятница – суббота: 10:00-14:00
                    </p>

                     <p> <a href="//beithair.org/" target="_blank">beithair.org</a></p>

                    <h3>
                          Музей олимпийских достижений
                    </h3>
                     <p>
                          A new museum in Tel Aviv-Yafo, The Olympic Experience Museum, presents a one-Этот новый музей в регионе Тель Авив – Яффо предлагает посетителям за один час совершить путешествие протяженностью в пять олимпийских колец и пережить величайшие олимпийские достижения Израиля. Подача информации в музее отличается от стандартной пояснениями и визуальным рядом по последнему слову техники с аудио-видео сопровождением, голограммами, динамическими изображениями с эффектом присутствия и многим-многим другим.
                          <br/>
						Организованные экскурсии проходят каждые 30 минут. Рекомендуется забронировать места заранее.
						<br/>
						Часы работы:
						<br/>
						Воскресенье – четверг: 10:00 – 18:00, Пятница: 10:00 – 14:00
						<br/>
						Путешествие по олимпийским кольцам, ул. Шитрит, Хадар Йосеф.
						<br/>
						Тел. : +972-3-6498385


                    </p>



                    <h3>
                          Музей Иланы Гур
                    </h3>
                    <p>
                          Это частный дом художницы с мировым именем, который был превращен в музей. Здесь можно увидеть ее скульптуры, мебель, ювелирные изделия и ознакомиться с этим своеобразным яффским домом.
                          <br/>
                          Часы работы:
                          <br/>
                          Воскресенье – пятница: 10:00-16:00<br/>
                          Суббота: 10:00-18:00
                          <br/>
                          <a href="https://www.ilanagoormuseum.org/" target="_blank" rel="noopener">www.ilanagoormuseum.org</a>
                    </p>

                    <h3>
                         Музей ПАЛЬМАХа
                    </h3>
                    <p>
                        «Trip Advisor» отметил его как достопримечательность №1. Этот музей исследует историю ПАЛЬМАХа, военного подразделения сионистского движения, которое действовало до создания государства Израиль.
                        <br/>
                        <a href="//info.palmach.org.il" target="_blank" rel="noopener">info.palmach.org.il</a>
                    </p>


                    <h3>
                          Другие заслуживающие внимания музеи
                    </h3>
                    <p>
                          В Тель Авиве – Яффо можно найти целый спектр небольших специализированных музеев, таких как «Бейт Бен-Гурион» (дом Давида Бен-Гуриона, первого премьер-министра Израиля), «Бейт ха-Танах» (Дом Библии), музей «Хагана» (музей военной организации Хагана), музей «I.Z.L.» (Национальная военная организация), «Бейт ха-Софер» (Дом писателя), «Бейт Реувен», Музей Жаботинского и многие другие. Каждый из этих маленьких музеев – это кладезь артефактов. Например, в «Бейт Бялик», доме национального поэта, можно увидеть книги, мебель и личные вещи известного во всем мире израильского поэта. Личная библиотека Бялика, составляющая более 3.000 книг, была сохранена, а в архивах музея хранятся тысячи рукописей поэта.
                    </p>
                    <h3>
                          ЧАСЫ РАБОТЫ МУЗЕЕВ ТЕЛЬ-АВИВА:
                    </h3>
                    <p>
                          Музей «Эцель» <br/>

							Воскресенье – четверг: 8:30-16:00
							<br/>
							<a href="//www.goisrael.com" target="_blank" rel="noopener">www.goisrael.com</a>
                    </p>
                    <h3>
                          Дом Бен-Гуриона
                    </h3>
                    <p>
                          Воскресенье, вторник – четверг: 8:00-15:00 <br/>

							Понедельник: 8:00-17:00
							<br/>
							Пятница: 8:00-13:00
							<br/>
							Суббота: 11:00-14:00 <br/>
							<a href="//www.bg-house.org"  target="_blank" rel="noopener">www.bg-house.org</a>
                    </p>

                    <h3>
                          Институт Жаботинского в Израиле
                    </h3>
                    <p>
                          Воскресенье – Четверг: 8:00-16:00
                          <br/>
                          <a href="//en.jabotinsky.org"  target="_blank" rel="noopener">en.jabotinsky.org</a>
                    </p>
                    <h3>
                          Музей Израиля
                    </h3>
                    <p>
                          Воскресенье, понедельник, среда: 9:00-17:00
                          <br/>
							Вторник, четверг: 9:00-19:00
							<br/>
							Пятница: 9:00-14:00 <br/>
							<a href="//www.imj.org.il"  target="_blank" rel="noopener">www.imj.org.il</a>
                    </p>
                    <p>
                            Туристический информационный центр Яффо <br/>
							Летом. Воскресенье – четверг, суббота: 9:00-20:00
                    </p>
                    <p>
                          Пятница: 9:00-17:00 <br/>

							Зимой. Воскресенье – четверг, суббота: 9:00-18:00
							<br/>
							Пятница: 9:00-15:00 <br/>
							<a href="//www.touristisrael.com"  target="_blank" rel="noopener">www.touristisrael.com</a>
                    </p>
                    <h3>
                          Зал Независимости
                   </h3>
                    <p>
                          Воскресенье – четверг: 9:00-17:00 <Br/>

                           Пятница: 9:00-14:00
                    </p>
                    <p>
                          Музей Библии <Br/>
						Воскресенье – пятница: 10:00-13:00 + 16:00-18:30 <br/>
						<a href="//www.blmj.org"  target="_blank" rel="noopener">www.blmj.org</a>
                    </p>
                    <h3>
                          Дом-музей Йосефа Бау
                    </h3>
                    <p>
                          По предварительному заказу (включая выходные)
                    </p>

                        <a href="//www.josephbau.com"  target="_blank" rel="noopener">www.josephbau.com</a>
                    <h3>
                          Дом-музей Рубина
                    </h3>
                    <p>
                          Воскресенье: закрыто <br/>
                          Понедельник, среда, четверг: 10:00-15:00
							<br/>
							Вторник: 10:00-20:00
							<br/>
							Суббота: 11:00-14:00 <br/>
							<a href="//www.rubinmuseum.org.il" target="_blank" rel="noopener">www.rubinmuseum.org.il</a>

                    </p>
                    <h3>
                            Художественные галереи
                    </h3>
                    <p>
                            Не пропустите десятки художественных галерей, большая часть которых сконцентрирована на улице Гордон и в старом Яффо, где вы сможете познакомиться с современным израильским творчеством. Мы не станем вдаваться в подробности – пусть искусство говорит само за себя.
                    </p>   


            	`,
      };
    },
  },

  {
    id: "A_Taste_Of_Jerusalem",
    bgImage: "/posts/bank/taste-of-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/taste-of-jerusalem/M/1.jpg",
    title: "Иерусалим",
    ctg: "culinaryjerusalem",
    isVid: true,
    vidId: "2CSCe2WC7Ns",
    smlTitle: "",
    html: function() {
      return {
        __html: `



				     <br/>
                     <h2 class="ac-margin-bottom-20 ac-margin-top-20">Обязательно попробуйте в Иерусалиме</h2>
				


				     <p>Иерусалим – чарующий и волшебный город. Многие люди, которые посещают Иерусалим, увлекаются удивительной атмосферой, незабываемыми местами, захватывающим дух видом и многим другим. Однако, чтобы по-настоящему понять, что такое Иерусалим, кое-что вам нужно попробовать. Вот лишь некоторые блюда, которые вам действительно необходимо попробовать во время посещения Иерусалима:</p>
                     <p>Малаби: уникальное сочетание напитка и десерта, изготовленного из смеси розовой воды, молока, кукурузного крахмала и сахара. Малаби очень популярное блюдо в Иерусалиме, которое есть во многих ресторанах Ближнего Востока и киосках по всему городу. Гарантируем, оно не будет похожим ни на что иное, что вы когда-либо пробовали. </p>
                     <div class="img-wrapper">
					     <img src=${getImgUrl() +
                 "/thingsToDo/posts/39/1.jpg"} class="img-responsive" />
				     </div>
                     <p>Кнафе: очень интересное и потрясающе вкусное блюдо, если подается и употребляется свежим. Кнафе по сути представляет собой арабский десерт, изготовленный из растопленного козьего сыра и наполненного оранжевым спагетти, погруженных в сироп из сладкой розовой воды. Поиск идеального Кнафе – это миссия, и когда вы его найдете, вы станете зависимыми от него.</p>
                     <p>Иерусалимский претцель: безусловно, необходимо, во время туров по интересным местам старого города, остановиться у одной из малых зеленых тележек и приобрести настоящий иерусалимский претцель. Вместе с ним вы получите ароматную местную зеленую траву, которая называется Заатар, она идеально сочетается с теплым тестом.  </p>
                     <p>Мероав Ерушалми: непосредственно переводится как «Смешанный Иерусалим», это вкусное сочетание различных видов мяса с особой местной смесью специй – действительно рай для любителей мяса.</p>
                     <p>«Аштанур»: сокращенное на иврите выражение «пожар в печи». Аштанур – это настоящий местный хлеб пита, который вы можете найти в центре или на рынках во время обеда. Если вы очень голодны, попробуйте завернутую в него порцию шаурмы или фалафель. </p>
                     <p>Сабич: абсолютно оригинальное и действительно уникальное местное блюдо, состоящее из хлеба Пита с жареными баклажанами, вареными яйцами и маринованными огурцами, обычно покрытыми местной ароматной приправой – Амба. Как только вы его попробуете – запомните на всю жизнь. </p>


            	`,
      };
    },
  },

  {
    id: "Sectrets_Of_Jewish_Jerusalem",
    bgImage: "/posts/bank/sectrets-of-jewish-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/sectrets-of-jewish-jerusalem/M/1.jpg",
    title: "ОТКРОЙТЕ ИЕРУСАЛИМ В ВОЛШЕБНОМ СТАРОМ ГОРОДЕ",
    ctg: "jerusalem",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
                                <!--<p>Jerusalem is an open invitation for a journey. Climb the mountains, enter the city and feel the unique mix between past and present, ordinary and extraordinary. One of the most ancient cities in the world, sacred for Jews, Christians and Muslims, Jerusalem offers an unparalleled sensory and spiritual experience.</p>

                                <p>Enter. The heart of the holiest city in Judaism is the Old City. Enter through the historic entrance, The Jaffa Gate, or use The Zion Gate that leads straight to the Jewish Quarter, one of the four quarters of the walled city and home to Jews almost consecutively since 8 BCE. Wonder through the alleyways, see the people, visit the Cardo, Jerusalem's ancient main street and absorb the unique atmosphere. You're walking in the footsteps of kings and prophets – It's no ordinary thing.</p>
                                <div class="img-wrapper">
					                <img src=${getImgUrl() +
                            "/posts/sectrets-of-jewish-jerusalem/1.jpg"} class="img-responsive" />
				                </div>
							    <small style="color:#000; display:block;">
                      		        Credit: Noam Chen
                      	        </small>
								<p>Witness History Comes alive and Feel the Deep Spiritual Energy within the Walls </h2>

                                <p>What Lays Ahead.  The last remaining segment from the ancient walls that surrounded The Second Temple, The Western Wall, is a symbol of Jewish yearnings for their ancestral and spiritual homeland. Every Jew outside Jerusalem pray facing the place you stand in now, the place where according to Judaism, God resides. No matter what your beliefs are, it's a humbling experience. Honor the spirit of the site and place a note in the wall with a prayer or a wish.</p>

                                <p>What Lays Beneath. Jerusalem is literally covered with layers of history and touching history gets a whole new meaning here.</p>

                                <p>Take the fascinating tour at the Western Wall Tunnels and reveal the hidden sections of the Western Wall. History will come to life as you move through underground passages, discover life in Jerusalem during The Second Temple era and learn about the art, architecture and building practices.</p>

                                <p>Visit the nearby archeological site City of David and learn more about the history of the city King David declared as the unified capital of Israel's 12 tribes 3000 years ago. Go on a journey between ancient walls and fortresses, hidden springs where kings were coroneted and follow the path of fleeing Jerusalem residents after the city was conquered by the Romans.</p>

                                <h2>Marvel at the Breathtaking Extraordinary Vista and Feel on Top of the World</h2>

                                <p>What Lays Above. Originally built to protect the city against intruders, Jerusalem is surrounded by walls.  Today The Walls of Jerusalem offer an opportunity to explore the city from a different angle. Hear the stories, see the city below you and take in all this beauty.</p>

                                <p>You are just beginning to stretch the surface.</p>-->

                                <p>Совершите незабываемое духовное восхождение в удивительный Иерусалим</p>
								<p>Иерусалим приглашает вас в неповторимое путешествие. Поднимитесь в горы, вступите в город и ощутите уникальное слияние прошлого и настоящего, повседневного и сверхъестественного. Иерусалим — один из древнейших городов мира, священный для евреев, христиан и мусульман — подарит незабываемые ощущения и духовные переживания.</p>
								<p><strong>Вход</strong>. Сердцем святыни иудаизма является Старый город. Войдите в него через исторические <em>Яффские ворота</em>, либо через <em>Сионские ворота</em>, ведущие прямо в <strong>Еврейский квартал. </strong>Это один из четырех кварталов города за стенами, где евреи живут практически постоянно с VIII века до нашей эры. Побродите по его переулкам, повстречайтесь с жителями, посетите <strong>Кардо</strong> — древнюю главную улицу Иерусалима, и впитайте уникальную атмосферу города. Вы следуете по стопам королей и пророков — а это случается не каждый день!</p>
								<p><strong>Станьте свидетелем оживающей истории и ощутите духовную энергию иерусалимских стен</strong></p>
								<p><strong>Что перед вами</strong>. <strong>Западная Стена</strong> (Стена Плача) — это последний из сохранившихся фрагментов древних стен, окружавших Второй храм. Стена Плача служит символом стремления еврейского народа к своей исторической и духовной родине. Каждый еврей, находящийся вне Иерусалима, совершает молитву, обратившись лицом к месту, где вы стоите сейчас; здесь, согласно иудаизму, можно ощутить Божественное присутствие. И это неповторимое ощущение порождает смирение в сердце приверженца любой веры. Воздайте дань уважения этому святому месту и вложите в стену записку с молитвой или сокровенным желанием.</p>
								<p><strong>Что под вами</strong>. Иерусалим буквально состоит из многовековых слоев различных культур, и выражение «прикоснуться к истории» обретает здесь совершенно особый смысл.</p>
								<p>Совершите увлекательную прогулку по <strong>тоннелю Западной Стены</strong> и ознакомьтесь со скрытыми участками Стены Плача. По мере продвижения по подземным тоннелям перед вами будет оживать сама история. Вам откроется иерусалимская жизнь периода Второго храма, вы узнаете об искусстве, архитектуре и строительстве того времени.</p>
								<p>Посетите расположенный поблизости археологический парк <strong>Город Давида</strong> и узнайте больше об истории города, который царь Давид провозгласил объединенной столицей 12 колен Израиля 3000 лет назад. Не спеша прогуляйтесь между древних стен, башен и скрытых источников, где совершались коронации, и пройдите путем беженцев из Иерусалима после захвата города римлянами.</p>
								<p><strong>Полюбуйтесь захватывающим видом и почувствуйте себя на вершине мира</strong></p>
								<p><strong>Что над вами</strong>. Иерусалим обнесен стенами, изначальным предназначением которых была защита города от врагов. Сегодня <strong>иерусалимские стены</strong> позволяют увидеть город под необычным углом. Послушайте истории об Иерусалиме, взгляните на город у своих ног и насладитесь его необычайной красотой.</p>
								<p>И это только начало!</p>



            	`,
      };
    },
  },

  {
    id: "Gastronomic_Atractions_Telaviv",
    bgImage: "/HomeSlider/desktop/6.jpg",
    mobBgImage: "/HomeSlider/M/3.jpg",
    title: "ГАСТРОНОМИЧЕСКИЕ ДОСТОПРИМЕЧАТЕЛЬНОСТИ",
    ctg: "telaviv",
    isVid: true,
    vidId: "jfyHxk8ZRrI",
    smlTitle: "",
    html: function() {
      return {
        __html: `       
				                <br/>
				                <h2 class="ac-margin-bottom-20 ac-margin-top-20">ГАСТРОНОМИЧЕСКИЕ ДОСТОПРИМЕЧАТЕЛЬНОСТИ ТЕЛЬ-АВИВА СТОИТ УВИДЕТЬ, СТОИТ ПОПРОБОВАТЬ!</h2>
                               
                      	        <p>«Вкусный» Тель-Авив<br/>
							   <em>Шира Гур</em></p>
								<p><strong>Тель-Авив</strong>, город на берегу Средиземного моря, который никогда не спит - это одно из лучших туристических направлений в мире. Яркий, веселый, насыщенный жизнью город, второй по величине в Израиле, знаменит и своими гастрономическими изысками, творческим подходом, оригинальной кухней, признанной гурманами всего мира и предлагающей блюда на любой вкус и кошелек. От изысканных современных ресторанов с меню «от шефа», рассчитанных на гурманов, до простых уличных кафе с традиционной кухней - и полный набор заведений общепита между этими двумя крайностями. Он даже был признан одним из лучших мест для туристов-веганов. Да, гурманы из разных стран, Тель-Авив - это место для вас.</p>
							      
								<p><strong>Питаться не дома</strong> Жители Тель-Авива не любят сидеть в четырех стенах. В городе всегда происходит что-то новое и захватывающее, и в городе всегда есть возможность вкусно поесть. Хотите познакомиться с кулинарной душой Тель-Авива? Для начала просто выйдите на улицу. Отправляйтесь на одну из оживленных улиц города, например, <strong>Дизенгофф</strong> и <strong>Ибн-Габироль</strong>, и осмотритесь. Лучшие кафе, рестораны, бары, магазины деликатесов и киоски с уличной едой - прямо перед вами.</p>
								<p><strong>Городские продуктовые рынки. </strong>Посетите рынок <strong>Кармель</strong>, самый большой, чрезвычайно популярный продовольственный рынок, расположенный прямо в центре города. Загляните на <strong>Левинский рынок</strong>, настоящий рай для гурманов, расположенный в южной части города. Совет:&nbsp; Выделите на это посещение достаточно времени. В лабиринте его улочек скрыты настоящие гастрономические шедевры.&nbsp;&nbsp;</p>
								<p><strong>Местная и интернациональная кухня. </strong>В Тель-Авиве проживают иммигранты из более чем 120 стран, поэтому неудивительно, что Тель-Авив - это огромный кипящий котел (в буквальном смысле). Если вы под национальной едой вы понимаете только японскую, тайскую или индийскую кухню, то здесь этот термин имеет гораздо более широкий смысл. Турецкая кухня, марокканская, персидская, яманийская, эфиопская, грузинская... этот список можно продолжать и продолжать.</p>
								<p>Тем не менее, Тель-Авив гордится также и местной кухней, которая впитала в себя изобилие международных традиций и влияний, но в основе которой лежат традиционные блюда. Результат получился очень вкусный и по-настоящему оригинальный. Посетите фермерский рынок, расположенный в<strong> порту Тель-Авива</strong> и международный рынок <strong>Сарона</strong>, попробуйте лучшие продукты питания, какие только можно найти в Тель-Авиве.&nbsp;</p>
								<p><strong>Сложная, изысканная и инновационная. </strong>Не секрет, что многие из лучших ресторанов мирового класса в Израиле находятся именно в Тель-Авиве.&nbsp; Шеф-повара здесь креативны и любят экспериментировать с классическими блюдами стран Ближнего Востока, восточной Азии и Европы, благодаря их гастрономическим шедеврам Тель-Авив превратился не только в центр притяжения гурманов не только Израиля, но и всего мира. Эстетично сервированные, грамотно приготовленные блюда, для которых используются самые свежие местные ингредиенты - такой кулинарный опыт вы определенно не забудете.&nbsp;&nbsp;&nbsp;</p>
								<p><strong>Кухня для вегетарианцев и веганов. </strong>В отличие от многих других мест по всему миру, здесь очень просто провести неделю (или больше) без мяса и молочных продуктов. Вы без труда отыщите заведения, где для вас быстро приготовят отличные и изысканные блюда с национальным колоритом. Здесь есть пекарни, магазины деликатесных продуктов, рестораны, где в меню только вегетарианские блюда, и заведения, в меню которых включены блюда для вегетарианцев и веганов. Все блюда свежие, вкусные и оригинально приготовленные.</p>
								<p>Этой тенденции уже несколько лет, и постепенно она превратилась в одну из главных особенностей кулинарной жизни Тель-Авива. Развитию этого направления способствует наличие разнообразных гастрономических влияний, огромный выбор овощей на рынках, а также серьезное отношение жителей Тель-Авива к поддержанию экологических стандартов на высоком уровне.&nbsp;&nbsp;&nbsp;</p>
								<p>Не пора ли перекусить?&nbsp;</p>
								


            	`,
      };
    },
  },

  {
    ctg: "telavivAndJerusalem",
    isVid: false,
    id: "Travel_With_Family",
    bgImage: "/posts/bank/travel-with-family/1.jpg",
    mobBgImage: "/posts/bank/travel-with-family/M.jpg",
    title: "Беспрерывные развлечения для всей семьи",
    smltitle: "",
    html: function() {
      return {
        __html: `

                             
                            <p>Путешествие с детьми в Тель-Авив и Иерусалим – это фантастические впечатления. Оба города чрезвычайно семейно-ориентированы – от природы до культуры, здесь уйма интересных мест и развлечений. </p>

                               <p>Благодаря почти 300 солнечным дням в году, великолепные пляжи – это место, где солнце сочетается с весельем, их дорожки – прекрасное место для прогулок с детьми, бега или катания на велосипеде или на мини-самокате. Убедитесь, что посетите множество музеев, спектаклей на открытом воздухе и парк Яркон, чтобы прекрасно провести день.</p>

                               <p>Путешествие в Иерусалим зажгет воображение своими странными аллеями, уникальными музеями и увлекательной историей. Тенистые парки, водные фонтаны и детские представления – в нем точно есть что-то для каждого возраста.</p>

                               <p>Благодаря большому числу увлекательных мероприятий, ваше путешествие в Тель-Авив и Иерусалим гарантированно станет незабываемым для всей семьи.</p>
                                
                                <p>Посещение Иерусалима и Тель-Авива – это идеальное направление для семей, которые ищут веселья и удовольствия.  Оба города просто переполнены количеством удивительных развлечений и аттракционов для всей семьи, чтобы родоваться вместе. Вот лишь несколько сказочных способов прекрасно провести время вместе с семьей в Иерусалиме и Тель-Авиве, все что вам нужно – выбрать и пойти:</p>
                                <div class="img-wrapper">
                                                <img src=${getImgUrl() +
                                                  "/thingsToDo/posts/35/1.jpg"} class="img-responsive" />
                                </div>
                              <h3>
                                              Тель-Авив
                              </h3>
                              <p><strong>«Луна-парк»:</strong> фантастический парк развлечений в самом сердце города, в котором есть множество веселых и захватывающих аттракционов для всей семьи. Прямо напротив красивого парка Хаяркон – зеленых легких Тель-Авива.</p>
                              <p><strong> Парк ХаЯркон:</strong> спокойный парк Яркон в окрестностях бурного города с хорошими зелеными пространствами, возможностью катания на лодке по реке, катания на велосипеде, спортивными площадками и многим другим для всей семьи. Наслаждайтесь пикником с видом на потрясающий горизонт Тель-Авива.</p>
                              <p><strong> Воздушный шар:</strong> после отдыха в роскошном парке ХаЯркон, поднимитесь высоко с видом на роскошный Тель-Авив, который вы никогда раньше не видели, летайте над парком Яркон наслаждаясь чувствами в романтическом или семейном путешествии.</p>
                              <p><strong> Обсерватория:</strong> находясь в Азриеле, обязательно посмотрите удивительную обсерваторию, расположенную на верхнем этаже ради 360° вида на Тель-Авив, который дети забудут не скоро.</p>
                              <p><strong> Планетарий:</strong> веселое введение в астрономию, интерактивные экспонаты перенесут вас в космос, вращающиеся сиденья и информативные презентации произведут впечатление на всю семью.</p>
                              <p><strong> Сафари:</strong> вы сможете провести замечательный день в дикой природе, с самой большой коллекцией животных на Ближнем Востоке лишь в 15 минутах от центра Тель-Авива, где вы можете посмотреть остальные достопримечательностей города.</p>
                              <p><strong> ХаТачана, старый железнодорожный вокзал Тель-Авива: </strong>удовольствие для всей семьи. Комплекс старого вокзала предлагает что-то для каждого в ресторанах, в детских учреждениях, в художественных галереях, на уличных выставках и даже езду поездом.</p>
                              <p><strong> Порт Тель-Авива:</strong> дышите морским воздухом и наслаждайтесь великолепной набережной, заказывайте блюда в ресторанах и кафе, и посмотрите замечательные выступления уличных музыкантов, магического театра и прочего, специально для радости малышей. </p>
                              <p><strong> Ярмарка улице Нахлат Биньямин:</strong> крупнейшая в своем роде ярмарка в Израиле – это яркое и шумное место с ремесленниками, живой музыкой, уличными представлениями и кафе для людей разного возраста.</p>
                              <p><strong> Сарона:</strong> модное место с ресторанами, кафе и барами, крытый рынок – это популярное место для пары, групп и семей, ищущих одно из самых живых мест в городе.</p>

                              <h3>
                                              Музеи:
                              </h3>
                              <p><strong>Тель-Авивский музей искусства:</strong> благодаря большому количеству коллекций, гидов, творческих и интерактивных мероприятий и игр, музей является сокровищем как для родителей, так и для детей.</p>
                              <p><strong>Музей естественной истории:</strong> Открытый в 2018-му, 5-этажный музей со своими 3000 экспонатами, предоставляет детям возможность увидеть обитателей страны непосредственно рядом.</p>
                              <p><strong>Олимпийский музей:</strong> можно посетить экскурсией с гидом, с интерактивной историей спорта в Израиле через мультимедийные экспонаты, интересные для всей семьи.</p>
                              <p><strong>Зал независимости – </strong>место рождения Государства Израиль и место рождения первого города, говорящего на Иврите – Тель-Авива. Увлекательное путешествие историей для всей семьи.</p>
 
                               <div class="img-wrapper">
                                    <img src=${getImgUrl() +
                                      "/thingsToDo/posts/35/2.jpg"} class="img-responsive" />
                                </div>
                              <h3>
                                             Иерусалим 
                              </h3>
                              <p><strong>Город Давида:</strong> захватывающий археологический опыт в самом сердце древнего Иерусалима, с археологическими раскопками, экскурсиями и прогулками по подземному водному тоннелю.</p>
                              <p><strong>Ночные эффектные звуки и световое шоу:</strong> впечатляющее, первое в своем роде шоу, где стены Цитадели стали сценой ночного шоу, отмечает 4000-летнюю историю Иерусалима звуками и светом.</p>
                              <p><strong>Аквариум:</strong> одна из самых популярных достопримечательностей в Иерусалиме, открытый в конце 2017 года, предлагает захватывающее приключение четырьмя морями Израиля, которая впечатлит всех, от молодых до стариков.</p>
                              <p><strong>Лифт времени:</strong> Окунитесь в виртуальную реальность, путешествуя увлекательной историей Иерусалима, а трясущиеся сиденья и спец. эффекты поразят подростков.</p>
                              <p><strong>Ботанический сад:</strong>потрясающая жемчужина в самом центре города, в котором представлено более 6000 видов растений со всего мира, это интересное и спокойное место для всех.</p>
                              <p><strong>Сегвей-туры:</strong> Сегвей-туры подходят для более старших подростков, и оставляют незабываемые впечатления от захватывающих мест города, такие туры позволят вам насладиться его современным и старинным характером.</p>
                              <p><strong>Мини-Израиль:</strong> демонстрирует сотни миниатюрных реплик израильских выдающихся мест, с уникальным видом на исторические, религиозные и современные объекты вокруг страны.</p>

                              <h3>
                                   Музеи:
                              </h3>
                              <p><strong>Израильский музей:</strong> ведущий художественный и археологический музей, погружает вас в богатую историю и культуру страны и ее людей, с экспонатами интересующими посетителей всех возрастов.</p>
                              <p><strong>Музей башни Давида:</strong> исторический вход в Старый город Иерусалима, средневековая цитадель с трехмерными моделями, со скрытыми проходами, и возможными семейными турами и мероприятиями.</p>
                              <p><strong>Активный музей Аймен-Яел:</strong> предоставляет экскурсионные путешествия через старинную Римскую улицу, творческие мастерские, пекарни с выпечкой пита и встречи с актерами периода. Семьям понравится такой день.</p>
                              <p><strong>Музей науки Блумфилда:</strong> Фантастический детский культурно-образовательный музей, в котором представлены выставки и интерактивные экспонаты по предметам науки и техники.</p> 

               
							</p><p>
								Po więcej informacji: <br>
								<a href="//visit.tel-aviv.gov.il/home" target="_blank">http://www.visit-tel-aviv.com/</a><br>
								<a href="//www.itraveljerusalem.com/" target="_blank">http://www.itraveljerusalem.com/</a>
							</p>

            	`,
      };
    },
  },

  {
    id: "Jamie_Oliver",
    bgImage: "/posts/bank/jamie_oliver/1.jpg",
    mobBgImage: "/posts/bank/jamie_oliver/M/1.jpg",
    title: "ДЖЕЙМИ ОЛИВЕР ПРОБУЕТ ТЕЛЬ-АВИВСКИЙ ЗАВТРАК",
    ctg: "culinarytelaviv",
    isVid: true,
    vidId: "gGe4W8WaIiQ",
    smlTitle: "",
    html: function() {
      return {
        __html: `

						<small style="color:#000; display:block;position: relative;top: 5px;">
						Автор видео:  Israeli food channel
						</small>

            	`,
      };
    },
  },

  {
    id: 37,
    bgImage: "/posts/bank/enjoy-and-indulge/1.jpg",
    mobBgImage: "/posts/bank/enjoy-and-indulge/M/1.jpg",
    title: "Направление абсолютной роскоши",
    isVid: false,
    ctg: "telaviv",
    smltitle: "",
    html: function() {
      return {
        __html: `
                    
                   	
					


					<p>Забудьте о Карибах, Каннах и Мальдивах, если вы в поисках роскошного отдыха, Тель-Авив – это место, где надо побывать! </p>
                    <p>Прежде всего, город, который издание Нью-Йорк Таймс назвало «столицей всего модного», находится всего в нескольких часах путешествия, что означает, что вам не придется беспокоиться о том, что вы можете потерять хотя бы минуту вашего долгожданного отпуска на адаптацию к смене часовых поясов.</p>
                    <p>Как только вы оказываетесь здесь, вашим первым наслаждением станет прекрасная солнечная погода в течение всего года, специально разработанная для вашего удовольствия. </p>
                    <p>Далее – выбирайте среди огромного разнообразия предложений роскошных номеров – от 5-звездочных отелей мирового класса с видом на пляж до многочисленных потрясающих бутик-отелей в захватывающих расположениях по всему городу. </p>
                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/38/1.jpg"} class="img-responsive" />
					</div>
                    <p>Чтобы дополнить впечатления, берите полотенце и отправляйтесь к любому из замечательных пляжей, наполненных всеми удобствами, необходимыми для сказочного дня, не говоря уже о роскошной прохладной воде.</p>
                    <p>Проголодались? Наслаждайтесь огромным выбором ресторанов изысканной, местной и не только кухни, Тель-Авив известен во всем мире качеством блюд титулованных и изысканных шеф-поваров. </p>
                    <p>Время покупок – берите кошелек и приезжайте выбрать подарки в местных дизайнерских бутиках, шикарных высококлассных магазинах и роскошных торговых центрах, где вы можете найти что-то от Haute Couture до последних международных трендов. </p>
                    <p>Завершайте свой день, взяв крафтового пива или гламурный коктейль в любом из сенсационных ночных клубов или гламурных баров по всему городу и танцуйте свою ночь, прежде чем вернуться в отель для заслуженного 5-звездочного сна.</p>
                    <p>Роскошь? Стиль? Гламур? У нас есть все это! Так что спешите и бронируйте путешествие в Тель-Авив сегодня! </p>


            	`,
      };
    },
  },

  {
    id: "Cool_Jerusalem",
    bgImage: "/posts/bank/cool-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/cool-jerusalem/M/1.jpg",
    title: "",
    ctg: "jerusalem",
    isVid: true,
    vidId: "nLKWDp5uA-U",
    smltitle: "Иерусалимские сюрпризы",
    html: function() {
      return {
        __html: `
				<br/>
                    <h2 class="ac-margin-bottom-20 ac-margin-top-20">Город превосходящий ожидания</h2>
					
					



					<p>Иерусалим – это всемирно известный город и одно из самых популярных направлений отдыха в мире. Много людей ежегодно посещают Иерусалим благодаря его историческому значению, его святым местам, его очаровательной и неповторимой архитектуре и прекрасной атмосфере. Однако Иерусалим – город сюрпризов, и в этом удивительном городе есть множество вещей, которые большинство людей с ним не ассоциируют. Вот лишь некоторые из них, которые вы не обязательно ожидаете увидеть в Иерусалиме:</p>

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/40/1.jpg"} class="img-responsive" />
					</div>
                    <h3>Летние вечеринки</h3>
                    <p>Ежегодно летом центр Иерусалима заполняется пятничными полуденными вечеринками, музыкой, танцами, замечательными людьми со всего мира, а также пьянящими беззаботными ритмами вечеринок, разогревая вас и готовя к оставшимся выходным.</p>


                    <h3>Рыночное безумие</h3>
                    <p>Удивительное мероприятие, происходящее в четверг вечером, в котором живой день рынка Макне Йегуда превращается в шумную позднюю ночную сцену, заполненную фантастическими барами, пабами и живой музыкой непрерывно в течение всей ночи.</p>


                    <h3>Фестивали</h3>
                    <p>Иерусалим – это город, наполненный фестивалями – от знаменитого кинофестиваля к фестивалю вина, международного кукольного фестиваля и даже пивного фестиваля, где бы вы ни побывали, вы обязательно найдете фестиваль по вашему стилю и вкусу, который проходит в определенное время и в определенном месте в городе. </p>

                    <h3>Иерусалимский марафон</h3>
                    <p>Фантастический и чрезвычайно популярный марафон с различными дорожками, от профессиональных до семейных, которые проходят рядом с захватывающими историческими памятниками и освещают 3000 лет истории Иерусалима, и это обеспечит не простые, однако захватывающие и незабываемые впечатления для всех бегунов и зрителей.</p>
                    <h3>Музеи и выставки</h3>
                    <p>Разнообразный характер города Иерусалима распространяется на музеи и культурные мероприятия, представленные по всему городу. От всемирно известного музея Израиля до Яд Вашем, запоминающегося света и звука в цитадели, прогулок по стенам, и многого другого, город просто переполнен удивительными культурными впечатлениями.</p>

                    <h3>Фермерский рынок</h3>
                    <p>Каждую пятницу в немецкой колонии в центре города можно найти рынок местных фермеров. На нем представлено множество замечательных продуктов и огромное разнообразие местных деликатесов со прекрасными скидками.</p>

                    <h3>Аквариум мирового класса</h3>
                    <p>Один из крупнейших аквариумов на Ближнем Востоке, этот сказочный аттракцион для детей и взрослых открыл для всех свои двери впервые в этом году. Аквариум размером 7000 м2 и имеет 40 видов морских обитателей в 33 водных резервуарах, крупнейший из которых вмещает 1,6 миллиона литров воды. </p>


            	`,
      };
    },
  },

  {
    id: "TelAviv_Cycle",
    bgImage: "/posts/bank/cycle-in-telaviv/1.jpg",
    mobBgImage: "/posts/bank/cycle-in-telaviv/M/1.jpg",
    vidId: "88OV6xU0vPI",
    isVid: true,
    ctg: "telaviv",
    title: "Велосипедные путешествия Тель-Авивом",
    smltitle: "",
    html: function() {
      return {
        __html: `

					
					<p>Будучи одним из самых модных городов мира, неудивительно, что в последние годы Тель-Авив присоединился к тенденции, которая охватывает самые известные города в мире – велосипедную моду. </p>
                    <p>Знакомство с городом на велосипеде имеет целый ряд преимуществ – это экологически приемлемое, существенно снижающее углеродный след, а также чрезвычайно полезное средство передвижения, которое экономит драгоценное время отдыха, которое можно потерять в пробках. Велосипед – это фантастическое средство для физических упражнений, а для туриста или посетителя езда на велосипеде, как средство для изучения города – это сказочный способ насладиться его достопримечательностями, звуками и запахами, без каких-либо препятствий. </p>
                    <p>Вот лишь несколько вещей, которые делают Тель-Авив фантастическим городом для путешествий на велосипеде:</p>
                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/41/1.jpg"} class="img-responsive" />
					</div>
                    <p>Специальные велосипедные дорожки: город Тель-Авив активно продвигает велосипеды в качестве транспортного средства и для поддержания этого дела по всему городу проложено более 100 км отделенных велосипедных дорожек для обеспечения безопасности и удобства города для велосипедистов. </p>
                    <p>Фантастическая погода: Тель-Авив наслаждается фантастической погодой круглый год с очень небольшим количеством осадков, что делает его оптимальным городом для велосипедных прогулок, наслаждаясь прохладным ветром с пляжа на потрясающей набережной или мчась по потрясающим внутренним улицам с их сказочной баухаусовой архитектурой.  </p>
                    <p>Tel-O-Fun: «Tel o Fun» – это удобный, простой и выгодный муниципальный публичный прокат велосипедов. Постоянные пользователи и гости города могут брать и оставлять качественные велосипеды «Tel o Fun» с помощью кредитной карты на 150-ти удобных станциях по всему городу.</p>
                    <p>Лучше всего то, что в Тель-Авиве все настолько близко, вы можете взять велосипед на пляж, ехать по волшебной набережной, поехать на фантастический пикник в парке ХаЯркон и проехаться по ночному городу к сказочным клубам и барам Дизенгоф или к гавани. </p>
                    <p>Путешествия на велосипеде никогда не были столь простыми, полезными и веселыми, как в прекрасном городе Тель-Авиве. </p>


            	`,
      };
    },
  },

  {
    id: "TelAviv_Adventures",
    bgImage: "/posts/bank/telaviv-adventures/1.jpg",
    mobBgImage: "/posts/bank/telaviv-adventures/M/1.jpg",
    title: "Что делать в Тель-Авиве",
    smltitle: "",
    isVid: false,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
                   
					<p>Тель-Авив, всемирно известный как город, который никогда не останавливается, славится своей удивительной ночной жизнью, сказочными пляжами, фантастической культурой и искусством и многим другим. Но есть несколько менее известных вещей, которые вы можете сделать в городе летом.</p>
                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/42/1.jpg"} class="img-responsive" />
					</div>
                    <h3>Посетите «Браслет бар»</h3>
                    <p>Браслет-бары – это отличный способ выпить ночью, не тратя много денег. Просто отправляйтесь в один из многих баров в Тель-Авиве, где можно заранее оплатить фиксированную цену и выпить столько, сколько хотите или сможете...</p>
                    <h3>Пятничные послеобеденные барабанные кружки</h3>
                    <p>Отправьтесь на известный банановый пляж в пятницу после обеда и наслаждайтесь дважды – удивительными барабанными сессиями на берегу моря и прекрасным закатом солнца – все это совершенно бесплатно! </p>
                    <h3>Развлечения на крыше</h3>
                    <p>Может благодаря погоде; возможно благодаря замечательным видам – одно точно, тель-авивцы любят быть на открытом воздухе, особенно с напитком в руках. Летом вы увидите, что большинство баров и пабов поднимают крышу (буквально!) и превращаются в открытые площадки, тогда как много баров появляются на крышах коммерческих и офисных зданий. Чтобы найти эти удивительные места, всё, что вам нужно – просто следовать за звуками музыки и развлечений. </p>
                    <h3>Фитнес под открытым небом</h3>
                    <p>Ничто не важнее вашего здоровья, и кое-что полезное, что вы можете сделать для своего тела – выполнить несколько упражнений. Тель-Авив предоставляет отличные возможности для этого – от плавания в море, бега вдоль набережной, езды на велосипеде по сказочным городским улицам до, даже, занятий на нескольких тренажерных площадках в любых местах под открытым небом (бесплатных), расположенных по всему городу. </p>
                    <h3>Эпические летние мероприятия</h3>
                    <p>От всемирно известных международных художников до удивительных технологий, арт и пивных фестивалей, открытий галерей, выставок, живой уличной музыки, открытых кинотеатров и пляжных вечеров, которые длятся всю ночь, лето в Тель-Авиве – это неисчерпаемый источник веселья и развлечений, не упустите его! </p>


            	`,
      };
    },
  },

  {
    id: "2_AWESOME_CITIES",
    bgImage: "/posts/bank/27/1.jpg",
    mobBgImage: "/posts/bank/27/M.jpg",
    title: "2 УДИВИТЕЛЬНЫХ ГОРОДА",
    smltitle: "",
    isVid: true,
    vidId: "NlOJ-i5hJdI",
    ctg: "telavivAndJerusalem",
    html: function() {
      return {
        __html: `

					
					
					<p>
						Тель-Авив – это современный мегаполис с прекрасными песчаными пляжами, легкой атмосферой и многочисленными возможностями для получения наслаждения от отдыха. Все это дополнено подлинным восточным ароматом, не говоря уже о замечательной кухне и божественном кофе. Всего только в сорока минутах езды от него, вы попадете в совершенно иную атмосферу с другими ритмами – Иерусалим, город удивительной красоты, который вдохновлял миллионы людей на самые невероятные поступки.
						Тель-Авив и Иерусалим живут своей жизнью, являясь важными и интригующими городами. Они предлагают вам различные достопримечательности, которые просто необходимо посмотреть. Несмотря на географическую близость, города отличают совершенно разные архитектурные стили, ландшафты, климат, запахи и ароматы. В какой еще стране можно так легко объединить отпуск на пляже современного города-курорта с прогулками по одному из самых древних и самых святых городов в истории?
						Так вот примерный план того, что можно сделать во время отпуска:
						Тель- Авив – вечно бодрствующий город.
					</p>

					<p>
						Итак, вы приземлились в Тель- Авиве – уникальном ближневосточном городе. Полюбуйтесь на потрясающие лазурные оттенки Средиземного моря, на причудливые постройки Белого города, погуляйте по его рынкам, ресторанам, подышите его ароматами и окунитесь в его ночную жизнь. Купайтесь в волнах средиземного моря и наслаждайтесь непрерывностью жизненной активности города нон-стоп, жизнь в котором не замирает ни на минуту и брызжет своей жизненной энергией 24 часа в сутки.
						Итак, вперед.
					</p>

					<h3>Неве-Цедек</h3>
					<p>
						Откройте для себя магию этого заново отремонтированного района, расположенного на южной оконечности набережной Тель-Авива, рядом с Яффо. Начните утро с типичного израильского завтрака: вкусная выпечка, яйца, сыры и приправы, зеленый салат, апельсиновый сок и, конечно же, отличный кофе. Во время тура по Неве-Цедек вы сможете посетить исторические достопримечательности и маленькие, чудесные музеи.
					</p>
					<h3>
						Ха-Тахана
					</h3>
					<p>
						После прогулки, приходите в замечательное место – отреставрированный комплекс старой железнодорожной станции Тель-Авива – Ха-Тахана, находящийся совсем рядом. Станция на линии Яффо-Иерусалим действовала в период 1892 по 1948 г. В настоящий момент там расположено множество потрясающих ресторанчиков, кафе и дизайнерских бутиков.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/1/7.jpg"} class="img-responsive" />
					</div>
					<h3>
						Яффо
					</h3>
					<p>
						Далее, прогуляйтесь вдоль Тель-Авивской набережной в Яффо. Мы рекомендуем посетить порт Яффо, который считается одним из самых древних портов в мире, посетить многочисленные лавочки художников, посидеть в одном из прибрежных кафе и полюбоваться на рыбаков. Затем продолжайте движение к колоритному блошиному рынку, где вы можете приобрести старинные безделушки, в том числе армянскую керамику, а также хамсы (восточные обереги, приносящие счастье). В ночное время, площадь превращается в живую площадку с многочисленными барами и ресторанами.
					</p>
					<h3>
						Прокатитесь до берега
					</h3>
					<p>
						Тель-Авив известен, как столица велосипедного движения. В один из таких прекрасных дней дайте выход вашему спортивному драйву, арендуйте велосипед на одной из станций или в любой другой точке, где можно взять велосипед на прокат. Поездка из Неве-Цедек до пляжа Тель-Барух – северная оконечность города станет замечательным времяпрепровождением и подарит незабываемые впечатления.
					</p>
					<h3>
						Музей Эрец-Исраэль
					</h3>
					<p>
						Если вы окажетесь в северной части города, мы предлагаем вам посетить музей Эрец-Исраэль. Это многопрофильный музей, акцент в котором сделан на историю и культуру Израиля. Всевозможные выставки по археологии, этнографии и филателии, фольклору и иудаике, выставки традиционных ремесел, народного творчества, истории культуры и местной самобытности.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/1/2.jpg"} class="img-responsive" />
					</div>
					<h3>
						Бульвар Ротшильда
					</h3>
					<p>
						Ищете место, где вы можете наслаждаться вкусной едой? Постарайтесь присесть в одном из прекрасных ресторанов на бульваре Ротшильда или рядом, в самом центре города, это одна их трех зон, которые составляют Белый город, внесенный ЮНЕСКО в список Всемирного культурного наследия. Эта улица, которая определяет сущность Тель-Авива, предлагает Вам уникальную возможность понаблюдать за людьми и насладиться прекрасной кухней. Вы также можете прогуляться и полюбоваться на архитектуру в стиле Баухаус, старые киоски и маленькие музеи, которые являются частью захватывающей тель-авивской истории, а также заглянуть в район еврейского поселения Ахузат Байт.
					</p>
					<h3>
						Ночная жизнь
					</h3>
					<p>
						Если вы планируете оставаться в городе на несколько дней, вы можете снять номер в одном из больших отелей, расположенных на берегу моря, рядом с набережной, или в одном из прекрасных бутик – отелей. А если к вечеру вы еще полны энергией и вам по-прежнему хочется продолжать открывать все новые и новые места, то зайдите в одни из популярных баров или ночных клубов. Или в Оперный театр, или посетите танцевальное представление или примите участие в одном из многочисленных культурных событий и фестивалей Тель-Авива.
Ну что, попробовали прекрасной тель-авивской жизни, настало время открыть для себя другую часть мира – вперед в Иерусалим. Это всего только 40 минут езды. Святой город ждет вас!
					</p>
					<h3>
						Иерусалим – один их самых красивейших городов
					</h3>
					<p>
						Откройте для себя город священный для представителей трех монотеистических религий: иудаизма, христианства и ислама. Посетите исторические места, вдохните головокружительные ароматы, попробуйте специальные блюда, подышите чистым горным воздухом и получите удовольствие в многочисленных развлекательных местах, распложенных по всему городу.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/1/3.jpg"} class="img-responsive" />
					</div>
					<h3>
					Эйн-Керем
					</h3>
					<p>
						Даже не доходя до старого города, можно насладиться живописными окрестностями Эйн-Керема. Это район расположен всего в 20 минутах езды от центра города и известен своим умиротворяющим характером. Зеленый массив и прекрасный вид на каменные дома, церкви, галерею и бутики, кафе и изысканные рестораны, старые и новые отели – подарят вам незабываемые впечатления.
					</p>
					<h3>
						Музей науки
					</h3>
					<p>
						Научный музей Иерусалима – это волшебное царство для детей и взрослых. Музей представляет вам различные движущиеся объекты, оптические иллюзии, электрические предметы, с которыми можно экспериментировать, чтобы сделать наш мир удобным местом для жизни.
					</p>
					<h3>
						Старый город
					</h3>
					<p>
						Самая важная часть любого маршрута – Старый город Иерусалима, попросту говоря, древний клад и бесконечный источник радости. Истинная сущность Иерусалима скрывается в узких извилистых переулках Старого города: особая атмосфера, увлекательные истории и тайны раскрываются среди древних камней. Посещение Стены плача, чтобы прикоснуться к остаткам Храма и вложить между камнями в Стене Плача записку с просьбой к Б-гу.
					</p>

					<p>
					Вы можете пройти по следам Иисуса вниз по Дороге скорби к Храму Гроба Господня – месту двух самых святых событий христианства: месту, где был распят Иисус из Назарета и где он воскрес. Продолжить путь на гору Сион, где вы можете посетить горницу, где, по преданиям, проходила Тайная Вечеря так же, как это делал Иисус, часто посещавший гору Елеонскую гору для молитвы в Гефсиманском саду. Именно там молился Иисус в ночь перед распятием, когда его ученики спали. И наконец, поднимитесь на крышу церкви Святого Семейства, чтобы полюбоваться поистине великолепным видом на Иерусалим и Старый город.
					Для того, чтобы еще глубже погрузиться в атмосферу древнего Иерусалима, мы предлагаем совершить прогулку по туннелям западной стены, посетить Купол Скалы, святое место, где Мухаммед, как полагают, вознесся на небеса, и заглянуть в лютеранскую церковь Спасителя, где находится один из самых красивых органов в Израиле.

					</p>
					<h3>
						Рынок Махане-Иехуда

					</h3>
					<p>
						Вы были сильно заняты сегодня и, наверно, проголодались. Сейчас самое время заглянуть на рынок Махане-Иехуда – шумный открытый иерусалимский рынок. Наряду со старинными лавками, которые всегда были частью его истории, здесь появилось множество новых магазинчиков буквально за последние несколько лет.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/1/4.jpg"} class="img-responsive" />
					</div>
					<h3>
						Шоппинг в Иерусалиме
					</h3>
					<p>
						Готовы к покупкам сувениров? Можно купить изделия из армянской керамики или предметы иудаики в специальных и красивых магазинах в Старом городе. Вы также найдете магазины, торгующие сувенирами прямо в центре города. Многочисленные магазины одежды расположены на пешеходной улице Бен Иегуда. И не забудьте проверить магазины, торгующие подержанными вещами, если вы хотите купить что-то более аутентичное. Не пропустите визит на фешенебельную торговую улицу Мамила, которая считается одной из самых привлекательных для совершения покупок.
						Визиты в Иерусалим и Тель-Авив подарят вам многообразие различных впечатлений, несмотря на то что эти города находятся всего в нескольких минутах езды друг от друга. Именно яркость разнообразных впечатлений делают данный туристический пакет – идеальным предложением для отпуска. Он преподносит вам историю и современность, древние артефакты и современное искусство, веселое времяпрепровождение на солнце и самое «духовное» путешествие вашей жизни. Что же еще можно желать? Не медлите! Закажите свой отпуск прямо сейчас!
					</p>


           `,
      };
    },
  },

  {
    id: "Jerusalem",
    bgImage: "/posts/bank/jerusalem-p/1.jpg",
    mobBgImage: "/posts/bank/jerusalem-p/M.jpg",
    title: "ВЕЧНЫЙ ГОРОД",
    smltitle: "",
    isVid: true,
    vidId: "FvAWuLQEOJw",
    ctg: "jerusalem",
    html: function() {
      return {
        __html: `
                     <br/>
                     <h2 class="ac-align-center ac-margin-top-20">Вечный город: душа и сердце земли израильской</h2>
				    <p class="ac-align-center ac-margin-bottom-20"><em>Иерусалим: духовное путешествие к истокам религий</em></p>
					<p>Иерусалим - это открытая дверь в историю. Поднявшись на горы, войдите в город и почувствуйте уникальную атмосферу, сочетающую дух великого прошлого и динамичность современной жизни.&nbsp; Посещение Иерусалима - одного из древнейших городов мира, священного для евреев, христиан и мусульман, оставляет уникальный след в душе и памяти каждого путешественника.</p>
					<p><strong>Войдите в Старый город. </strong>Сердцем самого святого города иудеев является Старый город. Историческим входом в город являются <em>ворота Яффы</em> или&nbsp; <em>ворота Сиона</em>, которые ведут прямо в <strong>еврейский квартал</strong>, один из четырех кварталов обнесенного стеной города, где евреи живут с VIII века до нашей эры. Погуляйте по узким улочкам, посмотрите на людей, посетите <strong>Кардо</strong>, старинную главную улицу Иерусалима, ощутите ее неповторимую атмосферу. Вы идете там, где ступали цари и пророки. Это - необычное ощущение.</p>
					 <div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/Jerusalem-p/1.jpg"} class="img-responsive" />
							    </div>
					<p><strong>В этих стенах история оживает перед вами, вы ощутите глубокую духовную энергию, которой пронизано пространство Старого Города.</strong></p>
					<p><strong>Пред нами – Стена плача. </strong>Последний фрагмент, оставшийся от древних стен, окружавших Второй храм, это место является символом духовной родины, земли предков, символом духовных устремлений еврейского народа. Каждый еврей за пределами Иерусалима во время молитвы поворачивается лицом к тому месту, где вы сейчас находитесь, потому что согласно иудейской вере, в этом месте живет Бог. Независимо от того, верите вы в это или нет, но здесь становится не по себе от величия этого места. Здесь многие оставляют в стене записку с молитвой или пожеланием - они верят, что все сбудется.&nbsp;</p>
					<p><strong>Прах веков под ногами </strong>Иерусалим подобен гигантскому археологическому «пирогу», который буквально состоит из исторических пластов, в этом городе история приобретает совершенно новое значение.</p>
					<p>Совершите увлекательную экскурсию по <strong>туннелям Западной стены</strong> и посетите ее скрытые участки. Проходя по подземным переходам, вы увидите, как перед вами будет открываться история, вы узнаете, как жили люди в Иерусалиме во времена Второго Храма, узнаете много нового о тогдашнем искусстве, архитектуре и методах строительства.</p>
					<p>Обязательно побывайте на площадке археологических раскопок в <strong>Городе Давида,</strong> которая находится неподалеку от этого места, вы узнаете много интересного об истории города. 3000 лет назад Царь Давид объявил этот город единой столицей 12 израильских племен.&nbsp; Погуляйте между древними стенами и крепостями, скрытыми источниками, где проводилась коронация царей, пройдите тем путем, по которому жители Иерусалима бежали из города после того, как он был завоеван римлянами.</p>
					<p><strong>Оцените неповторимую красоту видов, открывающихся с этого места, и почувствуйте себя на вершине мира</strong></p>
					<p><strong>Что находится наверху. </strong>Иерусалим окружен стенами, которые были построены для защиты города от захватчиков.&nbsp; Сегодня <strong>Стены Иерусалима</strong> помогают увидеть город под другим углом. Послушайте рассказ об истории города, посмотрите на город, раскинувшийся внизу, насладитесь всей этой красотой.</p>
					<p>Как много еще интересного и неизведанного таит этот край!</p>

					<!--<h2>A CITY OF MAGIC AND RADIANCE BEYOND YOUR WILDEST DREAMS</h2>
					<p><strong>Jerusalem is The Capital of Israel and By Far One of The Most Famous and Fascinating Cities in the World, Where Thousands of Years of Glorious History Seamlessly Intertwine with Modern Day Life.</strong></p>
                              
                                <p>Discover the overwhelming power of this 3,000 year old city - its innumerable historic sites and archeological wonders, its magical walkways and magnificent views which are guaranteed to leave a lasting impression. At the same time, the city’s strikingly modern attractions promise around the clock excitement and pleasure for all lovers of culture, arts, music, and culinary delights.</p>

                                <h2>Walk through 3000 years of history</h2>

                                <p>The Old City of Jerusalem is a favourite for all visitors from first timers, seasoned visitors as well as the locals. Surrounded by an ancient wall that has been rebuilt throughout history, there are 7 gates allowing access to historical and holy sites here. Make your way down the stone cobbled streets and find yourself walking through four thousand years of history, leaving you humbled and yet excited as you connect the modern day present with the simple beginnings of the past.</p>
                              
                                <h2>Meet the modern vibrant Jerusalem</h2>

                                <p>Step outside of the Old City and find everything that a typical modern city offers including hotels, promenades, restaurants and shopping malls. Visit museums, like the Israel Museum which is the largest cultural institution in Israel and ranked among the world’s leading art and archaeology museums housing the infamous Dead Sea Scrolls (oldest biblical manuscripts) among other treasures. Local farms, wineries and breweries are set up around Jerusalem offering a variety of options to foodies ranging from the traditional Israeli cuisine to the contemporary and fusion fare paired with delicious award-winning wines and beers attracting enthusiast from all over the world.</p>
                                <div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/Jerusalem-p/1.jpg"} class="img-responsive" />
							    </div>
                                <p>Visit Mahane Yehuda, a colourful and vibrant outdoor market with an attractive vibe filled with culture and delicious aromas of the delicacies sold here. Wait till sundown and see this ‘shuk’ transform into a trendy hangout with live music to suit every mood accompanied with energetic people, a growing ‘street-art’ gallery exceptional food and delightful drinks. Mahane Yehuda offers a special experience so walk down the streets, stop by a food joint, dance a little while enjoying a drink and make your way to the next spot.</p>

                                <p>Drenched in art, history, culture and diversity the capital city of Israel loves to have a good time while allowing one to experience the contrast between old world historical charm and modern city living. As you drive in to Jerusalem you can’t help but connect with the culture, archaeology and history of the many nations who have walked through here, where old meets new beyond the walls of the Old City in this unique world capital.</p>
                                -->
				


           `,
      };
    },
  },

  {
    id: "Jerusalem_Kitchen",
    bgImage: "/posts/bank/jerusalem1/1.jpg",
    mobBgImage: "/posts/bank/jerusalem1/M.jpg",
    title: "КУХНЯ ИЕРУСАЛИМА",
    smltitle: "",
    isVid: true,
    vidId: "2CSCe2WC7Ns",
    ctg: "jerusalem",
    html: function() {
      return {
        __html: `
                     <br/>
                     <h2 class="ac-align-center ac-margin-top-20">Разнообразие вкусных блюд</h2>
				   <p>
						Иерусалим наполнен множеством оживленных и модных ресторанов и развлекательных мест. Город оборудован площадками, которые предоставляют отличные возможности для любых развлечений днем и ночью, где вы сможете насладиться прекрасным вечером с прекрасной едой, холодным пивом или танцами под замечательную музыку.
					</p>

					<p>
						В Иерусалиме говорят, что вы приезжаете за хумусом, но остаетесь благодаря невероятно разнообразной кухне. От традиционных кухонь Ближнего Востока и Северной Африки до Южной Америки, азиатских черт и континентальной европейской кухни; от уличной еды до высококлассных гастрономических ресторанов- в Иерусалиме есть все это. Широкий выбор вкусных блюд в Иерусалиме можно найти буквально везде, как местные деликатесы в уличных торговых площадках, так и аутентичные рестораны на рынках, и, если вы ищете впечатлений как гурман, вы можете заказать место в одном из многочисленных эксклюзивных ресторанов города.
					</p>
				


           `,
      };
    },
  },

  {
    id: "Magical_Deadsea",
    bgImage: "/posts/bank/deadsea1/1.jpg",
    mobBgImage: "/posts/bank/deadsea1/M.jpg",
    title: "МЕРТВОЕ МОРЕ",
    smltitle: "",
    isVid: true,
    vidId: "9aDP-jV6soE",
    ctg: "deadsea",
    html: function() {
      return {
        __html: `

					             <br/>
					            <h2 class="ac-align-center ac-margin-top-20">Душа и тело парят в самой низкой точке на Земле</h2>
							   
								
							    <p class="ac-align-center ac-margin-bottom-20"><strong>Расслабьтесь в соленых водах Мертвого моря и проведите здесь незабываемый исцеляющий отпуск</strong></p>
								<p>Потрясающая красота природы, успокаивающие спа-процедуры с морскими минералами, доказанные целебные свойства и незабываемые впечатления... Неудивительно, что Мертвое море — один из популярнейших курортов в мире. Загадочное соленое озеро предлагает все необходимое для незабываемого отдыха души и тела.</p>
								<p><strong>Расслабьтесь. </strong>Соль, грязи, солнце… и не только. Погрузитесь в естественные, горячие, серные источники и насладитесь спа–процедурами. В этом нет ничего предосудительного: расслабьтесь и получите незабываемое удовольствие от оздоровительного отпуска, который возродит вас к жизни.</p>
								<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/magical-deadsea/1.jpg"} class="img-responsive" />
							    </div>
								<p><strong>Насладитесь одним из чудеснейших даров природы</strong></p>
								<p><strong>Качайтесь на соленых волнах</strong>. Благодаря невероятно высокой концентрации солей в воде, вы сможете сотворить маленькое «чудо» и... если не пройти по поверхности воды, то хотя бы полежать на ней! Войдите в воду, чуть отклонитесь назад... и природа сделает все сама. Возможно, вам потребуется минута-другая, чтобы привыкнуть к новым ощущениям, но мы гарантируем: это настоящее чудо.</p>
								<p><strong>Исцеляйтесь</strong>. Одно только приближение к окрестностям Мертвого моря — словно шаг в иной мир. Другие ландшафты, другой ритм жизни, воздух и даже другое солнце.</p>
								<p>Две последние особенности — это и результат особых геологических условий, в которых формировался регион, и основа его неповторимых целебных свойств.&nbsp;</p>
								<p>Уникальная атмосфера рождается благодаря испарению насыщенной солями морской воды и множеству полезных минералов, содержащихся в местном воздухе. Безопасный уровень солнечного излучения в регионе также обусловлен особым расположением соленого озера. Его побережье находится намного ниже уровня моря, поэтому лишние метры атмосферы служат надежным фильтром для вредоносных ультрафиолетовых лучей. Выйдите на свежий воздух и насладитесь этими благословенными дарами природы!</p>
								<p><strong>Почувствуйте себя ребенком и позвольте природе исцелить вас</strong></p>
								<p><strong>Обмажьтесь грязью</strong>. Целебные свойства грязей Мертвого моря широко известны и доказаны. Они улучшают состояние кожи, возвращают ей тонус и упругость. Конечно, вы можете купить грязь Мертвого моря и использовать ее дома, но стоит ли упускать прекрасную возможность вновь ощутить себя ребенком? Намажьте себя черной грязью с головы до ног и получите незабываемое удовольствие. Не побоитесь сфотографироваться?</p>
								<p><strong>Повторите все сначала.&nbsp;&nbsp;</strong></p>
								
                               


           `,
      };
    },
  },

  {
    id: "Unlimited_Relax",
    bgImage: "/posts/bank/1.jpg",
    mobBgImage: "/posts/bank/M.jpg",
    title: "ОТДЫХ БЕЗ ОГРАНИЧЕНИЙ",
    smltitle: "",
    isVid: true,
    vidId: "jfyHxk8ZRrI",
    ctg: "telaviv",
    html: function() {
      return {
        __html: `


				        <div class="ac-cradit" style="margin-top: -10px;margin-bottom: 20px;">
					    <span class="ac-cradit-text">A film by VIA TOLILA </span>
					    </div>
					    <br/>

					    <h2 class="ac-margin-bottom-20 ac-margin-top-20">Яркий и захватывающий, прекрасный Тель-Авив</h2>


					    <p>
                         Тель-Авив – настоящий туристический центр для ценителей кулинарного искусства. Этот город может предложить туристам не только море удовольствий, пляжи, древности и самобытную культуру, но и потрясающе вкусную еду. Недавно Тель-Авив вошел в список самых выдающихся кулинарных направлений по версии журнала для гурманов “Sauver” в ежегодном конкурсе “Culinary Travel Awards” за исключительные достижения в кулинарном искусстве. Тель-Авив был также отмечен как «выдающийся» город в категории «Лучшие магазины и рынки», а на международном конкурсе “Space Design Award” 2014 года тель-авивский ресторан “Pastel Brasserie” был признан «самым стильным рестораном в мире».
                    </p>
                    <div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/unlimited-relax/2.jpg"} class="img-responsive" />
							    </div>

					<p>
                          Израиль – страна иммигрантов, каждая этническая группа принесла с собой свой уникальный кулинарный опыт, и в результате сформировался тель-авивский кулинарный феномен. В Тель-Авиве вы можете отведать эфиопскую, румынскую, грузинскую, русскую, индийскую, йеменскую, иракскую, иранскую и другие кухни, но переиначенные на израильский лад. В этом городе немало элегантных ресторанов-гурмэ, таких как “Chef Mir Adoni’s Mizlala”, “Chef Avi Conforti’s Topolpompo” и знаменитый “Chef Eyal Shani’s North Abraxas”. Есть тут и камерные ресторанчики типа “Abdu Hadayag”. Не оставим без внимания и признанную самой здоровой в мире знаменитую тель-авивскую уличную еду.
                    </p>

					<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/unlimited-relax/3.jpg"} class="img-responsive" />
							    </div>

					<h3>
                          Тель-авивские бары
                    </h3>
                    <p>
                         Тель-Авив знаменит не только своими  ресторанами, но  и барами. Журнал “Drinks International” включил Тель-Авив в свой список “World’s 50 Best Bars Awards”. Тель-авивский бар «Imperial Craft Cocktail Bar» был избран лучшим баром Африки и Ближнего Востока. Этот бар знаменит своими коктейлями по индивидуальному заказу. В Тель-Авиве около  4,5 тысяч ресторанов и баров, что составляет примерно один ресторан на 1.000 человек. Журнал «Time Out Israel» отметил улицу Лилиенблюм, порт, тель-авивскую набережную, улицы Бен Иегуда и Дизенгоф как районы, где сконцентрированы лучшие бары города. «Trip Advisor» отдал предпочтение бару «Lima Lima», одному из старейших баров «Abraxas», камерному бару «Ozen» и пляжному бару «La La Land».
                    </p>
                    <div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/unlimited-relax/4.jpg"} class="img-responsive" />
							    </div>
					

					
					
							    
								
								
								
                               


           `,
      };
    },
  },
  {
    id: "Next_Level_DS",
    bgImage: "/posts/bank/deadsea1/1.jpg",
    mobBgImage: "/posts/bank/deadsea1/M.jpg",
    title: "МЕРТВОЕ МОРЕ",
    smltitle: "",
    isVid: true,
    vidId: "9aDP-jV6soE",
    ctg: "deadsea",
    html: function() {
      return {
        __html: `

					<br/>
					<h2 class="ac-align-center ac-margin-top-20">Почувствуйте себя на вершине мира в самой низкой точке на Земле</h2>
                    <p class="ac-align-center ac-margin-bottom-20"><b>Новое слово в релаксации</b></p>
					<p>Мертвое море, официально признанное самым низким участком суши на Земле (428 метров ниже уровня моря) и кандидатом на звание одного из 7 природных чудес света — это захватывающее и незабываемое сочетание величественной природы, увлекательной древней истории и современной роскоши.</p>
					<p>Целебные свойства бирюзовых вод, волшебная красота окружающего ландшафта и множество достопримечательностей… Мертвое море — подлинный источник покоя, здоровья и вдохновения для души и тела.</p>
					<p>Поплавайте на поверхности вод, примите грязевую ванну или совершите путешествие по окрестностям — в этом регионе насчитывается 330 солнечных дней в году. Вас ждет множество самых интересных занятий, от великолепных процедур с морскими минералами и пеших прогулок до посещения ресторанов для гурманов, закусочных и захватывающих дух аттракционов. Вдоль основной прибрежной полосы длиной 75 километров раскинулось множество прекрасных пляжей. А первоклассные гостиницы и спа-услуги подарят вам поистине незабываемый отдых.</p>
					<div class="img-wrapper">
													   <img src=${getImgUrl() + "/posts/next-level/1.jpg"} class="img-responsive" />
									</div>
					<p><strong>Волшебные пляжи Мертвого моря</strong></p>
					<p>Пляжам Мертвого моря нет равных в мире. На многие километры протянулись ухоженные и комфортные берега, где вы сможете понежиться на солнце во время отпуска своей мечты. Выберите место на каменистом песке и насладитесь величественным видом горных хребтов, окружающих море. Теплые воды Мертвого моря всегда спокойны: вам обеспечено потрясающее расслабление с первого же погружения.</p>
					<p>На южном берегу озера, вблизи самой низкой точки суши, к вашим услугам широкий выбор гостиниц. Здесь вы сможете полюбоваться волшебным закатом над Мертвым морем, когда лучи заходящего солнца окрашивают во все цвета радуги рассыпанные вокруг небольшие озерца с соляными образованиями. А чтобы впечатление от пребывания в этом удивительном месте было максимально полным, намажьтесь темной шелковистой грязью, насыщая кожу полезными минералами. Целебность грязей Мертвого моря для кожи и тела уже давно доказана. Ваша кожа быстро обретет свежий, словно обновленный вид. Побалуйте себя: испачкайтесь в грязи Мертвого моря — ведь это так полезно для здоровья!</p>
					<div class="img-wrapper">
													   <img src=${getImgUrl() + "/posts/next-level/2.jpg"} class="img-responsive" />
									</div>
					<p><strong>Исследуйте пустыню вокруг Мертвого моря</strong></p>
					<p>На Мертвом море можно не только расслабиться, покачаться на воде и принять процедуры с морскими минералами. Если вы собираетесь приехать сюда из Иерусалима, пополните свои знания о пустынях, остановившись в кибуце Эйн-Геди — природном оазисе на склонах Иудейской пустыни. Совершите пешую прогулку по заповеднику, где можно встретить диких животных — например таких как ибекс (альпийский горный козел), и полюбоваться горными водопадами и озерами. Эйн-Геди предлагает также проживание и посещение процедур с морскими минералами, включая горячие бассейны с серной водой и различные виды лечебных процедур и массажей. А отправившись еще южнее, вы достигнете древней крепости Масада. Эта национальная достопримечательность с богатой историей расположена на вершине высокой горы, на которую искатели приключений могут подняться пешком, а остальные — на комфортном подъемнике.&nbsp;</p>
									
				
				
				
				        


           `,
      };
    },
  },
  // {
  // 	    id:"Natures_Glory",
  //         bgImage : "/posts/bank/natures-glory/1.jpg",
  //         mobBgImage : "/posts/bank/natures-glory/M.jpg",
  //         title : "NATURE'S GLORY",
  //         smltitle : "",
  //         isVid:true,
  //         vidId: "M627s8TdaB8",
  //         ctg: "deadsea",
  //         html: function(){
  // 			return {
  // 				__html: `

  // 			    <p>
  // 					Get high on life in the lowest place on earth
  // 				</p>
  // 				<p>
  // 					The Dead Sea, officially the lowest place on earth (428m below sea level) and one the world’s natural wonders, is an enthralling and evocative combination of natural splendor, compelling ancient history, and modern luxuries.
  // 				</p>
  // 				<p>
  // 					Float on the waters, take a mud bath or go exploring - with 330 sunny days a year, the Dead Sea area is filled with superb attractions including natural healing spas, magnificent hiking trails, gourmet and fast food restaurants and adrenaline-charged attractions.
  // 				</p>
  // 				<h2>
  // 					NEW BOARDWALK AT THE DEAD SEA
  // 				</h2>
  // 				<p>
  // 					Just in time for the Passover and Easter holidays, a new, stone 4k boardwalk and free, accessible public beaches with full facilities have opened in the hotels area of the Dead Sea. The promenade will eventually extend another ten kilometers, to include a total of 16 public beaches, connecting Ein Bokek and Hamei Zohar, along the southern part of the Dead Sea. This is part of a major new leisure and hotel complex that is planned for the region.
  // 				</p>
  // 				<div class="img-wrapper">
  // 								   <img src=${getImgUrl() +  "/posts/natures-glory/1.jpg"} class="img-responsive" />
  // 				</div>
  // 				<p>
  // 					Visitors to the Dead Sea - the lowest place on earth and the world’s largest natural spa known for its unique wellness properties since Biblical times – can now enjoy full access to wide, sandy beaches, walking, jogging, cycling or even taking a Segway along the entire length of the new boardwalk. The new beaches are all free to the public, with facilities that include beach chairs, showers, canopies, sports equipment, children’s playgrounds and more.
  // 				</p>
  // 				<p>
  // 					The beaches are accessible for the disabled, with special wheelchairs and trails that can take visitors right into the waters of the Dead Sea. Special illumination allows tourists and visitors to walk the boardwalk at night, while at the same time enjoying the very special atmosphere at the Dead Sea.
  // 				</p>

  //            `
  //     }
  //   }
  // },
  // {
  // 	    id:"Natural_Spa",
  //         bgImage : "/posts/bank/1.jpg",
  //         mobBgImage : "/posts/bank/M.jpg",
  //         title : "THE DEAD SEA NATURAL SPA",
  //         smltitle : "",
  //         isVid:true,
  //         vidId: "8p4qfkneH1c",
  //         ctg: "deadsea",
  //         html: function(){
  // 			return {
  // 				__html: `

  // 				    <p>
  // 						The Dead Sea, officially The Lowest Place On Earth (428m Below Sea Level) And A Shortlist Candidate For The World’s 7 Natural Wonders, Is An Enthralling And Evocative Combination Of Natural Splendor, Compelling Ancient History And Modern Luxuries.
  // 					</p>
  // 					<p>
  // 						From the healing powers of the Dead Sea’s cobalt blue waters, through the awesome beauty of the surrounding landscape to the myriad of fascinating sights this area has to offer, the Dead Sea is a place of tranquility, health and inspiration for body and soul alike.
  // 					</p>
  // 					<p>
  // 						Float on the waters, take a mud bath or go exploring - with 330 sunny days a year, the Dead Sea area is filled with superb attractions including natural healing spas, magnificent hiking trails, gourmet and fast food restaurants and adrenaline-charged attractions. Along the main part of the 75 kilometer stretch dotted with beautiful beaches, you will also find world class hotels and spa facilities to guarantee a truly indulgent experience.
  // 					</p>

  // 					<div class="img-wrapper">
  // 					    <img src=${getImgUrl() +  "/posts/natural-spa/1.jpg"} class="img-responsive" />
  // 					</div>

  // 					<p>
  // 						The Magical Beaches of the Dead Sea
  // 					</p>
  // 					<p>
  // 						The beaches of the Dead Sea are like nothing else the world has to offer. There are many kilometers of beautifully developed and well-maintained spots where you can soak up the sun while on your dream vacation. Choose your spot on the rocky sand and take in the breathtaking scenery with the incredible mountain ranges surrounding the sea. The warm waters of the Dead Sea are always calm and offer superior relaxation from the minute you get in.
  // 					</p>
  // 					<p>
  // 						On the southern shores at the lowest point on earth, you will find an array of hotels where you can enjoy a magical sunrise over the lake, leaving an array of colors on the small ponds with the salt formations scattered throughout. To complete the experience of being at the Dead Sea, take some of the silky dark mud and lather it on allowing your skin to absorb the helpful minerals. Dead Sea mud has been proven beneficial to the skin and body. You will feel refreshed with skin that looks and feels younger. Give yourself the pampering that you deserve and get dirty with the Dead Sea mud – it’s healthy!
  // 					</p>
  // 					<p>
  // 						Discover the desert area around the Dead Sea
  // 					</p>
  // 					<p>
  // 						There is more to do than just relaxing in the spas and floating in the Dead Sea. If you are travelling south from Jerusalem, complement your desert experience by stopping at kibbutz Ein Gedi, a natural oasis on the slopes of the Judean desert, and take a hike through a nature reserve where you will see wildlife like the ibex (a kind of mountain goat) and enjoy the waterfalls and pools cascading on the rock formation. Ein Gedi also offers hotel accommodations and spas which houses hot sulphur pools and have different types of healing and therapeutic massages too. Continue south from here to Masada, a national landmark with a strong historical connection, located at the top of a massive mountain that the adventure seeker can hike, or it can be reached comfortably by cable car.
  // 					</p>

  //            `
  //     }
  //   }
  // },
  // {
  // 	    id:"Natural_Phenomena",
  //         bgImage : "/posts/bank/1.jpg",
  //         mobBgImage : "/posts/bank/M.jpg",
  //         title : "NATURAL PHENOMENA",
  //         smltitle : "",
  //         isVid:true,
  //         vidId: "8p4qfkneH1c",
  //         ctg: "deadsea",
  //         html: function(){
  // 			return {
  // 				__html: `

  //                         <p>
  // 							The Dead Sea is one of the most unique natural phenomena on the planet. A crevice in the earth’s crust that is part of the Great Rift Valley allows the waters of the River Jordan to flow south into a lozenge-shaped lake at the lowest point on our planet. With no outlet, the rays of the blazing sun evaporates the Jordan water to a point where its mineral content is highly concentrated; and it is this density of minerals and salt that makes it impossible to sink in the sea: bathers float effortlessly on the water’s surface. Because the sun has to travel an additional 1,200 feet to reach the shore, ultra-violet rays are filtered out and oxygen is enriched to a point where even the fairest skins tan but do not burn.
  // 						</p>
  // 						<div class="img-wrapper">
  // 								   <img src=${getImgUrl() +  "/posts/natural-phenomena/1.jpg"} class="img-responsive" />
  // 					    </div>
  // 						<p>
  // 							This is why a visit to the Dead Sea enables sufferers of rheumatic diseases to breathe better, and why victims of psoriasis and other serious skin ailments receive temporary cures by bathing in the Dead Sea, slathering themselves with Dead Sea mud and baking in the non-burning sun.
  // 						</p>
  // 						<p>
  // 							The Dead Sea is lined with spas, bathing beaches and spa hotels.
  // 						</p>

  //            `
  //     }
  //   }
  // },
  // {
  // 	    id:"Masada",
  //         bgImage : "/posts/bank/1.jpg",
  //         mobBgImage : "/posts/bank/M.jpg",
  //         title : "MASADA",
  //         smltitle : "",
  //         isVid:true,
  //         vidId: "XxWa_MNm5x8",
  //         ctg: "deadsea",
  //         html: function(){
  // 			return {
  // 				__html: `

  //                     <p>
  // 				Next to the Dead Sea is a site that, unlike the rest of the landscape, appears to be part of the Rift Valley cliff but is in fact an oval-shaped flat-topped mesa – a mountain completely surrounded by a virtually sheer drop. In the days before helicopters and drones, this was about as secure a site as could be found for King Herod to build himself a palace fortress to which he could retire in the case of emergency. (And, as it was adjacent to the Dead Sea it was convenient for a monarch who historians tell us had a “chronic skin ailment” - possibly psoriasis.) The splendor of Masada was epic. It was also a marvel of engineering that used artificial water courses to channel the desert’s rare rainfall into giant cisterns where, despite the 120°-Fahrenheit heat, they could make and store ice.
  // 			</p>
  // 			<div class="img-wrapper">
  // 								   <img src=${getImgUrl() +  "/posts/masada/1.jpg"} class="img-responsive" />
  // 							    </div>
  // 			<p>
  // 				After Herod’s death the site was all-but abandoned…until the year 73. After the Romans destroyed Jerusalem in 70 and expelled Jews from their holy city, a group of Jewish refugees made their way to the summit of Masada and converted the once grand palace into their home. Having no interest in the palace’s grandeur and considering themselves zealots, the refugees built a synagogue, created a mikveh, planted crops and tended goats. The Romans, however, could not tolerate their defiance and went on to besiege the mountain for three years, condemning thousands of legionnaires to camp in the extreme heat in a quest to starve the mountaintop inhabitants into surrender. (The outlines of the Roman encampments are clearly visible to this day.) Thousands of Jewish slaves were forced to build a giant ramp to the summit and after the months it took to complete the  construction, the mountaintop zealots -- realizing that the next day would bring Roman soldiers into their hideout -- determined to commit mass suicide rather than have their their wives, children and themselves murdered or enslaved. When the Romans finally battered their way onto the mountaintop they met no resistance and discovered 960 corpses. Two women who had hidden themselves from the mass suicide shared details of the events with the “conquerors” and Jewish Roman historian, Josephus, told the story of Masada in his book “The Jewish Wars.” The pledge by the zealots’ leader, Elazar Ben Yair on the last night of freedom has entered immortality: “Since we long ago resolved never to be servants to the Romans, nor to any other than to God Himself, Who alone is the true and just Lord of mankind, the time is now come that obliges us to make that resolution true in practice...We were the very first that revolted, and we are the last to fight against them; and I cannot but esteem it as a favor that God has granted us, that it is still in our power to die bravely, and in a state of freedom.” The Byzantines built a church atop Masada in the 4th-century, but it and the mountain went on to be abandoned for centuries.
  // 			</p>
  // 			<div class="img-wrapper">
  // 								   <img src=${getImgUrl() +  "/posts/masada/2.jpg"} class="img-responsive" />
  // 							    </div>
  // 			<p>
  // 				In 1964. Israel’s Professor Yigal Yadin lead a two-year international excavation to discover Masada’s secrets. Their hundreds of discoveries support Josephus’ history, with the archeologists even finding the clay tokens on which the zealots had carved names and used as lots to decide who would “euthanize” their families and themselves first…and last.
  // 			</p>
  // 			<p>
  // 				The story of what occurred two millennia ago atop Masada has become a symbol of Israelis’ commitment never to allow “Masada to fall again” and, fifty years after the excavation, Masada is, after Jerusalem, the most visited site in Israel. Access to the summit on foot is possible up the traditional snake path used by Herod, and up the Roman ramp.  But the majority of the millions of tourists who visit Masada are whisked from the Masada Museum and Visitors Center to the summit in giant cable cars that operate daily with the exception of Yom Kippur. Every June, the base of Masada becomes the site of giant Opera Festival and spectacle that uses the floodlit mountain as a backdrop.
  // 			</p>

  //            `
  //     }
  //   }
  // },

  {
    id: "Tel_Aviv",
    bgImage: "/posts/bank/telaviv-p/1.jpg",
    mobBgImage: "/posts/bank/telaviv-p/M.jpg",
    title: "ТЕЛЬ-АВИВ ПОЛЮБИТЕ ЭТОТ «ГОРОД НОН-СТОП»",
    smltitle: "",
    isVid: true,
    vidId: "PdTkXbiBpFs",
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
			                   
			                   <br/>
			                   <h2 class="ac-margin-bottom-20 ac-margin-top-20">«ОДИН ИЗ 10 ЛУЧШИХ ПРИМОРСКИХ ГОРОДОВ МИРА»</h2>
			                   <p>Не так давно газета «Нью-Йорк Таймс» удостоила Тель-Авив звания «столицы средиземноморских наслаждений», а издательство путеводителей Lonely Planet включило его в список «10 лучших городов для путешествий». Поэтому Тель-Авив, вне всякого сомнения, является тем городом Средиземноморья, которое вы непременно должны посетить!</p>
								<p>Названный газетой «Нью-Йорк Таймс» «столицей средиземноморских наслаждений», <strong>Тель-Авив</strong> — это оживленный и современный космополитичный город. Насыщенная культурная жизнь, дома в стиле баухаус, внесенные ЮНЕСКО в список объектов Всемирного наследия, отмеченная множеством наград кулинария, знаменитая на весь мир ночная жизнь, дружелюбная неформальная атмосфера и превосходные пляжи… Благодаря всему этому Тель-Авив занимает особое место среди самых популярных туристических объектов мира.</p>
								<p>И хотя в городе есть буквально все — начните с <strong>пляжа</strong>!</p>
								 <div class="img-wrapper">
								   <img src=${getImgUrl() + "/posts/telaviv-p/1.jpg"} class="img-responsive" />
							    </div>
								<p><strong>В самом сердце динамичного города</strong></p>
								<p><strong>Что</strong>. Главной достопримечательностью города, которую журнал National Geographic назвал «Майами-бич Средиземноморья» является его побережье. Именно благодаря ему Тель-Авив был включен в список «10 лучших приморских городов мира».</p>
								<p><strong>Почему</strong>. Песчаные пляжи, теплая вода, множество водных аттракционов и прекрасная&nbsp;погода — что еще нужно? Побережье Тель-Авива состоит из 13 уникальных пляжей, где вас ждут самые разные развлечения и впечатления. От шумных и модных до спокойных и неспешных — все вместе они создают неповторимый «многоцветный» стиль Тель-Авива.</p>
								<p><strong>Где</strong>. Если вы остановитесь в западной части Тель-Авива, побережье окажется от вас буквально в двух шагах. Поддайтесь искушению, перейдите через дорогу, снимите обувь… и наслаждайтесь!</p>
								<p><strong>Выберите свое приключение </strong></p>
								<p><strong>Активный отдых</strong>. Пляжные и водные виды спорта очень популярны в Тель-Авиве. Сёрфинг, парусный спорт, гребля, плавание, сапсёрфинг, ныряние, волейбол — этот список далеко не полный.</p>
								<p>Выберите свой любимый вид спорта — и получите удовольствие. А когда вы услышите на пляже характерный стук м<em>аткота</em> — обязательно присоединяйтесь и примите участие в этой невероятно популярной в Израиле разновидности пляжного тенниса. Здесь нет победителей и проигравших, одна лишь радость... только будьте осторожны — эта игра затягивает!</p>
								<p><strong>Запишитесь</strong> на соревнования по парусному спорту SAIL TLV. Они проходят весной и включают соревнования яхт, моторных яхт и моторных лодок со всего мира. Получите удовольствие от спорта и отличной компании.</p>
								<p>Хочется чего-то еще? Присоединитесь к местным жителям и прокатитесь на велосипеде, пройдитесь пешком или пробегитесь по набережной. &nbsp;&nbsp;</p>
								<p><strong>Общайтесь</strong>. Постройте замок из песка со своей семьей, отправьтесь выгуливать собаку и станьте частью дружелюбной и пестрой толпы.</p>
								<p><strong>Отдохните</strong>. Хотите замедлить темп и расслабиться? Нет проблем! Найдите тихий уголок на одном из более спокойных пляжей, понаблюдайте за игрой барабанщиков (или составьте им компанию) и посидите в одном из прибрежных ресторанов. После обеда подойдите ближе к воде, возьмите шезлонг, устройтесь в нем поудобнее и полюбуйтесь прекрасным тель-авивским закатом. О большем нельзя и мечтать.</p>
											                  

								


           `,
      };
    },
  },

  {
    id: "Simply_Delicious",
    bgImage: "/posts/bank/simply-delicious/1.jpg",
    mobBgImage: "/posts/bank/simply-delicious/M.jpg",
    ctg: "culinarytelaviv",
    isVid: true,
    // vidId: "n4kCnPXEX7g",
    vidId: "JQD9JpMaw9g",
    title: "Тель-Авив - просто восхитительный вкус",
    smltitle: "",
    html: function() {
      return {
        __html: `

                    <br/><h2 class="ac-align-center ac-margin-top-20">Настоящий рай для гурманов</h2>
                    <p class="ac-align-center ac-margin-bottom-20"><b>Сотни знаменитых ресторанов, удивительные продукты и вкусная уличная еда</b></p>
					<p>
						Благодаря 4500-м мест где можно поесть, Тель-Авив – это действительно Мекка для гурманов. Многие рестораны принадлежат известным в мире шеф-поварам, которые учились и работали в одних из лучших заведений всего мира до того, как вернуться в Израиль и предоставить свою уникальную марку местной кулинарной сцене.
					</p>

					<p><strong>По признанию журнала </strong><strong>Saveur</strong><strong>, Тель-Авив — один из наиболее ярких центров кулинарного туризма. И это неудивительно.&nbsp; </strong></p>
					<p>Тель-Авив может похвастаться золотыми песчаными пляжами, беспрерывной активностью и бурной ночной жизнью. А еще в нем невероятное множество уникальных ресторанов и баров, превращающих приморский город в модный гастрономический курорт. Кулинария действительно является душой и сердцем Тель-Авива. Здесь множество высококлассных кафе и ресторанов, но символом города стала именно уличная еда.</p>
					<p><strong>Новая концепция традиционной уличной еды</strong></p>
					<p>Канули в Лету те времена, когда на улицах Тель-Авива вам могли предложить один лишь, пусть и очень вкусный, но однообразный хрустящий фалафель в свежеиспеченной пите. Сегодня в Тель-Авиве — на каждом углу широчайший выбор лакомств и деликатесов на любой вкус. Пройдитесь по улице Ибн Гвироль, Бен-Йегуда или Кармель и выберите любое из мясных, рыбных или овощных блюд. Его вам подадут в пите, между ломтиками тоста или в другом виде, с соусом или без, все как вы захотите. Прогуливаясь по городу, попробуйте блюда самых разных стран мира: сабих с соусом тхина в арабской лепешке-лафе, невероятно вкусные сэндвичи с селедкой и многое другое, и конечно же насладитесь подлинным вкусом местной израильской еды. Приятное чувство сытости вам гарантировано!</p>
					
					<p><strong>Ресторанные блюда «на бегу» — для настоящих гурманов </strong></p>
					<p>В городской суете Тель-Авива, среди вечно спешащих бизнесменов и восторженных туристов, что может быть важнее возможности быстро перекусить, но изысканными ресторанными блюдами? В городе появляется все больше высококлассных закусочных быстрого питания, предлагающих, например, такие блюда, как антрекот в итальянском хлебе чиабатта или кукурузные лепешки арепа. Неудивительно, что Тель-Авив был признан журналом Saveur одним из наиболее ярких центров кулинарного туризма.</p>
					<p>Восторг гурмана: необычайно широкий выбор вкусной, разнообразной и колоритной уличной еды делает Тель-Авив идеальной целью для гастрономического путешествия. Вы должны непременно посетить его во время своей следующей поездки в Израиль.</p>
										

         `,
      };
    },
  },

  {
    id: "Nonstop_Excitement",
    bgImage: "/posts/bank/35/1.jpg",
    mobBgImage: "/posts/bank/35/M.jpg",
    title: "УВЛЕЧЕНИЯ БЕЗ ОГРАНИЧЕНИЙ",
    vidId: "88OV6xU0vPI",
    isVid: true,
    smltitle: "",
    ctg: "telaviv",
    html: function() {
      return {
        __html: `



				    <br/>
                    <h2 class="ac-margin-bottom-20 ac-margin-top-20">Красивый, красочный и захватывающий – Удивительный Тель-Авив</h2>
				    <p>
					 Энергичная, вдохновляющая или веселая релаксация – Ваш отдых в живом городе Тель-Авив может быть таким, каким пожелаешь. Благодаря прекрасной погоде, практически круглый год можно расслабляться на ослепительных просторах золотых пляжей, побродить по живописным рынкам, среди разнообразных культур и развлечений, необычайных ночных развлечений и увлекательных кулинарных творений.
					 </p>
					 <div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/2/3.jpg"} class="img-responsive" />
					</div>

					 <p>Вы также можете насладиться просто прогулкой по улицам с захватывающими зданиями Баухауса и просто прочувствовать уникальную атмосферу города, которая сделала его одним из самых популярных направлений для туристов со всего мира.
					</p>
					<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/2/2.jpg"} class="img-responsive" />
					</div>
					<p>
					Получите заряд, вдохновение, и приготовьтесь – вы влюбитесь в Тель-Авив!
					</p>

					<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/2/4.jpg"} class="img-responsive" />
					</div>

					<h3>
						Тель-Авив НОН-СТОП <br> Непревзойденные развлечения на пляже
					</h3>

					<p>
						Победитель опроса журнала National Geographic как «Один из десяти лучших пляжных городов мира» – благодаря чистым водам и пляжами, которые наполнены развлечениями, у каждого из 16 пляжей Тель-Авива есть свой собственный стиль, который привлекает определенных личностей – от простых хиппи до девушек, которые любят загорать. Днем или ночью, пребывание на пляже – это один из лучших способов провести время в Тель-Авиве.
					</p>

					<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/2/5.jpg"} class="img-responsive" />
					</div>

					<h3>
						Сенсационная ночная жизнь
					</h3>
					<p>
						Израильские выходные начинаются в четверг вечером и продолжаются до, почти, рассвета в воскресенье – начала новой рабочей недели. Но почти каждая ночь – это «ночь вечеринок» в Тель-Авиве. Город, который не останавливается, продолжает жить всю ночь и переполнен шумом стильных и энергичных мест. Этот город – дом для одних из самых грандиозных клубов и вечеринок в мире.
					</p>

					<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/2/6.jpg"} class="img-responsive" />
					</div>

			          <br/>

					<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/2/7.jpg"} class="img-responsive" />
					</div>

         `,
      };
    },
  },

  {
    id: "Vegan_Friendly_TelAviv",
    bgImage: "posts/bank/8/1.jpg",
    mobBgImage: "posts/bank/8/M.jpg",
    title: "ТЕЛЬ-АВИВ ДЛЯ ВЕГЕТАРИАНЦЕВ",
    ctg: "culinarytelaviv",
    isVid: true,
    vidId: "Tub5VbKN4lQ",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                   
                   

                   
                      <br/>
                     <h2 class="ac-margin-bottom-20 ac-margin-top-20">Путешествие в Тель-Авив — гастрономическое приключение для веганов</h2>
						<p>Путешествие за границу иногда может оказаться непростым для веганов, которые не употребляют продуктов животного происхождения. Но в Тель-Авиве это не проблема: здесь вы найдете и веганскую кулинарную школу, и список подходящих для веганов ресторанов и закусочных. Тель-Авив, признанный центром гастрономического туризма и «Лучшим кулинарным городом мира» журналом <em>Saveur</em>, серьезно воспринял растущую популярность веганства. В итоге кулинарный журнал The Daily Meal отдал Тель-Авиву звание «Лучший в мире город для веганов», признав его превосходство над 8 другими «дружественными веганам» городами.</p>
                         <div class="img-wrapper">
						     <img src=${getImgUrl() + "posts/6/2.jpg"} class="img-responsive" />
					     </div>
						<p><strong>Чего хотят веганы</strong></p>
						<p>Прогуляйтесь по Тель-Авиву, и вы увидите бесчисленные веганские или подходящие для веганов рестораны, бистро и закусочные. Вдохните сладкие и пряные запахи, наполняющие городской воздух — ммм, неподалеку готовится вкусное лакомство, которое, вполне возможно, вы захотите отведать. Учитывая потребности и вкусы жителей Тель-Авива и туристов, большинство заведений питания (по крайней мере, уважающих себя заведений) предлагают в меню различные веганские блюда. А некоторые перешли на полностью веганское меню и предлагают фалафель без яиц, шаурму из сейтана и пиццу из продуктов, не содержащих молока.</p>
						<p><strong>Свежий средиземноморский вкус</strong></p>
						
						<p>Свежий средиземноморский воздух пробудил желание попробовать местные лакомства? Веганов, путешествующих по Тель-Авиву, ждет множество заведений, где из свежих местных продуктов готовят восхитительные блюда, согласно рецептам различных культур, с учетом кулинарных направлений и модных течений.</p>
						 <div class="img-wrapper">
						     <img src=${getImgUrl() + "posts/6/3.jpg"} class="img-responsive" />
					     </div>
						<p>В любой части Израиля вам предложат широкий выбор веганской еды, но по числу веганских ресторанов и закусочных ничто не может сравниться с Тель-Авивом. Идет ли речь о быстрой еде, меню для гурмана или десерте – в этом городе вам предложат любой веганский вариант. Поэтому обязательно посетите Тель-Авив во время своей следующей поездки в Израиль.</p>


			`,
      };
    },
  },

  {
    id: "Vegan_Friendly_TelAviv_Post",
    bgImage: "posts/bank/8/1.jpg",
    mobBgImage: "posts/bank/8/M.jpg",
    title: "ТЕЛЬ-АВИВ ДЛЯ ВЕГЕТАРИАНЦЕВ",
    ctg: "telaviv",
    isVid: true,
    vidId: "Tub5VbKN4lQ",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                     <br/><h2 class="ac-margin-bottom-20 ac-margin-top-20">Лучшие вегетарианские ресторанами Тель-Авива</h2>
					
                    <p>
                        Американский сайт гурманов «The Daily Meal» отметил Тель-Авив как один из ведущих городов для путешественников-вегетарианцев. Поскольку в Тель-Авиве больше 400 ориентированных на вегетарианцев ресторанов, у вас просто нет шансов уйти оттуда голодными.
                    </p>
                    <h3>
                        «Нанушка»
                    </h3>
                    <p>
                       В 2014 году этот традиционный грузинский ресторан перестроился на вегетарианскую кухню. Сегодня здесь подают грузинские вегетарианские блюда, среди которых традиционные изделия из теста, фаршированные грибами вместо говядины.
                    </p>

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "posts/6/2.jpg"} class="img-responsive" />
					</div>

						<h3>
                        «HaShwarma HaTzemchonit»
                    </h3>
                    <p>
                        Вегетарианская шаурма – специально для вегетарианцев, которые хотят попробовать местную кухню. Пикантный тофу и пшеничное «мясо» (сейтан) можно купить в булочке, пите, тортилье или на хлебе «фокачча». «Aba Gil» – еще один Тель-Авивский ресторан, в котором подают традиционную ближневосточную еду в вегетарианской версии.
                    </p>

                    <h3>
                        «Buddha Burgers»
                    </h3>
                    <p>
                        Сеть ресторанов, ориентированных на вегетарианцев и специализирующихся на гамбургерах с филиалами в Хайфе и Эйлате. Рестораны предлагают разнообразное меню уличной еды со всего мира, включая индийские, итальянские и американские гамбургеры и хот-доги, естественно, все без мяса. Вы можете попробовать даже кошерные (соевые) чизбургеры.
                    </p>
                    <div class="img-wrapper">
						<img src=${getImgUrl() + "posts/6/3.jpg"} class="img-responsive" />
					</div>
                    <h3>
                        «Zakaim»
                    </h3>

					

					<p>
                        Этот эксклюзивный ресторан подает оригинальные блюда, приготовленные из свежайших ингредиентов. Здесь не используют пластиковой продукции и подают различные вегетарианские блюда в сочетании с популярными блюдами, типа салат Цезарь, голубцы или фрике.
                    </p>


                    <h3>
                        «Tanat»
                    </h3>
                    <p>
                       Тот ресторан специализируется на самобытной эфиопской кухне, но в вегетарианском варианте. Вкусив их замечательный хлеб «teff flour injera» (без глютена), вы влюбитесь в эфиопскую кухню. А если вы заглянете сюда в понедельник вечером, вас побалуют джазовой музыкой в живом исполнении.
                    </p>
                    <p><a href="https://info.goisrael.com/en/attractions#/specFilters=6m!#-!19&amp;pageSize=24&amp;viewMode=grid&amp;orderBy=0&amp;pageNumber=1" rel="nofollow" target="_blank">View attractions in Tel Aviv &amp; Center at Tourist Information site</a><br><a href="https://info.goisrael.com/en/accomodations#/specFilters=6m!#-!19" rel="nofollow" target="_blank">View accommodations in Tel Aviv &amp; Center at Tourist Information site</a></p>
                     


			`,
      };
    },
  },

  // {
  //     	id:13,
  //         bgImage : "/posts/bank/28/1.jpg",
  //         mobBgImage : "/posts/bank/28/M.jpg",
  //         title : "Jerusalem Cuisine",
  //         ctg:"culinary",
  //         isVid:true,
  //         vidId:"2CSCe2WC7Ns",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `

  // 				<h2>Exhilarating and diverse and oh so yummy</h2>

  // 					<!--<div class="responisve-iframe">
  // 						<iframe src="https://www.youtube.com/embed/2CSCe2WC7Ns/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
  // 					</div>-->
  // 					<p>
  // 						Jerusalem is filled with scores of lively and trendy restaurants and entertainment spots. The city is packed with areas offering excellent options for every form of day and night time entertainment, where you can enjoy a delightful evening over a great meal, a cold beer or dance to great music.
  // 					</p>

  // 					<p>
  // 						In Jerusalem, they say that you come for the hummus, but stay for the incredibly diverse cuisine. From traditional Middle Eastern and North African to South American, Asian fusion, and continental European cuisine; from street food to fine dining, Jerusalem’s got it all. Jerusalem’s wide array of culinary options can be found literally everywhere local delicacies in street stalls, authentic restaurants in the markets, and if you are looking for the gourmet experience, you can reserve a spot at one of the city’s many exclusive chef restaurants.
  // 					</p>

  //          `
  //     }
  //   }
  // },

  {
    id: "Coffee_In_TelAviv",
    bgImage: "posts/bank/42/1.jpg",
    mobBgImage: "posts/bank/42/M.jpg",
    title: "КОФЕЙНАЯ ЖИЗНЬ ТЕЛЬ-АВИВА",
    ctg: "culinarytelaviv",
    isVid: true,
    vidId: "rVr0gqFC364",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			           
						<br/>
					    <h2  class="ac-margin-bottom-20 ac-margin-top-20">Стиль городских кофеен</h2>
						<p>Тель-Авив известен как оживленный туристический город со множеством достопримечательностей, с шумной и яркой жизнью, при этом кофе - это важная часть культуры и досуга жителей.</p>
							
							<p>Если вы хотите узнать, что такое «настоящий Тель-Авив», нет лучшего способа, чем присоединиться к традициям местных кофе-шопов. Вы можете выпить чашечку кофе в одном из популярных туристических кофейных заведений, каких в городе очень много. Если вы захотите «покофейничать» по-особенному, то вам прямая дорога в небольшие местные кофейни. Присоединитесь к жителям Тель-Авива, которые по вечерам заполняют уличные кафе, наслаждаются вечерней прохладой, общаются и, конечно же, пьют кофе. А если вы захотите остаться за столиком чуть подольше, то попробуйте местные блюда. Европейская выпечка или же полноценный ужин - в кофейнях Тель-Авива можно попробовать самую разнообразную еду мира.</p>
							<div class="img-wrapper">
						    <img src=${getImgUrl() +
                  "posts/coffe-in-tlv/1.jpg"} class="img-responsive" />
					    </div>
							<p>Недалеко от пляжа под лучами солнца вы можете выпить кофе со льдом, пообщаться с местными жителями в элегантной атмосфере кофейни, окруженной знаменитыми зданиями в стиле «Баухауз» в модном районе Неве Цедек или же расслабиться со стаканчиком латте в оживленном морском порту Тель-Авива. Мимо вас будут пробегать энергичные загорелые спортсмены, мчаться байкеры и лавировать подростки на скейтбордах, а вы будете мирно сидеть за столиком и наслаждаться жизнью - с чашечкой хорошего кофе в руке.&nbsp;</p>

							<h2>Время для чашечки кофе</h2>
							<p>В Тель-Авиве можно попробовать не просто кофе разных сортов - вы будете вбирать в себя разные культурные традиции. Вашей утренней чашкой кофе может быть современный и модный «кофе хафух» - это израильская версия капучино: кофе, который готовят путем добавления эспрессо в молочный пар; этот напиток популярен среди молодежи. В полдень прогуляйтесь по Старому Яффо, атмосфере которого подходит традиционный восточный кофе – горячий напиток с сильным вкусом. И, наконец, познакомьтесь со средиземноморским обычаем и выпейте чашечку вечернего кофе с плодами цабра за столиком на бульваре Ротшильда.</p>
							<p>В Тель-Авиве чашечка кофе всегда кстати!</p>
              
			`,
      };
    },
  },

  // {
  // 	id:"Non_Stop_Markets",
  // 	bgImage : "posts/bank/non-stop-markets/1.jpg",
  // 	mobBgImage : "posts/bank/non-stop-markets/M.jpg",
  // 	title: "Non Stop Markets",
  //     ctg:"telaviv",
  // 	isVid:false,
  // 	smlTitle: "",
  // 	html: function(){
  // 		return {
  // 			__html:`
  // 			                 <p>A tour of the markets in Tel Aviv, with their unparalleled human tapestry and never-ending variety of delicacies is probably one of the best ways to get to know the true local spirit of Tel Aviv.<br>
  //                              Here are some of the markets that are definitely a must, when visiting the sunny city:</p>

  //                              <h2>Carmel Market:</h2>
  //                              <p>The city’s most famous market, renowned for its colorful spirit and food stalls, featuring fresh local delicacies and excellent restaurants serving fresh food straight from the market. You can also find hidden food placed behind the stalls and around the area. They are really worth finding. <br>
  //                              <h2>The Flea Market:</h2>
  //                              <p>Located in Jaffa, packed with fantastic authentic antiques from Tel Aviv and Jerusalem, a joy to bargain hunters. This market is also home to many fashionable and excellent cafés and restaurants of all varieties of cuisines: from Greek, to Italian, to Arabic.<br>
  //                              <div class="img-wrapper">
  // 						         <img src=${getImgUrl() + "posts/non-stop-markets/1.jpg"} class="img-responsive" />
  // 					         </div>
  //                              <h2>Nahalat Binyamin Arts & Crafts Market: </h2>
  //                              <p>Open on Tuesdays and Fridays, this is a ‘fair-like’ artists’ market, rich with creative and original ideas for gifts. It is just the place to pick up that perfect souvenir you won’t find in any store.<br>
  //                              <h2>Sarona Market</h2>
  //                              <p>Offering a unique and fabulous culinary adventure, Sarona Market is located in the Trendy Sarona Complex, and is home to a modern and vibrant “food court” which offers a huge assortment of culinary options. Sarona is also extremely family friendly, filled with outdoor activities and fantastic playgrounds. <br>
  //                              <h2>Tel Aviv Port Market</h2>
  //                              <p>With more of a Farmers Market feel, this seaside Market is packed with tasty treats and specialty produce which you can enjoy, on the spot of take home as culinary souvenirs.<br>

  // 			`
  // 		}
  // 	}

  // },

  {
    id: "Magic_JAffa",
    bgImage: "posts/bank/joys-of-jaffa/1.jpg",
    mobBgImage: "posts/bank/joys-of-jaffa/M.jpg",
    title: "ВОЛШЕБНЫЙ ЯФФО",
    ctg: "telaviv",
    isVid: true,
    vidId: "FRmgXjfVPoE",
    smlTitle: "",
    html: function() {
      return {
        __html: `              <br/>
			                     <h2 class="ac-margin-bottom-20 ac-margin-top-20">ЯФФО ПОРТ МЕЧТЫ</h2>
                            <p>
                               У современного города Тель-Авива есть своё скромное начало – это порт Яффа, где иммигранты, армии и торговцы пришвартовали свои корабли. Порт известен как один из старейших в мире, и сегодня он все еще используется местными рыбаками, а историческая окраина стала популярным местом туризма.
                            </p>
			               
					         <p><strong>Яркая история и неотразимый шарм Леванта</strong></p>
                             <p>Запах моря смешивается с ароматом черного кофе и специй, левантийская культура — с европейской, древность — с современностью: это Яффо. Один из древнейших портовых городов в мире, история которого восходит к незапамятным временам. Сегодняшний Яффо — оживленный и динамичный, никогда не устающий удивлять и обновляться. Живописные аллеи, галереи, уникальные бутики, древние здания, множество достопримечательностей и оригинальных ближневосточных ресторанов — каждый гость Израиля просто обязан посетить старый Яффо и подарить себе настоящий фейерверк ощущений. Вы уже готовы влюбиться?</p>
                           
                             <p><strong>Волшебство оживленного портового города&nbsp; </strong></p>
                             <p>Расположенный на холме у Средиземного моря, на юг от Тель-Авива, Яффо на протяжении веков был центром исторических событий. <strong>Яффский порт</strong> действует и сегодня, и не забудьте ознакомиться с ним. Пройдитесь по галереям изобразительного искусства, бутикам и рынкам — настоящему раю для гурманов. Прогуляйтесь у старых доков, послушайте живую музыку, отведайте местные блюда и напитки и впитайте неповторимую атмосферу.</p>
                             <p>Самый лучший вид на город открывается из горного парка <strong>А-Писга («Вершина»). </strong>Отсюда вы сможете полюбоваться заливом и прекрасным Яффо, раскинувшимся внизу. Спускаясь, загадайте желание на <strong>Мосту желаний</strong>. Кто знает, может, оно сбудется!</p>
                             <p><strong>Романтическое городское приключение</strong></p>
                             <p>Улицы Яффо полны сюрпризов. Прогуляйтесь по узким мостовым древнего города, загляните во внутренние дворики и обратите внимание на необычные детали — раскрашенную керамическую плитку, маленькие скульптуры и открытые террасы верхних этажей. Понаблюдайте за людьми, посетите галереи, студии художников и оригинальные бутики.&nbsp;&nbsp;</p>
                             
              
			`,
      };
    },
  },
  // {
  // 	id:"Joys_Of_Jaffa",
  // 	bgImage : "posts/bank/joys-of-jaffa/1.jpg",
  // 	mobBgImage : "posts/bank/joys-of-jaffa/M.jpg",
  // 	title: "Joys of Jaffa",
  //     ctg:"telaviv",
  // 	isVid:true,
  // 	vidId:"LLOUxE-K_9Y",
  // 	smlTitle: "",
  // 	html: function(){
  // 		return {
  // 			__html:`
  // 			            <p>Recently named among CNN Travel’s must visit places for 2019, Jaffa is Tel Aviv’s smaller sister, and even though it dates back thousands of years, a visit to Old Jaffa always feels like an exciting discovery. A tour of Jaffa reveals charming winding alleyways interspersed with art galleries, historic buildings, newly renovated hotels in extraordinary landmark areas and a multitude of quaint authentic restaurants.</p>

  //                         <h2>Jaffa Flea Market</h2>
  //                         <p>Located in Jaffa, the famous flea market is a pure delight for the bargain hunters among you, packed with great authentic antiques. The flea market has been experiencing a recent bloom, and is considered a nightlife hub, featuring trendy bars and cool outdoor eateries, packed with young party people until the (very) late.</p>

  //                         <h2>Jaffa Port </h2>
  //                         <p>Considered one of the world’s most ancient ports, the Port of Jaffa served fishermen, sailors, merchants, crusaders, conquerors and immigrants for thousands of years. Today, the port continues to serve as a fishing port, and is also being renovated as an urban attraction that offers cultural and leisure activities, shopping and tourism, while preserving its unique historical and fascinating character.</p>

  //                         <h2>Around Jaffa </h2>
  //                         <p>A stone’s throw away from Jaffa you can find the HaTachana complex, Tel Aviv’s renovated Old Railway is now a now vibrant tourist hub and an attractive site in itself and also lovely Neve Tzaedek  neighborhood, perfect for a leisurely stroll. Jaffa also boasts stunning beaches and fantastic restaurants serving a variety of fantastic local cuisine at affordable prices.  </p>

  //                         <h2>Colorful History and Irresistible Levantine Charm</h2>
  //                         <p>The smells of the sea flavored with black coffee and spices from the markets, Levantine culture combined with European, ancient mixed with new – this is Jaffa. One of the oldest port cities in the world whose history dates back to the great flood, today's Jaffa is a vibrant city that never ceases to surprise and innovates. Picturesque alleys, art galleries, unique boutiques, ancient building, wonderful landmarks and an abundant of authentic middle-eastern restaurants – a trip to old Jaffa is a must-have multi-sensory stimulating experience for anyone visiting Israel. Prepare to fall in love.<br>&nbsp;</p>
  //                         <h2>Discover the magic of a vibrant Port City</h2>
  //                         <p>Situated on a hill overlooking the Mediterranean Sea, in the southern part of Tel-Aviv, Jaffa has been the center of historical events for thousands of years. Still an active port today the Jaffa Port is a great place to explore. Wander through the art galleries, shopping boutiques and gourmet food markets. Stroll by the old docks, listen to live music, drink, eat and absorb the special atmosphere.<br><br>To get a better view of the city, climb up the hill to Peak (Ha'Pisga) Park overlooking the bay and gaze at the beautiful city below. On your way down, make a wish at the Wishing Bridge. Who know, it may come true.</p>
  //                         <h2>Go on A Romantic urban adventure</h2>
  //                         <p>Jaffa streets are full of surprises. Stroll in the narrow stone-paved streets of old Jaffa, discover hidden courtyards and notice the small details – painted ceramic tiles, small sculptures and upper open terrace. See the people, enter the art galleries, artists' studios and unique boutique.<br><br>Keep exploring. From the Clock tower square at the heart of the city continue to the well-known Jaffa Flea Market and weave your way through daily basics and hidden treasures. It's time to test those bargaining skills. Enjoy the small quaint cafés, middle-eastern authentic restaurants, great bar and some of best hummus you ever tasted. Guaranteed.</p>

  //                         <p><a href="https://info.goisrael.com/en/attractions#/specFilters=6m!#-!19&amp;pageSize=24&amp;viewMode=grid&amp;orderBy=0&amp;pageNumber=1" rel="nofollow" target="_blank">View attractions in Tel Aviv &amp; Center at Tourist Information site</a><br><a href="https://info.goisrael.com/en/accomodations#/specFilters=6m!#-!19" rel="nofollow" target="_blank">View accommodations in </a><a href="https://info.goisrael.com/en/attractions#/specFilters=6m!#-!19&amp;pageSize=24&amp;viewMode=grid&amp;orderBy=0&amp;pageNumber=1" rel="nofollow" target="_blank">Tel Aviv &amp; Center</a><a href="https://info.goisrael.com/en/accomodations#/specFilters=6m!#-!19" rel="nofollow" target="_blank"> at Tourist Information site</a></p>

  // 			`
  // 		}
  // 	}

  // },

  {
    id: "Shakshuka_Time",
    bgImage: "/posts/bank/43/1.jpg",
    mobBgImage: "/posts/bank/43/M.jpg",
    title: "ВРЕМЯ ШАКШУКИ",
    smltitle: "",
    isVid: true,
    ctg: "culinary",
    vidId: "n4kCnPXEX7g",
    html: function() {
      return {
        __html: `

				<h2 class="ac-margin-bottom-20 ac-margin-top-20">Научитесь делать всемирно известное блюдо Шакшука!</h2>

		<p>
          Когда вы спросите людей, которые посещали Тель-Авив и Иерусалим, какое блюдо, из тех, которые они пробовали во время поездки, было их любимым, наиболее частым ответом будет – Шакшука. Этот средиземноморский деликатес и, определенно, местное излюбленное блюдо, по сути, представляет собой блюдо из яиц, жаренных в соусе из помидоров, перца чили и богатого ароматами лука, а также часто подаваемого с хлебом и тахини. Конечно, есть множество вариаций этого блюда в соответствии с местными стилями и вкусами, и обычно его подают на завтрак или поздний завтрак, хотя вам оно покажется фантастическим также в качестве обеда.
      		</p>
      		<p>
          Лучше всего есть Шакшуку находясь под фантастическим, сияющим круглый год, солнцем Тель-Авива или Иерусалима, наслаждаясь потрясающим городским туром, наполненным вкусами и незабываемыми впечатлениями.
      		</p>
      		<p>
          Тем не менее, если вы пожелаете сделать её самостоятельно и воссоздать вкус сенсационной Шакшуки у себя на кухне, вот как она делается:
      		</p>
      		<h3>
            <u>Ингредиенты</u>
          </h3>
          <ul>
             <li>2 столовые ложки оливкового масла</li>
             <li>1 лук, нарезанный кубиками</li>
             <li>1 красный перец, без семян и нарезанный кубиками</li>
             <li>4 зубчика чеснока, рубленых на мелкие кусочки</li>
             <li>2 баночки нарезанных кубиками томатов</li>
             <li>6 яиц</li>
             <li>2 столовые ложки свежей кинзы, нарезанной</li>
             <li>¾ чайной ложки соли</li>
             <li>1 чайная ложка паприки</li>
             <li>¼ чайной ложки черного перца</li>
             <li>1 халапеньо (по желанию)</li>
          </ul>
          <h3>
             <u>Способ приготовления</u>
          </h3>
          <ol>
              <li>Разогрейте духовку до 375 градусов, пока вы ждете.</li>
              <li>Нагрейте оливковое масло на среднем огне в тяжелой сковороде, безопасной для готовки в духовой печи. Добавьте лук, перец и халапеньо, и жарте до тех пор когда лук станет полупрозрачным.</li>
              <li>Добавьте чеснок и паприку. Добавьте помидоры, соль и черный перец.</li>
              <li>Доведите до кипения и уменьшите огонь. готовить 10-15 минут.</li>
              <li>Освободите 6 небольших участков в соусе и аккуратно разбейте каждое яйцо в этот участок.</li>
              <li>Поместите сковороду в предварительно разогретую духовку и варите до тех пор, пока не будут готовы белки яиц – примерно через 10 минут.</li>
              <li>Добавьте кинзу в качестве гарнира перед подачей на стол.</li>
              <li>Подавайте с хлебом и тахини и наслаждайтесь!</li>
          </ol>

         `,
      };
    },
  },

  {
    id: "Gourmet_TelAviv",
    bgImage: "posts/bank/33/1.jpg",
    mobBgImage: "posts/bank/33/M.jpg",
    title: "Тель-Авив – центр кулинарного искусства",
    ctg: "culinarytelaviv",
    isVid: true,
    vidId: "jfyHxk8ZRrI",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<br/>
			<h2 class="ac-margin-bottom-20 ac-margin-top-20">Пробудите свои вкусовые рецепторы в Тель-Авиве</h2>
			<p>
			   Тель-Авив предлагает огромный выбор великолепных ресторанов. Это лучшее место, где вы сможете себя побаловать
			</p>
              
			`,
      };
    },
  },

  {
    id: "The_Desert_Negev",
    bgImage: "/posts/bank/negev4/1.jpg",
    mobBgImage: "/posts/bank/negev4/M.jpg",
    title: "ВЕЛИЧЕСТВЕННАЯ ПУСТЫНЯ",
    ctg: "eilat-negev",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `

			<div class="responisve-iframe">
					                    <iframe width="560" height="315" src="https://www.youtube.com/embed/yXzhH92kREg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
				                    </div>
			<br/>
			<h2 class="ac-align-center ac-margin-top-20">НЕГЕВ - НАСТОЯЩАЯ ВОЛШЕБНАЯ ПУСТЫНЯ</h2>
			<p class="ac-align-center ac-margin-bottom-20"><b>Приключения под солнцем пустыни. В пустыне Негев вам будет некогда скучать,<br class="hide-on-mobile"/> ведь здесь столько всего интересного</b></p>
			
			<p>
								Израильская пустыня предлагает вам захватывающие дух пейзажи и множество развлечений; вот почему это лучшее место для отпуска. Негев приглашает своих гостей в удивительное путешествие, где они найдут множество вариантов интересно провести время.
							</p>
							<p>
								Израиль - маленькая страна, и 62% ее территории занимает пустыня Негев. На красновато-мерцающей пустынной местности расположено множество впечатляющих геологических горных образований. Туристы могут насладиться уникальным зрелищем нетронутых просторов - величественных и беззвучных.
							</p>
							<p class="p-margin">
								Наряду с археологическими памятниками здесь имеются следы прошлых цивилизаций и их методов земледелия. Негев представляет собой идеальное место для встречи с бедуинскими племенами, людьми пустыни.
							</p>

							<h3>
                               <u> Отличительные свойства израильской пустыни:</u>
                            </h3>

							<ul class="p-margin">
							    <li>
										<b>Пустыня совсем рядом:</b> всего 4 часа лета из Европы. В Израиле есть два международных аэропорта: имени Бен-Гуриона и «Увда», что гарантирует короткий путь в пустыню всем путешественникам (от получаса до полутора часов). С ноября текущего года туристам будут предлагаться прямые авиарейсы из Европы и России в аэропорт «Увда» компаниями Ryanair, Wizzair и SAS.
							    </li>
                                <li>
                                        <b>Удобство для пеших походов и езды на велосипедах:</b> множество размеченных маршрутов. Израиль предложит вам самые впечатляющие пешеходные тропы в мире, в том числе сотни безопасных маршрутов по израильской пустыне. Широкий выбор маршрутов вы можете найти на следующих сайтах:<br>
                                        <a href="//www.negevtour.co.il" target="_blank">www.negevtour.co.il</a>
							    </li>
							    <li>
                                        <b>Радушие местных жителей:</b> обитатели пустынь дружелюбны и гостеприимны. Благодаря им ваше путешествие станет еще более приятным и запоминающимся.
							    </li>
							    <li>
                                        <b>Разнообразие туристических видов деятельности:</b> значительное увеличение количества мест для ночлега и огромный выбор занятий для туристов превратили Негев в популярное, многофункциональное и необычное место отдыха в последние годы.
							    </li>
							    <li>
                                        <b>Изумительные пейзажи:</b> множество туристов уже наслаждаются очарованием Негева и его разнообразными видами.<br>
                                        <ul>
                                        	<li>
                                        		На севере находятся эффектные песчаные дюны.
                                        	</li>
                                        	<li>
                                        		Кратер Рамон расположен среди крутых скал и сезонных водных источников.
                                        	</li>
                                        	<li>
                                        		На востоке вы сможете увидеть настоящую африканскую пустыню, просторную саванну с деревьями акации.
                                        	</li>
                                        	<li>
                                        		На юге вы увидите красный и черный гранит, на контрасте с которым лежат предгорья из песчаника очень приятного цвета.
                                        	</li>
                                        </ul>
                                        За время трехчасовой поездки по пустыне вы сможете увидеть весь спектр пустынных пейзажей и насладиться их разнообразием - вместо того, чтобы преодолевать долгие километры, как в других пустынях. Многие туристы решают посвятить по 2-3 дня каждому из негевских регионов.

							    </li>
							    <li>
                                        <b>Очень высокая безопасность путешествий в Негеве.</b> На случай экстренной ситуации в этом районе действуют службы спасения - одни из лучших в мире и всегда готовые оказать помощь. Если путешественникам понадобится медицинская помощь, в Израиле им предложат высококачественные услуги в соответствии с самыми требовательными стандартами западной медицины.
							    </li>
							</ul>
							<h3>
							    Для получения дальнейшей информации, советов по поиску жилья и рекомендаций:
							</h3>
							
							<p>
							   <a href="//www.negevtour.co.il/homepage/accommodation/?lang=en" target="_blank">www.negevtour.co.il</a><br>
							   <a href="https://en.aravaway.co.il/business/category/1/" target="_blank">www.en.aravaway.co.il</a>
							</p>






                            <!--Negev - Transportations-->
                             <br/>
							<h2  class="ac-margin-bottom-20 ac-margin-top-20">
							    НЕГЕВ - ГДЕ ОН РАСПОЛОЖЕН И КАК ТУДА ДОБРАТЬСЯ
							</h2>
							<p class="p-margin">
							   Если вы приземлились в Эйлате или в аэропорту «Увда» и едете в Мицпэ-Рамон или Сдэ-Бокер:
							</p>

							<h3>
							   Общественный транспорт:
							</h3>
							<p>
								Автобус 392 из Эйлата в Мицпэ-Рамон и Беэр-Шеву останавливается в аэропорте «Увда» по воскресеньям в 07:13, 08:41, 09:43, 14:12, 15:41, 17:43.
							</p>
							<p>
								Прибытие на центральную автобусную станцию Мицпэ-Рамон - приблизительно через полтора часа.
							</p>
							<p>
								С понедельника по четверг - в 07:13, 07:41, 09:43, 14:12, 15:41, 17:43.
							</p>
							<p class="p-margin">
							   <a href="//www.egged.co.il/HomePage.aspx" target="_blank">Автобусы </a><br>
							   <a href="//www.egged.co.il/HomePage.aspx" target="_blank">Шаттл из аэропорта «Увда» </a>
							</p>
							<h3>
							   Аренда автомобилей в Эйлате, Мицпэ-Рамоне и Беэр-Шеве:
							</h3>
							<p>
								В этих городах у вас есть множество вариантов аренды автомобиля.
								В Израиле действуют как международные, так и местные компании.
							</p>
							<p class="p-margin">
								Если вы приземлились в международном аэропорту имени Бен-Гуриона и едете в Негев в Машабей-Садэ, Сдэ-Бокер, Мицпэ-Рамон

							</p>
							<h3>
							   Общественный транспорт:
							</h3>
							<p>
								Автобусные маршруты 370 и 380 из Тель-Авива в Беэр-Шеву, автобусные маршруты 446 и 470 из Иерусалима в Беэр-Шеву.
                            </p>
                            <p>
								Из Беэр-Шевы автобусными маршрутами номер 60, 64, 65 и 660. Автобусы выходят приблизительно каждые 20 минут, начиная с 6 часов утра.
								До Машабей-Садэ - 35 минут езды / до района Сдэ-Бокер - 55 минут / до Мицпе-Рамон - 1 час и 20 минут.
                            </p>
                            <p class="p-margin">
								Дополнительную информацию о маршрутах и расписании общественного транспорта можно найти  <a href="https://www.bus.co.il/otobusimmvc?Language=en" target="_blank">здесь</a> или <a href="//www.egged.co.il/HomePage.aspx">здесь</a>
                            </p>


                             <!--NEGEV DESERT-don't miss-->








                            <h3 class="margin-h">
                                 Расстояния по трассам Негева
                            </h3>
							<table>
							  <tr>
							    <th></th>
							    <th>Тель-Авив</th>
							    <th>Иерусалим</th>
							    <th>Беер-Шева</th>
							    <th>Эйлат</th>
							  </tr>
							  <tr>
							    <td class="place-table"> <strong>Старый город Беэр-Шевы</strong></td>
							    <td>113 км</td>
							    <td>122 км</td>
							    <td></td>
							    <td>232 км</td>
							  </tr>
							  <tr>
							    <td class="place-table"><strong>Тель-Арад</strong></td>
							    <td>134 км</td>
							    <td>144 км</td>
							    <td>40 км</td>
							    <td>229 км</td>
							  </tr>
							  <tr>
							    <td class="place-table"><strong>Дом Бен-Гуриона в Сдэ-Бокере</strong></td>
							    <td>162 км</td>
							    <td>171 км</td>
							    <td>49 км</td>
							    <td>185 км</td>
							  </tr>
							  <tr>
							    <td class="place-table"><strong>Кратер Рамон</strong></td>
							    <td>210 км</td>
							    <td>192 км</td>
							    <td>97 км</td>
							    <td>141 км</td>
							  </tr>
							  <tr>
							    <td class="place-table"><strong>Заповедник Хай-Бар Йотвата</strong></td>
							    <td>323 км</td>
							    <td>288 км</td>
							    <td>202 км</td>
							    <td>35 км</td>
							  </tr>
							  <tr>
							    <td class="place-table"><strong>Парк Тимна</strong></td>
							    <td>330 км</td>
							    <td>294 км</td>
							    <td>208 км</td>
							    <td>30 км</td>
							  </tr>
							</table>

                            <h2  class="ac-margin-bottom-20 ac-margin-top-20">
								ПУСТЫНЯ НЕГЕВ - ЛУЧШИЕ ДОСТОПРИМЕЧАТЕЛЬНОСТИ И РАЗВЛЕЧЕНИЯ
							</h2>

							 <h3>
                                Кратер Рамон
                            </h3>

                            <p>
								В самом сердце огромной Негевской пустыни лежит кратер Рамон, крупнейший в мире эрозионный кратер, известный также как «Махтеш Рамон». Этот завораживающий природный феномен состоит из огромного числа скал самых фантастических цветов и форм. Он насчитывает 40 км в длину и от 2 до 10 км в ширину и имеет форму сильно удлиненного сердца, образуя крупнейший национальный парк Израиля - заповедник Рамон. Кратер расположен вдали от толп и городских огней. В нем можно увидеть разноцветные песчаники, вулканические породы и окаменелости, и его часто называют израильским Гранд-Каньоном. Со смотровой площадки, расположенной на высоте 300 метров, открываются поистине захватывающие виды, напоминающие голливудские декорации, в течение всего года производя огромное впечатление на туристов со всего мира.
                            </p>

                            

							<div class="img-wrapper">
						         <img src=${getImgUrl() +
                       "posts/the-desert-negev/7.jpg"} class="img-responsive" />
						         Фото: Дафна Таль
					         </div>

							<h3>
                                Парк Тимна
                            </h3>

                            <p>
                               Окруженный крутыми скалами участок в 61 км², имеющий форму подковы, парк Тимна дарит вам незабываемые впечатления. Это настоящий подарок для любителей пеших походов. Вы сможете увидеть удивительную природную работу, понаблюдать за интереснейшей жизнью животного мира, познакомиться с различными растениями и деревьями, для которых пустыня является домом, и которые выживают в тяжелых погодных условиях. Парк Тимна является настоящим магнитом для посетителей благодаря разнообразию достопримечательностей, разноцветным уникальным пескам и скалистым горам.
                            </p>

                           
							<div class="img-wrapper">
						         <img src=${getImgUrl() +
                       "posts/the-desert-negev/9.jpg"} class="img-responsive" />
						         Фото: Дафна Таль
					         </div>
					         <br/>

							<h3 class="h2-fix">
								НАЖМИТЕ, ЧТОБЫ ПОСМОТРЕТЬ:<br> парк Тимна - пьянящее приключение в пустыне
							</h3>


						    <div class="responisve-iframe">
					            <iframe width="560" height="315" src="https://www.youtube.com/embed/i_4QKtXIeto" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
				            </div>

							<br/>

                            <h3>
							    Сэндбординг в пустыне
							</h3>
							<p>
								Культовый пустынный вид спорта. Как же здорово скользить вниз по шелковым песчаным негевским дюнам, сидя или стоя на доске. Это необычный вид спорта, и если вы овладеете необходимыми навыками (что действительно очень просто), то сможете называть себя подлинным песчаным серфером.
							</p>

							<div class="img-wrapper">
						         <img src=${getImgUrl() +
                       "posts/the-desert-negev/1.jpg"} class="img-responsive" />
					         </div>
					         <div class="img-wrapper">
						         <img src=${getImgUrl() +
                       "posts/the-desert-negev/2.jpg"} class="img-responsive" />
					         </div>



							<h3>
							    Ночной Негев
							</h3>
							<p>
								Небо Негева по ночам представляет собой завораживающее зрелище. Просто посмотрите на небо, когда опустится темнота. Вы поразитесь великолепию миллионов мерцающих звезд, освещающих иссиня-черную тьму. Так ярко звезды светят только в пустыне.
							</p>

							<div class="img-wrapper">
						         <img src=${getImgUrl() +
                       "posts/the-desert-negev/4.jpg"} class="img-responsive" />
					         </div>

							<h3>
							    Восход солнца на Масаде
							</h3>
							<p>
								Только если вы будете достаточно смелы, чтобы пешком взойти на вершину - встреча восхода солнца на Масаде, несомненно, станет одним из самых незабываемых впечатлений от поездки в Израиль. Медленно поднимаясь над иорданскими горами Моава и Мертвым морем, солнце заливает светом пустынные окрестности. Вы никогда не сможете забыть это невероятное зрелище.
							</p>

							<div class="img-wrapper">
						         <img src=${getImgUrl() +
                       "posts/the-desert-negev/6.jpg"} class="img-responsive" />
					         </div>
                            <br/>

							<h2  class="ac-margin-bottom-20 ac-margin-top-20">
                                НЕГЕВ - ВЕЛИЧЕСТВЕННАЯ ИЗРАИЛЬСКАЯ ПУСТЫНЯ
                            </h2>
                            <h3>
                                Здесь вас ждут приключения и вдохновение
                            </h3>
                            <p>
                              Самое лучшее место для тех, кто обожает приключения на свежем воздухе.
                              Юг Израиля является малонаселенной областью, но здесь имеется множество интересных мест и занятий.
                            </p>
                            <p class="p-margin">
                                Обладая уникальными природными чудесами, восхода до заката Юг Израиля может предложить вам незабываемые виды, от которых у вас, несомненно, буквально захватит дух. Да, это пустыня, но она далеко не пустынна. Здесь, определенно, есть что посмотреть и чем заняться. На ваш выбор - геологические чудеса, значительные исторические объекты, изумительные природные заповедники, где вы можете пойти в пеший поход, покататься на велосипедах и на верблюдах, а также поучаствовать в захватывающем сафари-рейде. Этот величественный южный регион является одной из величайших ценностей Израиля, и он просто обязателен для посещения.
                            </p>


							<h3>
                                Сдэ-Бокер
                            </h3>

                            <p class="p-margin">
                                Киббуц Сдэ-Бокер, занимающий значительное место в истории Израиля, был основан первопроходцами Юга в начале 50-х годов прошлого века с целью заселения Негева. Сдэ-Бокер знаменит тем, что здесь жил первый премьер-министр Израиля Давид Бен-Гурион. Сегодня его дом превращен в музей, открытый для посещений.


                            </p>

                            <h3>
                                Центр «Вайдор»
                            </h3>

                            <p class="p-margin">
                                Уникальный центр, где посетителям предлагается возможность ознакомиться с выдающейся природой района Аравы через все органы чувств. Гости центра смогут узнать о передовых методах выращивания различных культур, о местной флоре и фауне, о сложностях климатических условий, а также особых свойствах почвы и воды в пустыне.
                            </p>



                            <h3>
                                Неватим
                            </h3>

                            <p class="p-margin">
                               Посещение Неватим, дома кочинских евреев, станет для вас незабываемым впечатлением. Кочинские евреи, проживавшие в Индии, репатриировались в Израиль после провозглашения независимости государства. Они считают себя одной из наиболее древних еврейских общин. В центре наследия кочинских евреев в поселении Неватим вы сможете узнать историю этой уникальной общины.
                            </p>

                            <h3>
							   Фестиваль «Мидбурн»
							</h3>

							<p class="p-margin b-video">
								Израильская версия знаменитого фестиваля Burning Man. В рамках шестидневного фестиваля в пустыне Негев вырастает временный город, являющийся платформой для различных коммун, творчества, искусства и радикальных способов самовыражения.
							</p>

                            <div class="responisve-iframe">
					            <iframe width="560" height="315" src="https://www.youtube.com/embed/QL3BGy2p77g" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
				            </div>

							<br/>

                            <h3>
                                Знакомство с бедуинской культурой
                            </h3>

                            <p>
                               Вы будете поражены бедуинским гостеприимством, сможете получить истинное наслаждение и познакомиться с интереснейшей культурой. Бедуины Израиля, группа кочевых племен, живущих в этой области уже много сотен лет, продолжают вести традиционный образ жизни. Они открывают свои сердца и дома для гостей и всегда рады рассказать о своих традициях. Катание на верблюдах, традиционные бедуинские трапезы и даже ночлег в традиционных палатках - все это неизменно имеет огромную популярность у туристов. Не упустите возможность познакомиться с этим единственным в своем роде образом жизни.
                            </p>

							<div class="img-wrapper">
						         <img src=${getImgUrl() +
                       "posts/the-desert-negev/8.jpg"} class="img-responsive" />
						         Фото: Дафна Таль
					         </div>

							<h3>
                                Кулинарные королевы Иерухама
                            </h3>

                            <p class="p-margin">
                              Если вы желаете действительно аутентичных впечатлений, не забудьте принять участие в уникальном проекте «Кулинарные королевы Иерухама». В рамках этого проекта замечательные женщины приглашают туристов со всего мира отведать традиционные семейные блюда. Вы никогда не забудете эти ароматы, краски и вкусы. Познакомьтесь вблизи с жизнью местных жителей, которые расскажут вам свои захватывающие истории, пока вы будете пробовать деликатесы. Вы воочию увидите, что такое настоящее гостеприимство.
                            </p>
                            <h3>
                                Старый город в Беэр-Шеве
                            </h3>

                            <p class="p-margin">
                               По легенде, Беэр-Шева была основана праотцом Авраамом, и она является одним из старейших городов страны. Об этом свидетельствуют следы поселений возрастом несколько тысяч лет. Старый город в Беэр-Шеве представляет собой настоящую мозаику урбанистических пространств. Прогуляйтесь по старому городу, и вы обнаружите множество уникальных архитектурных памятников, исторических объектов и историй, древних, как само время.
                            </p>
                            <h3>
                                Научный парк Карасо
                            </h3>

                            <p>
                               Недавно построенный в старом городе, Научный парк Карасо в Беэр-Шеве раскинулся на площади почти в 2 гектара, и сегодня он является крупнейшим научным парком в Израиле. Научный парк предлагает занятия и развлечения для посетителей всех возрастов, в том числе, интерактивный музей и научный сад с различными играми. Здесь также расположено 10 интерактивных выставок, посвященных различным научным дисциплинам, в том числе, генетике, средствам связи, микроэлектронике, атомной энергетике и т.д.
                            </p>
                            <h3>
                                Арад
                            </h3>

                            <p class="p-margin">
                               Арад 21-го века является городом с юной душой и богатым прошлым. Арад и его окрестности богаты красивейшими видами, вы найдете здесь умиротворенность пустыни, множество пеших маршрутов на любой возраст и вкус, проложенных среди нетронутых пустынных уголков. Арад - это отличный исходный пункт для великолепного отдыха в пустыне благодаря множеству достопримечательностей как в самом городе, так и в его окрестностях.
                            </p>


							<h3>
                               Хай-Бар Йотвата
                            </h3>

                            <p>
                               Заповедник Хай-Бар Йотвата является самым крупным в этом регионе центром по разведению диких животных и восстановлению их природной популяции. Сотрудники заповедника по праву гордятся своими владениями, от которых придет в восторг любой любитель животных. Здесь живут и хищники, и мелкие обитатели пустыни. В темном помещении вы сможете понаблюдать за жизнью ночных животных, а на 12 км² свободно пасутся стада травоядных.

                            </p>

                            <div class="img-wrapper">
						         <img src=${getImgUrl() +
                       "posts/the-desert-negev/10.jpg"} class="img-responsive" />
						         Фото: Дафна Таль
					         </div>



							<h3>
                               Экстрим и приключения
                            </h3>

                            <p>
                               Юг Израиля – идеальное место времяпровождения для любителей приключений. Неповторимый сложный ландшафт этого региона великолепно подходит для различных экстремальных видов спорта, таких как спуск на канатах с обрывов, каньонинг, езда на мотоциклах по бездорожью и особо популярные как у туристов, так и у местных жителей поездки на внедорожниках.
                            </p>

                            <div class="img-wrapper">
						         <img src=${getImgUrl() +
                       "posts/the-desert-negev/11.jpg"} class="img-responsive" />
						         Фото: Дафна Таль
					         </div>

							<h3>
							    Катание на верблюдах
							</h3>
							<p>
								И напоминание о прошлом, и оригинальный способ открыть для себя неповторимую пустыню. Катание на верблюдах предлагают несколько верблюжьих ферм, расположенных в Негеве, и мы гарантируем, что вы никогда не забудете это приключение.
							</p>

							<div class="img-wrapper">
						         <img src=${getImgUrl() +
                       "posts/the-desert-negev/5.jpg"} class="img-responsive" />
					         </div>


              
			`,
      };
    },
  },
  // {
  // 	id:34,
  //              bgImage : "/posts/34/1.jpg",
  //               mobBgImage : "/posts/34/M/1.jpg",
  //               title : "the DEAD SEA",
  //               ctg:"deadsea",
  //               isVid:false,
  //               player_id_post :"",
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  // 				<p>
  //                		A geological wonder in a uniquely serene setting, the Dead Sea is an extremely popular tourist attraction.

  //                 </p>

  //                 <p>
  //                		Experience the calm tranquility of the water with its distinct healing properties while enjoying the unparalleled beauty of the surrounding landscape. The Dead Sea, also known as the oldest natural spa in the world, is blessed with an extremely high salt concentration of 31.5%, allowing tourists from far and wide the amazing experience of effortlessly floating on the waters of the lowest place on Earth. While here, you can bathe in the healthy black mud of the area or explore the fascinating and historically rich nearby landscapes.

  //                 </p>

  //                 <p>

  // 					Luxury hotels, varied cuisine from gourmet restaurants to fast food eateries, great souvenir shops, the extraordinary history of the nearby Masada, and many cultural activities throughout the year, make the Dead Sea a popular destination for local tourists as well as International visitors.

  //                 </p>

  //             	 `
  //     }
  //   }
  // },

  // {
  // 	    id:22,
  //         bgImage : "/posts/bank/43/1.jpg",
  //         mobBgImage : "/posts/bank/43/M.jpg",
  //         title : "Shakshuka Time",
  //         ctg:"culinary",
  //         isVid:true,
  //         vidId: "n4kCnPXEX7g",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  // 				<h2>Learn how to make the world famous Shakshuka Dish!</h2>
  // 				<!--<div class="responisve-iframe">
  // 						<iframe src="https://www.youtube.com/embed/n4kCnPXEX7g/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
  // 					</div>-->

  //       		<p>
  //       		When you ask people who visit Tel Aviv and Jerusalem what was their favorite dish they tried on their trip, the answer, more often than not, will be Shakshuka. This Mediterranean delicacy, a definite local favorite is essentially a dish of eggs poached in a sauce of tomatoes, chili peppers, and onions rich in flavor and often served with bread and tahini. Of course, there are many variations on this dish according to local styles and tastes and it is usually served for breakfast or brunch though you’’ll find it makes for a fantastic dinner as well.
  //       		</p>
  //       		<p>
  //       		The best way to eat Shakshuka is definitely by under the fantastic year round sun of Tel Aviv or Jerusalem, as you enjoy an amazing city break full of flavors and unforgettable experiences.
  //       		</p>
  //       		<p>
  //       		However, should wish to DIY and recreate the taste of the sensational Shakshuka in your own kitchen, here’s how it’s done:
  //       		</p>
  //       		<h2>
  //             Ingredients
  //           </h2>
  //           <ul>
  //              <li>2 tablespoons olive oil</li>
  //              <li>1 onion, chopped</li>
  //              <li>1 red bell pepper, seeded and diced</li>
  //              <li>4 cloves garlic, minced</li>
  //              <li>2 cans of diced tomatoes</li>
  //              <li>6 eggs</li>
  //              <li>2 tablespoon fresh cilantro, chopped</li>
  //              <li>¾ teaspoon salt</li>
  //              <li>1 teaspoon paprika</li>
  //              <li>¼ teaspoon black pepper</li>
  //              <li>1 jalapeno (optional)</li>
  //           </ul>
  //           <h2>
  //              Instructions
  //           </h2>
  //           <ol>
  //               <li>Preheat oven to 375 degrees while you wait.</li>
  //               <li>Heat the olive oil in a heavy oven-safe pan over medium heat. Add in onion, bell pepper, and jalapeno and fry until onions are translucent.</li>
  //               <li>Add in garlic and paprika. Add tomatoes, salt, and black pepper. </li>
  //               <li>Bring to a simmer and reduce heat. cook for 10- 15 minutes. </li>
  //               <li>Create 6 small spaces in the sauce and carefully crack each egg into the space.</li>
  //               <li>Place pan into the preheated oven and cook until eggs whites are set – roughly 10 minutes.</li>
  //               <li>Add cilantro as garnish before serving.  </li>
  //               <li>Serve with bread and tahini and enjoy! </li>
  //           </ol>

  //          `
  //     }
  //   }
  // },

  {
    id: "The_Gates_Of_Jerusalem",
    ctg: "jerusalem",
    isVid: true,
    // vidId:"MXtcTm_JXus",
    vidId: "V0Acsw3Hf_M",
    bgImage: "/posts/bank/gates-of-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/gates-of-jerusalem/M.jpg",
    title: "ИЕРУСАЛИМСКИЕ ВОРОТА",
    smltitle: "",
    html: function() {
      return {
        __html: `
				               
				               <br/> <h2 class="ac-margin-bottom-20 ac-margin-top-20">Войдите в ворота Старого города и <br class="hide-on-mobile"/> откройте для себя еще один лик Иерусалима.</h2>
				              
					            <p>В стенах Старого города Иерусалима, построенных в начале XVI века турецким султаном Сулейманом Великолепным, восемь ворот. Все они (кроме ворот Милосердия) до сих пор служат жителям Иерусалима и гостям столицы, стекающимся к рынкам, святым и историческим местам Старого города.</p>
								<p>Ниже приведено описание всех ворот, против часовой стрелки с юга на запад:</p>
								 
								<p><strong>Сионские ворота:</strong></p>
								<p>На иврите, русском и английском языках название ворот происходит от древнего библейского названия Иерусалима. На арабском ворота также называются «воротами пророка Давида», поскольку могила царя Давида находится неподалеку от них, на горе Сион. Сионские ворота ведут прямо в еврейский и армянский кварталы.</p>
								<div class="img-wrapper">
						            <img src=${getImgUrl() +
                          "/posts/gates-of-jerusalem/1.jpg"} class="img-responsive" />
					            </div>
								<p><strong>Мусорные (Навозные) ворота: </strong></p>
								<p>Необычное название ворот связано с нечистотами, которые в древние времена сбрасывали именно здесь – в месте, где ветры, дующие большую часть времени, уносили запах от города. В книге пророка Неемии 2:13 упоминаются Навозные ворота, которые, возможно, были расположены неподалеку от нынешних. Ворота ведут к Стене Плача и археологическому парку Южной стены.</p>
								<p><strong>Ворота Милосердия: </strong></p>
								<p>Эти ворота, расположенные в восточной стене, обрамляющей Храмовую гору, являются, возможно, наиболее известными. Их называют также Золотыми воротами или Восточными воротами, и они замурованы уже на протяжении веков. Считается, что эти ворота откроются чудесным образом, когда придет Мессия и мертвые воскреснут.</p>
								<p><strong>Львиные ворота:</strong></p>
								<p>Эти ворота названы в честь барельефов двух пар львов свирепого вида, украшающих стену по обе стороны ворот. Но на самом деле это тигры — геральдический символ султана XIII века Бейбарса. Также эти ворота называют воротами Святого Стефана, по имени первого христианского мученика, который, согласно христианским преданиям, был забит камнями неподалеку отсюда. Львиные ворота, ведущие в купальню Вифезда, на Виа Долороза и к рынкам, стали знаменитыми во время Шестидневной войны.</p>
								<p><strong>Ворота Ирода:</strong></p>
								<p>Несмотря на название, печально известный иудейский царь не имеет к этим воротам никакого отношения. На арабском и на иврите эти ворота, выходящие на север, называются Цветочными воротами. Одна из версий связывает их название с каменной розеткой над воротами. Арабское название ворот — Баб аз-Заара. В арабском языке похожее слово (сахира) означает «пробудившиеся», и, возможно, название ворот относится к близлежащему кладбищу и надежде на воскрешение мертвых.</p>
								<p><strong>Дамасские ворота:</strong></p>
								<p>Наиболее впечатляющие ворота Иерусалима также выходят на север и названы в честь великого города, из которого некогда произошли правители Иерусалима. Ворота всегда многолюдны благодаря расположенным рядом шумным рынкам. Под воротами XVI века археологи обнаружили часть ворот, построенных императором Адрианом во II веке н.э.</p>
								<p><strong>Новые ворота:</strong></p>
								<p>Это единственные ворота, не являющиеся частью оригинального плана городских стен XVI века. Они были построены в период упадка Османской империи, чтобы обеспечить христианским паломникам более удобный доступ к святыням, расположенным внутри городских стен.</p>
								<p><strong>Яффские ворота: </strong></p>
								<p>Через эти ворота въезжали в город еврейские и христианские паломники, прибывавшие в Яффский порт, отсюда и название. Они вели (и ведут и сейчас) прямо в еврейский и христианский кварталы и в наиболее популярные части рынка, а также к «Башне Давида» — некогда иерусалимской цитадели, а сегодня — музею его истории.</p>


         `,
      };
    },
  },

  {
    id: "Shopping_Delights",
    ctg: "jerusalem",
    isVid: true,
    // vidId:"nX9LnWAjOIY",
    vidId: "V0Acsw3Hf_M",
    bgImage: "/posts/bank/shopping-delights/1.jpg",
    mobBgImage: "/posts/bank/shopping-delights/M.jpg",
    title: "Шоппинг в удовольствие",
    smltitle: "",
    html: function() {
      return {
        __html: `
				    <br/>
					<h2 class="ac-margin-bottom-20 ac-margin-top-20">
						От модной одежды до сувениров – все это в Иерусалиме
					</h2>
					 <p>
                            В Иерусалиме есть несколько торговых улиц и множество крытых торговых центров.  Можете не сомневаться, что, отправляясь за покупками, вы обязательно найдете то, что ищете, причем на любой кошелек.
                        </p>

                        <h3>
                            Центр города: бен иегуда и смежные улицы
                        </h3>
                        <p>
                            Сегодня практически весь центр Иерусалима превратился в огромный пешеходный торговый центр. Центральная улица – это Бен Иегуда, пешеходная улица, на которой находится множество магазинов и ресторанов. После ремонта улица стала очень привлекательной – мостовая из иерусалимского камня, элегантные уличные фонари, уютные лавочки и последний штрих – небольшой фонтан. Соседние улицы также прошли реконструкцию – на них обновили плитки и установили фонари в том же стиле, что и на Бен Иегуда. Улицы обновили при подготовке к запуску иерусалимского трамвая, путь которого проходит по улице Яффо.
                        </p>

                        <p>
                            Отправляясь за покупками  в Иерусалиме, стоит пройтись по всем центральным улицам: Шац, Кинг Джордж, Гилель, Бен Иегуда, Яффо, Йоэль Саломон, включая переулки между ними. Маленький совет: в пятницу днем загляните на Ярмарку Искусств на улицах Шац и Бецалель – здесь вы обязательно найдете сувениры, изготовленные местными художниками.
                        </p>
                        <p>
                            Сама же улица Бен Иегуда находится на холме, на самой вершине она соединяется с улицей Кинг Джордж, а у подножья холма – с улицей Яффо, на перекрестке с которой находится Сионская Площадь (Кикар Цион).
                        </p>
                        <p>
                            Главные достопримечательности улицы Бен Иегуда – это две знаменитые израильские фирмы: косметика Мертвого моря «Ахава» и качественная ортопедическая обувь «Тева Наот». Бен Иегуда – это также прекрасное место для покупки предметов культа и сувениров на христианскую тематику, как правило, по доступным ценам, однако обязательно поторгуйтесь! В этом районе также можно купить практичные повседневные вещи – от шляп и зонтиков до бытовой техники.
                        </p>

                        <!--<p>
                            А в самом низу Бен Иегуда, на Сионской Площади, находится новый универсальный магазин «Хамашбир Лацархан» (местные называют его просто «Машбир»), это многоэтажный магазин, в котором вы найдете все, что обычно продается в универсальных магазинах. Рядом с Сионской Площадью, на улице Яффо находится ювелирный магазин «Балтинестер», в котором вам могут сделать на заказ ожерелье с вашим именем. С Сионской Площади вы перейдете в район Нахлат Шива по его центральной улице Йоэль Саломон. Здесь расположено несколько магазинов керамики и ювелирных магазинов, где продаются украшения ручной работы, а также бутики одежды.
                        </p>-->

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/5/2.jpg"} class="img-responsive" />
					</div>

					<h3>
                         Торговый центр «мамила» и кардо в старом городе: эксклюзивный шоппинг
                    </h3>

					<p>Удаляясь от улицы Бен Иегуда по направлению к Старому Городу, вы попадете на потрясающе элегантный торговый проспект Арлов Мамила, отреставрированный архитектурный памятник, превращенный в открытый торговый променад. На входе расположен пятизвездочный отель «Мамила», от которого проспект простирается до Яффских Ворот Старого Города. Здесь множество фирменных магазинов, таких как Versace, H. Stern, Nike, и Gap, а также ряд дорогих магазинов культовых предметов иудаизма. В шикарном торговом центре «Мамила» постоянно проходят выставки скульптур, в амфитеатре проходят концерты и мероприятия для всей семьи, в особенности в период праздников. Чтобы узнать больше, загляните в наше <a href="//www.itraveljerusalem.com/eventcategory/cat_events/" target="_blank"><strong>расписание мероприятий </strong></a><strong><u> </u></strong>&nbsp;.
                    <br/>
                        Во время экскурсии по Старому Городу вам очень понравится шоппинг на Кардо, который расположен в Еврейском квартале. Эксклюзивные магазины на Кардо – идеальное место для покупки иерусалимских сувениров в уникальной обстановке. Улица Кардо с ее древними римскими колоннами обеспечит незабываемые впечатления для любого туриста.
                    </p>
                    <h3>
                        Иерусалимский торговый центр «малха»
                    </h3>
                    <p>
                        Иерусалимский торговый центр «Малха» – надежный выбор для человека, желающего отправиться на шоппинг в хорошем торговом центре, а также для семьи, которая любит провести время вместе. Более двадцати лет назад, когда открылся иерусалимский торговый центр «Малха», он получил звание «Самого крупного торгового центра на Ближнем Востоке». Сегодня торговый центр «Малха» все еще самый крупный торговый центр в Иерусалиме, в нем более 250 магазинов.
                    </p>

                    <p>
                          В торговом центре «Малха» есть как международные, так и израильские фирменные магазины, от дешевых и средней руки магазинчиков до очень дорогих бутиков. Знаменитые торговые марки, такие как H&M, Zara, Home Depot и Toys R Us – все держат магазины в этом торговом центре. Здесь есть множество израильских популярных сетевых магазинов одежды, как дешевых, так и дорогих, есть отделение универсального магазина «Хамашбир Лацархан» (такое же, как на Сионской площади), а также супермаркет «Мега». Кроме того,  в торговом центре «Малха» есть синагога, почтовое отделение, банк «Хапоалим». Здесь можно и перекусить, в торговом центре есть большой выбор ресторанов с едой на вынос, все они кошерные.

                    <br/>
                          Зимой здесь можно кататься на коньках, во время каникул работают детские кружки. Чтобы запланировать семейный отдых, загляните в расписание мероприятий. Кроме того, в детском магазине Шилав можно найти продукцию Gymboree (американской сети магазинов детской одежды) для детей до шести лет.
                    <br/>
                         В  торговый центр «Малха» легко добраться на городском автобусе из центра города или на такси из любой точки.
                    </p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/5/3.jpg"} class="img-responsive" />
					</div>

					<h3>
                          Арабский базар в старом городе
                    </h3>
                    <p>
                         Если вы ищете традиционную местную продукцию, отправляйтесь на Арабский Базар в Старом Городе. Он расположен в Мусульманском и Христианском кварталах. Пройдите через Яффские ворота и идите прямо в Мусульманский квартал. Как только увидите высоко подвешенные платья и галабии, сразу поймете, что вы уже на месте. Это похоже на маленький Стамбул. Арабский Базар в Старом Городе – это ближневосточный рынок, где продаются традиционные вещи ручной работы, одежда и еда. Здесь можно найти христианские, еврейские и мусульманские сувениры, зачастую намного дешевле, чем на улице Бен Иегуда – выбор за вами, однако не забудьте поторговаться (совет: начинайте с половины предложенной вам цены).
                    </p>

                    <h3>
                         Рынок «махане иегуда»  (шук)
                    </h3>

                    <p>
                        Рынок «Махане Иегуда» или Шук (слово «шук» означает «рынок» на иврите) известен своим уникальным иерусалимским характером – свежие местные продукты, орехи, пекарни (такие как «Марципан»), закусочные, где продают шуарму и фалафель. В последние годы на рынке «Махане Иегуда» появились более дорогие заведения, то, что раньше было «шуком» стало настоящим «шиком». Специализированные магазины, где продаются дорогие вина и сыры, магазины здоровой пищи, вегетарианские рестораны и даже отделение израильской франшизы Café Aroma. Кроме еды здесь можно найти сувениры: культовые предметы иудаизма (иудаика), ювелирные изделия, керамическую посуду.
                    <br/>
                        И хотя в последние годы рынок «Махане Иегуда» очень изменился и подорожал, он все еще остается «солью земли», настоящий иерусалимский колорит остается неизменным, и вы просто обязаны его посетить.
                    </p>
                    <h3>
                         В заключение
                    </h3>
                    <p>
                         В общем, шоппинг в Иерусалиме отражает характер города, здесь древнее сливается с современным, есть товары на любой кошелек – от дешевых до самых шикарных. Шоппинг в Иерусалиме – это незабываемые впечатления на всю жизнь.<br/>
                         Чтобы узнать больше, зайдите на сайт:  <a href="//www.itraveljerusalem.com/articles/popular-shopping-places/#sthash.HdOTQ81q.dpuf" target="_blank"> www.itraveljerusalem.com/</a>
                    </p>

         `,
      };
    },
  },

  {
    id: "Shopping_Delights",
    ctg: "jerusalem",
    isVid: true,
    vidId: "nX9LnWAjOIY",
    bgImage: "/posts/bank/shopping-delights/1.jpg",
    mobBgImage: "/posts/bank/shopping-delights/M.jpg",
    title: "Шоппинг в удовольствие",
    smltitle: "",
    html: function() {
      return {
        __html: `
				    <br/>
					<h2 class="ac-margin-bottom-20 ac-margin-top-20">
						От модной одежды до сувениров – все это в Иерусалиме
					</h2>
					 <p>
                            В Иерусалиме есть несколько торговых улиц и множество крытых торговых центров.  Можете не сомневаться, что, отправляясь за покупками, вы обязательно найдете то, что ищете, причем на любой кошелек.
                        </p>

                        <h3>
                            Центр города: бен иегуда и смежные улицы
                        </h3>
                        <p>
                            Сегодня практически весь центр Иерусалима превратился в огромный пешеходный торговый центр. Центральная улица – это Бен Иегуда, пешеходная улица, на которой находится множество магазинов и ресторанов. После ремонта улица стала очень привлекательной – мостовая из иерусалимского камня, элегантные уличные фонари, уютные лавочки и последний штрих – небольшой фонтан. Соседние улицы также прошли реконструкцию – на них обновили плитки и установили фонари в том же стиле, что и на Бен Иегуда. Улицы обновили при подготовке к запуску иерусалимского трамвая, путь которого проходит по улице Яффо.
                        </p>

                        <p>
                            Отправляясь за покупками  в Иерусалиме, стоит пройтись по всем центральным улицам: Шац, Кинг Джордж, Гилель, Бен Иегуда, Яффо, Йоэль Саломон, включая переулки между ними. Маленький совет: в пятницу днем загляните на Ярмарку Искусств на улицах Шац и Бецалель – здесь вы обязательно найдете сувениры, изготовленные местными художниками.
                        </p>
                        <p>
                            Сама же улица Бен Иегуда находится на холме, на самой вершине она соединяется с улицей Кинг Джордж, а у подножья холма – с улицей Яффо, на перекрестке с которой находится Сионская Площадь (Кикар Цион).
                        </p>
                        <p>
                            Главные достопримечательности улицы Бен Иегуда – это две знаменитые израильские фирмы: косметика Мертвого моря «Ахава» и качественная ортопедическая обувь «Тева Наот». Бен Иегуда – это также прекрасное место для покупки предметов культа и сувениров на христианскую тематику, как правило, по доступным ценам, однако обязательно поторгуйтесь! В этом районе также можно купить практичные повседневные вещи – от шляп и зонтиков до бытовой техники.
                        </p>

                        <p>
                            А в самом низу Бен Иегуда, на Сионской Площади, находится новый универсальный магазин «Хамашбир Лацархан» (местные называют его просто «Машбир»), это многоэтажный магазин, в котором вы найдете все, что обычно продается в универсальных магазинах. Рядом с Сионской Площадью, на улице Яффо находится ювелирный магазин «Балтинестер», в котором вам могут сделать на заказ ожерелье с вашим именем. С Сионской Площади вы перейдете в район Нахлат Шива по его центральной улице Йоэль Саломон. Здесь расположено несколько магазинов керамики и ювелирных магазинов, где продаются украшения ручной работы, а также бутики одежды.
                        </p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/5/2.jpg"} class="img-responsive" />
					</div>

					<h3>
                         Торговый центр «мамила» и кардо в старом городе: эксклюзивный шоппинг
                    </h3>

					<p>Удаляясь от улицы Бен Иегуда по направлению к Старому Городу, вы попадете на потрясающе элегантный торговый проспект Арлов Мамила, отреставрированный архитектурный памятник, превращенный в открытый торговый променад. На входе расположен пятизвездочный отель «Мамила», от которого проспект простирается до Яффских Ворот Старого Города. Здесь множество фирменных магазинов, таких как Versace, H. Stern, Nike, и Gap, а также ряд дорогих магазинов культовых предметов иудаизма. В шикарном торговом центре «Мамила» постоянно проходят выставки скульптур, в амфитеатре проходят концерты и мероприятия для всей семьи, в особенности в период праздников. Чтобы узнать больше, загляните в наше <a href="//www.itraveljerusalem.com/eventcategory/cat_events/" target="_blank"><strong>расписание мероприятий </strong></a><strong><u> </u></strong>&nbsp;.
                    <br/>
                        Во время экскурсии по Старому Городу вам очень понравится шоппинг на Кардо, который расположен в Еврейском квартале. Эксклюзивные магазины на Кардо – идеальное место для покупки иерусалимских сувениров в уникальной обстановке. Улица Кардо с ее древними римскими колоннами обеспечит незабываемые впечатления для любого туриста.
                    </p>
                    <h3>
                        Иерусалимский торговый центр «малха»
                    </h3>
                    <p>
                        Иерусалимский торговый центр «Малха» – надежный выбор для человека, желающего отправиться на шоппинг в хорошем торговом центре, а также для семьи, которая любит провести время вместе. Более двадцати лет назад, когда открылся иерусалимский торговый центр «Малха», он получил звание «Самого крупного торгового центра на Ближнем Востоке». Сегодня торговый центр «Малха» все еще самый крупный торговый центр в Иерусалиме, в нем более 250 магазинов.
                    </p>

                    <p>
                          В торговом центре «Малха» есть как международные, так и израильские фирменные магазины, от дешевых и средней руки магазинчиков до очень дорогих бутиков. Знаменитые торговые марки, такие как H&M, Zara, Home Depot и Toys R Us – все держат магазины в этом торговом центре. Здесь есть множество израильских популярных сетевых магазинов одежды, как дешевых, так и дорогих, есть отделение универсального магазина «Хамашбир Лацархан» (такое же, как на Сионской площади), а также супермаркет «Мега». Кроме того,  в торговом центре «Малха» есть синагога, почтовое отделение, банк «Хапоалим». Здесь можно и перекусить, в торговом центре есть большой выбор ресторанов с едой на вынос, все они кошерные.

                    <br/>
                          Зимой здесь можно кататься на коньках, во время каникул работают детские кружки. Чтобы запланировать семейный отдых, загляните в расписание мероприятий. Кроме того, в детском магазине Шилав можно найти продукцию Gymboree (американской сети магазинов детской одежды) для детей до шести лет.
                    <br/>
                         В  торговый центр «Малха» легко добраться на городском автобусе из центра города или на такси из любой точки.
                    </p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/5/3.jpg"} class="img-responsive" />
					</div>

					<h3>
                          Арабский базар в старом городе
                    </h3>
                    <p>
                         Если вы ищете традиционную местную продукцию, отправляйтесь на Арабский Базар в Старом Городе. Он расположен в Мусульманском и Христианском кварталах. Пройдите через Яффские ворота и идите прямо в Мусульманский квартал. Как только увидите высоко подвешенные платья и галабии, сразу поймете, что вы уже на месте. Это похоже на маленький Стамбул. Арабский Базар в Старом Городе – это ближневосточный рынок, где продаются традиционные вещи ручной работы, одежда и еда. Здесь можно найти христианские, еврейские и мусульманские сувениры, зачастую намного дешевле, чем на улице Бен Иегуда – выбор за вами, однако не забудьте поторговаться (совет: начинайте с половины предложенной вам цены).
                    </p>

                    <h3>
                         Рынок «махане иегуда»  (шук)
                    </h3>

                    <p>
                        Рынок «Махане Иегуда» или Шук (слово «шук» означает «рынок» на иврите) известен своим уникальным иерусалимским характером – свежие местные продукты, орехи, пекарни (такие как «Марципан»), закусочные, где продают шуарму и фалафель. В последние годы на рынке «Махане Иегуда» появились более дорогие заведения, то, что раньше было «шуком» стало настоящим «шиком». Специализированные магазины, где продаются дорогие вина и сыры, магазины здоровой пищи, вегетарианские рестораны и даже отделение израильской франшизы Café Aroma. Кроме еды здесь можно найти сувениры: культовые предметы иудаизма (иудаика), ювелирные изделия, керамическую посуду.
                    <br/>
                        И хотя в последние годы рынок «Махане Иегуда» очень изменился и подорожал, он все еще остается «солью земли», настоящий иерусалимский колорит остается неизменным, и вы просто обязаны его посетить.
                    </p>
                    <h3>
                         В заключение
                    </h3>
                    <p>
                         В общем, шоппинг в Иерусалиме отражает характер города, здесь древнее сливается с современным, есть товары на любой кошелек – от дешевых до самых шикарных. Шоппинг в Иерусалиме – это незабываемые впечатления на всю жизнь.<br/>
                         Чтобы узнать больше, зайдите на сайт:  <a href="//www.itraveljerusalem.com/articles/popular-shopping-places/#sthash.HdOTQ81q.dpuf" target="_blank"> www.itraveljerusalem.com/</a>
                    </p>

         `,
      };
    },
  },

  {
    id: "TelAviv_Moments",
    ctg: "telaviv",
    isVid: false,
    bgImage: "/posts/bank/37/1.jpg",
    mobBgImage: "/posts/bank/37/M.jpg",
    title: "Яркие моменты Тель-Авива",
    smltitle: "",
    isVid: true,
    vidId: "F6n-WK0RHk0",
    html: function() {
      return {
        __html: `
					<br/>
					<h2 class="ac-margin-bottom-20 ac-margin-top-20">Топ-5 вещей, которые стоит увидеть и сделать в городе</h2>
					<h3>
						Старая Яффа
					</h3>
					<p>
					Несмотря на то, что возраст района достигает тысяч лет, посещение Старой Яффы всегда ощущается, будто это какое-то захватывающее открытие. Волшебные извилистые аллеи пересекаются с художественными галереями, историческими зданиями, необычайными достопримечательностями и множеством приятных аутентичных ресторанов. Экскурсия по Старой Яффе – это вдохновляющие впечатления, безусловно, место является обязательным для каждого туриста, который посещает Израиль.
					</p>
					<h3>
						Порт Яффа
					</h3>
					<p>
						Считается одним старейших портов мира, порт Яффа используется рыбаками, матросами, купцами, крестоносцами, завоевателями и иммигрантами в течение тысяч лет. Сегодня порт продолжает служить в качестве рыболовного порта, а также восстанавливается как городской памятник, предлагая культурно-развлекательные мероприятия, шопинг и туризм, сохраняя при этом уникальный исторический и захватывающий характер.
					</p>
					<h3>
						Порт ТА
					</h3>
					<p>
					Недавно отреставрированный, модный портовый район действительно получил все необходимое. В течение дня вы можете бродить в замечательных местах ангарного стиля среди брендовых магазинов и бутиков, отдыхая в ресторанах с прекрасным видом на море и принимать участие во множестве мероприятий для всей семьи. А ночью толпа юных клабберов прибывает на территорию, которая превращается в одно из самых популярных мест в городе с крутыми клубами и барами в Тель-Авиве.
					</p>
					<h3>
						Белый город
					</h3>
					<p>
					Присоединяйтесь к увлекательной экскурсии по «Белому городу» Тель-Авива и узнайте, почему он был провозглашен местом всемирного наследия ЮНЕСКО. Белый город является домом для крупнейшей в мире группы зданий международного стиля, которые также известны как Баухауз. Построенный в 1920-1930х годах, и тщательно восстановленный в его первоначальном виде, квартал «Белый город» является поистине уникальным и запоминающимся архитектурным богатством.
					</p>
					<h3>
						Неве Цедек
					</h3>
					<p>
					Отдохните от бурного темпа Тель-Авива; этот район – скрытая жемчужина, которая может похвастаться прекрасным восточным архитектурным стилем и волшебными узкими улочками, которые делают Неве-Цедек, что буквально означает «Оазис Правды», настоящим оазисом в самом сердце оживленного города.
					</p>

         `,
      };
    },
  },

  {
    id: "Amazing_Nightlife",
    bgImage: "/posts/bank/18/1.jpg",
    mobBgImage: "/posts/bank/18/M.jpg",
    title: "УДИВИТЕЛЬНАЯ НОЧНАЯ ЖИЗНЬ",
    ctg: "telaviv",
    isVid: true,
    vidId: "ogEN7aRT0SM",
    // vidId:"WKfjMATNH8Q", - this is an old youtube video
    smltitle: "",
    html: function() {
      return {
        __html: `

					<div class="ac-cradit">
					<span class="ac-cradit-text">Credits:</span>
						<br/>
						<span class="ac-cradit-text-1">Tel Aviv Jaffa municipality<br/></span<
						<span class="ac-cradit-text-2">UDINI prodactions<br/></span>
					</div>
					<p></p>
					</div>

                    <br/>
                    <h2 class="ac-margin-bottom-20 ac-margin-top-20">Вечеринка нон-стоп в городе, котрый никогда не спит</h2>
                    <p>
                       Если вы в поисках динамичной, трендовой и непрерывной ночной жизни, хватит искать! Местная ночная жизнь столь же разнообразна, как и сами жители Тель-Авива, и для каждого, безусловно, что-то найдется! Если и есть что-то в Тель-Авиве, что мы знаем как делать, так это играть хорошо и по-взрослому.
                    </p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/8/2.jpg"} class="img-responsive" />
					</div>

					<p>
                        Известный как один из центров вечеринок западного мира, у Тель-Авива есть множество удивительных клубов, и по всему городу можно обнаружить огромный квартал удивительных клубов, наполненный молодыми и прекрасными людьми, которые развлекаются на протяжении быстрых часов ночи (и продолжают развлечения на афтепати). От попа до техно, от регги до хауса, в городе есть клубы и бары для каждого стиля и настроения.
                    </p>

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/8/3.jpg"} class="img-responsive" />
					</div>

					<p>
                      Тель-Авив – это, бесспорно, столица вечеринок Ближнего Востока и одно из самых популярных направлений ночной жизни в мире. Город был назван одним из ведущих городов-вечеринок мира изданием Telegraph, USA Today назвали его одним из лучших мест вечеринок на планете, а Lonely Planet одним из крупнейших в мире городов-вечеринок.
                    </p>

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/8/4.jpg"} class="img-responsive" />
					</div>

					<p>
                      От шумных дискотек в клубах до вечеринок на пляже, которые длятся до следующего утра – у этого города свой, неповторимый, ритм жизни.
                    </p>
                    <p>

                       Для более непринужденного отдыха в Тель-Авиве предлагается огромное количество популярных баров, ресторанов и бистро, в которых подают изысканный выбор местных кулинарных шедевров, приготовленных всемирно известными шеф-поварами, сопровождающихся сказочными коктейлями в атмосфере дружеского веселого отдыха.

                    </p>
                    <p>Автор фото: Dana Friedlander</p>

         `,
      };
    },
  },

  {
    id: "Boutique_Hospitality",
    bgImage: "/posts/bank/1.jpg",
    mobBgImage: "/posts/bank/M.jpg",
    title: "Роскошь в центре Тель-Авива",
    ctg: "telaviv",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `
                                
                                <br/><p><b>Гoтеприимный город найдет, чем порадовать каждого из своих гостей.</b></p>
                                <p>Тель-Авив давно известен как молодой и яркий приморский город, где темп жизни напоминает смену картинок в калейдоскопе. Бары, рестораны, пляжи, музеи, магазины и развлечения занимают все пространство в Тель-Авиве. Недавно в гостиничной сфере города произошла революция и за два последних года появилось столько отелей, что можно без проблем провести роскошный отпуск и занять свой досуг так, что не будет ни одной свободной минуты: активный отдых можно чередовать со спокойным. Все путешественники остаются очень довольны.</p>
								<p><strong>Только для вас - самое лучшее</strong></p>
								<p>Если вам нужна гостиница экстра-класса в фешенебельном районе с хорошей инфраструктурой, то обратите внимание на бутик-отели в Тель-Авиве. Любые услуги, какие пожелаете, персонализированное обслуживание клиентов - бутик-отели известны своим индивидуальным вниманием к любому запросу и фантазии посетителей.</p>
								 <div class="img-wrapper">
						            <img src=${getImgUrl() +
                          "/posts/boutique-hospitality/1.jpg"} class="img-responsive" />
						            Credit: Dana Friedlander
					            </div>
								<p>Многие бутик-отели Тель-Авива располагаются в исторических зданиях или памятниках архитектуры - разумеется, отреставрированных. Каждый отель отличается от другого уникальным интерьером, концепцией, спектром услуг и видом на этот город, который, как известно, никогда не спит. Каждый бутик-отель обладает своим характером и особенностями: от спа-салонов, первоклассных ресторанов до открытых террас на крышах.</p>

								<p><strong>Жить в большом городе </strong></p>
								<p>Вы романтическая пара, ищете уединения и хотите насладиться отдыхом? Вы участвуете в бизнес-конференции, которая продолжается неделю, и вы ищете тихое место, чтобы расслабиться? Или вы хотите отдохнуть в семейном кругу, пообщаться с друзьями во время веселых пляжных каникул? Хотите жить в шаговой доступности от городских достопримечательностей, ночных клубов и мест проведения какого-нибудь события? Теплый и привлекательный, но роскошный стиль бутик-отелей в Тель-Авиве обеспечивает идеальный гостиничный сервис, и вы сможете «жить» в Тель-Авиве как местный житель.</p>
								<p>Подумайте о бутик-отеле, ибо любой из них - это высококлассный гостевой дом в самом сердце большого города. Вы можете скрыться от суеты, когда пришло время расслабиться и отдохнуть, но в любое время можете снова окунуться в круговорот большого города и беззаботно получать удовольствия, посещая различные места в Тель-Авиве и пользуясь городскими услугами, как и любой местный городской житель. Множество бутик-отелей расположено в модных районах, в том числе в Неве Цедек, вдоль береговой линии, на улицах Ротшильда, Шенкин и Монтефиори. Бутик-отели Тель-Авива - это очаровательный, оригинальный, приятный и увлекательный мир для всех, кто ищет комфорт и яркие впечатления.</p>
															   

         `,
      };
    },
  },

  // {
  // 	   id:10,
  //         bgImage : "/posts/bank/12/1.jpg",
  //         mobBgImage : "/posts/bank/12/M.jpg",
  //         ctg:"telaviv",
  //         isVid:false,
  //         title : "Culture Time",
  //         smltitle : " ",
  //         html: function(){
  // 			return {
  // 				__html: `

  // 					<h2>A variety of fascinating museums and unique galleries</h2>

  // 				    <h2>
  // 				        Tel-Aviv Museum of Art
  // 				    </h2>

  // 					<p>
  // 						The Tel Aviv Museum of Art presents a variety of permanent and temporal exhibits at its home in the Helena Rubenstein Pavilion, located on Shaul Hamelech Boulevard, next to the Mann Auditorium. The permanent exhibits include some of the best works of Israeli art, as well as sculptures from the 20’s until today. It features European paintings – impressionism and post-impressionism – from the 16th to the 19th centuries, as well as European and American works of the 20th century. The museum’s graphic collection includes more than 20,000 prints and sketches. Among the museum’s outstanding works are a unique selection of early painted reliefs of Alexander Archipenko and works by Chagall, which he donated to the museum before its establishment. Helena Rubenstein’s well-known collection of miniature rooms is on permanent display in the pavilion, which bears her name.
  // 					</p>

  // 					<h2>
  // 				        OPENING HOURS:
  // 				    </h2>

  // 				    <p>

  //                           Sun Closed <br>
  //                           Mon, Wed, Sat 10:00-18:00 <br>
  //                           Tue, Thu 10:00-22:00 <br>
  //                           Fri 10:00-14:00 <br>
  //                           Sat 10:00-16:00 (July-August closed on Sat)<br>
  //                     </p>

  //                     <p>
  //                        For more information, click to the&nbsp;<a href="//www.tamuseum.org.il/en/default.aspx" target="_blank">Tel-Aviv Museum of Art</a>
  //                     </p>

  //                     <h2>
  //                         Beit Hatfutsot: The Diaspora Museum
  //                     </h2>

  //                     <p>
  //                        Beit Hatefutsot-The Jewish Diaspora Museum, situated on the Tel Aviv University campus, has gained honorary distinction throughout the Jewish world as the first museum of the history of the Jewish people to showcase the Jewish contribution to human creativity and culture over a period of more than two millennia. The Museum’s permanent exhibition brings the story of the Jewish People throughout the Diaspora to life through drawings, video clips, films, reconstructed models and other means. The exhibit focuses on various subjects – including “The Jewish Family life cycle”, “the community”, “the faith”, and “the return to Zion”.
  //                     </p>

  //                     <div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/posts/10/2.jpg"} class="img-responsive" />
  // 					</div>

  // 					<p>

  //                           For more information, click to the&nbsp;<a href="//www.bh.org.il/" target="_blank">Beit Hatfutsot: The Diaspora Museum</a>

  //                     </p>

  //                     <h2>
  //                          Eretz Israel Museum
  //                     </h2>

  //                     <p>

  //                             The Eretz Israel Museum- Tel Aviv is a multi-disciplinary institution. It presents the history of the land and its culture through an extensive permanent exhibit, in addition to a variety of temporary exhibits on subjects such as archaeology, ethnography, folklore, Judaica, cultural history, local identity, traditional crafts and functional arts. The museum’s pavilions are scattered throughout a spacious courtyard with the ancient archaeological mound of Tel Kassile, at which excavations revealed valuable findings, positioned at its center. The museum houses a variety of reconstructed ancient production devices, including wine presses, an olive oil press, and a flour mill, along with a “craftsperson’s marketplace” which showcases traditional work instruments that were used in the Land of Israel and throughout the region. There is also a sophisticated Planetarium with its “Journey to the Universe” program, and a museum shop offering a unique selection of locally produced gifts and ornaments.<br>

  //                             OPENING HOURS:<br>

  //                           Sun-Wed 10:00-16:00 <br>

  //                           Thu 10:00-20:00<br>

  //                           Fri-Sat 10:00-14:00<br>

  //                         </p>

  //                     <p>
  //                        For more information, click to the <strong>&nbsp;</strong><a href="//www.eretzmuseum.org.il/e/" target="_blank">Eretz Israel Museum&nbsp;</a>
  //                     </p>

  // 					<h2>
  // 					    Beit Ha’ir
  // 					</h2>

  // 					<p>

  //                           Beit Ha’ir, renovated by the city, was the old City Hall in Tel Aviv-Yafo on Bialik Street, and is now a living display of the city’s history.  Beit Ha’ir has a new exhibition, which sums up the extensive collection of photos and stories featuring events, sites, and experiences of residents throughout the years, a project that was part of the centenary celebrations of the city. The main hall has a virtual display, including hundreds of documentary films and thousands of rare photos and documents that showcase major events in the early years of city life.  At Beit Ha’ir you can also visit the Dizengoff House, the restored residence of Meir Dizengoff, first mayor of Tel Aviv-Yafo, which includes a permanent exhibition.

  //                           <br>
  //                           OPENING HOURS:
  //                           Sun Closed
  //                           Mon-Thu 9:00-17:00 <br>
  //                           Fri-Sat 10:00-14:00
  //                     </p>

  //                     <p>
  //                       For more information, click to the <a href="//www.eretzmuseum.org.il/e/" target="_blank">Beit Ha’ir</a>
  //                     </p>

  //                     <h2>
  //                         The Olympic Experience Museum
  //                     <h2>

  //                     <p>

  //                           A new museum in Tel Aviv-Yafo, The Olympic Experience Museum, presents a one-hour, five-ring trip through the greatest Olympic records, with a special focus on Israel’s finest moments. The Olympic Experience boasts state-of-the art high tech imaging and illustrations, audio-visuals presentations, holograms, interactive screens, hands-on trials and much, much more.

  //                           Guided tours for organized groups every 30 minutes. Advanced reservation is recommended.

  //                           Opening Hours: Sunday-Thursday: 10:00-18:00, Friday:  10:00-14:00

  //                           The Olympic Experience, 6 Shitrit Street, Hadar-Yosef. Tel: +972-3-6498385

  //                     </p>

  //                     <p>
  //                        For more information, click to the&nbsp;<a href="//www.olympic.one.co.il/General/Page.aspx?id=86&amp;siteid=2" target="_blank">The Olympic Experience Museum</a>
  //                     </p>

  //                     <p>

  //                           Ilana Goor Museum in Jaffa

  //                           The private home of this world renowned artist has been turned into a museum. You can see her sculptures, furniture, jewelry and get a glimpse into this unique Jaffa home <br>
  //                           OPENING HOURS: <br>
  //                           Sun-Fri 10:00-16:00 <br>
  //                           Sat 10:00-18:00<br>
  //                           <a href="//www.ilanagoormuseum.org/eng/">www.ilanagoormuseum.org</a>
  //                     </p>

  //                     <h2>
  //                          Palmach Museum
  //                     </h2>

  //                     <p>
  //                         Rated #1 Tel-Aviv museum on Trip Advisor, this museum examines the Palmach, the military wing of the Zionist Movement, which functioned until the establishment of the State of Israel.
  //                     </p>

  //                     <p>
  //                         For more information, click to the&nbsp;<a href="//info.palmach.org.il/show_item.asp?itemId=8096&amp;levelId=42798&amp;itemType=0" target="_blank">Palmach Museum</a>
  //                     </p>

  //                     <h2>
  //                         Other unique Museums
  //                     </h2>

  //                     <p>
  //                         Tel Aviv-Yafo is home to a variety of smaller, specialized museums, such as Beit Ben Gurion (The home of David Ben Gurion, Israel’s first prime minister), Beit Hatanach (The home of the Bible), The Haganah (defense) Museum, The I.Z.L. (the Irgun Zva’I Leumi – National Military Organization) Museum, Beit Hasofer (author’s house), Beit Reuven, The Jabotinsky Museum, and many others. Each of these smaller museums is a treasure house of artifacts. For example, Beit Bialik – the house of the national poet, displays the books, furniture and belongings of Israel’s renowned national poet. Bialik’s personal library of more than 3,000 books has been preserved, and the museum’s archives contain thousands of manuscripts, including the most extensive collection of his writings.
  //                     </p>

  //                     <h2>
  //                         OPENING HOURS OF TEL AVIV MUSEUMS:
  //                     </h2>
  //                     <h2>
  //                         Etzel Museum:
  //                     </h2>

  //                     <p>

  //                           King George 38: Sun-Thu 8:30-16:00 <br>

  //                           For more information, click to the&nbsp;<a href="//www.goisrael.com/Tourism_Eng/Tourist%20Information/attractions/Pages/Etzel%20Museum.aspx" target="_blank">Etzel Museum</a>
  //                     </p>

  //                     <h2>
  //                         Ben Gurion House:
  //                     </h2>

  //                     <p>
  //                             Sun, Tue-Thu 8:00-15:00 <br>
  //                             Mon 8:00-17:00<br>
  //                             Fri 8:00-13:00<br>
  //                             Sat 11:00-14:00
  //                     </p>

  //                     <p>
  //                        For more information, click to the&nbsp;<a href="//www.bg-house.org/?categoryId=6575" target="_blank">Ben Gurion House</a>
  //                     </p>

  //                     <h2>
  //                         Jabotinsky Institute in Israel:
  //                     </h2>

  //                     <p>

  //                         Sun-Thu 8:00-16:00 <br>
  //                         For more information, click to the&nbsp;<a href="//en.jabotinsky.org/" target="_blank">Jabotinsky Institute in Israel</a>

  //                     </p>

  //                     <h2>
  //                            The Israeli Museum:
  //                     </h2>

  //                     <p>
  //                             Sun, Mon, Wed 9:00-17:00 <br>
  //                             Tue, Thu 9:00-19:00<br>
  //                             Fri 9:00-14:00 <br>
  //                             For more information, click to the
  //                             <a href="//www.imj.org.il/en/">www.imj.org.il</a>
  //                     </p>

  //                     <h2>
  //                        Jaffa Visitors Center:
  //                     </h2>

  //                     <p>

  //                             Summer Sun-Thu, Sat 9:00-20:00<br>

  //                             Fri 9:00-17:00<br>

  //                             Winter Sun-Thu, Sat 9:00-18:00<br>

  //                             Fri 9:00-15:00<br>

  //                             For more information, click to the  <br>

  //                             <a href="//www.touristisrael.com/old-jaffa-visitors-center/3604/" target="_blank">Jaffa Visitors Center</a>

  //                     </p>

  //                     <h2>
  //                          Hall of Independence:
  //                     </h2>

  //                    <p>

  //                             Sun-Thu 9:00-17:00 <br>

  //                             Fri 9:00-14:00<br>

  //                             For more information, click to the&nbsp;<a href="//eng.ihi.org.il/" target="_blank">Hall of Independence</a>

  //                     </p>

  //                     <h2>
  //                         The Bible Museum:
  //                     </h2>

  //                     <p>

  //                             Sun-Fri 10:00-13:00 + 16:00-18:30 <br>

  //                             For more information, click to the&nbsp;<a href="//www.blmj.org/en/" target="_blank">The Bible Museum</a>

  //                     </p>

  //                     <h2>
  //                         Joseph Bau house:
  //                     </h2>

  //                     <p>

  //                             By appointment only (including weekends) <br>

  //                             For more information, click to the&nbsp;<a href="//www.josephbau.com/" target="_blank">Joseph Bau house</a>

  //                     </p>

  //                     <h2>
  //                         Rubin Museum:
  //                     </h2>

  //                     <p>

  //                             Sun Closed <br>

  //                             Mon, Wed, Thu 10:00-15:00 <br>

  //                             Tue 10:00-20:00<br>

  //                             Sat 11:00-14:00<br>

  //                             For more information, click to the &nbsp;<a href="//www.rubinmuseum.org.il/" target="_blank">Rubin Museum</a>

  //                     </p>

  //                     <h2>
  //                         Art Galleries
  //                     </h2>

  //                     <p>
  //                         Don’t miss the dozens of fine galleries, primarily located along Gordon Street and in the Old City of Jaffa, featuring the very latest in contemporary Israeli art. We won’t say another word- we’ll let the art speak for itself.
  //                     </p>

  //          `
  //     }
  //   }
  // },

  // {
  // 	    id:99,
  //         bgImage : "/posts/bank/20/1.jpg",
  //         mobBgImage : "/posts/bank/20/M.jpg",
  //         ctg:"jerusalem",
  //         isVid:true,
  //         vidId:'k4OwoEk5wMw',
  //         title : "JERUSALEM MAIN SITES ",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  // 					<!--<div class="responisve-iframe">
  // 						<iframe src="https://www.youtube.com/embed/k4OwoEk5wMw/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
  // 					</div>-->
  // 					<h2>
  // 				    	Discover the history that stretches back thousands of years
  // 				    </h2>
  // 					<p>
  // 						Like any city, the charm and essence of Jerusalem is best absorbed by walking its streets. However, depending on your interests, you don’t want to miss out on exploring at least some of these major attractions.
  // 					</p>

  // 					<p>
  //                          When visiting religious sites, it’s advised to dress modestly and wear clothing that covers your knees and elbows.
  //                     </p>

  // 					<p>
  //                        A good place to start is Jerusalem’s Old City, which has a very special and distinct atmosphere and is where many of the major attractions of Jerusalem are found.
  //                     </p>

  //                     <h2>
  //                         OLD CITY
  //                     </h2>

  //                     <h2>
  //                         JERUSALEM WESTERN WALL
  //                     </h2>

  //                     <p>
  //                       The Western Wall, also known as the Wailing Wall and Kotel, is the western retaining wall of the Second Temple. Considered Judaisms’s holiest site, the wall is divided into a men’s and women’s section where worshipers congregate throughout the day for morning, afternoon and evening services. Diverse crowds come to pray against the stones, to tuck small pieces of paper with prayers into the cracks and to simply marvel at the site.
  //                     </p>

  //                     <p>
  //                           Address: Jewish Quarter, Old City <br>
  //                           Phone: +972-2-627-3515<br>
  //                           Hours: 24/7<br>
  //                     </p>

  //                     <h2>
  //                         VIA DOLOROSA
  //                     </h2>

  //                     <p>
  //                         TCrossing the Muslim Quarter from east to west is this street that traces the last steps of Jesus Christ as he was led to his crucifixion. Popular with both pilgrims and general tourists, the route marks 14 events on Christ’s last walk and is also lined with shops and stalls. It is worth visiting on a Friday afternoon (3:00opm in winter; 4:00pm in summer) when the Franciscans lead a procession along the route.
  //                         <br>Address: Via Dolorosa, Muslim Quarter, Old City.
  //                     </p>

  //                     <h2>
  //                         JERUSALEM CHURCH OF THE HOLY SEPULCHER
  //                     </h2>

  //                     <p>
  //                         One of the holiest sites for Christians, this impressive building draws millions of pilgrims from around the world every year. The compound is believed to be the site of Golgotha (the Hill of Calvary), where, according to the New Testament, Jesus was crucified, buried and resurrected.
  //                         <br>
  //                         Address: Between Suq Khan e-Zeit and Christian Quarter Rd, Christian Quarter, Old City<br>
  //                         Phone: +972-2-627-3314 <br>
  //                         Hours: Sun – Sat: 5:00am – 8:00pm/9:00pm
  //                     </p>

  // 					<h2>
  // 					    DAVID’S CITADEL
  // 					</h2>

  // 					<p>
  // 					   David’s Citadel (also known as the Tower of David) was originally built in the second century BC to strategically strengthen a weak point in the city’s defences, and was subsequently destroyed and rebuilt many times over the ensuing centuries. Since 1989, the grounds are home to a fascinating museum, which sheds light on the history of Jerusalem. Don’t forget to take in the splendid view of Jerusalem from its ramparts.
  // 					</p>

  // 					<p>
  //                           Address: Jaffa Gate, Christian Quarter, Old City <br>
  //                           Phone: +972-2-626-5333<br>
  //                           Hours: Sun-Thu: 10:00am -4:00pm, Fri: Closed, Sat: 10:00am – 2:00pm (September-June), Sun-Thu:<br> 10:00am – 5:00pm, Fri: 10:00am – 2:00pm, Sat: 10:00am – 5:00pm (July-August)
  //                     </p>

  //                     <h2>
  //                         CITY OF DAVID
  //                     </h2>

  //                     <p>
  //                         Situated deep below ground in the Arab village of Silwan is the remains of the once-grand citadel where a dynasty of Judean kings once ruled. A massive visitors’ center offers a tour that begins with an observation point overlooking the remains of ancient Jerusalem, then continues underground with a look at recent archaeological finds and ends at the Gihon Spring, where according to tradition Solomon was anointed king. Visitors can also wade through the waters of the 2,700-year-old Hezekiah’s Tunnel.
  //                     </p>

  //                     <p>
  //                           Address: Silwan, East Jerusalem <br>
  //                           Phone: +972-2-626-2341<br>
  //                           Hours: Sun-Thu: 8:00am – 5:00pm (winter), 8:00am – 7:00pm (summer), Fri: 8:00am – 1:00pm (winter), 8:00am – 3:00pm (summer)
  //                     </p>

  //                     <div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/posts/9/3.jpg"} class="img-responsive" />
  // 					</div>

  // 					<h2>
  //                        MOUNT OF OLIVES
  //                     </h2>

  //                     <p>
  //                         The hill that rises to the east of the Old City, the Mount of Olives, is a great place to take in views of the Old City and the Dome of the Rock. Its slopes are filled with holy and burial sites and are home to several grand churches including the Church of all Nations. To take in all the sights, it’s best to start at the top, near to the Mosque of Ascension, and walk downhill to the Tomb of the Virgin. The Old City views are best in the morning. <br>
  //                         Address: Mount of Olives, East Jerusalem
  //                     </p>

  //                     <h2>
  //                         YEMIN MOSHE
  //                     </h2>

  //                     <p>
  //                         This charming neighbourhood facing the Old City walls was originally built to escape overcrowding in the 19th Century. It is known for its windmill and communal housing block, known as Mishkenot Shaananim, which is now a venue for art and culture. The area is home to artists, writers and academics and is renowned for its Oriental-style houses, green parks, a music center, the YMCA, King David Hotel, Herod’s Family Tomb. <br>
  //                         CITY CENTER
  //                     </p>

  //                     <h2>
  //                         MAMILLA ALROV AVENUE
  //                     </h2>

  //                     <p>
  //                           Situated between the city center and the Old City, Mamilla Alrov Avenue is a pedestrian mall that offers a selection of luxury shops, as well as upscale restaurants and cafes. Mamilla is known for its chic and tasteful European feel, and offers spectacular views of the Old City walls. <br>
  //                           Address: 6 Yitzhak Kariv St, Jerusalem <br>
  //                           Phone: +972-2-636-0000<br>
  //                           Hours: Sun-Thu: 10:00am – 9:30pm (winter), 10:00am – 10:30pm (summer), Fri: 9:00am – 2:00pm (winter), 9:30am – 3:30pm (summer), Sat: One hour after Shabbat – 11:00pm
  //                     </p>

  //                     <h2>
  //                         BEN YEHUDA STREET
  //                     </h2>

  //                     <p>
  //                     One of Jerusalem’s prime hangout spots for locals and tourists alike, Ben Yehuda Street is a pedestrian mall extending between King George Street and Jaffa Road in downtown Jerusalem. The street is filled with gift shops, falafel and ice-cream stores, buskers, beggars, musicians and street performers.
  //                     </p>

  // 					<h2>
  //                         NACHALAT SHIVA
  //                     </h2>

  //                     <p>
  //                           This charming cobblestone neighbourhood just south of Ben Yehuda Street in the&nbsp;<a href="//www.itraveljerusalem.com/placecategory/food-nightlife?multi_hood=11" target="_blank"><strong>city center</strong></a>&nbsp;offers a great selection of shops, restaurants, bars and outdoor cafes. This is a great place to experience in summer and at night with many bustling until late.
  //                     </p>

  //                     <h2>
  //                        MEAH SHEARIM
  //                     </h2>

  //                     <p>
  //                           Though it is just a few minutes’ walk from modern Ben Yehuda Street, the ultra-orthodox enclave of Mea Shearim is an entirely different reality. You will feel as though you have stepped into 18th Century Europe with Jewish Orthodoxy dressed in full traditional attire such as long black coats, black fur hats and stockings. When touring, it’s recommended to dress extremely modestly, covering up your wrists and ankles, and to take photos with discretion. <br>
  //                           Address: Meah Shearim Rd, Jerusalem
  //                     </p>

  //                     <h2>
  //                         Mahane Yehuda Market
  //                     </h2>

  //                     <p>
  //                           Often referred to as “the shuk”, Mahane Yehuda Market offers a huge assortment of fresh produce and food, as well as a variety of other shops like clothing stores, kitchenware shops, jewellery stores, ceramic stores and a variety of gentrified eateries. The shuk includes an open air and closed area, bounded by Jaffa Road on the one side and busy Agripas Street on the other. It’s worth taking public transportation to the shuk as there is not a huge abundance of parking, and a great deal of traffic. If you can handle crowds, go on a Friday to experience last minute Shabbat shopping.<br>
  //                           Address: Agripas and Jaffa Street, Jerusalem
  //                     </p>

  //                     <h2>
  //                         OTHER AREAS OF JERUSALEM
  //                     </h2>

  //                     <h2>
  //                        YAD VASHEM
  //                     </h2>

  //                     <p>
  //                           Yad Vashem, Israel’s national Holocaust memorial, commemorates the six million men, women and children murdered by the Nazis and their allies. Located at the foot of Mt. Herzl, Yad Vashem comprises several moving memorials, including the Hall of Remembrance and the haunting Children’s Memorial; the Holocaust History Museum; the Museum of Holocaust Art; sculptures and installations; a massive archive and a research institute. Dress appropriately, and make sure to reserve at least a few hours for a visit to the Museum.  Address: Har Hazikaron <br>
  //                           Phone: +972-2-644-3400
  //                     </p>

  //                     <h2>
  //                        ISRAEL MUSEUM
  //                     </h2>

  //                     <p>
  //                           You’ll want to devote at least a day to Israel’s largest cultural institution, the Israel Museum, which was re-launched in the summer of 2010 after a major overhaul. The Museum is made up of many different wings and a huge collection of art, archaeological findings and Judaica. One of the major highlights is the distinctly shaped Shrine of the Book, which houses many ancient manuscripts including the Dead Sea Scrolls. Other highlights include the Youth Wing for children, the Billy Rose Art Garden, which showcases the development of western sculpture over the centuries, the Museum’s Fine Arts Wing and its in-depth Archaeology Wing.
  //                     </p>

  //          `
  //     }
  //   }
  // },

  {
    id: "Sensational_Beaches",
    ctg: "telaviv",
    isVid: true,
    vidId: "PdTkXbiBpFs",
    bgImage: "/posts/bank/17/1.jpg",
    mobBgImage: "/posts/bank/17/M.jpg",
    title: "ПРЕКРАСНЫЕ ПЛЯЖИ",
    smltitle: "",
    html: function() {
      return {
        __html: `
                    <br/>

                    <h2 class="ac-margin-bottom-20 ac-margin-top-20">Отдохните на солнечных пляжах Тель-Авива</h2>

				    <p>
                        Набережная Тель-Авив – Яффо простирается на много километров.  Здесь люди гуляют, бегают, катаются на велосипеде, сидят на лавочках и дышат свежим воздухом, любуясь бесконечным горизонтом и качающимися на волнах белыми парусами.
                    </p>
                    <p>
                         Десятки ресторанов, кафе, кафе-мороженных переполнены с утра и до самого вечера, а по вечерам веселье переносится в бары, дискотеки, джаз-клубы. В любое время дня и ночи на пляжах есть на что посмотреть – клоуны, карикатуристы, татуировщики, специалисты по плетению косичек, фокусники и, конечно же, бесконечная толпа людей, прогуливающихся и загорающих на пляжах.
                         На набережной вас ждет чистый песок, шезлонги, разносчики мороженного и обожающие море люди, которые плавают в любую погоду, зимой и летом, что бы ни случилось. 13 тель-авивских пляжей несколько отличаются друг от друга, у каждого свои особенности, но на всех есть спасательные станции, киоски, рестораны, детские и спортивные площадки и многое другое.
                    </p>

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/13/2.jpg"} class="img-responsive" />
					</div>

					<h3>
                        <u>Несколько полезных советов</u>
                    </h3>
                    <ul>
						<li>В пятницу после обеда на пляже «Дельфинариум» вы можете присоединиться к импровизированному фестивалю барабанщиков и бразильского боевого искусства «капоэйра», сочетающего в себе элементы танца, акробатики и игры и сопровождающегося национальной бразильской музыкой.</li>
						<li>Пляж «Гордон» идеально подходит для игры в волейбол.</li>
						<li>Для соблюдающих традиции религиозных людей есть раздельное купание на пляже «Хоф Хадатиим» (пляж «Нордау»), немного южнее тель-авивского порта. Женщины и девочки купаются здесь в воскресенье, вторник и четверг, а мужчинам и мальчикам купание разрешено в понедельник, среду и пятницу. По субботам разрешен вход на пляж для обоих полов.</li>
						<li>Узкая полоска песка рядом с причалом свободней и тише других пляжей. Здесь у стоянки для яхт вы можете взять на прокат оборудование для виндсерфинга, серфинга, парусную лодку, моторную лодку и оборудование для дайвинга.</li>
						<li>Серфинг особо популярен на пляже «Хилтон». Кстати, там недавно была установлена система ночного освещения.</li>
					    <li>Кайт-серфинг популярен на пляже «Авив».</li>
						<li>Для любителей виндсерфинга очень подойдет пляж «Дельфинариум».</li>
						<li>В волейбол обычно играют на пляжах «Авив» и «Гордон».</li>
						<li>Городские пляжи прекрасно оснащены, здесь есть раздевалки, душевые и туалеты. Спасатели патрулируют пляжи в купальный сезон (май – октябрь), а туристическая полиция дополнительно обеспечивает безопасность, помощь и информационные услуги.</li>
                    </ul>
                    <h3>
                          <u>Интересные факты</u>
                    </h3>
                    <ul>
						<li>Ежегодно пляжи посещает порядка 8,5 млн. отдыхающих.</li>
						<li>Официальный пляжный сезон: май – октябрь.</li>
						<li>Вдоль береговой линии «Тель- Авив – Яффо» располагаются 13 пляжей.</li>
						<li>К четырем пляжам есть доступ для людей с ограниченными возможностями: «Цук», северный «Цук», «Мецицим» и «Хилтон» (все они расположены в северной части города).</li>
						<li>Тель-авивские пляжи традиционно получают высокие оценки по результатам тестов Министерства охраны окружающей среды Израиля и считаются очень чистыми.</li>
						<li>Израильская версия ракетбола, которая называется «маткот», это самый популярный вид пляжного спорта.</li>
						<li>Арбуз с сыром «фета» – очень популярная еда на пляже. Еще здесь любят мороженое и конфеты на палочках, а самое популярное мороженое – банановое в шоколаде.</li>
                    </ul>

                    <h3>
                          <u> Правила поведения на пляже</u>
                    </h3>

                    <ul>
						<li>Купающиеся обязаны соблюдать указания спасателей и служб спасения.</li>
						<li>Если на пляже нет спасателя, купание запрещено.</li>
						<li>Купание в море запрещено, если вывешен черный флажок.</li>
						<li>В районе пляжа запрещено кататься на гидроциклах и моторных лодках.</li>
						<li>Моторные транспортные средства запрещены как на самом пляже, так и на пешеходной дорожке вдоль пляжа.</li>
						<li>На пляже запрещено разжигать костер.</li>
                    </ul>

                    <h3>
                           Пляжный сезон
                    </h3>

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/13/2.jpg"} class="img-responsive" />
					</div>

					<h3>
                          Пляжный сезон начинается 2 мая и заканчивается 31 октября.
                    </h3>
                    <p>
                         В пляжный сезон услуги спасательных служб и службы оказания первой медицинской помощи будут предоставляться на следующих пляжах: северный пляж «Клиф», южный пляж «Клиф», пляж «Тель Барух», пляж «Хилтон», пляж «Гордон», пляж «Фришман», пляж «Буграшов» (его открытие затягивается в связи с восстановительными работами), Иерусалимский пляж, пляж «Чарльз Клор», пляж «Гиват Алия».
                    </p>
                    <h3>
                         Часы работы:
                    </h3>
                    <p>
                         Июль-август: 7:00-19:00 <br>

						Сентябрь-октябрь: 7:00-17:00
						<br>
						Уборка и контроль за территорией осуществляются на всех указанных выше пляжах с 7:00 утра до вечера.
                    </p>
                    <h3>
                          Цены:
                    </h3>
                    <p>
                          Пита с хумусом или салатом – 12 шекелей <br>
							Бутылка минеральной воды – 7 шекелей<br>
							Конфета на палочке – 5 шекелей<br>
							Аренда шезлонга на весь день – 12 шекелей <br>
							Аренда пляжного стула на весь день – 6 шекелей <br>
							Аренда пляжного зонта на весь день – 6 шекелей
                    </p>


         `,
      };
    },
  },

  {
    id: "Modern_And_Vibrant",
    bgImage: "/posts/bank/39/1.jpg",
    mobBgImage: "/posts/bank/39/M.jpg",
    ctg: "jerusalem",
    isVid: true,
    // vidId: "nX9LnWAjOIY",
    vidId: "V0Acsw3Hf_M",
    title: "СОВРЕМЕННЫЙ И ДИНАМИЧНЫЙ",
    smltitle: "",
    html: function() {
      return {
        __html: `

                    <br/>
                    <h2 class="ac-margin-bottom-20 ac-margin-top-20"> 
                        Достопримечательности в центре Иерусалима
                    </h2>      
				    <p>
					Центр Иерусалима – это центр современного мегаполиса, с бурной ночной жизнью, культурными местами и ресторанами, и он конкурирует с любыми крупными городами мира.
					</p>
					<p>
					Территория состоит из нескольких кварталов и привлекательных мест, таких как волшебная Нахлат-Шива, оживленная улица Яффо и улица Бен-Йегуда, с неповторимыми чертами и атмосферой, которые нельзя оставить в стороне.
					</p>
					<p>
						Центр Иерусалима включает в себя некоторые из самых красивых районов и захватывающих достопримечательностей города. Для получения непревзойденных культурных впечатлений посетите различные интересные музеи Иерусалима, в частности, Музей Израиля мирового класса, Музей библейских пейзажей и Музей науки Иерусалима.
					</p>
					<h3>
						Рынок Махане-Иегуда
					</h3>
					<p>
						Откройте для себя непревзойденную атмосферу и разнообразие этого рынка, который ежедневно привлекает тысячи туристов. После того как закроются магазины, кафе и рестораны, присоединяйтесь к модной молодежи, как из иностранцев, так и из местных жителей, которые приходят на рынок, чтобы пить и развлекаться почти до утра в барах, ресторанах и на аллеях.
					</p>
					<h3>
					  Нахалат-Шива
					</h3>
					<p>
					Этот волшебный квартал в самом центре города предлагает отличный выбор магазинов, ресторанов, баров и открытых кафе. Нахалат-Шива – это дом Кикар-Хамусика (Музыкальной площади), оживленного и модного пространства на открытом воздухе, в котором можно послушать живую музыку каждый день в течение недели.
					</p>
					<h3>
						Ямин-Моше
					</h3>
					<p>
						Этот замечательный район, который стоит перед стенами Старого города, сначала был построен, чтобы избежать перенаселения в 19 веке. Он является домом для художников, писателей и ученых, Ямин-Моше известный своей прекрасной ветряной мельницей и домами восточного стиля, зелеными парками, живым музыкальным центром и потрясающими видами.
					</p>
					<h3>
					   	Эйн Керем
					</h3>
					<p>
					   Эйн-Керем расположен в спокойной долине между горами и террасами на юго-западе от Иерусалима. Он является одним из самых живописных районов Иерусалима. С его извилистыми переулками, их волшебными каменными домами, украшенными арками, с церквями, чьи колокола звонят в чистом воздухе, Эйн Керем излучает обаяние и красоту, как остров в море зеленого леса.
					</p>

         `,
      };
    },
  },

  {
    id: "Jerusalem_Humus",
    bgImage: "/posts/bank/39/1.jpg",
    mobBgImage: "/posts/bank/39/M.jpg",
    ctg: "jerusalem",
    isVid: false,
    title: "ИЕРУСАЛИМСКИЙ ХУМУС",
    smltitle: "",
    html: function() {
      return {
        __html: `

                   <p>  
                        Хотите попробовать лучший хумус? Путешествие начинается здесь<br/>
                        Посещение Иерусалима непременно сопряжено с двумя событиями: вы обязательно будете есть хумус, и десятки местных жителей попытаются убедить вас в том, что они лучше всех знают, где подают самый лучший в городе хумус. А с учетом абсолютной надежности источника рекомендации, который обязательно скажет: «Уж поверь мне на слово, ведь я производитель (или любитель) хумуса в седьмом поколении!», вы останетесь в растерянности, ведь при этом не найдется двух человек, которые порекомендуют вам одно и то же заведение.
                       </p><p>
						Так что, давайте мы сами попробуем помочь вам в этом вопросе. Потому что, право же, мы, как никто другой, знаем лучшие места, где можно попробовать в Иерусалиме это классическое ближневосточное блюдо. Честное слово, это действительно самые лучшие места, предлагающие хумус.
					 </p><p>
						Для тех, кто не совсем в курсе, что представляет собой это блюдо, хумус – это паста. Есть немало споров об истоках этого блюда, но большинство знатоков склоняются к тому, что изобрели хумус где-то на Ближнем Востоке. Готовят его из тщательно перетертого вареного нута (также известного как турецкий горох), перемешанного с тхиной  (паста из молотого кунжутного семени), оливковым маслом, лимонным соком, солью и чесноком. В ближневосточных ресторанах хумус подается в качестве закуски, и едят его, зачерпывая с тарелки кусочком питы. Процесс зачерпывания питой – очень важный компонент поедания хумуса.
                    </p>
                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/14/2.jpg"} class="img-responsive" />
					</div>
					<h3>
                          «Азура», иракский квартал базара «Махане Иегуда»
                    </h3>
                    <p>
                          Есть много причин посетить базар «Махане Иегуда», ресторан «Азура» – одна из них. Ресторан расположен в Иракском квартале базара. Здесь вам подадут замечательный хумус и другие ближневосточные блюда – супы и различные виды тушеного мяса.
                    </p>
				 	<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/14/3.jpg"} class="img-responsive" />
					</div>
					<h3>
                         «Лина», христианский квартал в старом городе Иерусалима
                    </h3>
                    <p>Некоторые из лучших хумусных Иерусалима находятся в районе Старого Города. Пройдитесь в Христианский квартал, где вы найдете одну из лучших иерусалимских хумусных. Ресторан&nbsp;<a href="//www.itraveljerusalem.com/city/jerusalem/lina/" target="_blank"><strong>Lina</strong></a>, все меню которого сконцентрировано вокруг хумуса, расположен недалеко от 8-ой станции Виа Долороза. Здесь подают различные варианты традиционного хумуса – хумус с кедровыми орешками, хумус с фасолью и хумус с вареным вкрутую яйцом.</p>
                    <h3>
                         «Хумус акрамауи», мусульманский квартал в старом городе иерусалима
                    </h3>
                    <p><a href="//www.itraveljerusalem.com/city/jerusalem/acramawi/" target="_blank">Ресторан</a> «Хумус Акрамауи», расположенный напротив Дамасских Ворот в Старом Городе, – еще одно чрезвычайно популярное место. Здесь вам подадут замечательный хумус в самобытной восточной атмосфере. Ресторан основан еще в 1952 году, и за многие годы своего существования довел это блюдо до совершенства.</p>
                    <h3>
                         «Хумус бен сира», центр города, рядом с отелем «Мамила»
                    </h3>
                    <p>
                          Это, пожалуй, единственная в Иерусалиме хумусная, страдающая бессонницей, она работает до самого утра. «Хумус бен Сира» – идеальное место для тех, кто проголодался после затянувшегося ночного веселья в расположенных поблизости ночных барах и клубах, или для туристов, которым поздно ночью захотелось выйти из гостиницы.
                    </p>
                    <h3>
                          «Абу шукри», мусульманский квартал в старом городе Иерусалима
                    </h3>
                    <p>
                         Маленький семейный ресторанчик «Абу Шукри», расположенный в Мусульманском квартале Старого Города, кроме хумуса предлагает также фалафель и салаты. «Абу Шукри» – не самый шикарный ресторан, но здесь можно присесть, укрывшись от палящего солнца (или от зимнего холода). После длительной прогулки по Старому Городу вы сможете замечательно освежиться и отдохнуть в ресторане «Абу Шукри».
                    </p>

         `,
      };
    },
  },

  // {
  // 	    id:"Jerusalem_After_Dark_Fun",
  //         bgImage : "/posts/bank/modern-and-vibrant/1.jpg",
  //         mobBgImage : "/posts/bank/modern-and-vibrant/M.jpg",
  //         ctg :"jerusalem",
  //         isVid:true,
  //         vidId:"nLKWDp5uA-U",
  //         title : "After Dark Fun in the Holy City",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `

  // 					            <p>Planning a trip to Jerusalem usually involves its many sights of culture and historical significance. However, just as important to many, Jerusalem’s has an amazingly cool after dark scene, filled with music, hipster hangouts, dance clubs, and much more.</p>
  //                               <p>To check it out, make your way to the City Center and explore the narrow streets just off Jaffa Street. There you’ll find bars and nightclubs that range from comfortably mainstream to eccentrically funky. Rivlin Street is a popular hangout for young people, while Shoshan Street and the surrounding area offers a more laid-back grown up vibe.</p>
  //                               <div class="img-wrapper">
  // 						          <img src=${getImgUrl() +  "/posts/modern-and-vibrant/1.jpg"} class="img-responsive" />
  // 					          </div>
  //                               <p>Machane Yehuda market offers a surprisingly awesome night out as in the evening it transforms into a trendy hotspot where vendor stalls and shops become the setting for bars, DJs, live music, and dancing. </p>
  //                               <p>Betzalel Street is famous for its student artsy vibe and the many little bars are a great place to befriend the locals who come for a drink and a jam session. </p>
  //                               <p>For a daytime change of pace head to the German Colony (Moshava) and, particularly, the neighborhood of Baka. Start at Beit Lechem Street where you’ll have your choice of popular, contemporary restaurants and bars. Then stroll all the way up Emek Refaim Street or through HaMesila (Railway) Park until you reach The First Station – once a railroad depot in use for over a century, it transformed now into a trendy culinary, cultural, and retail delight.</p>

  //          `
  //     }
  //   }
  // },

  {
    id: "Jerusalem_Musts",
    bgImage: "/posts/bank/38/1.jpg",
    mobBgImage: "/posts/bank/38/M.jpg",
    ctg: "jerusalem",
    isVid: true,
    // vidId: "WVGEqXhtipI",
    vidId: "FvAWuLQEOJw",
    title: "ОБЯЗАТЕЛЬНО В ИЕРУСАЛИМЕ",
    smltitle: "",
    html: function() {
      return {
        __html: `
                    <br/>
				    <h2 class="ac-margin-bottom-20 ac-margin-top-20">5 самых популярных вещей, которые нужно сделать, и мест,
				     которые вы должны увидеть в потрясающем городе</2>
					
					<h3>
						Сегвей туры
					</h3>
					<p>
						Это способ увидеть город с адреналином, он позволит вам принять красоту Иерусалима со вполне уникальной перспективы. Сегвей туры отправляются из разных центральных мест, включая набережную Армон-Ханацив (Восточный Тальпиот), Иамин-Моше и Старый Город, а также вблизи Кнессета и района музея.
					</p>
					<h3>
						Первая станция (Хатачана)
					</h3>
					<p>
					Первая станция расположена прямо в самом сердце Иерусалима, между Старым городом и центром города, между историческими кварталами Немецкой колонии и Ямин-Моше. Это место первой железнодорожной станции в Иерусалиме, которая была построена в 1892 году. После ремонта и сохранения Первая станция была вновь открыта как живое место для развлечений, открытое семь дней в неделю.
					</p>
					<h3>
						Лифт времени
					</h3>
					<p>
						Если вы являетесь поклонником аттракционов и авантюр, вам понравится то, как благодаря лифту времени вспыхнут ваши чувства. Это интерактивные впечатления, которые приводят посетителей в сказочные путешествия по увлекательным местам, в уникальном зале с подвижными сиденьями, наполненном спецэффектами.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/posts/jerusalem-must/1.jpg"} class="img-responsive" />
					</div>
					<h3>
						Библейский зоопарк
					</h3>
					<p>
					Этот прекрасный двух-ярусный зоопарк, который простирается на 62 акра, расположен на огромном рукотворном озере, укомплектованном водопадами и бассейнами по бокам, окруженный просторными лужайками и затененными местами отдыха. На радость детям и взрослым представлено более 200 видов животных, большинство из них упоминается в Библии, и некоторые сейчас почти на стадии вымирания.
                     Это не означает, что здесь нет обычных животных, здесь есть даже пингвины. Наряду с зоопарком есть прекрасный, огромный и впечатляющий аквариум, открытый для посетителей днем и вечером, с представленной морской средой Средиземного, Красного и других морей.

					</p>
					<h3>
						Парк Тедди
					</h3>
					<p>
					Назван в честь Тедди Коллека, который был мэром Иерусалима в период 1965-1995 годов; Тедди парк веселый, волшебный и исторически значимый.
          Парк является местом встречи Старого и Нового Иерусалима, и включает в себя пруд желаний, впечатляющую оригинальную скульптуру – солнечные часы, реставрации исторических памятников и фантастическую привлекательность водяного фонтана с впечатляющим световым и звуковым вечерним шоу.


         `,
      };
    },
  },

  {
    id: "Gourme_Heaven",
    bgImage: "/posts/bank/38/1.jpg",
    mobBgImage: "/posts/bank/38/M.jpg",
    ctg: "telaviv",
    isVid: true,
    vidId: "n4kCnPXEX7g",
    title: "Рай для гурмана",
    smltitle: "",
    html: function() {
      return {
        __html: `
                    <br/>
				    <h2 class="ac-margin-bottom-20 ac-margin-top-20">Познакомьтесь с удивительной кулинарной сценой Тель-Авива</h2>
					
					<p>
					Если вы гурман (и посмотрим правде в глаза, большинство из нас – гурманы), вам просто необходимо отведать кухню Тель-Авива.
					</p>
					<p>
						Израильские повара стали известны во всем мире благодаря своим инновационным блюдам, а Тель-Авивская ресторанная сцена – это что-то взрывное.
					</p>
					<p>
					С 4500 заведениями питания, Тель-Авив – это настоящая Мекка для гурманов. Многие рестораны принадлежат известным в мире шеф-поварам, которые учились и работали в некоторых лучших заведениях всего мира до того, как вернуться в Израиль и представить свою марку на местной кулинарной сцене.
					</p>
					<p>
						Тель-Авивского кухня имеет то, что подойдет для любого вкуса. Названный «лучшим направлением для веганов» сайтом для гурманов из США, The Daily Meal, в Тель-Авиве есть около 400 дружественных веганов ресторанов. Вы захотите попробовать замечательные традиционные уличные продукты питания, такие как фалафель и хумус, а также разнообразные деликатесы на местных рынках. Не пропустите модные рестораны в Тель-Авивском порту, на авеню Ротшильд, в Неве-Цедек или в потрясающем восстановленном комплексе «Тачана» и получить фантастические кулинарные впечатления.
					</p>
					<p>
						Сегодня некоторые из самых современных кухонь города вы сможете найти на рынке Сарона – ранее колонии немецких тамплиеров; Этот рынок в 8700 м2 был тщательно восстановлен, и сейчас он является домом для 91 магазина всех категорий, киосков и ресторанов, где вы сможете попробовать новые блюда, не только аппетитные, но и исключительно оригинальные.
					</p>
					

         `,
      };
    },
  },

  // {
  // 	    id:16,
  //         bgImage : "/posts/bank/34/1.jpg",
  //         ctg:'eilat',
  //         isVid:true,
  //         vidId:"yXzhH92kREg",
  //         mobBgImage : "/posts/bank/34/M.jpg",
  //         title : "NEGEV MAJESTIC DESERT",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  // 				<h2>Action adventures in the desert sun. With so much to see and do, there is never a dull moment in the Negev</h2>

  // 					<!--<div class="responisve-iframe">
  // 						<iframe src="https://www.youtube.com/embed/yXzhH92kREg/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
  // 					</div>-->
  // 					<h3 class="negev-secondary-title">
  // 								 The Negev Desert - Pure Magic Desert
  // 							</h2>

  // 							\n

  //                             <!--negev text-->

  //                             <p>
  // 								The Israeli desert with its breathtaking landscape and various attractions is offering the perfect place for a holiday. The Negev invites the visitors to an exciting journey that is rich in variety of opportunities.
  // 							</p>
  // 							<p>
  // 								Israel is a small country with 62% of the total area occupied by the Negev desert. The reddish gleaming desert terrain is characterized by many impressive geological rock formations. The visitors enjoy here a unique view of an untouched vastness - silent and majestic.
  // 							</p>
  // 							<p class="p-margin">
  // 								There are traces of past civilizations and their agriculture as well as archaeological sites. The Negev offers an unmistakable backdrop for encountering the Bedouin tribes - people of the desert.
  // 							</p>

  // 							<h2>
  //                                 The Israeli desert is special for the following reasons:
  //                             </h2>

  // 							<ul class="p-margin">
  // 							    <li>
  // 										<b>The desert is very near:</b> just 4 hours of flying from Europe. Israel has two international airports - Ben Gurion and Ovda, which guarantee a short trip to the desert to all travellers (half an hour to an hour and a half).
  // 										Starting from November, there will be direct flights from Europe and Russia to Ovda airport including Ryanair, Wizzair, and SAS.
  // 							    </li>
  //                                 <li>
  //                                         <b>Easy to Hike and Bike:</b> There are a lot of marked paths. Israel offers the most imposing hiking trails of the world and hundreds of safe paths lead through the Israeli desert. You can find a selection of trails on the following websites:<br>
  //                                         <a href="//www.negevtour.co.il" target="_blank">www.negevtour.co.il</a>
  //                                         <a href="//www.en.aravaway.co.il " target="_blank">www.en.aravaway.co.il</a>
  // 							    </li>
  // 							    <li>
  //                                         <b>Cordial local population:</b> The desert dwellers are friendly and hospitable and make the desert experience both pleasant and exciting for visitors.
  // 							    </li>
  // 							    <li>
  //                                         <b>Tourists Activities:</b> Along with the development of accommodation, the huge offer of tourist activities has converted the Negev in a popular, interesting, versatile and creative destination in recent years.
  // 							    </li>
  // 							    <li>
  //                                         <b>Magnificent landscapes:</b> Lots of tourists today, enjoy the charm of the Negev with its landscapes rich in variety<br>
  //                                         <ul>
  //                                         	<li>
  //                                         		There are spectacular sand dunes in the north.
  //                                         	</li>
  //                                         	<li>
  //                                         		The Ramon Crater is present in the middle with its bold cliffs and seasonal water sources.
  //                                         	</li>
  //                                         	<li>
  //                                         		In the east, one experiences the African desert with wide savannas and acacia trees.
  //                                         	</li>
  //                                         	<li>
  //                                         		To the south, one finds red and black granite, contrasted by sandstone foothills having a powerfully pleasant colour.
  //                                         	</li>
  //                                         </ul>
  //                                         During a desert trip of approx. 3 hours, you can get to know the entire spectrum of the desert landscape and enjoy its variety, which one experiences in other deserts often only with a long trip of several kilometers.
  // 										Many tourists decide for to stay for 2 or 3 days in each region of the Negev.

  // 							    </li>
  // 							    <li>
  //                                         <b>The Negev is very safe to travel.</b> In case of emergency, the rescue units working in the area are some of the best trained in the world and are always close by. Should anyone require medical assistance, Israel offers high quality, first class advanced western medical services.
  // 							    </li>
  // 							</ul>
  // 							<h2>
  // 							    More information and tips for accommodation and recommendations:
  // 							</h2>
  // 							<p>
  // 							   <a href="//www.negevtour.co.il/homepage/accommodation/?lang=en" target="_blank">www.negevtour.co.il</a><br>
  // 							   <a href="https://en.aravaway.co.il/business/category/1/" target="_blank">www.en.aravaway.co.il</a>
  // 							</p>
  // 							<p class="p-margin">
  // 							   <a href="//goisrael.de/taxonomy/term/85" target="_blank">Travel deals</a><br>

  // 							</p>

  //                             <!--Negev - Transportations-->

  // 							<h2>
  // 							    NEGEV - LOCATION AND APPROACH
  // 							</h2>
  // 							<p class="p-margin">
  // 							   Landing at the airports of Ovda or Eilat with the  onward journey to Mitzpe Ramon or Sde Boker:
  // 							</p>

  // 							<h2>
  // 							   Public means of transportation:
  // 							</h2>
  // 							<p>
  // 								Bus 392 from Eilat to Mitzpe Ramon and Be'erSheva, stops at the airport of Ovda on Sunday at 07:13, 08:41, 09:43, 14:12, 15:41, 17:43.
  // 							</p>
  // 							<p>
  // 								Arrival at the central bus station of Mitzpe Ramon after about an hour and a half.
  // 							</p>
  // 							<p>
  // 								Mondays - Thursdays at 07:13, 07:41, 09:43, 14:12, 15:41, 17:43.
  // 							</p>
  // 							<p class="p-margin">
  // 							   <a href="//www.egged.co.il/HomePage.aspx" target="_blank">Bus service </a><br>
  // 							   <a href="//www.egged.co.il/HomePage.aspx" target="_blank">Shuttle service from Ovda Airport </a>
  // 							</p>
  // 							<h2>
  // 							   Car rental in Eilat, Mitzpe Ramon and Be'erSheva:
  // 							</h2>
  // 							<p>
  // 								There a multiple option in renting a car in these cities.
  //                                 There is a choice of international and Israeli companies.

  // 							</p>
  // 							<p class="p-margin">
  // 								Landing at the Ben Gurion International Airport near Tel Aviv and onward journey for Negev to Mashabei Sadeh / Sde Boker / Mitzpe Ramon

  // 							</p>
  // 							<h2>
  // 							   Public means of transportation:
  // 							</h2>
  // 							<p>
  // 								Bus routes 370/380 from Tel Aviv to Be'erSheva, routes 446/470 from Jerusalem to Be'erSheva.
  // 								<a href="//www1.rail.co.il/EN/Pages/Homepage.aspx" target="_blank">Train from Ben Gurion or Tel Aviv to Be'erSheva.</a>
  //                             </p>
  //                             <p>
  // 								From Be'erSheva bus routes 60, 64, 65, 660 Departure every morning 6 o'clock onward (approx. every 20 minutes).
  //                                 Arrival in Mashabei Sadeh in 35 minutes / SdeBoker area in 55 minutes / Mitzpe Ramon in 1 hour 20 minutes.
  //                             </p>
  //                             <p class="p-margin">
  // 								More information about the public means of transportation is given <a href="https://www.bus.co.il/otobusimmvc?Language=en" target="_blank">here</a> or <a href="//www.egged.co.il/HomePage.aspx">here</a>
  //                             </p>

  //                              <!--NEGEV DESERT-don't miss-->

  //                             <h3 class="margin-h">
  //                                  NEGEV ROAD DISTANCES
  //                             </h2>
  // 							<table>
  // 							  <tr>
  // 							    <th></th>
  // 							    <th>Tel Aviv</th>
  // 							    <th>Jerusalem</th>
  // 							    <th>Bee'r Sheva</th>
  // 							    <th>Eilat</th>
  // 							  </tr>
  // 							  <tr>
  // 							    <td class="place-table"> <strong>Old Town <br class="show-on-mobile"> Beer Sheva</strong></td>
  // 							    <td>113 Km</td>
  // 							    <td>122 Km</td>
  // 							    <td></td>
  // 							    <td>232 Km</td>
  // 							  </tr>
  // 							  <tr>
  // 							    <td class="place-table"><strong>Tel Arad</strong></td>
  // 							    <td>134 Km</td>
  // 							    <td>144 Km</td>
  // 							    <td>40 Km</td>
  // 							    <td>229 Km</td>
  // 							  </tr>
  // 							  <tr>
  // 							    <td class="place-table"><strong>Ben-Gurion's House <br class="show-on-mobile">in Sde Boker</strong></td>
  // 							    <td>162 Km</td>
  // 							    <td>171 Km</td>
  // 							    <td>49 Km</td>
  // 							    <td>185 Km</td>
  // 							  </tr>
  // 							  <tr>
  // 							    <td class="place-table"><strong>Ramon Crater</strong></td>
  // 							    <td>210 Km</td>
  // 							    <td>192 Km</td>
  // 							    <td>97 Km</td>
  // 							    <td>141 Km</td>
  // 							  </tr>
  // 							  <tr>
  // 							    <td class="place-table"><strong>Hai Bar Wildlife <br class="show-on-mobile"> reserve Yotvata</strong></td>
  // 							    <td>323 Km</td>
  // 							    <td>288 Km</td>
  // 							    <td>202 Km</td>
  // 							    <td>35 Km</td>
  // 							  </tr>
  // 							  <tr>
  // 							    <td class="place-table"><strong>Timna Park</strong></td>
  // 							    <td>330 Km</td>
  // 							    <td>294 Km</td>
  // 							    <td>208 Km</td>
  // 							    <td>30 Km</td>
  // 							  </tr>
  // 							</table>

  //                             <h2>
  // 								NEGEV DESERT - DON'T MISS
  // 							</h2>

  // 							 <h2>
  //                                 Ramon Crater
  //                             </h2>

  //                             <p>
  //                                 At the heart of Israel’s vast Negev Desert, lies the Ramon Crater, the world’s largest erosion crater,also known as Machtesh Ramon.
  // 								Encompassing a vast diversity of rocks of fantastic colors and forms, this mesmerizing natural phenomenon measures 40km in length and between 2 and 10km in width, shaped like an longated heart, and forms Israel’s largest national park, the Ramon Nature Reserve.
  // 								Far from the city lights and crowds, featuring multicolored sandstone, volcanic rock and fossils, the Ramon Crater is often described as Israel’s very own Grand Canyon.
  // 								The truly stunning views from the 300m edge lookout point of Machtesh Ramon, reminiscent of a Hollywood backdrop offer a powerful experience for tourists from all over the world, all year round.

  //                             </p>

  //                             <div class="img-wrapper img-page3">
  // 								<img src=${getImgUrl() +  "/Negev/7.jpg"} class="img-responsive" />
  // 								Credit: Daphna Tal
  // 							</div>

  // 							<h2>
  //                                 Timna Park
  //                             </h2>

  //                             <p>
  //                                15,000 acres in a horseshoeshaped valley surrounded by steep cliffs, Timna Park is an extraordinarily stunning experience and an absolute treat for hiking enthusiasts. Here you'll witness the marvelous works of nature, as well as the amazing wildlife, plants and trees which make the desert their home, surviving in the harsh arid conditions.
  //                                With its multitude of attractions, colorful sands and craggy mountains, Timna Park is an incomparable visitor magnet.

  //                             </p>

  //                             <div class="img-wrapper img-page3">
  // 								<img src=${getImgUrl() +  "/Negev/9.jpg"} class="img-responsive" />
  // 								Credit: Daphna Tal
  // 							</div>

  // 							<h2 class="title-to-play">
  // 								CLICK TO PLAY: Timna Park - An Exhilarating Desert Adventure
  // 							</h2>
  // 							<div class="responisve-iframe">
  // 							    <iframe src="https://www.youtube.com/embed/i_4QKtXIeto/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
  // 							</div>

  //                             <h2>
  // 							    Sandboarding in the desert
  // 							</h2>
  // 							<p>
  // 								An iconic desert experience. The plush sweeping sand dunes of the Negev desert allow you to glide down sitting down or standing up at an exhilarating pace. This is a fantastic and very special skill, which once you master (it’s really very easy) you can call yourself a genuine sand surfer – how cool is that?
  // 							</p>
  // 							<div class="img-wrapper img-page3">
  // 								<img src=${getImgUrl() +  "/Negev/1.jpg"} class="img-responsive" />
  // 							</div>
  // 							<div class="img-wrapper img-page3">
  // 								<img src=${getImgUrl() +  "/Negev/2.jpg"} class="img-responsive" />
  // 							</div>

  // 							<!--<div class="img-wrapper img-page3">
  // 								<img src=${getImgUrl() +  "/Negev/3.jpg"} class="img-responsive" />
  // 							</div>-->

  // 							<h2>
  // 							    Negev at night
  // 							</h2>
  // 							<p>
  // 								The sky of the Negev at night is a mesmerizing sight. Simply look up once darkness sets and you will immediately be struck by the splendor of millions of twinkling stars, lighting up the blue-black darkness in a radiance that can only be seen in the dessert.
  // 							</p>

  // 							<div class="img-wrapper img-page3">
  // 								<img src=${getImgUrl() +  "/Negev/4.jpg"} class="img-responsive" />
  // 							</div>

  // 							<h2>
  // 							    Sunrise at Masada
  // 							</h2>
  // 							<p>
  // 								Available only to those brave enough to climb atop by foot - watching the Sunrise at Masada is undoubtedly one of the most unforgettable experiences to be had in Israel. The slow rise of the sun as it emerges over the Jordanian Moab Mountains and the Dead Sea, shedding its light on the surrounding desert landscapes, is a truly spectacular sight, one which you will not soon forget.
  // 							</p>

  // 							<div class="img-wrapper img-page3">
  // 								<img src=${getImgUrl() +  "/Negev/6.jpg"} class="img-responsive" />
  // 							</div>

  // 							<h2>
  //                                 NEGEV - ISRAEL’S MAJESTIC DESERT
  //                             </h2>
  //                             <h2>
  //                                 Where Adventure and Inspiration Await
  //                             </h2>
  //                             <p>
  //                               An ideal destination for travelers who love adventure in the great outdoors.
  // 							  The south of Israel is sparsely populated, but packed with fascinating sites and activities.

  //                             </p>
  //                             <p class="p-margin">
  //                                 With amazing natural wonders and beauty, the South boasts magnificent views that are guaranteed to take your breath away, from sunrise to sunset.
  // 								A desert but definitely not deserted, there is so much to see and do here – there are many extraordinary geological marvels, significant historical landmarks and wonderful nature reserves, where you can go hiking, cycling and camel riding, or enjoy adrenaline-charged safari rides in the desert.
  // 								Simply put, this majestic Southern region is one of the country’s greatest assets and an absolute must on the itinerary.

  //                             </p>

  // 							<h2>
  //                                 Sde Boker
  //                             </h2>

  //                             <p class="p-margin">
  //                                 A remarkable glance to the history of the State of Israel, Sde Boker is a Kibbutz originally established by pioneers, with the mission to settle the Negev in the early 50’s.
  //                                 Sde Boker is renowned as the home of David Ben Gurion, Israel’s first Prime Minister whose home is now a museum open to the public.

  //                             </p>

  //                             <h2>
  //                                 Vidor Center
  //                             </h2>

  //                             <p class="p-margin">
  //                                 A truly unique attraction, offering a multi-sensory experience of the exceptional nature of the Arava region. Visitors to the center can discover advanced farming methods, the local flora and fauna, climate challenges, and special qualities of the soil and water of the desert.
  //                             </p>

  //                             <h2>
  //                                 Nevatim
  //                             </h2>

  //                             <p class="p-margin">
  //                                A visit to Nevatim, the home to Cochin Jews, is a fascinating experience. Cochin Jews, originally from India, immigrated to Israel after the establishment of the State. Cochin Jews consider themselves as one of the most ancient Jewish communities in the world.
  //                                The Center for Cochin Heritage at Moshav Nevatim tells the story of this unique community.
  //                             </p>

  //                             <h2>
  // 							   MidBurn Festival
  // 							</h2>

  // 							<p class="p-margin">
  // 								Israel’s own version of the famous “Burning Man” festival; where for 6 days, a temporary city is set up in the Negev desert, creating a platform which allows a communal life style, creativity, art and radical self-expression.
  // 							</p>

  // 							<div class="responisve-iframe">
  // 							    <iframe src="https://www.youtube.com/embed/QL3BGy2p77g/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
  // 							</div>

  // 							<br>

  //                             <h2>
  //                                 The Bedouin Experience
  //                             </h2>

  //                             <p>
  //                                The Bedouin hospitality is a truly unrivalled experience, one which is both highly enjoyable and culturally engaging.
  //                                A group of nomadic tribes indigenous to the area and dating back many hundreds of years, the Bedouins of Israel continue to live in traditional ways, opening their hearts, their homes and their way of life to the public, to share in their customs and their world-renowned hospitality. From camel riding to traditional Bedouin meals and even overnight stays in traditional Bedouin tents - all these are immensely popular attractions with tourists in the region, and an opportunity to discover and connect with a longforgotten way of life.

  //                             </p>

  //                             <div class="img-wrapper img-page3">
  // 								<img src=${getImgUrl() +  "/Negev/8.jpg"} class="img-responsive" />
  // 								Credit: Daphna Tal
  // 							</div>

  // 							<h2>
  //                                 The Culinary Queens of Yeruham
  //                             </h2>

  //                             <p class="p-margin">
  //                               For a truly memorable local experience, make sure to visit the Culinary Queens of Yeruham – a unique project, in which the wonderful women of Yeroham host tourists from far and wide for an excellent traditional meal in their homes, creating an unforgettable experience of smells, colors and flavors.
  //                               Get to know the real life of locals through their fascinating stories, while tasting the ethnic delicacies and enjoying their amazing hospitality.

  //                             </p>
  //                             <h2>
  //                                 The Old City of Be'er Sheva
  //                             </h2>

  //                             <p class="p-margin">
  //                                Said to have been founded by biblical Abraham, Be'er Sheva is one of the oldest cities in the country, with evidence of a settlement dating back thousands of years. As charming as it is historic, the old city of Be'er Sheva offers a fascinating mosaic of urban spaces, and exploring the Old City will reveal a rare wealth of unique architecture, extensive history and stories as old as time.
  //                             </p>
  //                             <h2>
  //                                 Carasso Science Park
  //                             </h2>

  //                             <p>
  //                                New in the Old City of Be’er Sheva, the Carasso Science Park, spread over 4.25 acres, is the largest science park in Israel.
  //                                Engaging and entertaining for all ages, Carasso Science Park features an interactive museum and a scientific garden with games and hands-on activities. The park also offers ten interactive exhibitions in various fields of science including: Genetics, Communication, Microelectronics, Nuclear Energy and more.

  //                             </p>
  //                             <h2>
  //                                 Arad
  //                             </h2>

  //                             <p class="p-margin">
  //                                Arad of the new millennium is a town with young spirit and rich experience. Arad and its surroundings have been blessed with beautiful landscapes, desert tranquility, and many walking trails nestled amongst untouched desert nooks, suitable for any age or style.
  //                                With lots of attractions and plenty of tourism sites in and around the city, Arad is the perfect starting point and your natural gate to the perfect desert vacation.

  //                             </p>

  // 							<h2>
  //                                Yotvata Hai-Bar
  //                             </h2>

  //                             <p>
  //                                The Yotvata Hai-Bar Nature Reserve is the area’s largest animal breeding and reclamation center for animals before they are reintroduced into the wild. The reserve boasts wonderful attractions that are an absolute delight for animal lovers, including the predators’ center with its live predators and small desert animals, a Nocturnal animal’s observatory in dark room conditions and 12 square kilometers of ground where herds of herbivores roam free.

  //                             </p>

  //                             <div class="img-wrapper img-page3">
  // 								<img src=${getImgUrl() +  "/Negev/10.jpg"} class="img-responsive" />
  // 								Credit: Daphna Tal
  // 							</div>

  // 							<h2>
  //                                Extreme Adventures
  //                             </h2>

  //                             <p>
  //                                The south of Israel is a total dream destination for adventure-hungry travelers.  Its unique and challenging terrain make for an ideal setting for various extreme sports and activities including abseiling down steep ravens and canyons, dirt biking and off road cycling which are extremely popular in this area as are the 4x4 adventure drives which are all the rage for locals and tourists alike.

  //                             </p>

  //                             <div class="img-wrapper img-page3">
  // 								<img src=${getImgUrl() +  "/Negev/11.jpg"} class="img-responsive" />
  // 								Credit: Daphna Tal
  // 							</div>

  // 							<h2>
  // 							    Camel rides
  // 							</h2>
  // 							<p>
  // 								A definite throwback, this is still most authentic way to explore the marvelous desert surrounding. Riding on the back of a Camel is an activity found in a number of camel farms across the Negev and one guaranteed to last in your memory.
  // 							</p>

  // 							<div class="img-wrapper img-page3">
  // 								<img src=${getImgUrl() +  "/Negev/5.jpg"} class="img-responsive" />
  // 							</div>

  //                             <!--NEGEV - וPDATED TEXT SITES-->

  //                             <h2>
  //                                 EVENTS IN THE NEGEV: CALENDAR
  //                             </h2>

  // 							<div class="row-1 mounth-row">
  // 					             <div class="mounths active">
  // 					            <p id="myHeader1" data-div="newboxes1" onClick="toggleMounth(event)" href="">January <img src=${getImgUrl() +  "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
  // 					         </div>

  // 					         <div class="mounths month-mid">
  // 					            <p id="myHeader2" data-div="newboxes2" onClick="toggleMounth(event)" href="">February <img src=${getImgUrl() +  "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
  // 					         </div>

  // 					         <div class="mounths" >
  // 					            <p id="myHeader3" data-div="newboxes3" onClick="toggleMounth(event)" href="">May <img src=${getImgUrl() +  "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
  // 					         </div>

  // 					         <div class="mounths month-mid">
  // 					            <p id="myHeader1" data-div="newboxes4"onClick="toggleMounth(event)"  href="">June <img src=${getImgUrl() +  "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
  // 					         </div>

  // 					         <div class="mounths">
  // 					            <p id="myHeader2" data-div="newboxes5" onClick="toggleMounth(event)" href="">July <img src=${getImgUrl() +  "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
  // 					         </div>
  // 					        </div>

  // 					        <div class="row-2 mounth-row">
  // 					          <div class="mounths" >
  // 					            <p id="myHeader3" data-div="newboxes6" onClick="toggleMounth(event)" href="">August <img src=${getImgUrl() +  "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
  // 					         </div>

  // 					         <div class="mounths month-mid">
  // 					            <p id="myHeader1" data-div="newboxes7"onClick="toggleMounth(event)"  href="">October <img src=${getImgUrl() +  "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
  // 					         </div>

  // 					         <div class="mounths">
  // 					            <p id="myHeader2" data-div="newboxes8" onClick="toggleMounth(event)" href="">November <img src=${getImgUrl() +  "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
  // 					         </div>

  // 					         <div class="mounths month-mid" >
  // 					            <p id="myHeader3" data-div="newboxes9" onClick="toggleMounth(event)" href="">December <img src=${getImgUrl() +  "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
  // 					         </div>

  // 					        </div>

  // 					         <div class="newboxes" id="newboxes1" style="    display: block;"> <!--Jen-->
  // 					                Round The Arava Race - The 63-kilometer bike race named after Yoni Friedman offers a breathtaking desert landscape, endless expanses of nature, the power of spirituality, serenity and serenity and a connection to an extraordinary sporting experience. The starting point and end of the race are in Moshav Hatzeva.<br>
  // 					                <a href="https://www.arava-active.co.il/MenuDefault.aspx?id=4240" target="_blank">www.arava-active.co.il</a>
  // 					        </div>
  // 					        <div class="newboxes" id="newboxes2"><!--Feb-->
  // 					                Darom Adom is an annual festival held during the Anemone flower's blossoming season in the northern Negev region. The festival offers agricultural tours, farmers' markets, and countryside lodging, as well as sports activities such as marches, race, bike tours through the red fields of the northern Negev and other activities such as artistic performances. The local tourism association "Shikma Besor" is responsible for the festival and its yearly activities.<br>
  // 					                <a href="//daromadom.habsor.co.il/" target="_blank">www.daromadom.habsor.co.il</a>
  // 					        </div>
  // 					        <div class="newboxes" id="newboxes3"><!--May-->
  // 					                The cherry festival takes place in the Yatir Forest, which is the largest forest in Israel where large orchards of orchards grow, and is a 5-minute drive from Be'er Sheva. The event includes a cherry harvest for the whole family, sweet and sour snacks, baking pita bread, sheep herding, cheese gibbon, local farmers' market, klezmer melodies, climbing wall, omega and many other activities for the whole family.<br>
  // 					                <a href="//kinderland.co.il/events/%D7%A4%D7%A1%D7%98%D7%99%D7%91%D7%9C-%D7%93%D7%95%D7%91%D7%93%D7%91%D7%9F-%D7%91%D7%99%D7%A2%D7%A8-2017-%D7%A7%D7%98%D7%99%D7%A3-%D7%A2%D7%A6%D7%9E%D7%99-%D7%A9%D7%9C-%D7%93%D7%91%D7%93%D7%91%D7%A0/" target="_blank">www.kinderland.co.il</a>
  // 					        </div>

  // 					        <div class="newboxes" id="newboxes4"><!--June-->
  // 					                Experience the magic of Ramadan nights in Rahat - when the night becomes a day and the streets are bustling with life. Join an unforgettable tour at the most special time of the year, giving a unique glimpse into Bedouin culture in Rahat. Meet the authentic dishes, absorb the fragrances of spices and roasted coffee, discover the secrets of Rahat from local guides and enjoy street performances, Debka music and more.<br>
  // 					                <a href="//ramadan-nights.co.il/" target="_blank">www.ramadan-nights.co.il</a><br>
  // 					                The Cinema South Festival, initiated by the School of Sound and Screen Arts at Sapir Academic College, started in 2002 with an emphasis on student films. Within a few years, however, became the festival an international film festival that provides a central stage for Israeli cinema, international quality and radical cinema. The festival takes place every year in June for five full days in various locations throughout the northern and western Negev. This is a festival that opens its doors to anyone, free of charge. The South Cinema Festival is produced from a unique cultural agenda relevant to the place where it was created.<br>
  // 					                <a href="//csf.sapir.ac.il/csf2017/csf.sapir.ac.il/index.html" target="_blank">www.csf.sapir.ac.il</a>
  // 					        </div>
  // 					        <div class="newboxes" id="newboxes5"><!--July-->
  // 					               The International Fringe Festival Beer Sheva is a multi-disciplinary festival that crosses audiences and ages and constitutes a quality stage for the best Israeli and international artists from the fields of theater, dance, music, street art and the plastic arts. The festival is considered one of the major fringe events in Israel and the largest and leading cultural festivals in the south of the country. The festival was recently received by the EFFE (European Festivals Association) and is gaining a reputation as a prestigious event.<br>
  // 					               <a href="https://www.iffb7.com/" target="_blank">www.iffb7.com</a>
  // 					        </div>
  // 					        <div class="newboxes" id="newboxes6"> <!--Aug-->
  // 					               Negev Of Stars - Like every summer, the Earth passes through the shrapnel left behind by the comet SWIFT-TATTLE. These fragments penetrate our atmosphere and create a spectacular view of "shooting stars". During this time in the Negev celebratethe people the amazing experience of the Perseid Meters, a number of astronomical events - a joint observation of the meteor shower, observation points with elaborate telescopes, lectures and many other activities.
  // 					        </div>
  // 					        <div class="newboxes" id="newboxes7"><!--Oct-->
  // 					                The Tamar Festival is a combination of the ideal Israeli soundtrack and the spectacular vista of Masada and the Dead Sea region. The extraordinary experience takes place with concerts over 4 days at various locations and at different times over 24 hours, when the audience ventures out to the country's most extraordinary sites and landscapes.<br>
  // 					                <a href="//www.tamarfestival.com/" target="_blank">www.tamarfestival.com</a><br>
  // 					                Desert Magic Festival - The first Bedouin festival: A variety of experiential activities for the whole family that provide an authentic glimpse into the ancient Bedouin tradition.<br>
  // 					                <a href="//www.kesem-hamidbar.co.il/" target="_blank">www.kesem-hamidbar.co.il</a>
  // 					        </div>
  // 					        <div class="newboxes" id="newboxes8"><!--Nov-->
  // 					                The Arava Film Festival is a unique event that has been going on for several years every November in the heart of the Arush Nature Reserve, adjacent to Tzukim. The films at the festival are screened in the evening and in the night, under the stars in the open air. They are the first line of international production that has been screened at world film festivals in the last year. Among the films of the festival are films for children and teenagers, as well as short films produced and filmed during the past year in the Arava. The films are screened on a giant screen and the audience can relax on a spacious and surprisingly comfortable platform, which was built especially for this purpose in the valley between the mountain cliffs of the eastern Negev.<br>
  // 					                <a href="https://www.aravaff.co.il/" target="_blank">www.aravaff.co.il</a>
  // 					        </div>
  // 					        <div class="newboxes" id="newboxes9"><!--Dec-->
  // 					                Ben-Gurion's march has been taking place for more than 20 years, at the initiative of the Ramat Negev Regional Council, following the daily sporting march of the first Prime Minister, David Ben-Gurion, during his stay in Kibbutz Sde-Boker. The march takes place on three tracks – a short track for families (7 km), a medium pathway (15 km) and a long one (22 km).<br>
  // 					                <a href="//www.zaadatbg.org.il/" target="_blank">www.zaadatbg.org.il</a><br>
  // 					                 Docaviv Negev - Docaviv, the Tel Aviv International Documentary Film Festival, is the largest film festival in the city of Tel Aviv, and the only festival in Israel dedicated in its entirety to documentary films. In order to expose as wide an audience as possible to documentary work, the NPO also organizes a regional festivals: Docaviv Negev, held in Yeruham, as well as dozens of documentary film screenings at cultural centers located throughout the country. Each year, Docaviv NPO awards Israel’s largest prize for an original Israeli documentary production, and alongside it, prizes for the Best International Film Award, prizes for outstanding student filmmakers, and an additional prize within the Depth of Field framework, for innovative, inspiring documentary films from around the world.<br>
  // 					                <a href="//www.docaviv.co.il/" target="_blank">www.docaviv.co.il</a>
  // 					        </div>

  //                             <a href="//graphics-lapam.org.il/clients/tayarut/negev/files/assets/basic-html/page-1.html#" target="_blank">FOR MORE IMFORMATION CLICK HERE </a>

  //          `
  //     }
  //   }
  // },

  // {
  // 	ctg :"telavivAndJerusalem",
  // 	isVid:false,
  // 	id:41,
  //               bgImage: "/posts/bank/46/1.jpg",
  //               mobBgImage: "/posts/bank/46/M/1.jpg",
  //               title :"Tel Aviv and Jerusalem",
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `
  // 				<h2>Nonstop fun for the whole family</h2>

  //               		<p>
  // 			Travelling with kids to Tel Aviv and Jerusalem is a fantastic experience. Both cities, as is most of the country, are extremely family oriented, and from nature to culture, there is absolutely loads of amazing attractions and exciting activities for families to enjoy together. Wherever you turn, you’re likely to find children out and about with parents, grandparents or groups.
  // 		</p>
  //               		<p>
  // 			With up to 300 sunny days a year, the beautiful beaches of Tel Aviv are a favorite destination for locals and tourists alike. The beaches themselves offer a fabulous combination of sun and fun the Tel Aviv boardwalk to is a great place for kids to walk, run or ride along on a bike or a mini scooter, and there are plenty of playgrounds and cafes.
  //               		</p>
  //               		<p>
  // 			For a fun day outdoors, take a picnic basket to the lovely Yarkon Park and enjoy bike riding, boating or running around. Tel Aviv also offers a multitude of hands-on museums and exhibitions, free performances, especially in the gorgeous Tel Aviv port area and outdoor entertainment guaranteed to keep visitors of all ages entertained.
  //               		</p>
  //               		<p>
  // 			A visit to Jerusalem will ignite the imaginations of your little ones with its quaint alleyways, unique museums and fascinating history. with shady parks, water fountains and children-oriented exhibits and shows, there’s definitely something for every age.
  //               		</p>
  //               		<p>
  // 			An incredible variety of food will keep all the kids, and adults, of your group happy. From outdoor food stalls to sit-down restaurants there is no shortage of places to eat and most restaurants and cafés offer children’s’ meals at considerably reduced rates.
  //               		</p>
  //               		<p>
  // 			Your visit to Tel Aviv or Jerusalem with the young ones is guaranteed to be fun and rewarding.
  // 			Here are just a few of the fabulous ways you can have a great family time in Jerusalem and Tel Aviv, all you and yours need to do is choose and go go go:
  //               		</p>
  // 		<div class="img-wrapper">
  // 			<img src=${getImgUrl() +  "/thingsToDo/posts/35/1.jpg"} class="img-responsive" />
  // 		</div>
  //               		<h2>
  //               			Tel Aviv
  //               		</h2>
  //               		<p>
  // 			<strong>"Luna Park":</strong> A fantastic amusement park in the heart of the city offering a range of fun and exciting rides and attractions for the entire family. Right across from the beautiful Hayarkon Park, the green lung of Tel Aviv.
  //               		</p>
  //               		<p>
  // 			<strong>HaYarkon Park:</strong> The tranquil Yarkon Park on the outskirts of the busy city offers beautiful green expanses, boating on the river, cycling along the bike paths, sports fields, and much more for the whole family. Enjoy a picnic with a view of the stunning Tel Aviv Skyline.
  //               		</p>
  //               		<p>
  // 			<strong>Hot Air Balloon:</strong> After relaxing in gorgeous HaYarkon Park, get high with a view of gorgeous Tel Aviv like you’ve never seen it before, float above the Yarkon Park in an experience that is suitable for romantic trips or family fun.
  //               		</p>
  //               		<p>
  // 			<strong>The Observatory:</strong> While in Azrieli, be sure to check out the amazing top floor observatory located on the top floor for an 360 view of Tel Aviv the little ones will not soon forget.
  //               		</p>
  //               		<p>
  // 			<strong>The Planetarium:</strong> Offering a fun introduction to astronomy, you’ll be transported into space by interactive exhibits, revolving seats and informative presentations to suit the whole family.
  //               		</p>
  //               		<p>
  // 			<strong>Safari:</strong> With the largest collection of animals in the Middle East, you can spend a wonderful day in the wild, just 15 minutes from the heart of Tel Aviv, where you can check out the rest of the city’s stunning attractions.
  //               		</p>
  //               		<p>
  // 			<strong>HaTachana:</strong> Tel Aviv’s Old Railway Station: A delight for the whole family, the Old Train Station complex offers something for everyone with restaurants, kids activities, art galleries, street performances, and even a train carriage ride.
  //               		</p>
  //               		<p>
  // 			<strong>Tel Aviv Port:</strong> Breath in the sea air and vies from the gorgeous marina, get some food in any of the  and check out the awesome street performances of music, magic theatre and more geared specifically for the joy of the little ones.
  //               		</p>
  //               		<p>
  // 			<strong>Nachlat Binyamin Street Fair:</strong> The biggest of its kind in Israel, the fair is a bright and bustling experience of crafts, live music, street performances, and cafes that will appeal to people of all ages.
  //               		</p>
  //               		<p>
  // 			<strong>Sarona:</strong> A trendy hub of restaurants, cafes, and bars, the covered market is a popular destination for couples, groups and families looking for one of the most happening places in the city.
  //               		</p>
  //               		<h2>
  //               			Tel Aviv Museums
  //               		</h2>
  //               		<p>
  // 			<strong>Tel Aviv Museum of Art:</strong> With a large number of collections, guides, creative and interactive activities, and games, the museum is a treasure for parents and children alike.
  //               		</p>
  //               		<p>
  // 			<strong>The Museum of Natural History:</strong> Opened in 2018, the 5-floor museum with its 3,000 items, gives children the possibility to see the country’s creatures right up close.
  //               		</p>
  //               		<p>
  // 			<strong>The Olympic Experience Museum:</strong> Available via guided tours, offering an interactive glimpse into the history of sport in Israel through multimedia exhibits that are fun for the whole family.
  // 			Independence Hall- the birthplace of the State of Israel and the birthplace of the first Hebrew speaking city, Tel Aviv. A fascinating journey through history for the entire family.
  //               		</p>
  // 		<div class="img-wrapper">
  // 			<img src=${getImgUrl() +  "/thingsToDo/posts/35/2.jpg"} class="img-responsive" />
  // 		</div>
  //               		<h2>
  //               			Jerusalem
  //               		</h2>
  //               		<p>
  //               			<strong>City of David:</strong> An immersive archeological experience in the heart of Ancient Jerusalem including archeological digs, guided tours and a walk through an underground water tunnel.
  //               		</p>
  //               		<p>
  // 			<strong>Night Spectacular Sound & Light Show:</strong> A stunning first of its kind show where the walls of the Citadel become the stage for a nighttime show celebrating Jerusalem’s 4,000-year-old history through sights and sounds.
  //               		</p>
  //               		<p>
  // 			<strong>The Aquarium:</strong> One of the hottest attractions in Jerusalem, opened at the end of 2017, it offers a captivating adventure through the four seas of Israel that will thrill everyone, from young to old.
  //               		</p>
  //               		<p>
  // 			<strong>The Time Elevator:</strong> Immerse yourself in virtual reality on a journey through the fascinating history of Jerusalem, with shaking seats and special effects that will amaze the youngsters among you.
  //               		</p>
  //               		<p>
  // 			<strong>The Botanical Gardens:</strong> A stunning gem in the heart of the city featuring more than 6,000 species of plants from around the world, it is an interesting and tranquil location for anyone to enjoy.
  //               		</p>
  //               		<p>
  // 			<strong>Segway Tours:</strong> Suitable for older teens to adults, Segway tours offer an unforgettable experience through fascinating areas, allowing you to enjoy the modern to the ancient character of the city.
  //               		</p>
  //               		<p>
  // 			<strong>Mini Israel:</strong> Offering hundreds of mini replicas of Israeli landmarks, it offers a unique birds-eye view of historical, religious, and modern sites around the country.
  //               		</p>
  //               		<h2>
  //               			Jerusalem Museums
  //               		</h2>
  //               		<p>
  //               			<strong>Israel Museum:</strong> A leading art and archeological museum absorbing you in the rich history and culture of the country and its people, with exhibits to interest visitors of all ages.
  //               		</p>
  //               		<p>
  // 			<strong>The Tower of David Museum:</strong> The historic entrance to the Old City of Jerusalem, the medieval citadel features 3D models, hidden passageways, and family tours and activities.
  //               		</p>
  //               		<p>
  // 			<strong>Ein Yael Active Museum:</strong> Providing an experiential journey through an old Roman street, creative workshops, pita baking, and one-on-one meetings with period actors, families will love this day out.
  //               		</p>
  //               		<p>
  // 			<strong>The Bloomfield Science Museum:</strong> A fantastic children oriented cultural and educational museum, that presents exhibitions and interactive exhibits on subjects of science and Technology.
  //               		</p>

  //             	`   }
  //   }
  // },

  // {
  // 	ctg :"telaviv",
  // 	isVid:true,
  // 	vidId:"ogEN7aRT0SM",
  // 	id:"Party_Capital",
  //               bgImage: "/posts/bank/party-capital/1.jpg",
  //               mobBgImage: "/posts/bank/party-capital/M.jpg",
  //               title :"Party Capital",
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  // 						<div class="ac-cradit">
  // 							<span class="ac-cradit-text">Credits:</span>
  // 								<br/>
  // 								<span class="ac-cradit-text-1">Tel Aviv Jaffa municipality<br/></span<
  // 								<span class="ac-cradit-text-2">UDINI prodactions<br/></span>
  // 							</div>
  // 							<p></p>
  // 						</div>

  //                             <h2>Epic Nights in the non stop city</h2>
  //               		        <p>Tel Aviv is rightly famous as one of the world’s great nightlife cities, with her warm Mediterranean climate making it ideal to party outdoors for most of the year. As the sun goes down the city transforms into a welcoming nighttime experience that’s pulsing with life.</p>

  //                             <h2>Tel Aviv by Night</h2>
  //                             <p>No matter what time it is, there’s always something going on in Tel Aviv. Watch the sun go down at a casual beach bar, feet in the warm sand and a cold drink in your hand, before moving on to taste craft brews in a packed, friendly pub, enjoy an exotic cocktail in a relaxed bar or eat something delicious before heading off to one of Tel Aviv’s pumping, pulsing clubs to dance the night away.</p>

  //                             <p>Foodies will love the amazing cocktails mixed by Tel Aviv’s expert baristas, Israel’s lively pub scene serving craft beers and snacks, and the restaurants that range from elegant to casual to street pop-ups, offering every possible style and type of food. Eat your heart out!</p>
  //                             <div class="img-wrapper">
  // 			                    <img src=${getImgUrl() +  "/posts/party-capital/1.jpg"} class="img-responsive" />
  // 		                    </div>
  //                             <h2>Making the Most of Tel Aviv’s Nightlife</h2>
  //                             <p>Spend a relaxed evening in an upmarket wine bar in a trendy neighborhood like Neve Tzedek, where you’ll be introduced to some of Israel’s highly acclaimed wines. Move on to chill at one of the many bars that feature live bands, or enjoy some culture with your cocktails in one of Tel Aviv’s new and exciting gallery bars that display pieces by up and coming artists.</p>

  //                             <p>If you want a pumping party night on the town, Tel Aviv is the right place to find it. Tel Aviv’s nightclubs are world-famous, often hosting international DJs. During the long summer season some of the beaches transform into nightclubs for all-night raves, with throbbing beats, lasers and pulsing music. The party doesn’t reach full swing until 2am in most of Tel Aviv’s wildly popular nightclubs, manned by top DJs. You’ll find every time of club, from intimate to massive and from throwback dance to the newest electric indie beats.</p>

  //                             <p>The LGBTQ scene is also hot in Tel Aviv, with some of the best parties and music nights hosted by gay-friendly clubs and bars. Whether you want chilled or full-on, cultural or flirty, you’ll find countless places to hang out at every hour of the day and night.</p>
  //                             <p>Tel Aviv’s awesome nightlife scene has become famous worldwide. The city the doesn’t stop is teaming up with endless possibilities designed for an epic night out! </p>
  //                             <p>Start slow and easy in a bar at the chilled out Port of Tel Aviv, or grab yourself a shoreline table, perhaps at Jerusalem Beach. Order a beer, feel the sand between your toes, and watch the sunset.</p>
  //                             <p>Now that you’re in a mellow mood, it’s time to get your groove on. you’ll be spoiled for choice with upscale clubs, bracelet bars, and other hangouts around Tel Aviv’s White City, Rothschild Boulevard and nearby streets (Levontin, Yehuda HaLevi, Lillenblum, and Allenby), with their trendy see and be seen vibe, filled with young party people all night long. </p>
  //                             <div class="img-wrapper">
  // 			                    <img src=${getImgUrl() +  "/posts/party-capital/2.jpg"} class="img-responsive" />
  // 		                    </div>
  //                             <p>A five-minute cab ride southwest and you can visit the more mellow upscale bars in Neve Tzedek. Alternatively, a ten-minute ride south takes you to the underground scene in the newly-trendy hipster heaven of the Florentin neighborhood, and of course don’t miss the up and coming hipster style Flea Market area in Jaffa.</p>
  //                             <p>Want a more mainstream approach to a night on the town? Three streets – King George, Dizengoff, and Ibn Gabirol – will be just right for you, allowing you a chance to interact with the locals and be part of the authentic nightlife scene of the city.</p>
  //                             <p>Wherever you go, you will always find where to have an awesome night in nonstop Tel Aviv! </p>

  //             	`   }
  //   }
  // },

  {
    ctg: "jerusalem",
    isVid: false,
    id: "Mamilla_Avenue",
    bgImage: "/posts/bank/mamila-avenue/1.jpg",
    mobBgImage: "/posts/bank/mamila-avenue/M.jpg",
    title: "БУЛЬВАР МАМИЛА ИСТОРИЯ И ИСКУССТВО",
    smltitle: "",
    isVid: true,
    vidId: "nX9LnWAjOIY",
    html: function() {
      return {
        __html: `
                               
                                <br/>
		                         <h2 class="ac-margin-bottom-20 ac-margin-top-20">Роскошь современных магазинов и величие древнего Иерусалима</h2>
								<p>На стыке древнего и нового Иерусалима, напротив потрясающих стен Старого города и в двух шагах от Яффских ворот расположен бульвар Альров Мамила. Этот современный торговый центр под открытым небом завоевал популярность среди местных жителей и туристов благодаря своей близости к Старому городу и гармоничному сочетанию древности и современности — богатой истории, самобытной культуры и изысканных магазинов.</p>
								<div class="img-wrapper">
			                         <img src=${getImgUrl() +
                                 "/posts/mamila-avenue/1.jpg"} class="img-responsive" />
		                         </div>
								<p><strong>Современный комплекс развлечений у подножия Старого города</strong></p>
								<p>Прогуляйтесь по иерусалимским улицам и прочтите надписи на табличках, рассказывающие об истории построек района. Посмотрите уличные театральные представления, посидите в одном из местных ресторанов или кафе (а может, и не в одном) и загляните в дизайнерские магазины как местных, так и международных брендов.&nbsp;</p>
								<p>Вечером устройтесь поудобнее в одном из прекрасных баров района, поднимите голову и полюбуйтесь прекрасным видом Старого города.&nbsp; Другого такого места нет в мире.</p>
								<p><strong>Посетите улицы на границе между старым и новым Иерусалимом</strong></p>
								<p>Бульвар Мамила — современный центр отдыха и развлечений, предлагающий посетителям познакомиться с богатой, оригинальной и постоянно меняющейся культурой Иерусалима.</p>
								<p>Лучшее время для посещения бульвара Мамила — теплые дни. Тысячи людей прогуливаются здесь летними вечерами, получая удовольствие от множества самых разных культурных мероприятий. Присоединитесь к ним, чтобы увидеть ярмарки уличного искусства, выставки под открытым небом и представления уличного театра, оцените мастерство клоунов, акробатов и барабанщиков и ежедневные музыкальные представления. Здесь так много интересного, что вам не захочется уходить.</p>

							    
            	`,
      };
    },
  },

  // {
  // 	ctg :"jerusalem",
  // 	isVid:true,
  // 	vidId:"nLKWDp5uA-U",
  // 	id:"First_Time_In_Jerusalem",
  //               bgImage: "/posts/bank/first-time-in-jerusalem/1.jpg",
  //               mobBgImage: "/posts/bank/first-time-in-jerusalem/M.jpg",
  //               title :"FIRST TIME IN JERUSALEM",
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  // 				<h2>The must list for the first-time visitor</h2>

  //               		<p>
  // 						Scour the globe it’s hard to match Jerusalem for history, culture, and significance! So rich in sites and activities, it’s difficult to know where to begin. Here are a few suggestions…
  //               		</p>
  // 					<p>
  // 						Jerusalem is the nexus of three of the world’s great faiths. As such, you might want to consider religious, spiritual, or historical locations that will be meaningful to you.
  // 					</p>
  // 					<p>
  // 						Almost any itinerary will include Old City. Famous as the home of the Western Wall, and the Church of the Holy Sepulcher, you could spend days exploring its four quarters – Jewish, Christian, Muslim, and Armenian – and only see but a small part of its many treasures. Make sure to download the free Audio Tours of Jerusalem app, which offers dozens of walking routes, GPS maps, and geo-location alerts as you approach each site.
  // 					</p>
  // 					<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/posts/first-time-in-jerusalem/1.jpg"} class="img-responsive" />
  // 					</div>
  // 					<p>
  // 						A five-minute cab ride southwest and you can visit the more mellow upscale bars in Neve Tzedek. Alternatively, a ten-minute ride south takes you to the underground scene in the newly-trendy hipster heaven of the Florentin neighborhood, and of course don’t miss the up and coming hipster style Flea Market area in Jaffa.
  // 					</p>
  // 					<p>
  // 						Want a more mainstream approach to a night on the town? Three streets – King George, Dizengoff, and Ibn Gabirol – will be just right for you, allowing you a chance to interact with the locals and be part of the authentic nightlife scene of the city.
  // 					</p>
  // 					<p>
  // 						Wherever you go, you will always find where to have an awesome night in nonstop Tel Aviv!
  // 					</p>
  //             	`   }
  //             }
  // },

  // {
  // 	ctg :"telavivAndJerusalem",
  // 	isVid:false,
  // 	id:44,
  //               bgImage: "/posts/bank/travelling-on-budget/1.jpg",
  //               mobBgImage: "/posts/bank/travelling-on-budget/M.jpg",
  //               title :"TRAVELLING ON A BUDGET",
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  // 				    <h2>Making It Count in Tel Aviv and Jerusalem!</h2>

  //               		<p>
  // 						So you’ve heard of the stunning beaches, the amazing sights and the fabulous cuisine and you are looking to travel to Jerusalem and Tel Aviv, but affordability is a concern. Well, pack your bags and worry no more! Both cities offer low-cost accommodations, transportation, and meals, as well as countless sites to see and things to do, which require little or no expense.
  //               		</p>
  // 					<p>
  // 						For affordable accommodation you can choose from the many hostels and smaller hotels, many of which are located only a few minutes’ walk from Tel Aviv’s Beaches and Jerusalem’s main attractions.
  // 					</p>
  // 					<p>
  // 						Getting around? In both cities it’s a snap with a Rav Kav card. Purchase one for little more than a dollar at”Al Hakav” (on the line) Service centers at central stations and other locations around the city. Jerusalem also offers an affordable City Pass option, and in Tel Aviv, the Tel Ofan bicycle rental municipal service is a great and low cost way to get around in the city.
  // 					</p>
  // 					<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/80/1.jpg"} class="img-responsive" />
  // 					</div>
  // 					<p>
  // 						What to do? Jerusalem and Tel Aviv are packed with sites, marketplaces, parks, nearby nature reserves and hiking trails. There are endless ways to not spend a dime and fill your trip with unforgettable experiences.
  // 					</p>
  // 					<p>
  // 						Finally, everyone’s gotta eat, from hummus to gourmet, both cities are famous for great street food and low-price restaurants offering cheap lunch time dining.
  // 					</p>
  // 					<p>
  // 						So come visit Tel Aviv and Jerusalem where you are guaranteed a fantastic time without breaking the bank.
  // 					</p>
  //             	`
  //             }
  //   }
  // },

  // {
  // 	ctg :"jerusalem",
  // 	isVid:false,
  // 	id:45,
  //               bgImage: "/posts/bank/upscale-jerusalem/1.jpg",
  //               mobBgImage: "/posts/bank/upscale-jerusalem/M.jpg",
  //               title :"UPSCALE JERUSALEM",
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `
  //                     <h2>Modern luxuries for the pampered traveler</h2>
  //               		<p>
  // 						When it comes to luxury travel, high class accommodations, fine dining, and top-drawer shopping options Jerusalem is a city that’s truly arrived.
  //               		</p>
  // 					<p>
  // 						The city features numerous 5-star and boutique hotels ready to custom cater to your needs for comfort and relaxation, offering amazing rooftop views and inhouse spa treatments to boot.
  // 					</p>
  // 					<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/81/1.jpg"} class="img-responsive" />
  // 					</div>
  // 					<p>
  // 						Looking to delight your palette? Well, in 2018, several Jerusalem establishments were listed in the prestige French restaurant guide, Gault & Millau. Beyond that, the city features and is increasingly attracting some of the world’s best chefs.
  // 					</p>
  // 					<p>
  // 						When it comes to style, fashion, and swanky shopping, Jerusalem has any number of places you’ll want to visit. Among these are Arlov Mamilla Avenue. This happening and trendy outdoor mall complex is a must for your go-to city destinations. Even better, it’s situated just steps away from the Old City’s Jaffa Gate.
  // 					</p>
  // 					<p>
  // 						Another not-to-be-missed stop on your itinerary is the elegant The First Station. For over 100 years a railway depot, the site has been transformed into an urban shopping and culinary mecca that’s chock-a-block with restaurants, shops, art galleries and an artists’ marketplace three days a week, as well as live performances and more.
  // 					</p>
  // 					<p>
  // 						And as long as you’re in the neighborhood, treat yourself to a romantic afternoon or evening on Emek Refaim Street, the German Colony’s main thoroughfare. Its beguiling architecture laid back mood, stylish boutiques, intimate restaurants, and 1920s-era cinema offer an absolute treat for all the senses.
  // 					</p>
  //             	`   }
  //   }
  // },

  // End Posts

  // 	{

  // 	id:5,

  // 	ctg:'deadsea',
  // 	isVid:false,
  // 	bgImage:  "posts/bank/100/1.jpg",
  // 	mobBgImage: "posts/bank/100/M.jpg",
  // 	title: "Dead Sea Joys",
  // 	smlTitle: "",
  //  	html: function(){
  // 			return {
  // 					__html: `
  // 					<h2>For a floating good time</h2>

  // 			              <p>
  // 			                              A geological wonder in a uniquely serene setting, the Dead Sea is an extremely popular tourist attraction.
  // 			                              Experience the calm tranquility of the water with its distinct healing properties while enjoying the unparalleled beauty of the surrounding landscape.
  // 			                              <strong>The Dead Sea, also known as the oldest natural spa in the world, is blessed with an extremely high salt concentration of 31.5%,
  // 			                              allowing tourists from far and wide the amazing experience of effortlessly floating on the waters of the lowest place on Earth.
  // 			                              While here, you can bathe</strong> in the healthy black mud of the area or explore the fascinating and historically rich nearby landscapes.
  // 			              </p>

  // 			              <p>
  // 			                              Luxury hotels, varied cuisine from gourmet restaurants to fast food eateries, great souvenir shops, the extraordinary history of the nearby Masada, and many cultural activities throughout the year, make the Dead Sea a popular destination for local tourists as well as International visitors.
  // 			              </p>

  // 			`
  // 			}
  // 	}
  // },

  // {
  // 	id:"Ultimate_Beach_Fun",
  //                bgImage : "/posts/bank/17/1.jpg",
  //         	mobBgImage : "/posts/bank/17/M.jpg",
  //               title : "ULTIMATE BEACH FUN",
  //               ctg:"telaviv",
  //               isVid:true,
  //               vidId:"I9a4BFWO_6w",
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  //             		<p>Israel has a wide selection of beaches to choose from. The wide Mediterranean stretch along the west side of the country boasts wide golden sands and the gorgeous blue waves of the med.</p>

  //         		 	<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/24/1.jpg"} class="img-responsive" />

  // 					</div>

  //             		<p>Up North the Sea of Galilee have some lovely beaches where you can camp out, barbeque and really make a day of it. The Galilee offer boat hire and water sport equipment for some water fun!</p>

  //             		<div class="videoWrapper">
  // 						            <iframe width="100%" height="400px" src="https://www.youtube.com/embed/8p4qfkneH1c?autoplay=1&amp;controls=0&amp;loop=1&amp;rel=0&amp;playlist=8p4qfkneH1c&amp;modestbranding=1&amp;autohide=1&amp;showinfo=0" frameborder="0" allowfullscreen=""></iframe>
  // 						        </div>

  //                                 <p>The Dead Sea’s desert beaches possess a unique atmosphere in the clear air and of course a sea which is not for swimming but for floating and taking care of your skin.</p>

  //                                 <p>Last but not least the beaches in Eilat boast crystal clear blue waters of the Red Sea that are very seldom wavey. Eilat is known for its beautiful diving spots and swimming with dolphins. They have wonderful beach bars, restaurants, water sports and attractions a perfect destination for holiday makers.</p>

  //             	 `
  //     }
  //   }
  // },

  {
    id: "Purchases_In_Israel",
    bgImage: "/posts/bank/purches-in-israel/1.jpg",
    mobBgImage: "/posts/bank/purches-in-israel/M.jpg",
    title: "УНИКАЛЬНЫЕ ПОКУПКИ В ИЗРАИЛЕ",
    ctg: "jerusalem",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `
              
              
                
            		            
                               

                                <p>Покупки в Израиле — это нечто большее, чем просто приобретение товаров. Это прекрасный способ сделать приятное своим друзьям и близким, поскольку вы привезете им (и себе) не просто сумку, бутылку или коробку, но символ знакомства с пережитыми эмоциями. Гуляя по рынкам, магазинам и галереям, вы увидите невероятно широкий выбор товаров, а значит — обязательно найдете подарок для каждого и получите удовольствие от покупки.</p>
								<p><strong>Прекрасные ближневосточные сувениры</strong></p>
								
								<p>Самые интересные и значимые напоминания о поездке в Израиль ждут вас в святых местах Галилеи и Иерусалима. Очень популярна яркая сине-белая армянская керамика, украшенная знакомыми мотивами святых мест, ее можно использовать как и сувенир, и посуду. Библии, шкатулки, броши и многие другие изделия украшены резной оливковой древесиной и перламутровыми инкрустациями. Благодаря красоте этих древних ремесел вы надолго сохраните в своем сердце память о поездке.</p>
								
								<div class="img-wrapper">
						               <img src=${getImgUrl() +
                             "/posts/purches-in-israel/1.jpg"} class="img-responsive" />
						
					            </div><p><strong>Уникальная иудаика</strong></p>
								<p>Великолепный способ вспомнить о своем посещении Цфата, Иерусалима, Яффо или других центрах иудаики — это украсить субботний или праздничный стол покрывалом для халы или мацы ручной работы (невероятно легким и компактно упакованным!), подсвечниками, бокалом для кидуша (еврейского обряда освящения, производимый над бокалом вина). или ханукальным светильником — менорой из современного или традиционного серебра, олова, стекла или керамики. Свитки мезузы станут чудесным подарком на новоселье, а покрывало талит – напоминанием о ритуале бар-мицвы или бат-мицвы.</p>
								<p><strong>Минералы Мертвого моря</strong></p>
								<p>В Израиле находится крупнейший в мире спа-курорт под открытым небом — Мертвое море. После купания в его насыщенной минералами воде ваша кожа и волосы станут гладкими и шелковистыми. А главное — эти драгоценные минералы можно увезти с собой! Вы можете приобрести широкий выбор красиво упакованных минеральных продуктов Мертвого моря в качестве отличного подарка из Израиля.</p>
								<p><strong>Одежда и обувь</strong></p>
								<p>Во время пребывания в Израиле вам, конечно же, захочется исследовать фабричные магазины или бутики дизайнеров с мировым именем. Отличную одежду для самых маленьких полностью из натурального хлопка легко упаковать в ваш даже уже набитый чемодан. Она станет чудесным подарком новорожденному. Ваши ноги устали от прогулок по Израилю? Пока не закончилось путешествие, приобретите пару удобнейших израильских сандалий или ботинок по цене, которую вы не встретите дома!</p>
								<p><strong>Ювелирные изделия</strong></p>
								<p>Израильские ювелирные изделия продаются в лучших магазинах мира. А когда вы покупаете их в Израиле — вы приобщаетесь к истокам их создания. Особенно заманчиво выглядят модные браслеты с разнообразными орнаментами из цветных кристаллов и бусинок и изделия из сине-зеленого малахита (эйлатского камня). Увидев их, все сразу поймут, что вы побывали в Израиле.</p>
								<p>Израиль славится своими бриллиантами, а опыт, знания и мастерство израильских огранщиков известны во всем мире. Израиль экспортирует бриллианты, поэтому здесь вы нередко сможете приобрести их по более низкой цене. Также вы можете заказать экскурсию по фабрике обработки алмазов и узнать все об этой драгоценной во всех смыслах промышленности.</p>
								<p><strong>Не забудьте о еде</strong></p>
								<p>В стране, славящейся блюдами со всех уголков мира, предлагается много упакованных продуктов, которые можно взять с собой. Это могут быть особые специи вроде библейского иссопа для любимого шефа, сладкие финики в красивой коробке, которыми можно угостить коллег или друзей, разнообразные фруктовые чаи, мед, отличные вина и много чего другого.</p>
								<p>А в аэропорту вам, безусловно, будет приятно получить возврат НДС за покупки на сумму свыше 100 долларов в магазинах, предоставляющих такие скидки.</p>
								            
            	 `,
      };
    },
  },

  // {
  // 	id:"Jerusalem_Fun",
  //                bgImage : "/posts/bank/jerusalem-fun/1.jpg",
  //         	mobBgImage : "/posts/bank/jerusalem-fun/M.jpg",
  //               title : "JERUSALEM FUN",
  //               ctg:"jerusalem",
  //               isVid:true,
  //               vidId: "nLKWDp5uA-U",
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  //                                <p>Planning a trip to Jerusalem usually involves its many sights of culture and historical significance. However, just as important to many, Jerusalem’s has an amazingly cool after dark scene, filled with music, hipster hangouts, dance clubs, and much more.</p>
  //                                 <div class="img-wrapper">
  // 						               <img src=${getImgUrl() +  "/posts/jerusalem-fun/1.jpg"} class="img-responsive" />

  // 					               </div>
  //                                  <p>To check it out, make your way to the <b>City Center</b> and explore the narrow streets just off <b>Jaffa Street</b>. There you’ll find bars and nightclubs that range from comfortably mainstream to eccentrically funky. <b>Rivlin Street</b> is a popular hangout for young people, while <b>Shoshan Street</b> and the surrounding area offers a more laid-back grown up vibe.</p>

  //                                  <p>Machane Yehuda market offers a surprisingly awesome night out as in the evening it transforms into a trendy hotspot where vendor stalls and shops become the setting for bars, DJs, live music, and dancing.</p>
  //                                  <p>Betzalel Street is famous for its student artsy vibe and the many little bars are a great place to befriend the locals who come for a drink and a jam session.</p>

  //                                  <p>For a daytime change of pace head to the <b>German Colony (Moshava)</b> and, particularly, the neighborhood of <b>Baka</b>. Start at <b>Beit Lechem Street</b> where you’ll have your choice of popular, contemporary restaurants and bars. Then stroll all the way up <b>Emek Refaim Street</b> or through <b>HaMesila (Railway) Park</b> until you reach The <b>First Station</b> – once a railroad depot in use for over a century, it transformed now into a trendy culinary, cultural, and retail delight.</p>

  //             	 `
  //     }
  //   }
  // },

  // {
  // 	id:"Western_Wall_Wonders",
  //               bgImage : "/posts/bank/30/1.jpg",
  //               mobBgImage : "/posts/bank/30/M.jpg",
  //               title : "WESTERN WALL WONDERS",
  //               ctg :"jerusalem",
  //               isVid:false,
  //               player_id_post :"",
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  // 				<p>
  // 					The Western Wall (or Kotel, in Hebrew) was part of the most magnificent building Jerusalem had ever seen, which was the Second Temple, built by the great King Herod.
  // 				</p>

  // 				<p>
  // 					The Second Temple was destroyed in the year 70 CE and despite the destruction that took place, all four of the Temple Mount support walls remained standing.  Throughout the generations since the Temple’s destruction, the Western Wall was the remnant closest to the site of the Temple’s ‘holies of holies - a place where only the Jewish High Priests were allowed, as it was there they believed God was present.  The actual remains of the Temple can be found the Western Wall Tunnels, which are an extraordinary journey through time.
  // 				</p>

  //              	<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/27/1.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					For centuries Jewish People from around the world have been going there to mourn the loss of this grand temple. You will often find hundreds of people of different nationalities and religions’ pouring out their heart with prayers as the wall is believed to have enormous spiritual significance.
  // 				</p>

  // 				<p>
  // 					It is tradition for the people that visit to write a note and place it in the cracks of the Western Wall, as it is believed the message will be taken to God. You will often find doves resting in the crevices of this impressive structure, which are a symbol of peace.
  // 				</p>

  // 				<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/27/2.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					The Western Wall is a national symbol as the ancient bricks have seen Israel and the Jewish peoples  birth, exile and redemption. It’s a very popular location for national ceremonies and even Bar Mitzvah to take place
  // 				</p>
  // 				<p>
  // 					For more information   <a  target="_blank" href="//www.thekotel.org">www.thekotel.org</a>
  // 				</p>

  //             	 `
  //     }
  //   }
  // },

  // {
  // 	id:28,
  //              bgImage : "/posts/bank/white-city-splendor/1.jpg",
  //               mobBgImage : "/posts/bank/white-city-splendor/M.jpg",
  //               title : "WHITE CITY SPLENDOR",
  //               ctg:"telaviv",
  //               isVid:false,
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  // 				<p>
  // 					Tel Aviv’s “WHITE CITY” is a UNESCO World Heritage Site, because the city is home to more Bauhaus, modern and “International” architecture than any city on earth.
  // 				</p>

  //              	<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/28/1.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					Tel Aviv was founded in 1909 as a garden suburb of the crowded port city of Jaffa. Very quickly it grew into a bustling metropolis so that by 1929, it was a flourishing city that was the apex of the Zionist dream. With the rise to power of Hitler in 1933, dozens of German Jewish architects escaped to Palestine – many of whom were students or graduates of the legendary Bauhaus school of design. The burgeoning of Tel Aviv required more and more buildings, and the arriving architects very quickly adapted their northern European Bauhaus design to the needs of the eastern Mediterranean heat. A walk through central Tel Aviv will bring you face to face with dozens of these extraordinary office buildings, apartment buildings and stores.
  // 				</p>

  // 				<p>
  // 					<a  target="_blank" href="//www.bauhaus-center.com/">www.bauhaus-center.com/</a>
  // 				</p>

  //             	 `
  //     }
  //   }
  // },

  // {
  // 	id:"Tower_Of_David_Museum",
  //               bgImage : "/posts/bank/30/1.jpg",
  //               mobBgImage : "/posts/bank/30/M.jpg",
  //               title : "TOWER OF DAVID MUSEUM",
  //               ctg:"jerusalem",
  //               isVid:false,
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  // 				<p>
  // 					Jerusalem’s Citadel, known as the “Tower of David”, is a historical and archaeological asset of international significance. The Tower is a medieval fortress that is located near the Jaffa Gate, the historical entrance to the Old City and has been the symbol for the city of Jerusalem for generations.
  // 				</p>

  //              	<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/29/1.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					At the Tower of David Museum you are presented with Jerusalem’s astounding story. While absorbing yourself in legends of the past and their dramatic chronicles it will not take you long to realise that the very stones of the museum are part of this city’s living history.
  // 				</p>

  // 				<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/29/2.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					The 500-year-old walls are part of the Turkish citadel; its name derives from a tower so massive that early Jerusalemites ascribed it to their great King David and despite the name being ‘The Tower of David’ it was actually build by King Herod.
  // 				</p>

  // 				<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/29/3.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					Your visit can begin with a breath-taking view of old and new Jerusalem from the top of the tower. Each ancient room has been revamped to showcase a different period, allowing the tempestuous events of 4,000 years to fall perfectly into place in your mind.
  // 				</p>

  // 				<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/29/4.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					The windows frame glimpses of modern Jerusalem, and with each doorway you exit, you look down into the citadel’s central courtyard, where archaeologists have unearthed remains dating from the Maccabees to the Middle Ages. This incredible site really is a maze of time!
  // 				</p>

  // 				<p>
  // 					The museum also utilizes its unique space for multi-sensory exhibits by leading designers and artists from Israel and abroad. This One of a kind museum hosts the annual ‘Night Spectacular’ which is a unique sound and light show where the whole of the Citadel is lit up with stunning designs!
  // 				</p>

  // 				<p>
  // 					For more information:   <a href="//www.tod.org.il/en/">www.tod.org.il/en/</a>

  // 				</p>

  //             	 `
  //     }
  //   }
  // },

  // {
  // 	id:"Must_Eat_In_Jerusalem",
  //               bgImage : "/posts/bank/must-in-jerusalem/1.jpg",
  //               mobBgImage : "/posts/bank/must-in-jerusalem/M.jpg",
  //               title : "MESMERIZING AND MAGICAL CITY",
  //               ctg:"jerusalem",
  //               isVid:true,
  //               vidId: "2CSCe2WC7Ns",
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  //                                 <p>
  // 						            Jerusalem is a mesmerizing and magical city. Many people who visit Jerusalem rave about the amazing atmosphere, the unforgettable sites, the breathtaking views and more. However, to truly understand what Jerusalem is all about, there are some things that you simply have to experience through your stomach. Here are just a few of the things you really should try while visiting Jerusalem:
  // 						        </p>
  //                                <div class="img-wrapper">
  // 						                 <img src=${getImgUrl() +  "/posts/must-in-jerusalem/1.jpg"} class="img-responsive" />
  // 				                 </div>

  // 							    <p><strong>Malabi:</strong> A unique a combination of beverage and dessert, made of a mixture of rosewater, milk, cornstarch and sugar. Malabi is a very popular Jerusalem dish, sold in many middle eastern restaurants and kiosks throughout the city. Guaranteed to be nothing like anything you have ever tasted.</p>

  //                                 <p><strong>Knafe:</strong> A very interesting and sensationally tasty dish when served and eaten fresh. Knafe is essentially an Arabic desert made of melted goats cheese and topped with hairs of orange pastry hairs, dipped in sweet rosewater syrup. Finding the perfect Knafe is a mission, once you find it, eating it becomes an addiction.</p>

  //                                 <p><strong>Jerusalem Pretzel:</strong> An absolute must when touring the fascinating sites of the old city is stopping by one of the small green carts and purchasing an authentic Jerusalem pretzel. Along with it, you will get a fragrant local green herb called Zaatar which goes great with the delicious warm doe.</p>

  //                                 <p><strong>“Meorav Yerushalmi”:</strong> Directly translates to “Mixed Jerusalem” this delicious mix of different meats in a special local blend of spices is an absolute carnivores’ heaven.</p>

  //                                 <p><strong>“Ashtanur”:</strong> Short in Hebrew for “fire in the oven” Ashtanur is an authentic local pitta bread which you can find in midtown or the markets during lunchtime. If you’re especially hungry, try it wrapped around a portion of shawarma or falafel.</p>

  //                                 <p><strong>Sabich:</strong> an absolute original, the Sabich is a truly unique local dish comprised of a Pitta bread packed with fried eggplant, hard-boiled eggs, and pickles, usually topped by Amba, a local, flavorful condiment. Once you try it, you’ll be hooked for life.</p>

  //             	 `
  //     }
  //   }
  // },

  {
    id: "Jerusalem_Arts",
    bgImage: "/posts/bank/jerusalem-art/1.jpg",
    mobBgImage: "/posts/bank/jerusalem-art/M.jpg",
    title: "ИЕРУСАЛИМ-ЦЕНТР ИСКУССТВА",
    ctg: "jerusalem",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `
            
                                
                                 
            	                <p>«Вечный Город» - столица Святой Земли. Центр искусства и культуры земли Израиля</p>
								<p>Несомненно, Иерусалим - один из самых интересных городов мира. На протяжение веков гостей города интриговало слияние разнообразных религий, традиций, древней истории и современной городской жизни. Не зря сюда устремляются художники в поисках вдохновения.&nbsp; Современный Иерусалим - это множество музеев, галерей, художественных магазинов и рынков, здесь проводятся фестивали культуры, все вместе это делает город уникальной культурной площадкой.&nbsp; Ощутите волшебство этого города&nbsp;</p>
								<p><strong>Открывайте новое.</strong> На холме рядом с <em>Кнессетом </em>и <em>Верховным судом Израиля</em> расположено крупнейшее культурное учреждение страны и один из ведущих музеев мира в области искусства и археологии - <strong>Музей Израиля</strong>. &nbsp;Начните с археологического крыла этого музея.&nbsp; Экспонаты музея организованы в хронологическом порядке, образуя самую обширную археологическую коллекцию в мире, посвященную библейским местам и памятникам Святой Земли.&nbsp; В соседнем крыле комплекса размещена экспозиция предметов еврейского искусства и быта, впечатляющая коллекция шедевров изящных искусств и периодически сменяемые выставки современного искусства.&nbsp; Обязательно посмотрите основные достопримечательности музея: Храм Книги, где хранятся свитки Мертвого моря, и потрясающий Художественный сад, откуда открывается вид на Иерусалимские горы.&nbsp; Совет: правильно спланируйте свое время: Это доступный, увлекательный музей и в нем есть что посмотреть.</p>
						        <div class="img-wrapper">
						            <img src=${getImgUrl() +
                          "/posts/jerusalem-art/1.jpg"} class="img-responsive" />
				                </div>
							    <small style="color:#000; display:block;">
                      		        Credit: Noam Chen
                      	        </small>
								<p>В непосредственной близости от Музея Израиля ваше внимание обязательно привлечет к себе <strong>Музей библейских стран.&nbsp; </strong>Это единственный такой музей в мире, его еще называют «интерактивной машиной времени». Прогуляйтесь по его галереям, откройте для себя чудеса древних культур на Ближнем Востоке, от начала цивилизации до времен раннего христианства, узнайте о взаимном влиянии и взаимосвязи различных культур.</p>
								<p><strong>Не уставайте удивляться. </strong>Направьте свои стопы в <strong>Колонию художников Иерусалима</strong> (Hutzot Hayotzer), там вы узнаете, что такое творческое мышление. Этот комплекс «ремёсел и искусства» является рабочим местом для художников и дизайнеров из самых разных областей искусства. Прогуляйтесь по этому живописному бульвару, среди магазинов и галерей под северными стенами Старого города, и понаблюдайте, как работают художники, создающие свои произведения прямо на глазах прохожих. Вы услышите немало интересных историй, узнаете о традиционных и более современных искусствах и сможете приобрести понравившиеся шедевры у их авторов.&nbsp;</p>
								<p>Посетите <strong>световое представление «Башня Давида»</strong>, известное также под названием «Зрелищная ночь в Иерусалиме». Это поистине потрясающее шоу, которое показывает историю города и красоту Башни с помощью современных технологий. На ваших глазах под звуки волнующей музыки стены и башенные спуски оживут благодаря применению световых 3D-установок; шоу оставляет неизгладимое впечатление у всех, кто его видел.&nbsp;</p>
								<p><strong>Отмечайте и празднуйте. </strong>Несмотря на свою многовековую историю, Иерусалим - оживленный современный город, где любят праздники и любят праздновать.&nbsp; Обязательно ознакомьтесь с графиком проведения фестивалей и культурных мероприятий и выберите лучшее из того, что предлагает Иерусалим на протяжении всего года.</p>
								<p><strong>Израильский фестиваль</strong>, это знаменитое культурное событие международного уровня, для участия в котором в Израиль приезжают известные театры, ансамбли современного танца, классические музыкальные оркестры и художественные коллективы со всего мира.&nbsp; Посетите Ярмарку искусств и ремесел в Иерусалиме <strong>Хатзот Айоцер</strong>, здесь вас ждут работы израильских и зарубежных художников, звучит отличная музыка; прогуляйтесь по многочисленным лавочкам Иерусалимского ночного рынка, где можно приобрести изделия и произведения художников и дизайнеров, работающих в разных стилях; обязательно загляните на <strong>Фестиваль «Свет в Иерусалиме»</strong>, это уникальное&nbsp; драматическое и художественное представление, показывающее Старый Иерусалим в новом художественном измерении благодаря использованию световых установок; побывайте на <strong>Фестивале оперы в Иерусалиме, </strong>послушайте прекрасные выступления. Представления проходят в бассейне Султана, где под открытым небом, на фоне волшебной иерусалимской ночи, вы будете наслаждаться искусством оперы.</p>
								<p>Не пропустите <strong>Иерусалимский фестиваль духовной музыки.</strong> Этот необычный фестиваль проводится в рамках <em>Сезона культуры в Иерусалиме, </em>в нем принимают участие артисты самых разных жанров, представляющие различные культуры и традиции, вы сможете послушать и познакомиться с образцами «духовной» музыки из разных стран.</p>
								                
            	 `,
      };
    },
  },

  // {
  // 	id:"All_Sensory_Markets",
  //              bgImage : "/posts/bank/1.jpg",
  //               mobBgImage : "/posts/bank/M.jpg",
  //               ctg :"culinary",
  //               isVid:false,
  //               title : "ALL SENSORY MARKETS",
  //               player_id_post :"",
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  // 				<p>
  // 					For a genuine Middle Eastern experience you can’t beat a visit to one of Israel’s many markets (Shuks).  The different colours, textures, smells, tastes and sounds of these hives of activity can be a highlight of any Israel visit.
  // 				</p>

  // 				<p>
  // 					These markets are a melting pot of cultures and a great place to give your bartering skills a go. Through the winding cobbled streets you will find, fresh produce, souvenirs, art and handmade jewellery…the list is endless. Bring home a gift for your friends and family or just enjoy walking around and tasting different flavours.
  // 				</p>

  //              	<div class="img-wrapper">
  // 					<img src=${getImgUrl() +  "/thingsToDo/posts/30/1.jpg"} class="img-responsive" />
  // 				</div>

  // 				<h2>
  // 					Tel Aviv
  // 				</h2>
  // 				<p>
  // 					The Carmel Market, or Shuk HaCarmel, is the most famous of all Tel Aviv’s marketplaces. In recent years, it’s even joined the ranks of Tel Aviv’s trendy spots for bars, restaurants, coffee shops and chef-owned food stalls. It’s no wonder Shuk HaCarmel is Tel Aviv’s largest and most-centrally located shuk: From hand-made Jachnun, a traditional Yemenite dish, to boutique cheeses, and from one-off cotton clothes to designer threads, HaCarmel has it all. Plan your visit around your tastebuds and food preferences - salted fish, cured meats, Middle Eastern fare, fresh baked French pastries, and local-roasted coffee or fresh-pressed fruit or vegetable juice blends to wash it all down.
  // 				</p>

  // 				<p>
  // 					<a target="_blank" href="//www.shuktlv.co.il/en/category/carmel-market">
  // 						www.shuktlv.co.il/en/category/carmel-market
  // 					</a>
  // 				</p>

  // 				<div class="img-wrapper">
  // 					<img src=${getImgUrl() +  "/thingsToDo/posts/30/2.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					Nachlat Binyamin arts and crafts fair was established in 1988. It is the oldest and biggest of its kind in Israel, and one of the nicest in the world. The market is home to over two hundred artists who use materials such as wood, glass, fabric, plastic, paper…even rocks (almost anything) to hand-make what they sell on their stall.
  // 				</p>

  // 				<p>
  // 					<a target="_blank" href="//www.shuktlv.co.il/en/category/carmel-market">
  // 						www.shuktlv.co.il/en/category/carmel-market
  // 					</a>
  // 				</p>

  // 				<div class="img-wrapper">
  // 					<img src=${getImgUrl() +  "/thingsToDo/posts/30/3.jpg"} class="img-responsive" />
  // 				</div>
  // 				<h2>
  // 					Jerusalem
  // 				</h2>

  // 				<p>
  // 					The Machane Yehuda market is widely recognized as a symbol of the Jerusalem, and for a very good reason: Jerusalemites see it as a place that represents them, symbolizes them, and gives them a unique identity in a larger Israeli social context. Jerusalem today has many shopping and entertainment centres, but there is something about the Machane Yehuda market that attracts people, even without a shopping list.  From the heady scent of spices to the colourful displays of fruits and vegetables, a trip to this market is pleasing for all your senses.
  // 				</p>

  // 				<div class="img-wrapper">
  // 					<img src=${getImgUrl() +  "/thingsToDo/posts/29/4.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					One option of experiencing this market is by buying a ‘Machane Yehuda Bites Card’.  This card is comprised of vouchers curated in order to give you a chance to try a variety of products, flavours and the aromas of the market - without having to depend on an organized group or tour.  For more information please click here:
  // 				</p>

  // 				<p>
  // 					<a target="_blank" href="//www.machne.co.il/en/">
  // 						http://www.machne.co.il/en/
  // 					</a>
  // 				</p>

  //             	 `
  //     }
  //   }
  // },

  // {
  // 	id:31,
  //               bgImage : "/posts/bank/20/1.jpg",
  //               mobBgImage : "/posts/bank/20/M.jpg",
  //               title : "UNFORGETTABLE YAD VASHEM",
  //               ctg :"jerusalem",
  //               isVid:false,
  //               player_id_post :"",
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  // 				<p>
  // 					Yad Vashem, Israel’s main Holocaust remembrance and education centre is situated on the green slopes of Har HaZikaron, (the Mount of Remembrance) in Jerusalem.
  // 				</p>

  // 				<p>
  // 					Israel’s Holocaust commemoration project began in 1953 with the task of perpetuating the memory of Holocaust victims and documenting the history of the Jewish people during the Holocaust so that it will be remembered by future generations. This project was an important step for the young nation of Israel at the time and was significant for the citizens of Israel, particularly for the survivors of the ghettos and concentration camps.
  // 				</p>

  //              	<div class="img-wrapper">
  // 					<img src=${getImgUrl() +  "/thingsToDo/posts/31/1.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					The new Yad Vashem museum was opened to the public in 2005. The museum is designed in the shape of a prism penetrating the mountain. Divided into nine galleries, the museum relates the stories of the Jewish communities before the Second World War and the series of events beginning from the rise of the Nazis to power, the pursuit of the Jews, their eviction to the ghettos and ending with “the Final Solution” and mass genocide
  // 				</p>

  // 				<div class="img-wrapper">
  // 					<img src=${getImgUrl() +  "/thingsToDo/posts/31/2.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					The personal experiences and feelings of the victims of the Holocaust constitute the groundwork for the museum’s exhibits. Photographs, films, documents, letters, works of art, and personal items found in the camps and ghettos are all an integral part of the exhibits. As you exit the Museum itself is the Hall of Names, an inspiring memorial containing over three million names of Holocaust victims that were submitted by their families and relatives. Names can still be submitted by visitors to the memorial and added to the computerized archive.
  // 				</p>

  // 				<p>
  // 					In addition to the Holocaust History Museum Yad Vashem has other memorials and monuments including  the Hall of Remembrance, where the ashes of the dead are buried and an eternal flame burns in commemoration; Yad Layeled, the children’s memorial, commemorating the one and a half million Jewish children who were murdered in the Holocaust;
  // 				</p>

  // 				<div class="img-wrapper">
  // 					<img src=${getImgUrl() +  "/thingsToDo/posts/31/3.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					The Memorial to the Deportees, an authentic railroad car hanging over the cliff on the road winding down from the mountain. The car was used to transport Jews who had been banished from their homes to the concentration camps.
  // 				</p>

  // 				<p>
  // 					The Avenue of the Righteous Among the Nations has over 2,000 trees which were planted in honor of non-Jews who endangered their lives in order to rescue Jews from the Nazis; The archives and library of Yad Vashem House the world’s largest repository of material about the Holocaust;
  // 				</p>

  // 				<p>
  // 					Visiting the Yad Vashem museum is an emotional and heartrending experience, but seeing the exhibits and remembering the Holocaust gives the more than one million individuals, world leaders and dignitaries who pass through its doors annually a meaningful way to commemorate the six million Jewish victims of the Holocaust.
  // 				</p>

  // 				<p>
  // 					For more information   <a target="_blank" href="//www.yadvashem.org/">www.yadvashem.org</a>
  // 				</p>

  //             	 `
  //     }
  //   }
  // },

  {
    id: "What_To_Pack",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "ЧТО ВЗЯТЬ С СОБОЙ",
    smltitle: "",
    html: function() {
      return {
        __html: `

								
								<p>Израиль — современная развитая страна, поэтому здесь вы сможете купить буквально все, что может понадобиться во время путешествия, включая одежду, косметику и предметы гигиены.</p>
								<p>Если вы едете в Израиль летом, вам будет необходима легкая одежда — рубашки или майки с коротким рукавом или без рукава, шорты, сандалии, пляжная обувь и купальный костюм. Стоит захватить свитер или легкую куртку, поскольку ночи в горах и в пустыне бывают прохладными.</p>
								<div class="img-wrapper">
								   <img src=${getImgUrl() + "/posts/what-to-pack/1.jpg"} class="img-responsive">
							    </div>
								<p>Если вы приезжаете в Израиль зимой, вам понадобится демисезонная одежда — пальто (советуем захватить и дождевик), ботинки, перчатки, шарф и другие теплые предметы гардероба, а также зонтик. Погода в Израиле не такая холодная, как в Европе, но зимой бывают дождливые и достаточно прохладные дни.</p>
								<p>Хорошо взять с собой небольшую сумку для ежедневных прогулок. Если вы намерены отправиться в Эйлат или на Мертвое море, возьмите купальный костюм, потому что здесь достаточно тепло, чтобы искупаться и зимой.</p>
								<p>Солнцезащитный крем, головной убор и темные очки — это предметы первой необходимости круглый год.</p>
								<p>Если вы планируете много ходить пешком, не забудьте соответствующую обувь и большой запас воды. Спальный мешок, палатка и походное оборудование понадобятся вам, только если вы планируете ночевку под открытым небом. Большинство хостелов для молодежи предлагают постельные принадлежности и одеяла.</p>

								
								

		                        `,
      };
    },
  },
  {
    id: "Electrical_Appliances",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "ЭЛЕКТРОПРИБОРАМИ",
    smltitle: "",
    html: function() {
      return {
        __html: `
								<p>Параметры электрической сети в Израиле: однофазное напряжение 220 вольт при частоте 50 Гц. Как правило, объекты в Израиле оснащены электрическими розетками с тремя отверстиями, тем не менее использование приборов с вилкой из двух штырьков допускается. Для использования бритв, переносных утюгов и прочих небольших бытовых электроприборов могут понадобиться трансформаторы или сетевые переходники.</p>
                                 <p><span><a href="https://info.goisrael.com/en/things-to-do" target="_blank"><span>Список требований и правил при использовании электроприборов и сети содержится на сайте туристической информации</span></a></span><br><br><a href="https://info.goisrael.com/en/organized-tourism" target="_blank">Ознакомиться с перечнем предлагаемых туристам услуг можно на сайте туристической информации</a></p>
                                <div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/electrical-appliances/1.jpg"} class="img-responsive">
							    </div>

		                        `,
      };
    },
  },
  {
    id: "Weather",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "WEATHER",
    smltitle: "",
    html: function() {
      return {
        __html: `
								<p>
								Eilat, the southernmost and sunniest city in Israel, enjoys ideal weather almost all year round.
								</p>
								<p>
								The summer is about 9 months long, while the winter only lasts about 3 - 4 months, from November to February. The hottest month of the year is August, with an average temperature of 42.6 ° C, while the coldest is January with an average temperature of 12.9 ° C.
								</p>
								<p>
								However, even in the dead of winter or the summer peak, the Red sea water temperature stays solid between 20°-26°c  throughout the year, an ideal temperature for swimming, surfing and diving.
								</p>
								<p>
								The Israeli Meteorological Service: <a href="https://www.ims.gov.il" target="_blank">www.ims.gov.il</a>
								</p>
								<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/weather-planyour-trip/1.jpg"} class="img-responsive">
							    </div>

		                        `,
      };
    },
  },
  {
    id: "Transportation",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "ТРАНСПОРТ",
    smltitle: "",
    html: function() {
      return {
        __html: `
								<p>Израиль – маленькая страна, поэтому добраться до любого места здесь можно быстро и с удобствами. Для городских или междугородних поездок в Израиле очень распространены такси, их можно остановить на улице или заказать по телефону либо посредством одного из телефонных приложений, вроде GetTaxi.</p>
								<p>Основные виды общественного транспорта — это автобусы и поезда, которые с комфортом и за разумную цену доставят вас практически в любую точку страны.</p>
								<p>Справочный центр железной дороги: <a href="//www.rail.co.il/ru" rel="nofollow noopener" target="_blank">www.rail.co.il</a> / Телефон: 08-6831222 или *5770.</p>
								
								<p>Автобусный справочный центр: <a href="//bus.gov.il/?language=en#/origindestination/1/0" rel="nofollow noopener" target="_blank">www.bus.co.il</a> / Телефон: 1-900-72-1111.</p>
								<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/transportation/1.jpg"} class="img-responsive">
							    </div>
								<p>Билеты можно приобрести в кассах на центральной автобусной станции города или у водителя. Большинство автобусных линий не работают в шаббат и во время еврейских праздников. Автобусы перестают ходить в пятницу вечером и возобновляют движение вечером в субботу.&nbsp;</p>
								<p>Студентам на междугородних автобусных линиях предоставляется скидка. Чтобы получить ее, при покупке билетов необходимо предоставить международное студенческое удостоверение.</p>
								<p><strong>Умная дорожная карта — Рав Кав</strong></p>
								<p>Туристы могут приобрести специальный электронный билет — анонимную карту Рав Кав. Ее можно купить в автобусе за небольшие деньги и пополнять как на единичную поездку, так и на несколько поездок – обычно с 20%-ной скидкой на поездки внутри региона.</p>
								<p>Туристы не могут использовать персональную карточку Рав Кав, содержащую все данные пассажира, и предназначенную только для граждан страны.</p>
								<p>Обратите внимание:</p>
								<p>· Одна Рав Кав может быть использована для оплаты проезда нескольких пассажиров одновременно.</p>
								<p>· Проезд ребенка стоит столько же, сколько и проезд взрослого.</p>
								<p>· Рав Кав можно использовать внутри региона, но не за его пределами — для этого ее нужно пополнить специальным образом.</p>
								<p>· В некоторых регионах можно приобрести билет на неограниченные поездки в течение дня внутри данного региона.</p>
								<p><strong>Внутренние полеты</strong></p>
								<p>Израиль — небольшая по территории страна, поэтому о полете стоит подумать только в том случае, &nbsp;если вам нужно попасть из Тель-Авива в Эйлат или обратно. Несколько авиакомпаний совершают рейсы между Эйлатом и аэропортом Бен-Гурион и аэропортом Сде-Дов на севере Тель-Авива. Цена билетов вполне доступна, хотя превышает стоимость поездки на автобусе.</p>
								<p>Существуют также частные авиакомпании, совершающие специальные рейсы в любое место страны, по требованию.</p>
								<p>Аркиа: <a href="//www.arkia.com/flights-in-israel" rel="nofollow" target="_blank">www.arkia.com/flights-in-israel</a> Телефон: 00 972 3 690 2222,</p>
								<p>Исраэйр: <a href="//int.israirairlines.com/cat_domestic.asp" rel="nofollow" target="_blank">&nbsp;int.israirairlines.com/cat_domestic.asp</a> Телефон: 00 972 3 795 5777</p>
								<p><strong>Аренда автомобиля</strong></p>
								<p>У большинства международных компаний по прокату автомобилей, а также у местных компаний есть офисы в крупных городах и в аэропорту Бен-Гурион. Мы рекомендуем заказать аренду машины еще до прибытия в Израиль.</p>
								<p>Чтобы арендовать машину в Израиле, водитель должен быть старше 24 лет, иметь действующие международные водительские права и международную кредитную карточку.</p>
								<p>В Израиле широкая сеть автомобильных дорог с четкими дорожными знаками в большинстве мест (на иврите, английском и арабском языках).</p>
								<p><strong>Вождение в Израиле</strong></p>
								<p><strong>Минимальный</strong> возраст водителя в Израиле — 17 лет, здесь правостороннее движение. Ограничение скорости — 30-50 км/ч в городах, 80-90 км/ч на загородных шоссе, 130 км/ч на скоростных шоссе и шоссе 6. Использование ремней безопасности является обязательным. А если вы решили повеселиться вечером, помните, что правила относительно вождения в состоянии опьянения в Израиле очень строгие, поэтому наймите специального водителя на вечер и развлекайтесь безопасно.</p>
								<p><strong>Шоссе 6 </strong></p>
								<p>Шоссе 6 — это скоростная магистраль с электронной оплатой и без светофоров, что обеспечивает быстроту передвижения. Современные компьютерные системы, установленные вдоль шоссе, включают электронные шлагбаумы, опознают транспортные средства, устанавливают категорию оплаты (абонемент или незарегистрированный пользователь) и высчитывают число секций дороги, которые проезжает транспортное средство. Стоимость каждой поездки подсчитывается автоматически и за нее выставляется счет. Воспользуйтесь всеми преимуществами безопасной и быстрой автомагистрали с ограничением скорости 130 км/ч.</p>
								<p>С туристов, использующих автомобиль на прокат, оплата за услуги будет взыскана по кредитной карточке. Узнайте в прокатной компании об условиях и тарифах такого использования.</p>
								<p>Большинство компаний по прокату автомобилей не предоставляют страхового покрытия на территории Западного Берега, контролируемой Палестинской Автономией. Туристам, желающим посетить Палестинскую Автономию на арендованной машине, мы рекомендуем приобрести соответствующую страховку.</p>
																

            	

		                        `,
      };
    },
  },
  {
    id: "Israeli_Currency",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "ISRAELI CURRENCY",
    smltitle: "",
    html: function() {
      return {
        __html: `

								<p>
								Eilat’s currency is the New Israel Shekel (NIS) or shekel for short (pluralized as shkalim in Hebrew or shekels in English). There are 100 agorot (agora in singular) in each shekel. Bank notes are in values of 20, 50, 100, and 200 NIS; coins are in values of 10, 5, 2 & 1 NIS and you have 50 and 10 aggorrot.
								</p>
								<h2>
								Exchange Services 
								</h2>
								<p>
								Unlimited sums of local and foreign money may be brought into Israel as cash, credit cards or State of Israel bonds. Foreign currency of all kinds may be exchanged at the airport, banks, post offices, most hotels or licensed exchange agencies in large cities. 
								A passport is required when exchanging currencies. The rates vary from place to place, and banks charge a commission. More Information is available here.
								</p>
								<h2>
								Cash Withdrawals 
								</h2>
								<p>
								Holders of international credit cards can withdraw local or foreign currency at banks which accept their credit cards. There are ATM Machines outside most banks.
								</p>
								<h2>
								Value-added tax refunds
								</h2>
								<p>
								Eilat is a VAT-free zone, but if you visit other places in Israel, foreign tourists may request VAT refunds on purchases made during their visits. Be sure to keep your receipts.
								</p>
								<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/israeli-currency/1.jpg"} class="img-responsive">
							    </div>
            	

		                        `,
      };
    },
  },
  {
    id: "Immigration_Customs",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "IMMIGRATION & CUSTOMS",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                <h2>Passport Control</h2>
                                <p>Upon arrival in Israel, visitors go to passport control and must present a passport that is valid for at least six months from the <strong>date of their departure.</strong><br>
                                   Please note, Israel has incorporated a new and modern technological system instrumental in meeting the needs of the various Immigration, security, Airport and Tourism authorities as well as providing the tourist with the credentials necessary to prove his visa status without stamping the passport. At a press of a button, the Border Control station will print a card including the principle details of the traveler as in the first page of the passport. The card will also depict the date of arrival and visa information. This card is called The “Electronic Gate Pass”.
                                </p>
                                <div class="img-wrapper">
								    <img src=${getImgUrl() +
                      "/posts/immigration-customs/1.jpg"} class="img-responsive">
							    </div>
							    <p><strong>The Gate Pass is an official form of identification while in Israel. We ask all tourists to keep the card at hand at all times as proof of their status.</strong><br>
										Arrival by Air and Land Crossings – Incoming travelers continue to the passenger luggage area after having their passports inspected. Carts are at their disposal. From there, they continue to customs control and to the airport exit.</p>
										<p><a href="https://www.gov.il/BlobFolder/service/group_entry_to_israel/en/land%20gateways%202017ENGLISH%20update.doc" target="_blank" rel="nofollow noopener" data-mk-aweb-org-font-size="17">Information Regarding&nbsp;Israel’s Land Gateways&#8203;</a></p>
										<h2>Customs</h2>
										<p>General information regarding the laws and policies of the Customs Authority can be downloaded:<br>
										<a href="https://www.gov.il/en/departments/topics/tourist-and-travelers-info/govil-landing-page" target="_blank" rel="noopener">https://www.gov.il/en/departments/topics/tourist-and-travelers-info/govil-landing-page</a></p>
										<p><strong>Please make note that travel through Allenby Bridge Crossing has specific limitations and directives. For example, visitors passing through the Allenby Bridge between Israel/Jordan may carry no more than the cash value of 2000 Jordanian Dinars.</strong></p>
										<h2>Customs and V.A.T. for Tourists:</h2>
										<p><a href="https://taxes.gov.il/English/Vat/Pages/VatLobby.aspx" target="_blank" rel="noopener">https://taxes.gov.il/English/Vat/Pages/VatLobby.aspx</a><br>
										<strong>Aside from Allenby Bridge Crossing, and for all other Gateways including airports,</strong> the following tourist guide is relevant for visitors as defined by the Customs and Tax Authority:<br>
										<a href="https://taxes.gov.il/English/Vat/pages/guides/vat-refund-for-tourists.aspx" target="_blank" rel="noopener">https://taxes.gov.il/English/Vat/pages/guides/vat-refund-for-tourists.aspx</a><br>
										<a href="https://taxes.gov.il/English/customs/PersonalImport/Pages/CustomsTuristGuide.aspx" target="_blank" rel="noopener">https://taxes.gov.il/English/customs/PersonalImport/Pages/CustomsTuristGuide.aspx</a><br>
										Please note: there is a two-lane customs transit system, one green and the other red, at Ben Gurion Airport and the various Crossing Points. Visitors who do not have goods to be declared may go through the green lane at the exit from the passenger arrival hall.</p>
								
		                        `,
      };
    },
  },
  {
    id: "Frequently_Asked_Questions",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "ЧАСТО ЗАДАВАЕМЫЕ ВОПРОСЫ",
    smltitle: "",
    html: function() {
      return {
        __html: `
											<h3>Часто задаваемые вопросы о COVID-19 </h3>
						                          <p>
						                         <ol start="1">
												        <li><strong>Я турист и нахожусь в Израиле. Меня беспокоит, что у меня может быть COVID-19, куда я могу обратиться?</strong>
						                                 <br/>
						                                <ul>
						                                       <li>
						                                          Если вы страдаете от озноба и температуры не менее 100,4 F (38C), кашля, проблем с дыханием или других респираторных симптомов, вы должны немедленно начать самоизоляцию и позвонить на горячую линию экстренной службы 101 MDA для получения медицинской консультации. 
						                                        <strong>
						                                          Не обращайтесь напрямую в местную поликлинику или отделение неотложной помощи.
						                                        </strong>
						                                       </li>
						                                   </ul>
						                                </li>
						                                <li><strong> Когда Израиль снова будет открыт для гостей и туристов?</strong><br/>
						                                <ul>
						                                       <li>
						                                        На данный момент нет точной информации о том, когда Израиль будет открыт для гостей и туристов.
						                                       </li>
						                                   </ul>
						                                </li>
												        
												       
												  </ol>
						                      </p>
											<p><strong>Далеко ли находится Израиль?</strong></p>
											<p>Полет из Москвы до Тель-Авива занимает всего три с половиной часа, а до Эйлата — четыре с половиной часа. Из Санкт Петербурга — четыре или пять с половиной часов соответственно. Регулярные рейсы в Израиль выполняют авиакомпании Аэрофлот, El Al, Уральские авиалинии. Отправиться в Израиль можно и из таких городов России, как Ростов-на-Дону, Екатеринбург, Краснодар, Самара и Сочи.</p>
											<p><strong>Какие документы понадобятся мне для поездки в Израиль?</strong></p>
											<p>Гражданам России виза для въезда в Израиль не нужна. Для въезда в Израиль паспорт должен быть действителен в течение 6 месяцев с даты въезда в страну. При путешествии с ребенком он должен быть вписан в заграничный паспорт родителя, с которым путешествует (или иметь собственный загранпаспорт).</p>
											<p><strong>Безопасно ли путешествовать по Израилю?</strong></p>
											<p>Мы не приглашали бы вас, если бы это было не так. Каждый год Израиль посещает от 3 до 4 миллионов туристов, и они все возвращаются домой живыми и здоровыми — разве что кроме тех, кто полюбил израильтянина или израильтянку… или же сам Израиль! Самолеты более 90 компаний не летали бы в Израиль, если бы это было опасно.</p>
											<p><strong>Говорят, что перед поездкой в Израиль необходимо пройти собеседование со службой безопасности.</strong></p>
											<p>Если вы летите израильской авиакомпанией «Эль Аль» (или из Европы авиакомпаниями «Аркиа» или «ИсраЭйр»), пожалуйста, помните, что меры безопасности, принятые на израильских авиалиниях, давно признаны эталонными и вызывают зависть всех авиакомпаний мира. При регистрации вашего полета сотрудники службы безопасности зададут вам ряд вопросов. Некоторые из них могут показаться некорректными, назойливыми, не имеющими отношения к делу или повторяющимися. Просто отвечайте правдиво, сотрудничайте с интервьюером и не теряйте самообладания. Помните, что вопросы специально составлены таким образом, чтобы защитить вас и других пассажиров. При вылете из страны самолетом любой авиалинии вас ждет аналогичная процедура.</p>
											<p><strong>Могу ли я соединить поездку в Израиль с поездкой в Иорданию и (или) в Египет?</strong></p>
											<p>Конечно. Между Тель-Авивом и Каиром и Тель-Авивом и Амманом существуют регулярные авиарейсы. Можно воспользоваться и наземным способом передвижения, и пересечь границу с Египтом в Эйлате/Таба, а границу с Иорданией — в Эйлате или через КПП «Мост Шейха Хусейна», расположенный немного южнее Галилейского моря. Для получения визы вы должны обратиться в местное египетское или иорданское консульство.</p>
											<p><strong>Что делать, если я хочу посетить другое арабское государство?</strong></p>
											<p>Пожалуйста. Как и многие европейские страны, Израиль больше не проставляет штампы в паспортах гостей страны, поэтому факт посещения Израиля не будет отражен в вашем паспорте.</p>
											<p><strong>Могу ли я посетить Палестинскую Автономию?</strong></p>
											<p>Поездка в Вифлеем — достаточно простое дело, и тысячи гостей Израиля ездят туда каждый день. Вы можете приобрести экскурсию (узнайте у администратора своей гостиницы) или взять такси до КПП между Израилем и Вифлеемом и палестинское такси внутри Вифлеема.</p>
											<p><strong>Здравоохранение, лекарства, прививки</strong></p>
											<p>Израиль — современная страна с самым высоким в мире числом врачей на душу населения, и израильская система здравоохранения известна во всем мире. Для посещения Израиля вам не потребуются прививки (кроме тех случаев, если в недавнем прошлом вы посещали регион, где отмечалась эпидемия желтой лихорадки, холеры или Эбола). В Израиле вы сможете приобрести большинство эквивалентов лекарств, не требующих рецепта. Также вы можете взять с собой запас своих обычных рецептурных лекарств (если вам понадобятся в поездке шприцы или ампулы с лекарствами — захватите на всякий случай письмо от врача, свидетельствующее о ваших нуждах). Если вам понадобится посетить врача в Израиле, обратитесь к администратору своей гостиницы. При поездке за границу всегда рекомендуется оформлять туристическую страховку, покрывающую медицинские расходы.</p>
											<p><strong>Что надеть?</strong></p>
											<p>Как почти везде в мире, удобная одежда является «униформой» для ежедневных прогулок и экскурсий. Возьмите удобную обувь для ходьбы, например, кроссовки, и несколько различных видов одежды. В Тель-Авиве и Иерусалиме израильтяне (особенно израильтянки) предпочитают «удобно-элегантную» форму одежды по вечерам. При посещении некоторых святых мест необходима скромная одежда (закрытые ноги и руки; в некоторые места не допускаются женщины в брюках). Не забудьте купальный костюм и пластиковую обувь для защиты ног на Мертвом море.</p>
											<p><strong>Деньги</strong></p>
											<p>Израильской валютой является шекель (официально — «новый израильский шекель»), стоимость которого равна примерно 16 рублям. По прибытии в Израиль мы советуем вам снять некоторую сумму в шекелях в одном из банкоматов, расположенных в залах прибытия аэропорта Бен-Гурион — или обменять небольшие суммы долларов/дорожные чеки в банке или гостинице. В Израиле множество банкоматов, и кредитные карточки принимаются в большинстве заведений.</p>
											<p><strong>Электричество</strong></p>
											<p>Почти все гостиничные номера оборудованы фенами, везде есть розетки для электробритв. При использовании других электроприборов следует учитывать, что напряжение переменного тока в Израиле 220 Вольт, частота — 50 герц, и можно использовать переходники 110 В — 220 В. У израильских розеток три отверстия, но европейские двухштырьковые адаптеры обычно подходят. Если у вас нет подходящего адаптера, обратитесь к администратору своей гостиницы или зайдите в магазин электротоваров.</p>
											<p><strong>Связь</strong></p>
											<p>В большинстве гостиниц есть бесплатный беспроводной интернет в лобби, а некоторые гостиницы предоставляют бесплатный интернет и в номерах. Во многих гостиницах есть также бизнес-центры, где вы можете бесплатно воспользоваться интернетом или проверить электронную почту.</p>
											<p><strong>Время</strong></p>
											<p>Время в Израиле совпадает с московским, но меняется при переходе на зимний сезон.</p>
											<p><strong>Погода</strong></p>
											<p>Температура воздуха в Израиле изменчива, поэтому захватите одежду для разной погоды, и все будет в порядке. Времена года иногда частично перекрываются, но общие рекомендации таковы:</p>
											<p>ЛЕТО (июнь/июль/август/начало сентября): в жаркие дни температура достигает 27-32⁰&nbsp;С. В Тель-Авиве и Тверии жарко и влажно. В Иерусалиме суше и прохладнее, особенно ночью. На Масаде и в Эйлате особенно жарко (43⁰&nbsp;С и выше!)… но сухо. Дождей летом в Израиле не бывает.</p>
											<p>МЕЖСЕЗОНЬЕ (конец марта/апрель/май, конец сентября/октябрь/ноябрь): дневные температуры очень приятны — около 24⁰&nbsp;С в большинстве регионов страны (жарче — на Красном и Мертвом морях). В Иерусалиме — около 20-21&nbsp;⁰С днем и 10⁰&nbsp;С вечером. Может пройти небольшой дождь, но не ливень.</p>
											<p>ЗИМА (декабрь/январь/февраль/начало марта): зимняя погода переменчива. Некоторые зимы достаточно теплые и солнечные, другие — более пасмурные и суровые. Иногда идет сильный дождь, а в январе и в феврале временами выпадает снег. Температура в большинстве мест — 10-15⁰&nbsp;С, но в Иерусалиме и в Галилее — около 5⁰&nbsp;С, и ночью холодно.</p>
											<p><strong>Транспорт</strong></p>
											<p><strong>АВТОБУСЫ:</strong>&nbsp;в Израиле существует &nbsp;одна из лучших в мире и самых недорогих систем автобусного сообщения, и автобусы ходят практически в любой город или населенный пункт.</p>
											<p><strong>ПОЕЗДА:</strong>&nbsp;скоростные поезда связывают аэропорт Бен-Гурион и Тель-Авив, Иерусалим и Хайфу, быстрые, удобные и недорогие железные дороги охватывают большую часть страны. Стоимость билета на поезд относительно невысока и в системе ценообразования легко ориентироваться.&nbsp;<a href="//www1.rail.co.il/Pages/homepage.aspx">Нажмите&nbsp;</a>для получения более подробной информации. &nbsp;&nbsp;</p>
											<p><strong>САМОЛЕТЫ:</strong>&nbsp;между Тель-Авивом и Эйлатом выполняются многочисленные ежедневные рейсы компаний Arkia&nbsp;и&nbsp;El Al ; существуют также рейсы в Хайфу и Галилею.</p>
											<p><strong>ТАКСИ:</strong>&nbsp;в городах много такси, и водители с радостью отвезут вас и в другой город. Но всегда уточняйте цену до начала поездки.</p>
											<p><strong>МАРШРУТНЫЕ ТАКСИ:</strong>&nbsp;маршрутные такси (называемые «шерут») очень популярны. В городах есть много остановок маршрутных такси. Узнайте в своей гостинице, где находится ближайшая остановка.</p>
											<p><strong>АРЕНДА МАШИНЫ:</strong>&nbsp;у большинства международных компаний по аренде автомобилей есть представительства в Израиле — наряду с отличными местными компаниями, предоставляющими машины напрокат.</p>					
													              
		                        `,
      };
    },
  },
  {
    id: "Passports_Visa",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: true,
    vidId: "r6yBwHYwo2A",
    title: "ПАСПОРТА, ВИЗЫ, ETA",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                
                                
                                <h3>Всем гостям Израиля</h3>
                                <p>С 1 января 2025 г. гражданам всех стран, с которыми у Израиля действует соглашение о безвизовом режиме, включая Россию, необходимо заблаговременно оформлять электронное разрешение на въезд в Израиль – ETA (Electronic Travel Authorization).</p>
                                
                                <p>Министерство туризма Израиля подчеркивает, что единственным сайтом для оформления разрешения ETA является официальный интернет-ресурс Управления народонаселения и миграции Израиля <a href="https://israel-entry.piba.gov.il" target="_blank"  rel="noopener">https://israel-entry.piba.gov.il</a>.</p>
                                
                                <p>ETA – не является визой. Соглашение о безвизовом режиме между Израилем и РФ продолжает действовать.</p>
                                
                                <p>Сбор за его оформление составит 25 шекелей.</p>
                                
                                <p>С 1 января 2025 г. минимальный срок действия заграничных паспортов будет составлять 90 дней для туристов из стран, с которыми у Израиля действует безвизовый режим.</p>
                                
                                <p><strong>‼ Для стран с визовым режимом вводится электронная виза. Подробности на сайте: <a href="https://israel-entry.piba.gov.il/" target="_blank" rel="noopener">https://israel-entry.piba.gov.il/</a>.</strong></p>
                                
                                <p>Проверить, нужно ли оформлять электронную визу или ETA можно на сайте <a href="https://israel-entry.piba.gov.il/eligibilitynational/" target="_blank"  rel="noopener">https://israel-entry.piba.gov.il/eligibilitynational/</a></p>
                                
                                <h3>Гражданам Российской Федерации</h3>
                                
                                <p>Между Российской Федерацией и Государством Израиль действует межправительственное соглашение об отказе от визовых требований при взаимных поездках граждан, подписанное 20 марта 2008 года в Тель-Авиве.</p>
                                
                                <p><strong>Статья 1 упомянутого соглашения гласит:</strong></p>
                                <ol>
                                  <li>Граждане государства одной Стороны, являющиеся владельцами действительных паспортов (за исключением дипломатических и служебных), дающих право на пересечение границы (далее именуемые паспортами), могут въезжать, выезжать, следовать транзитом и пребывать на территории государства другой Стороны без виз девяносто (90) дней в течение периода в сто восемьдесят (180) дней.</li>
                                  <li>Граждане государства одной Стороны, намеревающиеся пребывать на территории государства другой Стороны более девяноста (90) дней, либо осуществлять трудовую или коммерческую деятельность на его территории, должны получить визу в соответствии с законодательством государства въезда.</li>
                                </ol>
                                <div class="img-wrapper">
                                <img src=${getImgUrl() + "/posts/passports-visa/1.jpg"} class="img-responsive">
                                </div>
                                <p>На практике это означает, что россиянину, который едет в Израиль на срок менее 90 дней:</p>
                                <ul class="ac-ul ac-ul-marg-minus">
                                  <li>по частным делам (посещение друзей, родственников и т.п.);</li>
                                  <li>с деловой целью (переговоры, деловые встречи и т.д.);</li>
                                  <li>с целью туризма и/или лечения;</li>
                                  <li>в целях осуществления научных, культурных, общественно-политических, спортивных или религиозных связей; виза для въезда в Израиль не нужна, но необходимо получение электронного разрешения на въезд – ETA, которое можно оформить на сайте Управления народонаселения и миграции Израиля: <a href="https://israel-entry.piba.gov.il" target="_blank">https://israel-entry.piba.gov.il</a></li>
                                </ul>
                            
                                <p>Все прибывающие в Израиль должны иметь паспорт, действительный в течение по крайней мере 90  дней.</p>
                             
                                <h3>«Электронный пропуск»</h3>
                                <p>Согласно статье 13 «Закона о въезде в Израиль» от 1952 года уполномоченный контролер или офицер полиции имеет право потребовать предъявления идентификационных документов и доказательств законности пребывания в Израиле. С учетом данного факта на пункте пограничного контроля одним нажатием кнопки будет отпечатан электронный пропуск — карточка, содержащая все ваши данные, указанные на первой странице паспорта. Также в ней будет приведена информация о дате прибытия и визе, в случае если путешественнику она требуется. Эта карточка называется «электронный пропуск» и является современным технологическим средством, позволяющим решить все вопросы, касающиеся служб аэропорта и органов иммиграции, безопасности и туризма.</p>
                                
                                <p><strong>«Электронный пропуск» является заменой системы проставления штампов в паспортах.</strong> В аэропорту данная карточка позволяет путешественнику покинуть терминал прибытия без задержки.</p>
                                
                                <p><strong>«Электронный пропуск» будет вашим официальным идентификационным документом.</strong> Мы просим всех туристов постоянно держать карточку при себе как доказательство своего визового статуса. В аэропорту и наземных пограничных пунктах данная карточка позволит путешественнику покинуть терминал прибытия и пройти в зону получения багажа.</p>
                                
                                <p><strong>Продление пребывания</strong></p>
                                <p>В случае, если Вы попадаете под категорию граждан, которым нужна виза, Вы сможете продлить ее (для этого потребуется оплатить пошлину) в ближайшем отделении Министерства внутренних дел; телефон информационного центра: *3450 или 12223450.</p>
                                
                                <p>Все прибывшие, которым требуется виза, могут находиться в Израиле до трех месяцев со дня приезда, согласно условиям выданной им визы.</p>
                                
                                <p><strong>Виза для лиц, желающих работать в стране</strong></p>
                                <p>Лица, желающие работать в Израиле, должны подать прошение в Министерство внутренних дел о предоставлении специальной визы.</p>
                                
                                <p><strong>Пребывание в стране для лиц без гражданства</strong></p>
                                <p>Лица без гражданства должны иметь специальный проездной документ — свидетельство на возвращение (laissez-passer), а также визу страны, его выдавшей.</p>
        `,
      };
    }

  },

  {
    id: "Crazy_Night",
    ctg: "telaviv",
    bgImage: "/posts/bank/crazy-night/1.jpg",
    mobBgImage: "/posts/bank/crazy-night/M.jpg",
    isVid: true,
    vidId: "ogEN7aRT0SM",
    title: "Хотели бы окунуться в бурную ночную жизнь?",
    smltitle: "",
    html: function() {
      return {
        __html: `<div class="ac-cradit">
									<span class="ac-cradit-text">Credits:</span>
										<br/>
										<span class="ac-cradit-text-1">Tel Aviv Jaffa municipality<br/></span<
										<span class="ac-cradit-text-2">UDINI prodactions<br/></span>
									</div>
									<p></p>
									</div>
                               <h2>
                                 Забронируйте поездку в Тель-Авив уже сейчас!
                               </h2>
                               <p>
                                 Amazing nightlife in Tel Aviv <a href="https://en.citiesbreak.com/Posts/telaviv/Amazing_Nightlife" target="_blank">Click here >> </a>
                               </p>
		                        `,
      };
    },
  },
  {
    id: "Dead_Sea_Video",
    bgImage: "/posts/bank/natures-glory/1.jpg",
    mobBgImage: "/posts/bank/natures-glory/M.jpg",
    title: "МЕРТВОЕ МОРЕ",
    ctg: "deadsea",
    isVid: true,
    vidId: "ixFocykfYHo",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                      <p>Вознеситесь на пик жизненной энергии в самой низкой точке планеты</p>
                   
         	`,
      };
    },
  },

  {
    id: "Heart_Of_The_World",
    ctg: "jerusalem",
    bgImage: "/posts/bank/heart-of-the-world/1.jpg",
    mobBgImage: "/posts/bank/heart-of-the-world/M.jpg",
    isVid: true,
    vidId: "nLKWDp5uA-U",
    title: "Иерусалим - сердце целого мира",
    smltitle: "",
    html: function() {
      return {
        __html: `
						<br/>
						<h2 class="ac-align-center ac-margin-top-20">Путешествие сквозь время</h2>
					    <p class="ac-align-center ac-margin-bottom-20"><b>Волшебство и величие города превзойдут все ваши ожидания</b></p>
                         <p><strong>Иерусалим </strong>— столица Израиля и один из самых знаменитых и пленительных городов мира, где тысячелетия славной истории органично переплетаются с повседневной жизнью. </p>
                         <p>Ощутите всю мощь древнего города: его бесчисленные исторические места и археологические чудеса, очаровательные улочки и величественные виды покорят ваше сердце. А современные городские развлечения обещают интересное времяпровождение сутки напролет и подлинное удовольствие для любителей культуры, искусства, музыки и кулинарии.</p>
                         <p><strong>Пройдите сквозь три тысячи лет истории</strong></p>
                         <p>Старый город Иерусалима — невероятно популярное туристическое место, привлекающее как впервые посещающих город, так и завсегдатаев и местных жителей. Старый город окружен древними стенами, которые неоднократно перестраивались. Войти сюда можно через 7 ворот, открывающих доступ к памятным и святым местам. Пройдитесь по булыжным мостовым, ступая по 4000 тысячам лет истории, и ощутите, как вас охватывают смирение и радостное волнение на этом пути от истоков к современности.</p>
                         <p><strong>Познакомьтесь с оживленным современным Иерусалимом </strong></p>
                         <p>Покинув Старый город, вы увидите типичный современный город: гостиницы, бульвары, рестораны и торговые центры. Посетите Музей Израиля — это крупнейшее культурное учреждение страны признано одним из ведущих музеев искусства и археологии в мире. Здесь среди множества сокровищ хранятся и знаменитые свитки Мертвого моря (древнейшие библейские рукописи).</p>
                         <p>Фермы, винодельни и пивоварни, расположившиеся вокруг Иерусалима, предлагают широкий выбор продуктов для гурманов: от традиционной израильской кухни до современной кулинарии и кухни в стиле фьюжн, а также удостоенные множества наград местные вина и пиво, которые по достоинству оценили знатоки со всего мира.</p>

                         
                         <p>Посетите Махане Йегуда, яркий оживленный рынок под открытым небом. Погрузитесь в его бурлящую, динамичную атмосферу и насладитесь изысканными ароматами местных деликатесов. Дождитесь заката и посмотрите, как «шук» (рынок) преображается в стильное место отдыха, с живой музыкой на любой вкус, радостной толпой посетителей, галереями уличного искусства, отличной едой и изысканными напитками. Прогуляйтесь по его узким улочкам, перекусите в ресторанчике, выпейте и немного потанцуйте, и отправляйтесь дальше — Махане Йегуда произведет на вас неизгладимое впечатление.</p>
                         <p>Настоящий центр искусства, истории и культуры, столица Израиля подарит вам незабываемые минуты, позволяя насладиться контрастом между особым очарованием древнего мира и бурной жизнью современного города. Подобно тому, как история встречается с современностью за стенами Старого города в уникальной мировой столице, так и вы, приехав в Иерусалим, ощутите удивительную связь с культурой, археологией и историей тех народов, которые когда-то населяли эту землю.&nbsp;</p>
                               
		                        `,
      };
    },
  },

  // {
  // 		id:"EILAT1",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId: "ZdnNT-GDJv4",
  //         title : "EILAT",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `

  //                       <p>Eilat is a port that is Israel’s outlet to India, eastern Asia and Africa. Six decades ago it was a shanty-style frontier town, but Eilat has developed into one of Israel’s major resorts whose Red Sea beaches and dozens of hotels attract Israelis and tourists from 100 countries. Eilat is devoted to vacationing. Resorts line the promenade and lagoon, along with a giant shopping mall, restaurants and a variety of attractions for visitors young and old. Eilat is also an entrée to one of the world’s most magnificent coral reefs: the Eilat Underwater Observatory is a must for every visitor, as is the dolphin reef where tourists swim with the dolphins.</p>
  //                       <div class="img-wrapper">
  // 						    <img src=${getImgUrl()+ "/posts/eilat1/1.jpg"} class="img-responsive">
  // 					    </div>
  //                       <p>Eilat is a 4/5-hour drive from Tel Aviv and Jerusalem – or a one-hour flight into Eilat Airport which sits in the heart of town. A 15-minute drive south from Eilat brings visitors to the crossing point to Egypt. And 10-minutes to the north, tourists cross to Jordan and the neighboring port city of Aqaba. Many visitors to Eilat take day trips to Petra in Jordan.</p>

  //                        <div class="img-wrapper">
  // 						    <img src=${getImgUrl()+ "/posts/eilat1/2.jpg"} class="img-responsive">
  // 					    </div>
  //                       <p><strong>Take a deep at the Red Sea</strong></p>
  //                       <p>An amazing attraction in itself, Eilat’s gorgeous Red Sea and the 10 kilometer-long shoreline surrounding it are the city’s focal point and the main attraction for tourists from far and wide.<br> With their clean, clear and unexpectedly cool water allowing a welcome escape from the city’s high temperatures and dry air, and the wide variety of facilities and attractions, Eilat’s beaches are the perfect spot for sunbathing, rest and relaxation.</p>
  //                       <p>Extreme sports enthusiasts will love the dozens of water sports clubs spread along the southern and northern coasts of Eilat, and the range of activities such as Jet skiing, banana boats, tubing, kayaking and much more.</p>
  //                       <p><strong>Feel the vibe</strong></p>
  //                       <p>When evening comes and the hot desert sun sets on Eilat and the pools and beaches close, that is just the time to shower, change and hit the town’s fantastic nightlife scene. Eilat holds a unique record – the city with the most clubs, bars and other entertainment venues per capita in Israel, so there is no shortage of hotspots to make your night as fun-filled as your day.</p>
  //                       <p><strong>A desert adventure</strong></p>
  //                       <p>North of the city lies the southern Arava, a region of breathtaking desert vistas, and one of the most recommended areas to visit in the country, where you can feel the vast expanses and hike steep cliffs, valleys, streams and more.</p>
  //                       <p>The colorful and stunning mountains of the Eilat area, besides contributing to the city's breathtaking view, will provide all nature lovers with an unforgettable experience. There are a variety of routes and sites to visit and enjoy by hiking, bicycling, driving, camel riding and even rock climbing or rappelling down cliffs for the extreme sports enthusiasts.</p>
  //                       <p>Don't wait up. Visit Eilat. Escape to the sun.</p>
  // 				 `
  //     }
  //   }
  // },
  {
    id: "Welcome_To_Eilat",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/eilat2/1.jpg",
    mobBgImage: "/posts/bank/eilat2/M.jpg",
    isVid: true,
    vidId: "ZdnNT-GDJv4",
    title: "ЭЙЛАТ СТРАНА ВЕЧНОГО ЛЕТА",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                   
									

									<p>Столица Красного моря Эйлат — наиболее известный курорт Израиля, привлекающий ежегодно 2,8 миллиона туристов, приезжающих провести отпуск на великолепных берегах Красного моря.</p>
									<p>Самый южный город Израиля славится неповторимым сочетанием пустынного ландшафта, красивейшего залива и летнего солнца, которое светит круглый год.</p>
									<p>Не важно, приедете вы в Эйлат всей семьей, с любимым человеком или в одиночку — вы обязательно найдете что посмотреть и чем заняться. В Эйлате множество мест, где можно остановиться, от лучших пятизвездочных гостиниц до уютных пансионов и молодежных турбаз.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/welcome-to-eilat/1.jpg"} class="img-responsive">
									</div>
									<p>Эйлат может похвастаться 360 солнечными днями в году, что делает его необыкновенно популярным среди туристов из разных концов света, мечтающих хотя бы на время убежать от зимних холодов. Поездка в Эйлат — необыкновенное приключение, когда вы сможете расслабиться и зарядиться энергией одновременно! Этот оживленный курортный город предлагает множество различных развлечений и аттракционов круглый год. А еще вас ждут великолепные рестораны и кафе, торговые центры, стильные бары и клубы.</p>
									<p>Но главное — в Эйлате все это находится в двух шагах от берега!</p>
									<p><strong>Нырните в Красное море</strong></p>
									<p>Красное море и 10-километровая береговая линия — вот центр жизни города и главное развлечение для туристов со всего мира.<br>Чистая, прозрачная и неожиданно прохладная вода эйлатских пляжей — поистине спасение от городской жары и сухости. Поэтому, в сочетании с широким выбором услуг и развлечений, это чудесное место отдыха.<br>Любители экстремальных видов спорта оценят множество клубов, расположенных вдоль южного и северного берегов Эйлата, где предлагают катание на гидроцикле, каяке, «банане», прикрепленном к моторной лодке, тюбинг (катание на водных санках) и многое другое.</p>
									<p><strong>Наполнитесь энергией города</strong></p>
									<p>Когда приходит вечер, горячее пустынное солнце заходит над Эйлатом, закрываются бассейны и пляжи. А значит, самое время принять душ, переодеться и окунуться в бурную ночную жизнь. Интересно, что в Эйлате самое большое в Израиле количество клубов, баров и других увеселительных заведений на душу населения, поэтому здесь вы всегда найдете место, где повеселиться, хоть днем, хоть ночью.</p>
									<p><strong>Приключения в пустыне</strong></p>
									<p>На север от Эйлата лежит пустыня Арава с потрясающими пейзажами. Это одно из наиболее популярных для посещения мест в стране: здесь вы сможете полюбоваться бескрайними просторами и покорить крутые горные склоны, здесь вас ждут долины, источники и многое другое.</p>
									<p>Необычайно красивые разноцветные горы в окрестностях Эйлата не только украшают городской ландшафт, но и предлагают всем любителям природы окунуться в незабываемое приключение. Существуют различные маршруты и множество мест, которые можно посетить пешком, на велосипеде, на машине, на верблюде, а также маршруты для скалолазов и любителей экстремального спорта.</p>
									<p>Не откладывайте. Посетите Эйлат. Спешите на встречу с солнцем.</p>



		                        `,
      };
    },
  },
  {
    id: "The_Ultimate_Holiday",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev3/1.jpg",
    mobBgImage: "/posts/bank/negev3/M.jpg",
    isVid: false,
    title: "ПРЕКРАСНЫЙ ОТПУСК В СОЛНЕЧНОМ ЭЙЛАТЕ",
    smltitle: "",
    html: function() {
      return {
        __html: `
							    <p><strong>Эйлат - </strong>это город на самом юге Израиля, и здесь есть все для прекрасного отпуска. Независимо от того, стремитесь ли вы к романтическому уединению, хотите ли провести отпуск со своей семьей, ищете ли вы приключения или просто хотите оторваться по полной с друзьями - этот оживленный курортный город на берегу Красного моря то, что вам нужно. Солнце, кристально чистая вода, спа, яркая ночная жизнь, выгодный шоппинг и множество достопримечательностей - это все Эйлат.&nbsp;</p>
								<p><strong>Солнце, солнце и еще раз солнце. </strong>Летнее солнце греет круглый год, а лучшее время для посещения Эйлата - любое!&nbsp; Когда в Европе царствует зима, именно в Эйлате можно укрыться от холода. Если вы дрожите от холода, просто сядьте в самолет, и через несколько часов вы почувствуете, как снова оживаете.</p>
								<p><strong>Выберите свой дом для отпуска.&nbsp; </strong>Хостелы и бюджетные гостиницы или роскошные отели мирового класса и бутик-апартаменты.&nbsp; В Эйлате множество вариантов для размещения, подходящих для любого бюджета и потребностей. Здесь можно отдохнуть в кругу семьи, есть места для размещения туристических групп или для проведения романтического отдыха.&nbsp;</p>
								<p><strong>Прыгайте в воду.</strong> Эйлат расположен на берегу Красного моря, поэтому здесь много возможностей для занятий водными видами спорта.&nbsp; Сноркелинг, скуба-дайвинг, виндсерфинг, кайт-серфинг, парусный спорт и многое другое - в этом городе найдется развлечение для любого отдыхающего.</p>
								<div class="img-wrapper">
																	   <img src=${getImgUrl() +
                                       "/posts/the-ultimate-holiday/1.jpg"} class="img-responsive">
																	</div>
								<p>Посетите <strong>Дельфиний риф</strong>, где можно наблюдать за дельфинами, прикасаться к ним, плавать и нырять в компании с этими замечательными животными. <em>(Не волнуйтесь, эти прекрасные создания сами не против того, чтобы пообщаться с вами).</em></p>
								<p>Побывайте в <strong>Подводной Обсерватории</strong>, одной из самых популярных достопримечательностей Эйлата, где вы и ваша семья могут наблюдать и изучать уникальную жизнь обитателей Красного моря.&nbsp; Через огромные стеклянные окна вы увидите акул, черепах, скатов и разноцветных рыб Красного моря. Совершив морскую прогулку на корабле со стеклянным дном, вы почувствуете себя частью этого волшебного подводного царства.&nbsp;</p>
								<p>Не пропустите всемирно известный <strong>природный заповедник Корал-Бич</strong> с потрясающим коралловым рифом. Занимаясь сноркелингом и скуба-дайвингом, вы сможете увидеть красочных рыбок и необычные водные растения в их естественной среде обитания.</p>
								<p><strong>Приключение в пустыне. </strong>В пустыне Негев проложен один из самых живописных маршрутов в Израиле. Совершите поход пешком или на велосипеде или закажите поездку на джипе, исследуйте красоту окружающей вас природы.&nbsp;</p>
								<p>Всего в 25 км к северу от Эйлата находится <strong>Парк Тимна.</strong> Совершите тур в эту долину, вас ждут великолепные пейзажи и особые древности, медные шахты, получившие название «Копи царя Соломона». Здесь множество развлечений, рассчитанных как на семьи, так и на любителей приключений.</p>
								<p>Хотите разнообразить свое путешествие? Из Эйлата можно легко добраться до любого уголка Израиля. Например, вы можете совершить однодневную поездку на Мертвое море или в Иерусалим.</p>

								<p><strong>Шоппинг, гастрономия и вечеринки<em>.</em> </strong>Совершайте покупки на рынке, что протянулся вдоль городского променада, в роскошных торговых центрах&nbsp; на бульваре и в многочисленных моллах - и все это без НДС!</p>
								<p><strong>Ночная жизнь в городе. </strong>Не пропустите удивительное красочное шоу музыкального фонтана, а также шоу в бродвейском стиле, в котором сочетаются танцы, акробатические и световые эффекты и музыка. Поужинайте в одном из многочисленных ресторанов и баров в городе, а затем отправляйтесь в клуб на танцпол. Лучше не придумаешь.</p>
							  


		                        `,
      };
    },
  },
  // {
  // 		id:"Eilat_Calling",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"ZdnNT-GDJv4",
  //         title : "365 DAYS OF NONSTOP SUNNY JOY",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `

  // 							<p>Incredible adventure in Israel’s no. 1 vacation resort by the red sea.</p>
  // 							<p>The capital of the red sea, Eilat is Israel's famous resort city drawing nearly 2.8 million visitors a year who come to vacation by the shores of the stunning red sea.</p>
  // 							<p>The southernmost city in Israel, Eilat is renowned for its spectacular combination of the surrounding desert landscape, the beautiful bay and the summer sun that shines all year round.</p>
  // 							<p>A visit to Eilat is a fun-filled experience where you get to relax, recharge and get energized all at the same time. Eilat boasts a whopping 360 sunny days a year, making it extremely popular with tourists from far and wide looking to get away from their cold winter climate.</p>
  // 							<p>This lively resort city offers a multitude of year-round activities and attractions, excellent restaurants and cafés, shopping centers and trendy bars and clubs.</p>
  // 									                        `
  //     }
  //   }
  // },
  {
    id: "Eilat_Doolphin_Reef",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev2/1.jpg",
    mobBgImage: "/posts/bank/negev2/M.jpg",
    isVid: true,
    vidId: "3Cvz8GoxNzA",
    title: "ДЕЛЬФИНИЙ РИФ В ЭЙЛАТЕ",
    smltitle: "",
    html: function() {
      return {
        __html: `
                              
							   
							   <br/><h2 class="ac-align-center ac-margin-top-20">Незабываемая встреча с дикой природой</h2>
							   <p  class="ac-align-center ac-margin-bottom-20"><strong>Подружитесь с дельфинами в уникальном морском заповеднике Эйлата</strong></p>
								<p>Дельфиний риф в Эйлате — это неповторимый заповедник на берегу Красного моря, где вас ждут как увлекательные приключения, так и умиротворяющая красота дикой природы. Вы словно попадаете в волшебный мир, где можно понаблюдать за дельфинами в естественной среде их обитания; вас ждут берег невероятной красоты, полный цветущих растений, и захватывающие виды.</p>
								<p>Длинный пирс служит прекрасной точкой наблюдения за жизнью дельфинов. Вы сможете увидеть, как они едят, играют, охотятся и общаются друг с другом — а иногда решаются на контакт и с гостями рифа. Посетители, желающие познакомиться с дельфинами поближе, могут пообщаться с ними в рамках различных аттракционов, открытых для широкой публики.</p>
								<p>Изумительное зрелище — кормление дельфинов. Оно всегда происходит по расписанию и выглядит очень увлекательно. Есть нечто завораживающее в том, как весело и совсем по-детски дельфины играют со своими дрессировщиками, с нетерпением ожидая еды. Искренняя радость дельфина, получившего наконец свою порцию, всегда вызывает восторженные аплодисменты посетителей. Забавно, что последние при этом выглядят такими веселыми и довольными, словно покормили их самих, а не дельфинов…</p>
                                <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/eilat-doolphin-reef/1.jpg"} class="img-responsive">
									</div>
								<p>Одна из очаровательных особенностей Дельфиньего рифа — гости могут не только понаблюдать за дельфинами издалека, но и присоединиться к ним, нырнув на 6-метровую глубину и воочию увидев жизнь дельфинов в естественной среде обитания, на морской глубине. Используя маску с трубкой, также можно поплавать с дельфинами поближе к поверхности воды, пообщаться и поиграть с ними.</p>
								<p>«Расслабляющие бассейны» Дельфиньего рифа — это место, где, нежась в воде под звуки расслабляющей музыки, можно хотя бы на время забыть все свои тревоги и заботы. Кафетерии, расположенные тут же, позволяют насладиться вкусной едой и прекрасным обслуживанием прямо на лоне природы, не покидая территории заповедника.</p>

		                        `,
      };
    },
  },
  // {
  // 		id:"Action_Packed_Eilat",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:false,
  //         title : "ACTION PACKED EILAT",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                              <p>So, you’ve heard about the fabulous beaches, the awesome nightlife and fantastic atmosphere of year round sunny Eilat, but aren’t you wondering, amongst all the leisure, what to do with the excess energy? Well wonder no more. Here are just some of the amazing ways to have some action-packed fun in the sun:</p>

  //                                  <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/action-packed-eilat/1.jpg"} class="img-responsive">
  // 							</div>
  // 						   <p>Eilat’s stunning red sea offers loads of fantastic adventures. For one, its gorgeous underwater environment is known as a world-famous <b>scuba diving destination</b>. Not a pro? No problem. There are short courses that run for 1-2 days.</p>
  // 						   <p>Atop the waves, you’ll find, <b>windsurfing</b>, <b>kitesurfing</b>, and <b>stand-up paddle boarding</b> options for which it’s always an ideal time in Eilat, with its pristine beaches, calm waters, and perfect sunny weather almost year-round. By the way, don’t worry about equipment or experience, as there are plenty of options for rentals and individual or group lessons for all ages as well as all-inclusive packages. You’ll be flying across the sea in no time!</p>
  // 						   <p>Looking to flex a few more muscles? Eilat’s nearby desert area offers <b>fantastic hikes</b> in stunning trails where you can <b>walk or bike</b> through breathtaking desert scenery.<span class="Apple-converted-space">&nbsp; </span>Feeling adventurous? Check out the huge array of unique action attractions from unforgettable camel rides to <b>adrenaline charged ATV rides</b> to thrilling off cliff <b>paragliding,</b> guaranteed to get the heart racing.</p>
  // 						   <p>If your holidays are all about breathtaking adventures, Eilat is definitely the place for you!</p>

  //                         `
  //     }
  //   }
  // },
  {
    id: "Eilat_Ultimate_Beachside",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/eilat1/1.jpg",
    mobBgImage: "/posts/bank/eilat1/M.jpg",
    isVid: true,
    vidId: "ZdnNT-GDJv4",
    title: "ЗАДЕРЖАТЬ ВДОХ И НЫРНУТЬ",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                   <br/>
                                   <h2 class="ac-align-center ac-margin-top-20">Мир водных аттракционов Эйлата</h2>
								   
								   
									<p class="ac-align-center ac-margin-bottom-20"><strong>Водные аттракционы Эйлата — лекарство от скуки и повседневности</strong></p>
									<p>Окруженный морем Эйлат — самый южный город Израиля и центр увлекательнейших водных развлечений, которому нет равных в стране. Эйлат может похвастаться изумительными пляжами, разнообразными развлечениями и аттракционами, а также множеством центров водных видов спорта, которые открыты для посетителей круглый год благодаря местному теплому климату.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/eilat-ultimate-beachside/1.jpg"} class="img-responsive">
									</div>
									<p>Пройдитесь босиком по берегу чистейшего бирюзового моря, протянувшемуся на 12 километров. Песчаные пляжи перемежаются здесь с дощатыми настилами, современными гостиницами и аттракционами. Уединитесь на любом из тихих южных пляжей и поплавайте вокруг коралловых рифов, или же насладитесь оживленной атмосферой на одном из северных пляжей, где гостиницы, рестораны и магазины всегда заполнены веселой публикой. Вы можете также прокатиться на яхте, забыв обо всех делах и заботах, и скользить по волнам под теплыми солнечными лучами, наслаждаясь жизнью.</p>
									<p>Изучите уникальную флору и фауну эйлатского заповедника «Коралловый берег». Поплавайте с маской и трубкой и понаблюдайте за морскими жителями прямо под водой, в естественной среде их обитания.</p>
									<p>Эйлат — израильский центр экстремальных водных развлечений. Ощутите дуновение ветра в волосах и лучи солнца на лице, скользя с невероятной скоростью на водных лыжах, гидроцикле или надувном «банане», привязанном к моторной лодке, на доске виндсёрфинга или от катания на лодке с прозрачным дном. Предпочитаете держаться над водой? Тогда полюбуйтесь Эйлатским заливом с высоты во время полета на параплане.</p>
									<p>Вы любите дикую природу? Поплавайте вместе с дельфинами на Дельфиньем рифе. Уникальная экологическая зона, расположенная на необыкновенно красивом берегу, позволяет посетителям понаблюдать вблизи за жизнью дельфинов. Хотите побывать под водой и при этом не намокнуть? Посетите эйлатскую Подводную обсерваторию, где можно понаблюдать за жизнью подводных жителей, поучаствовать в различных мероприятиях и увидеть особые экспозиции.</p>

		                        `,
      };
    },
  },
  {
    id: "One_Day_In_Eilat",
    ctg: "eilat-negev",
    bgImage: "/HomeSlider/desktop/4.jpg",
    mobBgImage: "/HomeSlider/M/3.jpg",
    isVid: false,
    title: "ONE DAY IN EILAT",
    smltitle: "",
    html: function() {
      return {
        __html: `
                              
								   <p><b>Suggestions for an awesome day in the sun</b></p>
								   <p>Whether you’re staying in one of the city’s 5 star hotels, a hostel or have opted for the cool camping alternative, we recommend to start your day with a delicious breakfast and make your way to the <b>Dolphin Reef</b>. This is one of the most popular attractions in Eilat, where you can touch, swim and dive with these beautiful creatures. Watch the dolphins in their natural habitat, visit the underwater photo center, or take part in either scuba diving or snorkeling. Check out also <b>Coral Beach</b>, the natural underwater reserve that extends for 1,200 meters along the coast and gives you the opportunity to go snorkeling with an extraordinary variety of tropical fish in a beautiful coral reef.</p>
								   <div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/one-day-in-eilat/1.jpg"} class="img-responsive">
									</div>
								
								   <p>Once you’ve dried off, head to the stunning <b>Botanical Gardens</b> within Eilat. You’ll find there more than 1,000 types of trees and plants from all around the world, streams, waterfalls, a rainforest and bird sanctuaries.</p>
								   <p>To end of your day with something slightly different, head just outside of Eilat to the <b>Red Canyon,</b> where you can track through the riverbed and between the red Nubian sandstone walls that have been sculpted over the centuries by wind and water.</p>
								   <p>When evening comes, make your way to the buzzing Eilat promenade ,stroll by the shops and market stands which are open until late. You can treat yourself to a meal in any of the dozens of the excellent restaurants and cafés or a drink in any of the lively seaside pubs and bars.</p>
								  
		                        `,
      };
    },
  },

  {
    id: "Negev_Description",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev1/1.jpg",
    mobBgImage: "/posts/bank/negev1/M.jpg",
    isVid: false,
    title: "НЕГЕВ ПОБЕГ В ПУСТЫНЮ",
    smltitle: "",
    html: function() {
      return {
        __html: `
                              
								   <p>Нет другого такого места, как Негев, где можно было бы так спокойно и увлекательно отдохнуть под солнцем пустыни</p>
									<div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/negev-description/1.jpg"} class="img-responsive">
									</div>
									<p>Израильская пустыня Негев - потрясающее место, которое обязательно стоит посетить. Она занимает более половины общей площади страны, в этом регионе много не только песка и солнца, но также и природных парков, и туристических достопримечательностей, вы обязательно должны посетить этот южный регион, когда будете снова в Израиле и увидеть эту израильскую пустыню под ночным звездным небом.</p>
									
								      Отдых в окружении удивительных чудес природы</b>
									</p>
									<p>Отправляйтесь на юг Израиля в пустыню Негев, царство песка и солнца, регион, в котором проложены пешеходные маршруты, где перед вами откроются захватывающие дух виды, посетите исторические и туристические достопримечательности. Вы можете выбрать тот вид активного отдыха, который соответствует именно вашим интересам, вы можете пообщаться с местными жителями, повстречать на своем пути величественных животных, познакомиться с древними культурами. Посетите кратер Рамон, видом которого можно любоваться бесконечно долго. Если вы захватили с собой коврик для занятий йогой, разверните его и расположитесь на нём, или же сядьте прямо на красочный песок, отключитесь, расслабьтесь и погрузитесь в интенсивную медитацию.&nbsp; Когда солнце уходит за горизонт и на небе загораются звезды, отправляйтесь в бедуинский центр гостеприимства, где гостей угощают, как королей: восхитительные угощения, занятные поездки на верблюдах и возможность провести ночь в лагере посреди пустыни. Или отправьтесь в путешествие по маршруту, которым когда-то доставляли благовония, посетите четыре города, которые когда-то процветали благодаря торговле пряностями, а теперь являются объектами всемирного наследия.</span></p>
									<div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/negev-description/2.jpg"} class="img-responsive">
									</div>
									<p><b>Когда дело доходит до семейного отдыха, небо пустыни - это предел</b></p>
									<p>В израильской пустыне можно отлично провести время, здесь вас встретят тепло и радушно, и, если вы путешествуете семьей, то ни одна из ваших потребностей не останется неудовлетворенной - вдоль маршрутов расположено много современных отелей и необычных гостевых домов. В пустыне Негев много удивительных мест и много возможностей для активного отдыха, здесь можно хорошо отдохнуть; походы в национальные парки, езда на велосипеде по специально проложенным дорожкам или поход по дюнам, сопряженный со спусками и подъемами.&nbsp; Пустыня большая и скалистая, вас ждут трудности и приключения, независимо от того, какой вид активного отдыха вы выберете. Если вы предпочитаете провести свой отпуск в более спокойной обстановке, тогда вы можете побывать на винодельческом предприятии в Негеве, посмотреть на источник в сердце израильской пустыни, из которого вытекает кристально чистая вода, или отправиться в тур по южной ферме, чтобы попробовать соки местного производства. Путешествуя по пустыне Негев, вы можете поехать и немного дальше, к Мертвому морю, чтобы поплавать в его соленых водах, очистить кожу, принимая ванны из бархатистой целебной грязи.</span></p>
											                        `,
      };
    },
  },
  {
    id: "Majestic_Desert",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev2/1.jpg",
    mobBgImage: "/posts/bank/negev2/M.jpg",
    isVid: false,
    title: "НЕГЕВ",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                   <div class="responisve-iframe">
							           <iframe width="560" height="315" src="https://www.youtube.com/embed/yXzhH92kREg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
						           </div>
                                   <br/>
						           <h2 class="ac-align-center ac-margin-top-20">Величественная израильская пустыня — вдохновляющее путешествие</h2>
								
								   






									<p class="ac-align-center ac-margin-bottom-20"><strong>Идеальная цель для любителей приключений под открытым небом, юг израиля мало населен, но полон интереснейших мест и увлекательных развлечений</strong></p>
									<div class="img-wrapper">
												<img src=${getImgUrl() + "/posts/majestic-desert/1.jpg"} class="img-responsive">
												Автор фотографии: Daphna Tal
									</div>
									<p>Юг Израиля может похвастаться неповторимыми чудесами природы и видами, от которых у вас закружится голова.<br/>
									Несмотря на то что вы находитесь в пустыне, в Негеве вы не ощутите пустоты — здесь есть на что посмотреть и чем заняться. Вас ждет множество геологических чудес, исторических достопримечательностей и прекрасных заповедников, где Вы сможете совершить пешую прогулку, покататься на велосипеде или на верблюде, или же принять участие в захватывающей дух поездке на джипе.</p>
									<p>Попросту говоря, этот чудесный южный регион — одно из величайших богатств страны и обязательный пункт остановки во время вашего путешествия.</p>
									<p><strong>Кратер Рамон</strong></p>
									<p>В центре пустыни Негев находится кратер Рамон, один из крупнейших эрозионных кратеров в мире, известный также как «Махтеш Рамон». Состоящий из горных пород самых фантастических цветов и причудливых форм, этот завораживающий природный феномен протянулся на 40 километров. Его ширина варьируется от 2 до 10 километров, а по форме кратер напоминает удлиненное сердце. Кратер является крупнейшим национальным парком Израиля, носящим название «Заповедник Рамон».</p>
									<p>Расположенный вдали от городских огней и шумных толп, кратер Рамон с его разноцветным песчаником, вулканическим породами и окаменелостями часто называют местным израильским Гранд Каньоном. С точки обзора Махтеш Рамон, расположенной на 300-метровой высоте, открывается захватывающая панорама, напоминающая голливудские декорации. Гости со всего мира приезжают сюда круглый год, чтобы испытать самые невероятные эмоции.&nbsp;</p>
								
									<p><strong>Сде-Бокер</strong></p>
									<p>Сде-Бокер — кибуц, основанный первыми поселенцами в пустыне Негев в начале 1950-х годов, — дает уникальную возможность заглянуть в историю государства Израиль.</p>
									<p>Он известен как место жительства первого премьер-министра Израиля Давида Бен-Гуриона. В кибуце сохранился дом-музей политика, открытый для широкой публики.</p>
									<p><strong>Видор Центр</strong></p>
									<p>В этом уникальном месте можно узнать все о необыкновенной природе пустыни Арава. Посетителям расскажут о самых современных методах земледелия, о местной флоре и фауне, климатических проблемах, особенностях почвы и воды в пустыне.</p>
									<p><strong>Неватим</strong></p>
									<p>Побывать в поселении кочинских евреев — редкий шанс для туристов. Кочинские евреи исторически проживали в Индии, но иммигрировали в Израиль после создания независимого государства. Они считают себя одной из старейших еврейских общин в мире.</p>
									<p>Центр кочинского наследия в мошаве Неватим рассказывает историю этой уникальной общины.</p>
									<p><strong>Kоролевы </strong><strong>кулинарии из Йерухама</strong></p>
									<p>Чтобы увезти с собой действительно незабываемые воспоминания, обязательно загляните к «Королевам кулинарии из Йерухама». Это уникальный проект, в рамках которого замечательные женщины из городка Йерухам приглашают туристов к себе домой на традиционное угощение — настоящий фейерверк ароматов, цвета и вкуса.</p>
									<p>Послушайте захватывающие истории местных жителей и узнайте лучше их образ жизни, наслаждаясь национальными деликатесами и несравненным гостеприимством.</p>
									<p><strong>Научный парк Карассо</strong></p>
									<p>Словно гость из будущего в Старом городе, парк Карассо, раскинувшийся на площади 4,25 гектара, является крупнейшим научным парком Израиля.</p>
									<p>Детей и взрослых ждет множество интересных залов, включая интерактивный музей и научный сад с играми и практическими занятиями. Десять интерактивных выставок познакомят посетителей с разными научными дисциплинами, в том числе генетикой, телекоммуникациями, микроэлектроникой, ядерной энергетикой и так далее.</p>
									<h2 class="ac-margin-bottom-20 ac-margin-top-20">Парк Тимна</h2>
									<div class="responisve-iframe">
							           <iframe width="560" height="315" src="https://www.youtube.com/embed/QL3BGy2p77g" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
						           </div>
									<p>Парк Тимна, раскинувшийся на более чем 6000 гектаров в подковообразной долине, окруженной отвесными скалами, — ландшафт редкостной красоты и настоящий подарок любителям пеших походов. Вы увидите здесь удивительные нерукотворные пейзажи и богатую пустынную флору и фауну, приспособленную к выживанию в суровых условиях.</p>
									<p>Множество достопримечательностей, цветные пески и скалистый рельеф Тимны притягивают туристов подобно магниту.</p>
									 
									
									<p><strong>В гостях</strong>&nbsp;<strong>у бедуинов</strong></p>
									<p>Бедуинское гостеприимство не знает равных и станет для вас приятным и познавательным опытом.</p>
									
									<p>Израильские бедуины — это кочевники, живущие в регионе многие сотни лет. Они продолжают вести традиционный образ жизни, открывая свои сердца и дома для гостей и делясь с ними обычаями и известным всему миру гостеприимством.</p>
									<p>Вы сможете покататься на верблюде, отведать традиционную еду и даже переночевать в бедуинском шатре — это очень популярные туристические развлечения в регионе и прекрасная возможность познакомиться с давно забытым кочевым образом жизни.</p>
									<p><strong>Старый город Беэр-Шевы </strong></p>
									<p>Беэр-Шева, основанная, как считается, самим праотцом Авраамом, — один из древнейших городов страны, свидетельства оседлой жизни здесь насчитывают тысячи лет. Чарующий и богатый историческими достопримечательностями Старый город Беэр-Шевы откроет перед вами неповторимую мозаику городских пейзажей. Прогулка по Старому городу подарит знакомство с уникальной архитектурой, уходящей в глубь веков историей, и легендами, древними, как само время.</p>
									<p><strong>Арад</strong></p>
									<p>Арад нового тысячелетия — город с молодой душой, но богатым опытом. Арад и его окрестности встретят вас прекрасными ландшафтами, умиротворением пустыни и множеством пешеходных тропинок, которые подойдут людям любого возраста и для любого типа прогулки. Гуляя по ним, вы сможете увидеть нетронутые пустынные уголки.</p>
									<p>В Араде множество развлечений и интересных туристических объектов, это идеальные природные ворота для начала вашего путешествия по пустыне.</p>
									<div class="img-wrapper">
										<img src=${getImgUrl() + "/posts/majestic-desert/2.jpg"} class="img-responsive">
									</div>
									<p><strong>Природа</strong></p>
									<p><strong>Хай-Бар Йотвата</strong></p>
									<p>Заповедник Хай-Бар Йотвата — крупнейший в регионе центр разведения и восстановления популяции животных, которых потом выпускают на волю. Заповедник может похвастаться чудесными развлечениями для любителей животных, включая центр хищных зверей, где живут хищники и мелкие пустынные животные; ночную обсерваторию животных и территорию площадью 12 кв. км, где обитают большие популяции грызунов.</p>
									
									
									<p><strong>Экстремальные приключения</strong></p>
									<p>Юг Израиля — рай для любителей экстрима. Его уникальный и сложный ландшафт идеален для различных экстремальных видов спорта, включая дюльфер (скоростной спуск на веревке с отвесных скал), популярное в регионе катание на горном велосипеде и поездки на джипах по пустыне, любимые как местными жителями, так и туристами.</p>
                                   

		                        `,
      };
    },
  },
  // {
  // 		id:"Negev1",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"yXzhH92kREg",
  //         title : "NEGEV",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                              <p>The Israeli desert with its breathtaking landscape and various attractions is offering the perfect place for a holiday. The Negev invites the visitors to an exciting journey that is rich in variety of opportunities.</p>
  // 					   <p>Israel is a small country with 62% of the total area occupied by the Negev desert. The reddish gleaming desert terrain is characterized by many impressive geological rock formations. The visitors enjoy here a unique view of an untouched vastness - silent and majestic.</p>
  // 					   <p>There are traces of past civilizations and their agriculture as well as archaeological sites. The Negev offers an unmistakable backdrop for encountering the Bedouin tribes - people of the desert.</p>
  // 					   <div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/negev/1.jpg"} class="img-responsive">
  // 							</div>

  // 					   <p><strong>The Israeli desert is special for the following reasons:</strong></p>
  // 					   <ul>
  // 					      <li><strong>The desert is very near:</strong>&nbsp;just 4 hours of flying from Europe. Israel has two international airports - Ben Gurion and Ovda, which guarantee a short trip to the desert to all travellers (half an hour to an hour and a half). Starting from November, there will be direct flights from Europe and Russia to Ovda airport including&nbsp;Ryanair, Wizzair, and SAS.</li>
  // 					      <li><strong>Easy to Hike and Bike:</strong>&nbsp;There are a lot of marked paths. Israel offers the most imposing hiking trails of the world and hundreds of safe paths lead through the Israeli desert.</li>
  // 					      <li><strong>Cordial local population:</strong>&nbsp;The desert dwellers are friendly and hospitable and make the desert experience both pleasant and exciting for visitors.</li>
  // 					      <li><strong>Tourists Activities:</strong>&nbsp;Along with the development of accommodation, the huge offer of tourist activities has converted the Negev in a popular, interesting, versatile and creative destination in recent years.</li>
  // 					      <li>
  // 					         <strong>Magnificent landscapes:</strong>&nbsp;Lots of tourists today, enjoy the charm of the Negev with its landscapes rich in variety
  // 					         <ul>
  // 					            <li>There are spectacular sand dunes in the north.</li>
  // 					            <li>The Ramon Crater is present in the middle with its bold cliffs and seasonal water sources.</li>
  // 					            <li>In the east, one experiences the African desert with wide savannas and acacia trees.</li>
  // 					            <li>To the south, one finds red and black granite, contrasted by sandstone foothills having a powerfully pleasant colour.</li>
  // 					         </ul>
  // 					         <p>During a desert trip of approx. 3 hours, you can get to know the entire spectrum of the desert landscape and enjoy its variety, which one experiences in other deserts often only with a long trip of several kilometers. Many tourists decide for to stay for 2 or 3 days in each region of the Negev.</p>
  // 					      </li>
  // 					      <li><strong>The Negev is very safe to travel.</strong>&nbsp;In case of emergency, the rescue units working in the area are some of the best trained in the world and are always close by. Should anyone require medical assistance, Israel offers high quality, first class advanced western medical services.</li>
  // 					   </ul>
  // 					   <div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/negev/2.jpg"} class="img-responsive">
  // 							</div>

  //                         `
  //     }
  //   }
  // },
  // {
  // 		id:"Location_And_Approach",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"5AAqIhkq_tQ",
  //         title : "NEGEV – LOCATION AND APPROACH",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `

  // 						   <p>Landing at the airports of Ovda or Eilat with the onward journey to Mitzpe Ramon or Sde Boker:</p>
  // 						   <p><strong>Public means of transportation:</strong></p>
  // 						   <p>Bus 392 from Eilat to Mitzpe Ramon and Be'erSheva, stops at the airport of Ovda on Sunday at 07:13, 08:41, 09:43, 14:12, 15:41, 17:43.</p>
  // 						   <p>Arrival at the central bus station of Mitzpe Ramon after about an hour and a half.</p>
  // 						   <p>Mondays - Thursdays at 07:13, 07:41, 09:43, 14:12, 15:41, 17:43.</p>
  // 						   <p><strong>Car rental in Eilat, Mitzpe Ramon and Be'erSheva:</strong></p>
  // 						   <p>There a multiple option in renting a car in these cities. There is a choice of international and Israeli companies.</p>
  // 						   <p>Landing at the Ben Gurion International Airport near Tel Aviv and onward journey for Negev to Mashabei Sadeh / Sde Boker / Mitzpe Ramon</p>
  // 						   <p><strong>Public means of transportation:</strong></p>
  // 						   <p>Bus routes 370/380 from Tel Aviv to Be'erSheva, routes 446/470 from Jerusalem to Be'erSheva.Train from Ben Gurion or Tel Aviv to Be'erSheva.</p>
  // 						   <p>From Be'erSheva bus routes 60, 64, 65, 660 Departure every morning 6 o'clock onward (approx. every 20 minutes). Arrival in Mashabei Sadeh in 35 minutes / SdeBoker area in 55 minutes / Mitzpe Ramon in 1 hour 20 minutes.</p>
  // 						   <p><strong>NEGEV ROAD DISTANCES</strong></p>
  // 						   <table>
  // 						      <tbody>
  // 						         <tr>
  // 						            <th></th>
  // 						            <th>Tel Aviv</th>
  // 						            <th>Jerusalem</th>
  // 						            <th>Bee'r Sheva</th>
  // 						            <th>Eilat</th>
  // 						         </tr>
  // 						         <tr>
  // 						            <td><strong>Old Town&nbsp;Beer Sheva</strong></td>
  // 						            <td>113 Km</td>
  // 						            <td>122 Km</td>
  // 						            <td></td>
  // 						            <td>232 Km</td>
  // 						         </tr>
  // 						         <tr>
  // 						            <td><strong>Tel Arad</strong></td>
  // 						            <td>134 Km</td>
  // 						            <td>144 Km</td>
  // 						            <td>40 Km</td>
  // 						            <td>229 Km</td>
  // 						         </tr>
  // 						         <tr>
  // 						            <td><strong>Ben-Gurion's House&nbsp;in Sde Boker</strong></td>
  // 						            <td>162 Km</td>
  // 						            <td>171 Km</td>
  // 						            <td>49 Km</td>
  // 						            <td>185 Km</td>
  // 						         </tr>
  // 						         <tr>
  // 						            <td><strong>Ramon Crater</strong></td>
  // 						            <td>210 Km</td>
  // 						            <td>192 Km</td>
  // 						            <td>97 Km</td>
  // 						            <td>141 Km</td>
  // 						         </tr>
  // 						         <tr>
  // 						            <td><strong>Hai Bar Wildlife&nbsp;reserve Yotvata</strong></td>
  // 						            <td>323 Km</td>
  // 						            <td>288 Km</td>
  // 						            <td>202 Km</td>
  // 						            <td>35 Km</td>
  // 						         </tr>
  // 						         <tr>
  // 						            <td><strong>Timna Park</strong></td>
  // 						            <td>330 Km</td>
  // 						            <td>294 Km</td>
  // 						            <td>208 Km</td>
  // 						            <td>30 Km</td>
  // 						         </tr>
  // 						      </tbody>
  // 						   </table>
  // 						   <p><strong>NEGEV DESERT - DON'T MISS</strong></p>
  // 						   <p><strong>Ramon Crater</strong></p>
  //                                  <p>At the heart of Israel’s vast Negev Desert, lies the Ramon Crater, the world’s largest erosion crater,also known as Machtesh Ramon. Encompassing a vast diversity of rocks of fantastic colors and forms, this mesmerizing natural phenomenon measures 40km in length and between 2 and 10km in width, shaped like an longated heart, and forms Israel’s largest national park, the Ramon Nature Reserve. Far from the city lights and crowds, featuring multicolored sandstone, volcanic rock and fossils, the Ramon Crater is often described as Israel’s very own Grand Canyon. The truly stunning views from the 300m edge lookout point of Machtesh Ramon, reminiscent of a Hollywood backdrop offer a powerful experience for tourists from all over the world, all year round.</p>
  //                                   <div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/location-and-approach/1.jpg"} class="img-responsive">
  // 										Credit: Daphna Tal
  // 							</div>
  // 							<p><strong>Timna Park</strong></p>
  //                                   <p>15,000 acres in a horseshoeshaped valley surrounded by steep cliffs, Timna Park is an extraordinarily stunning experience and an absolute treat for hiking enthusiasts. Here you'll witness the marvelous works of nature, as well as the amazing wildlife, plants and trees which make the desert their home, surviving in the harsh arid conditions. With its multitude of attractions, colorful sands and craggy mountains, Timna Park is an incomparable visitor magnet.</p>
  //                             <div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/location-and-approach/2.jpg"} class="img-responsive">
  // 										Credit: Daphna Tal
  // 							</div>
  // 							<h3>Timna Park - An Exhilarating Desert Adventure</h3>
  // 							<div class="responisve-iframe">
  // 					           <iframe width="560" height="315" src="https://www.youtube.com/embed/i_4QKtXIeto" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  // 				           </div>
  // 				           <p><strong>Sandboarding in the desert</strong></p>
  //                                  <p>An iconic desert experience. The plush sweeping sand dunes of the Negev desert allow you to glide down sitting down or standing up at an exhilarating pace. This is a fantastic and very special skill, which once you master (it’s really very easy) you can call yourself a genuine sand surfer – how cool is that?</p>
  //                                   <div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/location-and-approach/3.jpg"} class="img-responsive">
  // 							</div>
  // 							<div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/location-and-approach/4.jpg"} class="img-responsive">
  // 							</div>
  // 							<p><strong>Negev at night</strong></p>

  //                                   <p>The sky of the Negev at night is a mesmerizing sight. Simply look up once darkness sets and you will immediately be struck by the splendor of millions of twinkling stars, lighting up the blue-black darkness in a radiance that can only be seen in the dessert.</p>
  //                            <div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/location-and-approach/5.jpg"} class="img-responsive">
  // 							</div>
  // 							<p><strong>Sunrise at Masada</strong></p>

  //                                   <p>Available only to those brave enough to climb atop by foot - watching the Sunrise at Masada is undoubtedly one of the most unforgettable experiences to be had in Israel. The slow rise of the sun as it emerges over the Jordanian Moab Mountains and the Dead Sea, shedding its light on the surrounding desert landscapes, is a truly spectacular sight, one which you will not soon forget.</p>

  //                         `
  //     }
  //   }
  // },
  {
    id: "Stay_In_The_Negev",
    ctg: "eilat-negev",
    bgImage: "/HomeSlider/desktop/4.jpg",
    mobBgImage: "/HomeSlider/M/3.jpg",
    isVid: false,
    title: "STAY IN THE NEGEV",
    smltitle: "",
    html: function() {
      return {
        __html: `<p> A trip to the Negev offers so much more than just grand vistas and tranquil surroundings one tends to think about when conjuring up the word desert. While the Negev still offers all the natural beauty, calmness and wondrous sites, which the desert tourist is looking for, it is also extremely interesting, westernized and packed with activities and adventures and even offers all the comforts of a modern holiday.</p>
                                 <p> The Negev offers a huge variety of accommodation options. So much more than just a place to lay your hat down, the form of accommodation you choose will offer you opportunity to acquaint yourself with the undisputable gem of the Negev - its local community. From the Kibbutz residents to the lone farm dwellers and the local Bedouin folk, you will find the people of the Negev are warm, hospitable and always ready to lend a hand. Here are just a few examples of hospitality options, which can be found in the Negev:</p>
                                 <div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/stay-in-the-negev/1.jpg"} class="img-responsive">
								  </div>

								   <p>Hotels – the Negev has a huge host of hotel options ranging from budget hotels to 5-star international prize-winning luxury hotels, where you can chill in style during your desert break.</p>
								   <p>Hostels – an affordable accommodation geared mostly towards young travelers. Here many tourists enjoy the opportunity to meet and engage with other like-minded travelers from all over the world and spend their evenings socializing and often creating lasting friendships.</p>
								   <p>Zimmers -This is Israel’s version of the Bed and Breakfast, usually separate from the owners’ own home, these are often more secluded and cozy lodgings, suitable for travelers looking for romance and peaceful settings.</p>
								   <p>Bedouin Hospitality tents- the definite Negev must, this truly unique and authentic form of hospitality, which welcomes you into the indigenous Bedouin community’s way of life, affords an exceptional opportunity to take part in the Bedouin traditions in their natural environment – highly recommended.</p>
								   <p>Khans – again, unique to the Negev, the popular Kahns are in fact large outdoors complexes, which offer huts and communal sleep areas as well as all basic facilities. While Kahns are often a more basic and rustic form of accommodation, they are an excellent way to experience the chilled atmosphere of the area, connect with other travelers and locals and feel part of the natural surroundings of the desert.</p>
								   <p>Lone farms – a more recently developed form of accommodation, lone farms are in fact guest rooms in quaint and remote family-run farms throughout the Negev. &nbsp;Combining tranquil settings with home comforts, the lone farms offer privacy, incredible views and an authentic way to experience the awesome desert atmosphere of the Negev.</p>
								   <p>Kibbutz - a distinctly Israeli form of collective communal settlements, Kibbutz accommodations offer good value accommodation at affordable prices. The true appeal of the Kibbutz, however, is their uncountably their special atmosphere and communal spirit, and the residents warm, inviting and hospitable spirit, guaranteeing a pleasant and memorable stay.</p>
								  
		                        `,
      };
    },
  },
  {
    id: "Ha_Arava",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev1/1.jpg",
    mobBgImage: "/posts/bank/negev1/M.jpg",
    isVid: false,
    title: "АРАВА: МЕСТО СЮРПРИЗОВ!",
    smltitle: "",
    html: function() {
      return {
        __html: `

						       <p>Пустыня Арава — небольшой по площади, но необыкновенный участок земли. Пустыня разместилась между перекрестком Менуча на севере и первой кольцевой развязкой Эйлата на юге, ограничена Хар Ханегевом и Эйлатскими горами с запада и Эдомскими горами — с востока. И какое бы путешествие вы ни выбрали: романтическое, семейное или с группой других туристов — здесь вы непременно <em>почувствуете</em> истинный дух пустыни. По пустыне можно передвигаться любым способом: пешком, на велосипеде, автомобиле или автобусе. Вариант проживания можно также подобрать по своему вкусу: от «люкса» и «глэмпинга» до ночевки под открытым небом.&nbsp; Что здесь посмотреть и чем заняться? Вот несколько рекомендаций.</p>
								<p><strong>Национальный парк Тимна</strong></p>
								<p>Контрастное сочетание созданных природой скульптур из красного песчаника и черно-белых валунов представляет собой невероятно эффектное зрелище. А в недавно открытом у входа в парк информационном центре можно получить общие сведения об этом удивительном ландшафте Тимны. Территория изогнутого в форме подковы парка — подлинная сокровищница артефактов разных эпох и прочих интересных объектов. Они позволят получше узнать историю развития древнеегипетских медных шахт, в которых до сих пор не иссякли запасы руды.</p>
								<p>В Тимне разработано более 25 маршрутов для пешеходов, велосипедистов и автомобилей, в том числе такие, как <strong>«Гриб»</strong>, <strong>«Арки»</strong>, <strong>«Соломоновы столбы»</strong>, <strong>«Розовый каньон»</strong>, <strong>«Винтовой холм»</strong> и <strong>«Лица»</strong>. И это еще не все! На территории парка можно увидеть точный макет библейской скинии, в которой израильтяне переносили святыни во время странствий по Синайской пустыне. Кроме того, здесь можно покататься на педальных лодках по озеру, поучаствовать в одном из увлекательных мастер-классов (например, создать композицию из цветного песка в бутылке), взять напрокат велосипед, пожить в оборудованном кемпинге или посетить кафе King Solomon's Inn, чтобы отведать вкусные десерты и приобрести сувениры.</p>
								 <div class="img-wrapper">
											   <img src=${getImgUrl() + "/posts/ha-arava/1.jpg"} class="img-responsive">
								    </div><p><strong>Заповедник Хай-Бар</strong></p>
								<p>Заповедник Хай-Бар был создан с целью разведения животных, упоминаемых в Библии, и их интегрирования в естественную среду обитания. Животных содержат в условиях, максимально приближенных к природным, на открытой для посещения территории. В частности, гостей заповедника приглашают поучаствовать в сафари, во время которого можно посмотреть на ориксов, антилоп мендес и даже страусов (!), свободно гуляющих среди особой флоры пустынь (например, деревьев библейской акации). В магазине заповедника продаются диски с записью экскурсионных туров на разных языках. Также можно посетить экскурсию, которая проходит в субботу в 11 часов утра — время кормления животных! Посетители могут переночевать в кемпинге с удобствами.</p>
								<div class="img-wrapper">
											   <img src=${getImgUrl() + "/posts/ha-arava/2.jpg"} class="img-responsive">
								    </div>
								<p><strong>Ферма специй в Эйлате</strong></p>
								 
								<p>Эта ферма, занимающаяся разведением морских культур, расположена на перекрестке древних путей между Дорогой специй и Морским путем, неподалеку от Эдомских гор. Среди культивируемых здесь видов — морские водоросли, моллюски, креветки артемия, а также ложнохромис Фридмана (названный так по имени обнаружившего его фермера).</p>
								<p>Посещение действующего при ферме магазина — настоящий праздник для всех органов чувств: пленительные ароматы разнообразных специй, кулинарных и лечебных смесей и настоев способны поистине вскружить вам голову. А специально обученные консультанты с удовольствием расскажут о предназначении целых наборов специальной кухонной утвари и принадлежностей.</p>
								<p><strong>Органическое земледелие в кибуце Неот-Смадар</strong></p>
								<p>Приглашаем совершить самостоятельную пешую экскурсию этой коммуне, где вы увидите потрясающее здание центра искусств — его строили 13 лет, ознакомитесь с другими объектами, в которых воплотились наше пристальное внимание к деталям и любовь к простоте. А еще вас ждут органические виноградники и самая южная в Израиле винодельня!</p>
								<p>В центре искусств расположены ремесленные мастерские, а также галерея, где предлагаются работы наших мастеров. Возвышающаяся над центром необычная башня — это водозаборная шахта, охлаждающая все здание по типу обычного кондиционера. Как снаружи, так и внутри члены коммуны украсили центр художественной резьбой по дереву.</p>
								<p><strong>Ночная Арава </strong></p>
								<p>На закате пустыня меняет свой облик: спускающиеся с Эдомских гор сумерки постепенно окрашивают пейзаж во все более темные оттенки красного и фиолетового, и вот уже над Аравой раскинулся усыпанный звездами и залитый лунным светом небосвод. Пришло время отправляться на ночлег... Мы поможем вам выбрать самый подходящий и удобный вариант размещения. Звоните по телефону +972 (8) 661.6976!</p>
																                               
		                        `,
      };
    },
  },
  // {
  // 		id:"Pure_Desert_Magic",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:false,
  //         title : "NEGEV PURE DESERT MAGIC",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  // 				               <p>The Israeli desert with its breathtaking landscape and various attractions is offering the perfect place for a holiday. The Negev invites the visitors to an exciting journey that is rich in variety of opportunities.</p>
  // 							   <p>Israel is a small country with 62% of the total area occupied by the Negev desert. The reddish gleaming desert terrain is characterized by many impressive geological rock formations. The visitors enjoy here a unique view of an untouched vastness - silent and majestic.</p>
  // 							   <p>There are traces of past civilizations and their agriculture as well as archaeological sites. The Negev offers an unmistakable backdrop for encountering the Bedouin tribes - people of the desert.</p>
  // 							   <div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/pure-desert-magic/1.jpg"} class="img-responsive">
  // 						       </div>
  // 						       <p><strong data-mk-aweb-org-font-size="17">The Israeli desert is special for the following reasons</strong>:</p>
  // 							   <ul>
  // 							      <li><strong>The desert is very near</strong>&nbsp;- just 4 hours of flying from Europe. Israel has two international airports - Ben Gurion and Ovda, which guarantee a short trip to the desert to all travellers (half an hour to an hour and a half).</li>
  // 							   </ul>
  // 							   <p>Starting from November, there will be direct flights from Europe and Russia to Ovda airport including&nbsp;<strong>Ryanair</strong>,&nbsp;<strong>Wizzair</strong>, and&nbsp;<strong>SAS</strong>.</p>
  // 							   <p>For further details check the following link:&nbsp;<a href="//www.iaa.gov.il/en-US/airports/ovda/Pages/default.aspx" target="_blank" rel="noopener">www.iaa.gov.il</a></p>
  // 							   <ul>
  // 							      <li><strong>Easy to Hike and Bike</strong>: There are a lot of marked paths. Israel offers the most imposing hiking trails of the world and hundreds of safe paths lead through the Israeli desert. You can find a selection of trails on the following websites:&nbsp;<a href="//www.negevtour.co.il/" target="_blank" rel="noopener">www.negevtour.co.il</a>&nbsp;;&nbsp;<a href="//www.en.aravaway.co.il/" target="_blank" rel="noopener">www.en.aravaway.co.il</a></li>
  // 							      <li><strong>Cordial local population</strong>: The desert dwellers are friendly and hospitable and make the desert experience both pleasant and exciting for visitors.</li>
  // 							      <li><strong>Tourists Activities:</strong>&nbsp;Along with the development of accommodation, the huge offer of tourist activities has converted the Negev in a popular, interesting, versatile and creative destination in recent years.</li>
  // 							      <li>
  // 							         <strong><strong>Magnificent landscapes:&nbsp;Lots of tourists today, enjoy the charm of the Negev with its landscapes rich in variety</strong></strong>
  // 							         <ul>
  // 							            <li>There are spectacular sand dunes in the north.</li>
  // 							            <li>The Ramon Crater is present in the middle with its bold cliffs and seasonal water sources.</li>
  // 							            <li>In the east, one experiences the African desert with wide savannas and acacia trees.</li>
  // 							            <li>To the south, one finds red and black granite, contrasted by sandstone foothills having a powerfully pleasant colour.</li>
  // 							         </ul>
  // 							      </li>
  // 							   </ul>
  // 							   <p>During a desert trip of approx. 3 hours, you can get to know the entire spectrum of the desert landscape and enjoy its variety, which one experiences in other deserts often only with a long trip of several kilometers.</p>
  // 							   <p>Many tourists decide for to stay for 2 or 3 days in each region of the Negev.</p>
  // 							   <ul>
  // 							      <li><strong>The Negev is very safe to travel</strong>. In case of emergency, the rescue units working in the area are some of the best trained in the world and are always close by. Should anyone require medical assistance, Israel offers high quality, first class advanced western medical services.</li>
  // 							   </ul>
  // 							   <p><strong>More information and tips for accommodation and recommendations:</strong></p>
  // 							   <p><a href="//www.negevtour.co.il/" target="_blank" rel="noopener">www.negevtour.co.il</a></p>
  // 							   <p><a href="//www.en.aravaway.co.il/" target="_blank" rel="noopener">www.en.aravaway.co.il</a></p>
  // 									                        `
  //     }
  //   }
  // },
  {
    id: "Action_Fun_In_The_Desert",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev3/1.jpg",
    mobBgImage: "/posts/bank/negev3/M.jpg",
    isVid: true,
    vidId: "yXzhH92kREg",
    title: "АКТИВНЫЙ ОТДЫХ В ИЗРАИЛЬСКОЙ ПУСТЫНЕ",
    smltitle: "",
    html: function() {
      return {
        __html: `

						            <p>Думаете, что в израильской пустыне нечего посмотреть и нечем полюбоваться? Красивые пейзажи, исторические достопримечательности и множество интересных видов отдыха заставят вас навсегда отказаться от этого мнения.</p>
									<p><b>Уникальность пустыни</b></p>
									<p>Израильская пустыня делится на четыре основные части: Мертвое море, горы Эйлата, Негев и Иудейская пустыня. Каждая из этих природных зон обладает особым очарованием. Здесь можно насладиться неземными пейзажами кратера Рамон — его неповторимой гаммой цветов и причудливыми выступами горных пород, или же яркой природной палитрой парка Тимна, вблизи от Эйлата. После спуска на канате с разноцветных скалистых утесов или сложного пешеходного маршрута по пыльным дорогам, что может быть лучше, чем окунуться в прохладный водоем одного из оазисов на берегу Мертвого моря — например, Эйн-Геди. Заночевав в одном из полностью оборудованных кемпингов, вы будете очарованы ночным небосводом, где мерцают мириады звезд. А если посчастливится, вы даже увидите кого-нибудь из пугливых ночных обитателей этих мест!</p>
									<p>Лучшее время для посещения израильской пустыни с ее сухим, суровым климатом — весна, осень и зима. Окунитесь в славное прошлое, посетив знаменитую крепость Масада: ее стены до сих пор хранят память о горьком поражении евреев в войне с римлянами, а дворец царя Ирода, как и сотни лет назад, восхищает своим великолепием. Руины византийских городов и удивительная культура древних набатейских поселений, высеченных из каменных глыб, ждут своих восхищенных поклонников.</p>
									<div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/action-fun-in-the-desert/1.jpg"} class="img-responsive">
								       </div> 
									<p>Активный отдых в пустыне</b></p>
									<p>Израильская пустыня предлагает множество видов активного отдыха. Откройте для себя уникальный рельеф Негева, совершив увлекательную поездку на джипе, или возьмите в аренду горный велосипед, чтобы не спеша прокатиться по пустынным тропам и вдоль разноцветных скал парка Тимна, поражающих неземной красотой. Хочется тишины и умиротворения? Вместе с семьей или друзьями отправьтесь в конное путешествие по Иудейской пустыне или горам Эйлата, или же насладитесь вкуснейшим мятным чаем, сочными финиками и другими «изюминками» местного гостеприимства в одном из бедуинских поселений. А чтобы почувствовать себя настоящим древним иудеем, прокатитесь на верблюде!</p>
									<div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/action-fun-in-the-desert/2.jpg"} class="img-responsive">
								       </div> 
									<p>Берега Мертвого моря — это возможность испытать на себе чудодейственную силу лечебных минеральных грязей, созерцая красоту окружающих скал и бирюзовой воды. Любителям экстрима понравится серфинг по песку: спуск на доске по длинным песчаным дюнам Негева подарит незабываемый всплеск адреналина!</p>
									<p>Поверьте, израильская пустыня намного интереснее, чем вы могли себе представить.</p>
						            
								                             
		                        `,
      };
    },
  },
  {
    id: "The_Incense_Route",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev3/1.jpg",
    mobBgImage: "/posts/bank/negev3/M.jpg",
    isVid: true,
    vidId: "5AAqIhkq_tQ",
    title: "ПУТЬ БЛАГОВОНИЙ",
    smltitle: "",
    html: function() {
      return {
        __html: ` 
						          
						          <br/>
						          <h2 class="ac-margin-bottom-20 ac-margin-top-20">История торгового успеха 2000-летней давности</h2>
						          <p>Легендарный Путь благовоний — это пример торгового успеха 2000-летней давности.</p>
									<p>Во времена, когда еще не было ни транспортных средств, ни дорог, ни путевых карт, длинные верблюжьи караваны шли по опасным тропам, пытаясь избегать грабителей, разбойников, жадных чиновников и других препятствий. По этому торговому пути, который начинался на востоке в Йемене, пересекал Саудовскую Аравию и Иорданию и оканчивался в израильском порту Газа, перевозили дорогостоящие товары, которые затем грузили на отправлявшиеся в Европу корабли. В результате столь опасного путешествия модницы Римской империи могли покупать благовония из ладана и мирры, наслаждаться ароматами восточных специй и использовать соль, незаменимую для приготовления и хранения пищи.</p>
									<p>Продолжительность путешествия по Пути благовоний длиной в 2400 километров равнялась примерно шести месяцам. Караваны из нескольких тысяч верблюдов неторопливо продвигались вперед, проходя через 56 городов и селений, где торговцы останавливались, чтобы дать животным отдохнуть и самим набраться сил для дальнейшего странствия.</p>
									<div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/the-incense-route/1.jpg"} class="img-responsive">
								       </div> 
									<p>Протяженность израильского участка Пути благовоний составляла около 150 километров. В пустыне Негев и сейчас сохранились его фрагменты, и сегодня этот древний маршрут пользуется популярностью у путешественников, которые стремятся постичь тайны пустыни и окунуться в атмосферу кочевой жизни. Например, в городе Моав в пустыне Арава на иорданской границе до сих пор можно увидеть развалины постоялого двора, сторожевого пункта, сельскохозяйственных сооружений, а также фрагменты пещер, древних складов и акведука. Отсюда караваны направлялись на северо-запад, в Мамшит — крупный город, где и современным путешественникам есть на что посмотреть: здесь сохранились руины множества древних зданий, в том числе постоялого двора, церквей, бани, бассейнов для сбора дождевой воды и других сооружений.</p>
									<p>Следующей остановкой был город Авдат, расположенный на склоне высокого холма. Здесь можно увидеть остатки крепости, церквей, древнего маслобойного пресса, гончарной мастерской, бани и даже пещер для захоронений.</p>
									<p>Из Авдата караваны двигались в Шивту — небольшой городок с хорошо развитой системой водоснабжения, бассейнами, маслобойными прессами и несколькими церквями. Предпоследним и самым северным местом стоянки была Халуца, в которой до сих пор сохранились развалины древнего театра и церкви. Отсюда путь пролегал прямиком в Газу. Помимо основных городов, вдоль Пути благовоний было сооружено еще несколько остановочных пунктов (Кацра, Некарот, Махмал и Графон), а также дополнительный постоялый двор — Эйн-Саароним, от которого остался внутренний двор с ремесленными мастерскими и баней.</p>
									<div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/the-incense-route/2.jpg"} class="img-responsive">
								       </div> 
									<p>Вдоль знаменитой дороги встречаются также водосборники, сторожевые вышки, ритуальные сооружения, банные комплексы, а также мильные камни, отмечавшие направление пути.</p>
									<p>До Моава, Мамшита, Авдата, Шивты и Халуцы, а также до Эйн-Сахаронима путешественники могут добраться на любом виде транспорта. Проехать же по самим дорогам, пролегающим через сердце пустыни, способен только внедорожник. Эти увлекательные маршруты доступны также для велосипедистов и пеших туристов. В 2005 году организация ЮНЕСКО объявила Путь благовоний объектом всемирного наследия. Израиль приглашает гостей страны посетить пустыни Негев и Арава, чтобы пройти по следам древних кочевников и ознакомиться с удивительной историей этого края, которая стала безмолвным, но впечатляющим свидетельством о неспокойных древних временах.</p>
															        

								        

										                        `,
      };
    },
  },
  // {
  // 		id:"Mount_Karkom",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:false,
  //         title : "MOUNT KARKOM",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                                   <p>In the heart of the western Negev lies a site considered one of the most significant landmarks in Christian history- the mysterious and beautiful Mount Karkom.</p>
  // 						    <p>Featuring a wildly unspoiled landscape - an 847-meter-high limestone plateau scored by dramatic ravines, mount Karkom is believed by some scholars to be the site of the biblical Mount Sinai – mentioned often in the book of Exodus as the place where Moses received the Ten Commandments.</p>
  // 						    <p>Walking down the eight-kilometer-long loop-trail, on the banks of the Karkom dry riverbed are two rows of standing stones and a rounded wall, reminiscent of nomadic shrine of the type built by the Israelites of the time. Looking closely, one can even spot 12 standing stones, believed by some to represent the 12 tribes of Israel.</p>
  // 							<div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/mount-karkom/1.jpg"} class="img-responsive">
  // 						    </div>
  // 						    <p>Adding to the mystery and appeal, Mount Karkom features many famous rock drawings, depicting worshipping figures, animals and enigmatic symbols.</p>
  //                                   <p>To visit the area Hikers must coordinate tour to the site in advance and use a Society for the Protection of Nature (SPNI) trail map (available in Hebrew only) to explore Mount Karkom.</p>

  // 								                        `
  //     }
  //   }
  // },
  {
    id: "Machtesh_Ramon",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev4/1.jpg",
    mobBgImage: "/posts/bank/negev4/M.jpg",
    isVid: false,
    title: "МАХТЕШ РАМОН",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                
								<p >В Израиле, в центре большой пустыни Негев, находится кратер Рамон, самый большой в мире эрозионный кратер, также известный как Махтеш Рамон.&nbsp; Кратер окаймлен разнообразными</p>
                                <div class="img-wrapper">
									<img src=${getImgUrl() + "/posts/machtes-ramon/1.jpg"} class="img-responsive">
								</div>
								<p>скалами фантастических цветов и форм, этот завораживающий природный феномен имеет длину 40 км и ширину от 2 до 10 км, с высоты птичьего полета он напоминает удлиненное сердце, здесь находится крупнейший национальный парк Израиля - заповедник Рамон.</p>
								<p>Кратер Рамон находится в пустынной местности вдали от городской суеты, он покрыт разноцветными песчаниками, вулканическими породами и окаменелостями, его часто называют Большим Каньоном Израиля.</p>
								<p>Cо смотровой площадки у трехсотметрового обрыва кратера Махтеш Рамон открываются потрясающие виды, напоминающие кадры из голливудских кинокартин, сюда в поисках сильных ощущений круглый год приезжают туристы со всего мира.</p>
								<p>Посещение Махтеш Рамона оставляет сильное впечатление, здесь много достопримечательностей, увидеть которые стремятся туристы и путешественники:</p>
								<p><strong>Центр для посетителей кратера Рамон </strong>-Этот центр построен прямо на краю кратера, отсюда открываются удивительные виды на Махтеш, здесь можно получить информацию об этом уникальном природном феномене, а также о жизни и работе первого израильского космонавта Илана Рамона.</p>
								<p><strong>Хай Рамон </strong>- парк животных «Хай Рамон» создан в целях информирования о местной фауне, посетители могут узнать о таинственных и скрытных маленьких обитателях пустыни. В парке представлено около 40 видов животных: ящерицы, змеи, черепахи, ежи , соколы, фазаны и многие другие.</p>
								<p><strong>Кан Сахароним </strong>- когда-то это было место отдыха на маршруте, по которому доставляли пряности из Набатеи, в нескольких минутах ходьбы отсюда находится прекрасный источник «Эйн Сахароним» (летом пересыхает), вокруг которого растет много деревьев и кустарников, здесь можно увидеть следы различных животных, приходящих сюда на водопой.</p>
								<p><strong>Карпентри </strong>- поразительный геологический феномен. Карпентри представляет собой группу из множества вытянутых вверх камней призматической формы, которые образованы из песчаника, «спекшегося» под воздействием высоких температур от раскаленного потока лавы, вытекшей из земных недр. Охлаждаясь, лава сформировала тысячи ребристых колонн, и фрагменты колонн действуют как призмы.</p>
								<p><strong>Стена аммонитов </strong>- каменная стена, на которой видны окаменелости аммонитов - морских животных, обитавших миллионы лет назад в море на месте пустыни Негев.&nbsp;</p>
								<p>Поездка в Махтеш Рамон - это очень увлекательное приключение, которое гарантированно оставит сильное впечатление и запомнится надолго.</p>
																
		                        `,
      };
    },
  },
  {
    id: "Epic_Masada",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev2/1.jpg",
    mobBgImage: "/posts/bank/negev2/M.jpg",
    isVid: true,
    vidId: "XxWa_MNm5x8",
    title: "МАСАДА",
    smltitle: "",
    html: function() {
      return {
        __html: `
						            <br/>
						            <h2 class="ac-align-center ac-margin-top-20">Вершина мужества в сердце Иудейской пустыни</h2>
                                   

								    <p class="ac-align-center ac-margin-bottom-20"><strong>Славная история великой крепости Иудейской пустыни </strong></p>
									<p>Посетите национальный парк Масада — уединенную древнюю крепость на вершине горы в Иудейской пустыне, над оазисом Мертвого моря. Поднимитесь на гору по извилистой «змеиной тропе», по дороге, проложенной еще древними римлянами, которая начинается у подножия крепости, или войдите через Центр посетителей Масады и воспользуйтесь подъемником. Бережно коснитесь древней истории, и она откроет вам свои тайны.</p>
									
									<p><strong>Величественные руины позволят вам ощутить себя частью истории</strong></p>
									<p>На вершине вы увидите руины некогда роскошных замков, которые служили последним приютом борцам за свободу, сражавшихся против Римской империи после разрушения Второго храма. Это место просто переполнено историей и кажется, что даже каменные стены оплакивают судьбу бесстрашных воинов, которые предпочли смерть рабству.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/epic-masada/1.jpg"} class="img-responsive">
								     </div>
									<p><strong>Место встречи религии и культуры</strong></p>
									<p>Прогуляйтесь по замковым руинам и рассмотрите повнимательнее древние постройки и археологические находки, рассказывающие о жизни в Масаде во время римской осады. Войдите в Северный замок — развалины личной крепости царя Ирода. Прошепчите слова молитвы в древней синагоге, где евреи собирались трижды в день, чтобы помолиться о спасении. Воздайте почести борцам за свободу в «Комнате жребия». Здесь отважные защитники крепости, бросая жребий, определяли порядок, в котором им предстояло умереть. Последний оставшийся в живых должен был покончить с собой.</p>
									<p>Полюбуйтесь мозаиками, сохранившимися в развалинах византийского монастыря. Скорее всего, он в течение столетий, начиная с I века н.э. и на протяжении около 600 лет, служил обителью беглым христианским монахам.</p>
									<p>Масада признана объектом Всемирного наследия ЮНЕСКО. На закате у подножья крепости вас ждет светомузыкальное шоу: оно поведает о жизни и битвах, гремевших здесь много веков назад.</p>
																	  
							    `,
      };
    },
  },
  // {
  // 		id:"The_Bedouin_Experience",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:false,
  //         title : "THE BEDOUIN EXPERIENCE",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `

  // 				           <p>The Bedouin hospitality is a truly unrivalled experience, one which is both highly enjoyable and culturally engaging.</p>
  //                                  <p>A group of nomadic tribes indigenous to the area and dating back many hundreds of years, the Bedouins of Israel continue to live in traditional ways, opening their hearts, their homes and their way of life to the public, to share in their customs and their world-renowned hospitality.</p>
  //                                  <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/the-bedouin-experience/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>From camel riding to traditional Bedouin meals and even overnight stays in traditional Bedouin tents - all these are immensely popular attractions with tourists in the region, and an opportunity to discover and connect with a long-forgotten way of life.</p>
  //                         `
  //     }
  //   }
  // },
  // {
  // 		id:"The_Israel_National_Trail",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:false,
  //         title : "THE ISRAEL NATIONAL TRAIL",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                                <p>The Israel National Trail (“Shvil Israel”) is a national project, paving a marked and safe hiking route across the country. Over 900km long, the route is one of the most rewarding ways to experience the nature and community in Israel.</p>
  //                           <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/the-israel-national-trail/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>The Israel Bike Trail (Part of The Israel National Trail Project) is a national initiative to create mountain biking trail that crosses the country from north to south, connecting Mt. Hermon at one end with Eilat at the other. Perfectly suited for bicycle tourism, the trail passes through national sites and amazing landscapes, allowing riders to experience Israel's diversity of culture and types of communities along the way.The trail is one of the longest demarcated trails in the world suited to, and with appropriate signage for, mountain biking.</p>

  //                         `
  //     }
  //   }
  // },
  {
    id: "Timna_Treasures",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev1/1.jpg",
    mobBgImage: "/posts/bank/negev1/M.jpg",
    isVid: true,
    vidId: "i_4QKtXIeto",
    title: "ПАРК ТИМНА",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                   
                                    <br/>
                                    <h2 class="ac-align-center ac-margin-top-20">Увлекательное приключение в пустыне</h2>

                                    
								    

								    <p class="ac-align-center ac-margin-bottom-20"><strong>Красота природы и захватывающие развлечения в парке Тимна</strong></p>
									<p>Парк Тимна – уникальное место, расположенное всего в 20 минутах езды от Эйлата, в сердце завораживающей израильской пустыни, в окружении великолепных пейзажей. Встреча с природой, древностями и приключениями на огромной территории парка подарит гостям любого возраста незабываемое волнующее переживание.</p>
									<p><strong>Невероятные природные феномены</strong></p>
									<p>Прогуляйтесь по парку и полюбуйтесь его <strong>уникальными каменными образованиями</strong> необычной формы с интересными названиями: Гриб, Полтора гриба, Розовый каньон, Арка, Соломоновы столбы, а также древними наскальными рисунками, изображающими жизнь давно ушедшей эры — это необыкновенно эффектное зрелище.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/timna-treasures/1.jpg"} class="img-responsive">
								    </div>
									<p><strong>Прогулка на свежем воздухе</strong></p>
									<p>Совершите пешую прогулку по одной из 20 отлично обозначенных пешеходных троп различных уровней сложности, выбирайте их согласно своим возможностям. Пройдите по любому из этих интереснейших с геологической или археологической точки зрения маршрутов. Если же вы предпочитаете более расслабляющий отдых — проведите время у <strong>озера Тимна</strong> и на постоялом дворе царя Соломона, где можно пообедать в ресторане, самостоятельно наполнить бутылку цветным песком, или прокатиться по озеру на водном велосипеде.</p>
									<p>Предпочитаете <strong>экстремальный спорт</strong>? Тогда в парке вас ждет дюльфер (скоростной спуск на веревке с отвесной скалы), зиплайн (спуск по стальному канату) и велосипедные прогулки; каждое из этих развлечений наполнит вас энергией и подарит чувство удовлетворения.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/timna-treasures/2.jpg"} class="img-responsive">
								    </div>
									<p><strong>Вернуться в древние времена</strong></p>
									<p>Прикоснитесь к библейской истории, посетив копию Скинии Завета, построенную в натуральную величину, где вы сможете увидеть имитацию жертвенника, Святая Святых и Ковчега Завета. Посмотрите, как юные посетители восторженно рассматривают макет священного сооружения, которое Бог повелел народу Израиля построить в пустыне, а гости постарше проверяют историческую достоверность постройки, попутно узнавая немало нового.</p>
									<p>Парк Тимна. Место встречи истории и приключений в сердце израильской пустыни. &nbsp;</p>
								   
		                        `,
      };
    },
  },
  {
    id: "Negev_Desert_Dont_Miss",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev2/1.jpg",
    mobBgImage: "/posts/bank/negev2/M.jpg",
    isVid: false,
    title: "ПУСТЫНЯ НЕГЕВ",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                   <p class="ac-margin-bottom-20 ac-margin-top-20"><strong>Пустыня негев: обязательный пункт вашего путешествия</strong></p>
                                
								   <p><strong>Серфинг на песке</strong></p>
									<p>Незабываемое приключение в пустыне. Мчитесь, как ветер, по мягким пологим дюнам Негева! Освоив столь фантастическое, ни на что не похожее искусство (на самом деле это очень легко), вы сможете с полным правом называть себя волком песчаных морей. Разве это не круто?</p>
									<p><strong>Негев под покровом ночи</strong></p>
									<p>Ночное небо над Негевом — поистине завораживающее зрелище. Едва стемнеет, поднимите голову и взгляните вверх: вы будете потрясены мириадами мерцающих звезд, озаряющих темно-синее небо таким блеском, какой можно увидеть лишь в пустыне.</p>
									  <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/negev-desert-dont-miss/1.jpg"} class="img-responsive">
								     </div>
									<p><strong>Катание на верблюдах</strong></p>
									<p>Настоящее путешествие в прошлое и самый аутентичный способ покорения пустынных просторов. В пустыне Негев расположены несколько верблюжьих ферм, где вам с радостью позволят прокатиться на «корабле пустыни». Это приключение запомнится вам надолго.</p>
									
									<p><strong>Фестиваль Мидберн</strong></p>
									<p>Это израильский аналог знаменитого фестиваля Burning Man, во время которого в пустыне Негев на шесть дней обустраивают лагерь с общинным укладом жизни, который становится площадкой для творчества, искусства и самовыражения.</p>
									 <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/negev-desert-dont-miss/2.jpg"} class="img-responsive">
								     </div>
									<p><strong>Рассвет в крепости Масада</strong></p>
									<p>Это испытание для сильных духом, готовых пешком подняться на гору, чтобы встретить восход солнца в незабываемом месте. Одно из самых сильных впечатлений в Израиле. Вы надолго запомните величественное зрелище: солнце встает над горами Моав и Мертвым морем, заливая светом пустынный ландшафт.</p>
									     

		                        `,
      };
    },
  },
  // {
  // 		id:"Negev_Charms",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"3UddwPEzDXo",
  //         title : "ESCAPE TO THE NEVEG",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                                 <p>A desert holiday is unlike any other - the tranquility, the awe inspiring grand vistas, the clear star-studded night skies, all come together to create a truly mesmerizing and exotic experience most of us do not to partake in during our day to day lives.</p>
  //                                 <p>The Negev is so much more than just a Desert. While it still offers all the natural beauty, calmness and wonderous sites which the desert tourist is looking for, it is also extremely westernized and packed with activities and adventures while offering all the comforts of a holiday. This is exactly what makes a trip to the Negev the perfect destination for travelers from all over the world. Another gem of the Negev is undoubtedly its local community, from the Kibbutz residents to the lone farm dwellers and the local Bedouin folk, the people of the Negev are warm, hospitable and always ready to lend a hand. The Negev is rich in geological and archeological treasures and offers loads of exciting activities for the more adventurous travelers.</p>
  //                           <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/negev-charms/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>At the same time, visitors looking for relaxation are sure to find it in the tranquil surroundings, and for some urban excitement, the nearby cities provide a wide range of city fun from culinary treats to exciting nightlife.</p>

  //                         `
  //     }
  //   }
  // },

  // {
  // 		id:"Galilee",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"5Ep3GgxELag",
  //         title : "GALILEE",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  // 				          <p>Most of northern Israel is generically known as The Galilee (Galil in Hebrew). It stretches virtually from the Mediterranean to the harp-shaped Sea Of Galilee and River Jordan on whose shores vast history has been made. Here is Mount Gilboa where King Saul and his son, Jonathan, died in battle against the Phillistines. Here is Hazor, where Deborah killed Sisera. Here, at Mount Meron, is the grave of Rabbi Hillel. Here in Tzippori, Hamat Tveriya and Bet Alpha, gorgeous 1,800-year-old synagogue mosaics have been discovered. Here is Armageddon (Megiddo) where Solomon built giant stables. Here is the lakeshore city of Tiberias, one of the “Four Holy Cities of Judaism” (another is Galilee’s Safed), which reached fame 2,000 years ago as one of the chief locations in which the Talmud was written.</p>
  //                                 <h3 >Galilee</h3>
  //                                 <div class="responisve-iframe">
  // 					           <iframe width="560" height="315" src="https://www.youtube.com/embed/lzYzxyvnfng" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  // 				           </div>
  // 				           <p>The restoration of the Jewish homeland in the period beginning in the 1880’s was largely centered in the Galilee, and in the ensuing 130 years a much neglected landscape of not much more than olive trees has been transformed into one of the most fertile areas in the world. Here are dozens of kibbutzim and independently owned farms – whose produce feeds not only Israelis but is also flown daily to the grocery stores and flower markets of Europe. Here are some of Israel’s 300+ vineyards producing award winning wines. And here are pretty villages, towns and cities including Nazareth and Carmiel.</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/galilee/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>In addition to hotels and very comfortable kibbutz guest houses, the Galilee is filled with dozens of country bed-and-breakfast accommodations, known as zimmerim. Many offer luxurious accommodations, including pools, and make a delightful base for relaxing and touring.</p>

  //                         `
  //     }
  //   }
  // },

  {
    id: "Caesarea",
    ctg: "north",
    bgImage: "/posts/bank/north3/1.jpg",
    mobBgImage: "/posts/bank/north3/M.jpg",
    isVid: true,
    vidId: "eLZ433_S6HI",
    title: "КЕСАРИЯ ПУТЕШЕСТВИЕ СКВОЗЬ ВЕКА",
    smltitle: "",
    html: function() {
      return {
        __html: `   
								   <p><b>Познакомьтесь с чудесами прошлого, созданными одним из величайших строителей древнего мира — царем Иродом</b></p>
									<p>Менее чем час езды от Тель-Авива — и на берегу лазурного Средиземного моря вас встречает древний город Кесария.</p>
									<div class="img-wrapper">
																		   <img src=${getImgUrl() + "/posts/caesarea/1.jpg"} class="img-responsive">
																	   </div>
									<p>Археологические сокровища этого великолепного города — яркое свидетельство того большого значения, которое Кесария имела на протяжении веков. Прогулявшись по национальному парку и древнему порту, римскому ипподрому и амфитеатру, впечатляющему дворцу и другим историческим достопримечательностям, вы словно вернетесь на много лет назад, в эпоху великих империй. Обязательно посетите «Путешествие сквозь время» — это невероятно захватывающее светомузыкальное шоу расскажет вам об удивительной многовековой истории Кесарии.</p>
									<p>А красота пляжей, множество уютных ресторанчиков и кафе, а также единственное поле для гольфа в стране только усилят ваше восхищение этим волшебным местом.</p>
											                  
		                        `,
      };
    },
  },

  {
    id: "Acre",
    ctg: "north",
    bgImage: "/posts/bank/north3/1.jpg",
    mobBgImage: "/posts/bank/north3/M.jpg",
    isVid: true,
    vidId: "KlXXyToCmCM",
    title: " СТАРЫЙ АККО ",
    smltitle: "",
    html: function() {
      return {
        __html: ` 
						         
                                     <br/>
                                    <h2 class="ac-align-center  ac-margin-top-20">По следам крестоносцев</h2>
								    <p class="ac-align-center ac-margin-bottom-20"><strong>Древний город за стенами превратился в культурный центр на севере Израиля</strong></p>
									<p>Старый Акко — одно из наиболее исключительных мест Израиля. Приморский город окружен древними каменными стенами. В старом Акко вас ждут бесчисленные исторические и кулинарные сокровища, здесь вы сможете насладиться неповторимой и изысканной атмосферой.</p>
									<p><strong>Захватывающее историческое наследие</strong></p>
									 <div class="img-wrapper">
									   <im
									<p>Приготовьтесь к встрече с самыми удивительными достопримечательностями и развлечениями, рассказывающими о жизни крестоносцев. Именно этот рыцарский орден когда-то господствовал в Старом Акко. Взгляните на величественные древние <strong>стены</strong>, которые окружают Старый город и служили его жителям надежной защитой во время осады войсками Наполеона. Посетите <strong>порт Акко</strong>, где, закрыв глаза и вдохнув свежего морского воздуха, так легко словно воочию увидеть, как выглядел много веков назад этот центр мореходства. Именно он связывал Святую Землю со странами Европы, и именно сюда прибывали паломники.</p>
									<p>Внимательно рассмотрите древний <strong>туннель тамплиеров</strong>. Некогда он соединял стратегическую крепость с портом Акко и позволял паломникам попасть в Израиль. А сегодня естественный каменный проход служит символом сотрудничества и упорства — и прогулка по нему станет неповторимым впечатлением. Продолжите путь к к<strong>репости госпитальеров</strong> (Рыцарским Залам), основанной королем Ричардом Львиное Сердце во время Третьего крестового похода. Окруженные арками руины центрального двора форта — яркое свидетельство о жизни города в трудные времена.</p>
								    <div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/acre/2.jpg"} class="img-responsive">
								   </div>	
									<p><strong>Редкое сочетание самобытности и различных культур</strong></p>
									<p>Акко может похвастаться множеством древностей и достопримечательностей. Но именно <strong>рынок</strong> города стал символом подлинного слияния восточной и западной культур. Такой симбиоз послужил основанием для создания древнего приморского города и служит порукой его нынешнего процветания. Разнообразные ароматы наполняют воздух, и местные торговцы радуют гостей со всех уголков света изысками местной кулинарии — вкуснейшими восточными сладостями, специями собственного изготовления, свежайшими продуктами и только что выловленной рыбой. А еще советуем пройти к южному концу рынка. Там расположены синагога Рамхала и дом политического деятеля Хаима Фархи — они внесут особый вклад в ваши знания о культуре и традициях Акко.&nbsp;&nbsp;</p>
											                     

		                        `,
      };
    },
  },

  {
    id: "Haifa",
    ctg: "north",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    isVid: true,
    vidId: "3ahATaKkhBk",
    title: "ХАЙФА",
    smltitle: "",
    html: function() {
      return {
        __html: `  
                                   

                                   <br/>
                                   <h2 class="ac-margin-bottom-20 ac-margin-top-20">	Врата северного Израиля</h2>
						           <p>Оживленная «столица Севера» Хайфа — третий по величине и один из самых увлекательных городов Израиля.</p>
									<p>Посещение Хайфы весной или летом — отличная возможность поплавать или отдохнуть на одном из ее прекрасных пляжей; но в Хайфе есть чем заняться в любое время года.</p>
									<p>Благодаря расположению на склонах величественной горы Кармель (интересной и самой по себе) Хайфа заслужила прозвище «израильского Сан-Франциско», и успешно поддерживает этот имидж прекрасными пляжами, захватывающими видами, бурной ночной жизнью и самобытной местной музыкой.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/haifa/1.jpg"} class="img-responsive">
								   </div>
									<p><strong>Бахайские сады </strong><strong>—</strong><strong> красота, величие и восхитительная архитектура</strong></p>
									<p>В июле 2008 года Бахайские сады были внесены в Список Всемирного наследия ЮНЕСКО в знак признания их «выдающейся универсальной ценности» как священного места паломничества для последователей веры Бахаи.</p>
									<p>Бахайское святилище и окружающие его сады поражают красотой, величием, утонченным дизайном и неповторимой умиротворяющей атмосферой. Бахайские сады — одно из самых популярных туристических мест в стране, привлекающее более 1 млн посетителей ежегодно.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/haifa/2.jpg"} class="img-responsive">
								   </div>
									<p><strong>Кармель — вечнозеленая гора у средиземноморского побережья Израиля</strong></p>
									<p>Одно из наиболее интересных для посещения мест — гора Кармель, символ красоты и цветения, идеальное место для необременительных пеших экскурсий и семейных пикников. Чтобы насладиться прекрасными видами, открывающимися с вершины горы Кармель, вам не придется штурмовать ее склоны: подняться на гору и спуститься с нее можно на горном метро — «Кармелит».</p>
									<p><strong>Искусство и культура</strong></p>
									<p>Хайфа — оживленный и творческий город, поэтому самобытные объекты культуры здесь можно найти буквально на каждом шагу. Среди множества подобных мест особо выделяются израильский Национальный музей науки, технологии и космоса Мадатек, Хайфский художественный музей и Хайфский зоопарк, расположенный на горе Кармель.</p>
									<p>В Хайфе также проходят самые разные культурные мероприятия, например фестиваль «Праздник праздников», во время которого совместно отмечаются еврейские, христианские и мусульманские праздники, приходящиеся на декабрь. Заслуживает внимания и Хайфский международный кинофестиваль. Он проходит ежегодно в сентябре в течение недели и превращает город в огромный кинотеатр, где можно посмотреть более 100 фильмов самых разных жанров.</p>
																	 
		                        `,
      };
    },
  },

  {
    id: "Safed",
    ctg: "north",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    isVid: true,
    vidId: "i3_ihL51bHo",
    title: "ЦФАТ",
    smltitle: "",
    html: function() {
      return {
        __html: ` 
                                    <br/>
                                    <h2 class="ac-align-center ac-margin-top-20">Цфат место, где земное начало встречается с мистическим</h2>
						            

								    <p  class="ac-align-center ac-margin-bottom-20"><strong>Погрузитесь в мир искусства и духовности и жизнь откроется вам по-новому</strong></p>
									<p>Вы будете заворожены красотой пейзажей, уходящих далеко, за линию горизонта. Вдохните чистейшего горного воздуха. Цфат очарует вас немедленно, лишь только вы ступите на землю этого чудесного города. Цфат известен как столица&nbsp; прошлого и настоящего еврейского мистицизма, этот удивительный город раскинулся на вершине холма, и это самый высоко расположенный город не только в Галилее, но и во всем Израиле - причем как в географическом смысле, так и в духовном. Цфат является одним из четырех священных городов для приверженцев иудаизма, это город, где можно совершить мистическое путешествие, от которого вы придете в восторг и которое тронет вас до глубины души.&nbsp;&nbsp;</p>
									<p>Цфат находится в нескольких минутах езды от Галилейского моря, в этом городе вас ждут причудливые булыжные мостовые и мистические памятники архитектуры.&nbsp; Прислушавшись, вы услышите таинственные голоса исторических персонажей, которые поделятся с вами своими секретами, вы посетите старую крепость, в строительстве которой принимали участие и крестоносцы, и мамлюки, в ней заметно влияние Османской империи и Великобритании, увидите монумент Войне за независимость, а также необычные синагоги и древние гробницы, памятники священной истории.</p>
                                   <div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/safed/1.jpg"} class="img-responsive">
								   </div>
									<p><strong>Вечная столица каббалы </strong></p>
									<p>От Рабби Шимона Бар-Йохая, который жил во II веке и написал основополагающую работу по Каббале, известную как Зоар, до Ари ха-Кадоша, отца современной Каббалы, город Цфат был домом для самых знаменитых мистиков иудаизма и их учеников. В XVI-ом веке Ари ха-Кадош «демократизировал» каббалистические учения, благодаря чему Каббала стала доступной пониманию простых людей.</p>
									<p>Переходя из одной синагоги в другую, вы почувствуете, каким неизменно притягательным местом является Цфат для искателей духовности, несмотря на всю трудную долгую историю этого города. Синагога Абухав, архитектурные элементы которой являются воплощением численного мистицизма, синагога Ари Ашкенази, посвященная Ари ха-Кадошу и синагога Йосефа-Каро, - посещая эти места, вы словно совершите путешествие в верхние миры мистицизма.</p>
									<p><strong>Старый Город, полный вдохновения</strong></p>
									<p>Незабываемый след в вашей памяти оставит прогулка по извилистым булыжным аллеям Старого Города, где можно посмотреть на уникальные каменные здания и по дороге заглянуть в квартал художников. Здесь много хороших художественных галерей, где вы можете познакомится с изысканными произведениями местных художников, в том числе увидеть множество предметов иудаистского обрядового искусства; эта часть Старого города предназначена для любителей искусства всех жанров. Искатели культурных впечатлений обязательно должны посетить Музей кукол и Музей печатного искусства.</p>
									<p>В Цфате можно найти то, что будет приятным не только для души, но и для тела - в Старом городе много мест, где туристы могут вкусно поесть, причем заведения рассчитаны на любой вкус и кошелек. Тут можно отведать йеменские блинчики, или просто перекусить на улице, или зайти в ресторан и заказать там деликатес - в этом благодатном городе с глубокими традициями любой человек найдет то, что ищет, и даже больше.</p>
																	   						   
		                        `,
      };
    },
  },

  // {
  // 		id:"The_Bahai_Gardens",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"JV_AmfRULOo",
  //         title : "THE STUNNING BAHA’I GARDENS",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  // 				          <p><strong>Visit the Baha’i Gardens</strong></p>
  //                                 <p>Picture yourself standing on the nineteenth terrace which is the very top of this breath taking monument where you can see the rolling hills of the Galilee, the city of Haifa, Akko and the Mediterranean Sea.</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/bahai-gardens/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>Beauty, grandeur, and inspired design combined with the meticulous gardening by generations of dedicated gardeners and a variety of cultures create the unique atmosphere of the Baha’i shrine and gardens in Haifa. While each garden offers a different experience they all share the same theme of gravelling paths, unique hedges and flourishing flower beds. A picture so perfect you must see it with your own eyes to believe the precision and symmetry.</p>
  // 						   <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/bahai-gardens/2.jpg"} class="img-responsive">
  // 						   </div>
  // 						     <p>This mystical iconic is site where members of the Baha’i faith have established their shrine and world centre because of its significance to their faith.</p>
  //                                  <p>The Baha’i faith had its origins from Iran. Its founder Baha'u'llah, was exiled from his homeland at the end of the 19th century, and came to Akko (Acre) and Haifa after suffering persecution in neighbouring countries.&nbsp; He was impressed with the beauty of Mount Carmel and expressed the desire that the Bab (one of the central figures of the Baha’i faith) would be buried there. About 20 years later the bones of the Bab were laid to rest in Haifa on the site that then developed into the centre of The Baha’i faith which is visited by half a million people every year.</p>
  //                         `
  //     }
  //   }
  // },

  {
    id: "The_Sea_Of_Galilee",
    ctg: "north",
    bgImage: "/posts/bank/north2/1.jpg",
    mobBgImage: "/posts/bank/north2/M.jpg",
    isVid: true,
    vidId: "haG-t3wwuMc",
    title: "КИННЕРЕТ",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                  
								   
		                        `,
      };
    },
  },

  {
    id: "Rosh_Pina",
    ctg: "north",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    isVid: true,
    vidId: "_qKbHL5-qrQ",
    title: "РОШ-ПИННА",
    smltitle: "",
    html: function() {
      return {
        __html: `  
						           <p><strong>Уединенная пасторальная красота в Галилее</strong></p>
                                   <p>Known as the Princess of the Galilee, Rosh Pina is home to the perfect mix of natural, cultural, historic and entertainment hotspots. A beautifully restored, serene northern village where aged olive trees and quaint homes are surrounded by lush golden fields, Rosh Pina is just the place for a leisurely and relaxing vacation, where visitors can relive village life as it was, over a century ago.</p>
                                   <div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/rosh-pina/1.jpg"} class="img-responsive">
								   </div>
								   <p><strong>Время словно течет вспять в живописном галилейском селении</strong></p>
									<p>Селение Рош-Пинна называют «принцессой Галилеи», что неудивительно. Восхитительное сочетание природных красот, исторических и культурных достопримечательностей и различных развлечений вполне оправдывает такое звание. Это полностью восстановленное, тихое северное селение, где старые оливы и причудливые домики окружены пышными золотыми полями, — отличное место отдыха. Гости Рош-Пинны смогут словно вернуться на более чем 100 лет назад и понять, как жили здесь тогда люди.</p>
									<p><strong>Волшебную тишину нарушит лишь пение птиц</strong></p>
									<p>Вы ищете мирный уголок на лоне природы, напоминающий итальянскую Тоскану или французский Прованс? Отправляйтесь на север Израиля, в Рош-Пинну, где исторические достопримечательности стали неотъемлемой частью мирных сельских пейзажей, и где вы почувствуете, словно перенеслись назад во времени. Выберите один из уютных пансионов, что скрываются среди романтических аллей. Здесь вас забудете о шуме большого города и ощутите невероятно гостеприимную атмосферу этого чудесного места.</p>
									<p>Прогуляйтесь по утопающим в зелени <strong>тропинкам</strong> вдоль реки Рош-Пинна или по садам барона Ротшильда, которые, как уверяют местные жители, были спланированы по подобию садов Версаля. Вдохните свежий воздух и полюбуйтесь красотой природы, чувствуя свое единение с ней и наполняясь новой энергией.</p>
									<p><strong>Место отдыха с неповторимым художественным шармом</strong></p>
									<p>Не спеша пройдитесь по мощеным улочкам, напоминающим о старых городах Европы, окунитесь в неповторимую культурную и художественную атмосферу в окружении величественных Галилейских гор. Рош-Пинна предлагает модные кафе, рестораны для гурманов, галереи, музеи, фестивали, исторические достопримечательности и торговые точки. Ее культура, природа и кулинарные изыски расскажут вам историю первой «мошавы» (поселения) Галилеи и еврейской общины в Израиле.</p>							   
											                      
		                        `,
      };
    },
  },

  {
    id: "Nazareth_Christian_Cradle",
    ctg: "north",
    bgImage: "/posts/bank/north3/1.jpg",
    mobBgImage: "/posts/bank/north3/M.jpg",
    isVid: true,
    vidId: "1M7N5BcmjFM",
    title: "НАЗАРЕТ КОЛЫБЕЛЬ ХРИСТИАНСТВА",
    smltitle: "",
    html: function() {
      return {
        __html: ` 
                                  <br/>
                                 
                                  <p class="ac-align-center ac-margin-bottom-20"><strong>Древний город c</strong><strong> богатой историей, археологическими чудесами, современной культурой и ближневосточным шармом</strong></p>
									<p>Назарет, или Нацрат на иврите, — колыбель христианства; город, где, согласно канонам христианской веры, архангел Гавриил возвестил Марии о том, что она зачнет от Духа Святого; место, где Иисус провел свои детство и юность. Назарет расположен в Нижней Галилее, в самом сердце долины, окруженной горами, словно обнимающими несколько важнейших христианских святынь. Это место религии и веры, духовности и святости, а еще город с богатой историей, археологическими чудесами, современной культурой и ближневосточным обаянием.</p>
									<p><strong>Колыбель христианства </strong></p>
									<p>Назарет, основанный как небольшое еврейское поселение более 2000 лет назад, спустя всего несколько столетий, в византийский период, был уже оплотом христианства. Его название стало известно по всему миру, а желание увидеть место, где жили Дева Мария и Иисус Христос, превратило Назарет в популярную&nbsp; точку паломничества. Благодаря этому там, где по преданию находился дом Иосифа и Марии, была построена первая церковь города — базилика Благовещения. На протяжении веков христианское владычество сменялось мусульманским, и наоборот. И за это время в городе было построено, разрушено и перестроено множество церквей. В XIX веке интерес христианства к Назарету вспыхнул с новой силой, и в городе вновь появились церкви и монастыри. Сегодня в Назарете проживает крупнейшая арабская община Израиля, в нем насчитывается около 30 церквей и монастырей, наряду с мечетями и древними синагогами.</p>
									<p><strong>Вкус древнего города</strong></p>
									<p>Во время экскурсии по Назарету вы словно проживаете различные периоды его истории. Каждая эпоха оставила в память о себе особые символы, которые сегодня превратились в популярные туристические объекты. Большинство достопримечательностей находится в Старом городе, построенном в середине XIX века в традиционном ближневосточном стиле. Прогулка по его узким улочкам между живописными домами – увлекательное занятие, и вам стоит замедлить шаг, чтобы полюбоваться их красотой.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/nazareth/1.jpg"} class="img-responsive">
								   </div>
									<p>В Старом городе расположено множество древних церквей, самая значительная из которых — базилика Благовещения. Во время перестройки к ней были присоединены части более ранних церквей, периода владычества крестоносцев и византийского владычества. В церкви также находится впечатляющая коллекция картин.</p>
									<p>Сразу за базиликой расположена церковь Святого Иосифа, возведенная на руинах сельскохозяйственных построек, где, по преданию, находилась мастерская плотника Иосифа, мужа Марии. Если католическая базилика Благовещения построена на месте дома Марии, то православная церковь Благовещения греческой епархии стоит на месте источника, к которому, согласно апокрифам, Мария приходила за водой. Это строение периода крестоносцев известно и своими древними фресками. Православная церковь Благовещения расположена рядом с источником Марии, внутри Зала крестоносцев. По преданию, здесь находилась синагога, где молился Иисус.</p>
									<p>Среди других церквей Назарета — церковь Менса Кристи, маронитская церковь и салезианская церковь Иисуса-отрока. В Старом городе расположены также официальные постройки османского периода, среди которых – административное здание — сарай, построенное Дааром эль-Омаром, правителем Галилеи в XVIII веке, и Белая мечеть, служащая сегодня молитвенным домом мусульман и центром просвещения и культуры. В Белой мечети также находится музей истории Назарета.</p>
									<p>Ни одна экскурсия по Назарету не будет полной без посещения местного рынка, ставшего популярной достопримечательностью благодаря своим многоцветным прилавкам и широкому выбору товаров. Здесь ваш взгляд порадуют самые модные яркие ткани, также вы сможете попробовать различные специи и местные продукты, приобрести произведения искусства и сувениры. Богатейшая палитра звуков, видов, запахов и вкусов позволит пережить вам потрясающие мгновения ближневосточной жизни.</p>
									<p><strong>Очарование Ближнего Востока </strong></p>
									<p>В Назарете множество очаровательных уголков, вид которых радует глаз и душу. Во время пешей экскурсии обязательно пройдитесь по променаду на горе Наби Саин, откуда можно полюбоваться великолепной панорамой Галилеи. Еще вы можете посетить древние турецкие бани, обнаруженные во время перестройки одного из городских магазинов, и заглянуть в шикарную усадьбу, где представлена экспозиция, посвященная обиходу и обычаям османских правителей XIX века, включая несколько уникальных фресок. Стоит увидеть и дом греческого православного епископа, где можно прогуляться по подземным переходам во внутреннем дворе. Еще одно интересное место — Русское Сергиевское подворье, построенное как приют для паломников.</p>
									<p>В Назарете, который на протяжении веков принимает паломников, есть христианские хостелы и комфортабельные гостиницы, всегда готовые распахнуть свои двери для гостей, особенно в рождественский период. Множество ресторанов предлагают вкуснейшую еду, неповторимые ароматы которой привлекают посетителей круглый год. Особенно великолепен Назарет во время Рождества: его праздничное убранство и особое настроение гармонично сочетаются с атмосферой святых мест и словами молитв, долетающими из церквей.</p>
										
						        
								   							   
		                        `,
      };
    },
  },

  {
    id: "Nazareth",
    ctg: "north",
    bgImage: "/posts/bank/north2/1.jpg",
    mobBgImage: "/posts/bank/north2/M.jpg",
    isVid: true,
    vidId: "1M7N5BcmjFM",
    title: "СЮДА СТРЕМЯТСЯ ТУРИСТЫ И ПАЛОМНИКИ",
    smltitle: "",
    html: function() {
      return {
        __html: ` 
                                  <br/>
                                   <h2 class="ac-margin-bottom-20 ac-margin-top-20">Древнее священное сердце Земли Израильской и центр притяжения туристов со всего света.</h2>
                                   

							
									<p >Название этого города многое значит для всего христианского мира, ведь Назарет — это город, где вырос Иисус, в наше время он стал главным местом паломничества для христиан, городом, который обязательно надо посетить. Папа Иоанн Павел II и Папа Бенедикт XVI включали посещение города в программу своих визитов в Израиль, как и десятки тысяч туристов, которых принимает Назарет каждый год.</p>
									<p >Святые места, имеющие религиозное значение, богатая история города, красочные базары, кулинарное разнообразие, удивительное гостеприимство и множество достопримечательностей привлекают туристов, которые справедливо полагают, что без посещения Назарета поездка в Израиль будет неполной.</p>
									<p >Поездка в этот город обещает быть захватывающей - вы окунетесь в его шумное разнообразие, познаете его богатую культуру и историю, духом которой пронизан каждый сантиметр городских улочек.&nbsp; Этот город никого не оставит равнодушным&nbsp;</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/nazareth2/1.jpg"} class="img-responsive">
								    </div>
									<p ><strong>По стопам Иисуса&nbsp; </strong></p>
									<p >Откройте для себя колыбель христианства и ощутите уникальную духовную атмосферу города.&nbsp; Пройдите по следам Иисуса, который провел в этом городе свое детство и юность, как и его семья.</p>
									<p >Посетите потрясающую <strong>Базилику Благовещения</strong>, которая, как верят христиане, построена на том месте, где Архангел Гавриил сообщил весть Деве Марии о грядущем рождении Иисуса Христа&nbsp;- Сына Божьего.&nbsp; Полюбуйтесь видом очаровательной <strong>церкви Св. Гавриила</strong> и побывайте у <strong>Колодца Марии</strong>, вода из которого, как говорят, обладает целебными свойствами.&nbsp; Обязательно осмотрите <strong>Церковь-синагогу</strong>, которая, согласно преданию, построена на развалинах старой синагоги, где учился &nbsp;Иисус Христос.</p>
									<p >Не ограничивайтесь только посещением святых мест, найдите время и осмотрите также и другие достопримечательности города. Побывайте в музее под открытым небом <strong>Назаретская деревня</strong> и в <strong>международном центре «Мария из Назарета»</strong>, где вы увидите, как оживает история.&nbsp; Совершите поездку на <strong>Гору Свержения</strong>, где, согласно библейской легенде жители Назарета пытались столкнуть Иисуса со скалы. Ощутите духовную энергию, которой пропитано это место, и полюбуйтесь потрясающим панорамным видом.&nbsp;</p>
									<p >Совет:&nbsp; Здесь столько всего нужно увидеть и сделать, что лучше всего воспользоваться услугами гида. &nbsp;Лучше всего открывать для себя это место с помощью местных жителей.</p>

									<p ><strong>Откройте для себя достопримечательности Назарета и ощутите знаменитое гостеприимство жителей города&nbsp; </strong></p>
									<p >В наши дни Назарет - крупнейший арабский город в Израиле. Во времена Римской империи это была небольшая деревушка, но теперь Назарет представляет собой современный компактный город-космополит с богатыми культурными и кулинарными традициями, очень гостеприимный, где жизнь кипит через край.</p>
									<p >Прогулка по городу обещает быть увлекательной. Побродите по вымощенным камнями улочкам, среди шумных рынков, ощутите многообразие запахов, вкусов и звуков.&nbsp; За столиком в кафе насладитесь отличной едой и окунитесь в неповторимую городскую атмосферу. Музыка и интересный разговор входят в меню. Посетите местные рестораны, отведайте одни из лучших и необычных блюд, какие вы когда-либо пробовали. Наш совет:&nbsp; Обязательно попробуйте десерты.</p>
									<p >Ознакомьтесь с городской архитектурой, посетите музей и даже фабрику «Халвы».&nbsp; В городе имеется много отелей, гостиниц, хостелов и других мест, где вы можете заночевать. Вы услышите, как каждый день ровно в полдень звонят церковные колокола в память о моменте Благовещения. Назарет - это место, где история и современность слились в пестром культурном многообразии.</p>
																		
						        
								   							   
		                        `,
      };
    },
  },

  {
    id: "Cheers_To_Israel",
    ctg: "north",
    bgImage: "/HomeSlider/desktop/4.jpg",
    mobBgImage: "/HomeSlider/M/3.jpg",
    isVid: true,
    vidId: "Cxii1yKqKwI",
    title: "GREAT WITH WHITE OR RED",
    smltitle: "",
    html: function() {
      return {
        __html: `  <p>Over the past decade, Israeli wine-making has become a vital and thriving industry.</p>
                                   <p>The fertile land of the area has been recognized worldwide as an excellent setting for burgeoning vineyards, and the local scene is trendy and opulent.</p>
                                   <p>In the north, the general atmosphere reminiscent of French or Italian wine regions while the south&nbsp;has become renowned for its burgeoning&nbsp;wine scene, thanks to pioneering farmers and their use of computerized drip irrigation.</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/cheers-to-israel/1.jpg"} class="img-responsive">
								   </div>
								    <p><span style="font-family: arial,sans-serif;">The Israeli wine scene allows visitors a fantastic experience combining delectable wine tastings with the stunning vistas and energy this has to offer.</span></p>
								   <p>So come get a taste of Israel’s wine country through its many fantastic tours of the vineyards and boutique wineries, the fantastic wine and music festivals and year-round wine-themed events.</p>
								   <p>FYI, a visit to Israel goes great with white or red.</p>
								   
		                        `,
      };
    },
  },

  {
    id: "A_Galilean_Treat",
    ctg: "culinarynorth",
    bgImage: "/posts/bank/north2/1.jpg",
    mobBgImage: "/posts/bank/north2/M.jpg",
    isVid: true,
    vidId: "kF808ENuuTQ",
    title: "Гастрономические каникулы в Галилее",
    smltitle: "",
    html: function() {
      return {
        __html: `  
						           <br/>
						           <h2 class="ac-margin-bottom-20 ac-margin-top-20">Рай для гурманов</h2>                           
                                 
								   <p>Посетив Галилею, вы откроете для себя новые вкусы и запахи, которые раньше даже представить cебе не могли: от местных сыров, которые изготавливают на небольших сыроварнях, до вин мирового класса; от семейных ресторанчиков для гурманов до свежих фруктов и овощей. Галилея – это рай для гурманов.</p>
									<p><strong>Регион, где текут молочные и винные реки</strong></p>
									<p>Откройте для себя богатство сыров Галилеи, посетив небольшую молочную ферму, где вы можете принять участие в процессе производства сыра. Вашим гидом будет опытный местный сыровар, вы попробуете уникальные мягкие, твердые и полутвердые сорта сыров этого региона. Например, <em>либан</em> - мягкий сыр, похожий на сливочный йогурт из овечьего или козьего молока; его часто подают в сочетании с местными травами, такими как <em>заатар</em>. Или же попробуйте соленый овечий сыр <em>зефатит</em> в корзинке, названный в честь города Цфат.</p>
									<p>Вместе с сыром вас угостят местным вином. Каждое новое вино еще лучше, чем предыдущее. Недавно в виноделии Израиля произошла настоящая революция, в результате которой на маленькой территории Галилеи появилось несколько эксклюзивных винодельческих производств. На каждом винограднике выращивают сорта с уникальным вкусом, характерным для местной почвы. Лучшие виноделы Израиля угостят вас свежими, с глубоким вкусом красными и белыми винами. Все это дополняет потрясающий вид на холмы виноградников. Попробуйте ассорти из лучших сортов винограда, используемых для изготовления вин. Израильские вина получают высшие награды на мировых ярмарках. Многие из этих вин нельзя купить за пределами Израиля.</p>
                                    <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/galilean-treat/1.jpg"} class="img-responsive">
								   </div>
									<p><strong>Визит на ферму</strong></p>
									<p>В Галилее туристам предлагаются визиты на фермы, где они сами могут принять участие в сборе урожая фруктов и ягод: своими руками сорвать с деревьев румяные яблоки, терпкую вишню, бархатистые персики, сливы или сочные и ароматные плоды сабра. Интересными обещают быть туры на фермы специй. Вы окунетесь в многообразие запахов и вкусов местных трав. Некоторые из них вам знакомы, но есть и такие, с которыми вы никогда не сталкивались. Откройте для себя родные ароматы Галилеи, создайте свои собственные травяные чаи и пряные смеси.</p>
									<p>Оливковое масло - еще один важный продукт, который производят в Галилее. Если вы думали, что оливковое масло везде одинаковое, то, посетив семейную оливковую ферму в Галилее, вы измените свое мнение. Попробуйте разные образцы оливкового масла, узнайте, почему каждое масло имеет свой вкус. Вы также можете присоединиться к бригаде сборщиков оливок, поучаствовать в процессе отжима масла старинным способом и приготовить свое собственное оливковое масло первого отжима.</p>
									<p><strong>Рынки и рестораны</strong></p>
									<p>В древних городах Галилеи есть множество рынков, на которых вы можете купить лучшие сезонные продукты и изделия местных мастеров. На рынках можно побродить самостоятельно или же воспользоваться услугами опытного гида, который приведет вас к самым лучшим прилавкам.</p>
									<p>Совершая гастрономическое путешествие по Галилее, вы можете посетить рестораны с изумительно вкусной кухней в самых неожиданных уголках. В скромных на вид ресторанчиках Галилеи подают одни из лучших блюд в стране, а бонусом станут потрясающие виды. Зачастую это семейные заведения, где предлагаются блюда, с любовью приготовленные из ингредиентов, выращенных неподалеку. Но чтобы действительно ощутить вкус Галилеи, примите участие в кулинарном мастер-классе. Такие уроки проводят местные повара, которые досконально знают землю и стремятся поделиться с вами своими знаниями о том, как лучше выбрать, приготовить и насладиться вкуснейшими местными продуктами. Часто гостям предлагают затем самостоятельно выбрать ингредиенты и приготовить блюдо.</p>
									<p><strong>Незабываемые впечатления Галилеи</strong></p>
									<p>Но Галилея - это больше, чем просто рай для гурманов.Это еще и богатая история, и живописные ландшафты: вы увидите древние крепости, где когда-то кипели сражения, и библейские места, где проповедовал Иисус. Совершите подъем на гору, спуститесь на плотах по бурлящим речкам или прокатитесь по берегу на велосипедах. Пусть все это станет частью отпуска вашей мечты в Галилее.</p>
								 		   
		                        `,
      };
    },
  },

  {
    id: "Galilee_Action",
    ctg: "north",
    bgImage: "/posts/bank/north2/1.jpg",
    mobBgImage: "/posts/bank/north2/M.jpg",
    isVid: true,
    vidId: "5Ep3GgxELag",
    title: "ГАЛИЛЕЯ ПРЯМО ПО КУРСУ",
    smltitle: "",
    html: function() {
      return {
        __html: `  



                                     <h2 class="ac-margin-bottom-20 ac-margin-top-20" >Активный отдых и приключения в Галилее</h2>
										<p>Разнообразный ландшафт этого края - множество озер, рек и протяженная береговая линия делают Галилею идеальным местом отдыха для туристов разных возрастов и привычек.<br>&nbsp;Любителям острых ощущений будет, чем заняться - захватывающий спуск на байдарках по бурным рекам, в облаке водных брызг, а семьи с детьми или пары могут насладиться спокойной прогулкой на лодке вдоль тенистых, покрытых зелеными зарослями берегов по одной из многочисленных рек Галилеи.&nbsp; К услугам отдыхающих - многочисленные развлечения на воде, например, водные лыжи, водные горки или кайт-серфинг на Галилейском море. Это поистине море удовольствия и взрыв адреналина!&nbsp; Туристы с удовольствием нежатся на солнышке на белоснежных&nbsp; песчаных пляжах Галилеи или посещают феерично красивые гроты Рош-А-Никра.</p>
										 <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/galilee-action/1.jpg"} class="img-responsive">
								    </div>
										<p>Испытать экстрим здесь можно не только на воде, но также на суше и в воздухе. К услугам туристов, предпочитающих активный отдых, такие насыщенные адреналином занятия, как скай-джампинг, поездки на джипах по крутым горным тропам или спуск по скалам со сложным рельефом. А зимой на горном хребте Хермон можно покататься на лыжах и сноуборде, здесь большой выбор трасс любой сложности.</p>
																      
						       
								  
								   
		                        `,
      };
    },
  },

  {
    id: "Treasures_Of_Galilea",
    ctg: "culinarynorth",
    bgImage: "/posts/bank/north2/1.jpg",
    mobBgImage: "/posts/bank/north2/M.jpg",
    isVid: false,
    title: "СОКРОВИЩА ГАЛИЛЕИ",
    smltitle: "",
    html: function() {
      return {
        __html: ` 



                                    <p>Ваш отпуск мечты в Израиле</p>
						            

								    <p>Чудесный север Израиля, несомненно, заслуживает внимания: маленькие городки на склонах холмов, местные винодельни и ресторанчики рядом с древними историческими местами. Для проживания можно выбрать роскошный отель в городе или загородный отдых в одном из знаменитых «<em>циммеров</em>» Галилеи – это семейные коттеджи в небольших деревнях.</p>
									<p><strong>Здесь оживает история </strong></p>
									<p>В Галилее много исторических мест. Посетите древние города Капернаум и Мигдаль и зайдите в церковь, которая находится на предполагаемом месте дома апостола Петра. На Севере Израиля расположены церкви и монастыри, которые были свидетелями ранних дней христианства. Вы будете дышать святым воздухом древнего города Цфата, в котором находится центр каббалы, мистического средневекового учения. Посетите самые старые синагоги в мире в таких местах, как Барам, а также крепости Крестоносцев - Монфорт и Нимрод. Посетите гробницу философа Маймонида в древнем городе Тверия и взгляните на чудеса Старого Акко, например, подземный город крестоносцев, крепость и туннель тамплиеров.</p>
                                      <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/treasures-of-galilea/1.jpg"} class="img-responsive">
								    </div>
									<p><strong>Рай гурманов в Галилее</strong></p>
									<p>Галилея просто заполнена небольшими винодельнями и сыроварнями, а кроме того, здесь можно попробовать блюда настоящей друзской или арабской кухни, приготовленные на открытом огне.&nbsp; Вы попробуете продукты непосредственно от производителя, полученные без использования химических удобрений. Семейные рестораны ждут гурманов, чтобы угостить их самыми свежими фруктами, выращенными в собственных садах. Откройте для себя Израиль, где текут не только реки из молока и меда, но также из вина и оливкового масла; страну, где делают великолепный козий сыр и выращивают сочные фрукты.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/treasures-of-galilea/2.jpg"} class="img-responsive">
								    </div>
									<p><strong>Активный отдых на живописном лоне природы</strong></p>
									<p>Благодаря сети рек зеленые холмы Нижней Галилеи идеально подходят для велосипедных прогулок. Любители острых ощущений могут попробовать взобраться на горные высоты Верхней Галилеи и заняться рафтингом на бурных стремительных водах реки Иордан. Также здесь вам предложат совершить захватывающие туры на джипах, заняться верховой ездой, взять напрокат велосипед, попробовать пейнтбол и водные развлечения. Доступны и более спокойные виды отдыха, например, вы можете насладиться видами нетронутой природы Израиля, гуляя в обширных заповедниках, или покататься на лодке по спокойным водам озера Кинерет. В северной части страны на заснеженных склонах массивной горы Хермон вы можете заниматься даже зимними видами спорта.</p>
									<p>Проведите отпуск своей мечты на Севере Израиля.</p>
								  
								   
		                        `,
      };
    },
  },

  // {
  // 		id:"Bet_Shean",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:false,
  //         title : "BET SHE’AN",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `  <p>South of the Sea of Galilee are the remains of one of the largest cities in the Roman-Byzantine Empire, Bet She’an. One of ten ancient cities (hence “Decapolis”) that included Philadelphia (present day Amman in Jordan) and Jerash, Scythopolis ((Bet She’an) was the only decapolis city west of the Jordan river.  It was very grand, with a giant theater, streets of tall columns, shops, bathhouses a hippodrome and hundreds of homes.</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/bet-shean/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>However, the splendid city was toppled in 749 by a massive earthquake, and never rebuilt. Over the centuries the ruins were overgrown – and it was not until the mid-20th century that Israeli archeologists pulled Bet She’an out of the murk, discovering (and restoring) the theater, the Cardo, the columns and much more.</p>

  //                         `
  //     }
  //   }
  // },

  // {
  // 		id:"Zichron_Yaakov",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:false,
  //         title : "ZICHRON YA’AKOV",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: ` <p>Zichron Ya’akov is a wonderful town for tourists, both local and foreign. This picturesque moshava semi-cooperative farming community built at the tip of the Carmel mountain range is the first moshava ever built in Israel and is a main tourism and vacation site in this region.</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/zichron-yaakov/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						    <p>Anyone who visits&nbsp;<strong>Zichron&nbsp;Ya’akov&nbsp;</strong>goes straight to Ha-Nadiv Street, and Ha-Meyasdim Street in the town center, which has become a very popular pedestrian mall, thanks to the special atmosphere in this place. The streets are paved with stones and pass between the moshava’s original houses (some of which have been reconstructed), which are bustling with activity.</p>
  // 						   <p>There are many quaint and charming restaurants and coffee shops, interspersed between beautifully designed stores that sell local art works and lovely souvenirs. There are art galleries, unique artists' studios and workshops. New, modern buildings stand alongside old ones, such as the synagogue and the administration building, an old courtyard with a display of antique agricultural implements.</p>
  // 						   <p>From its early days,&nbsp;<strong>Zichron Ya’akov</strong>&nbsp;had two main characteristics: wine and tranquility. The moshava’s founding farmers cultivated vineyards and the large winery built here in 1889 became the area’s most important industry. During the British Mandate period (1917-1948), the moshava became a holiday resort and rural vacations site, and to this day has hotels, spas and guesthouses.</p>

  //                         `
  //     }
  //   }
  // },

  // {
  // 		id:"Discover_The_Wine_Routes",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"Cxii1yKqKwI",
  //         title : "DISCOVER THE WINE ROUTES",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `  <p>Discover a different Israel through it's wineries and vineyards, through the passion of the people who are crafting award winning wines from home grown grapes.</p>
  //                                  <p>Enjoy vintage wines, gourmet foods, and gorgeous scenery. Spend time experiencing Israel as you never have before, as a Wine Connoisseur! The beauty of these routes in Israel is of course the authentic wine but also the incredible landscapes that surround the wineries. Many of the wineries are situated near ‘Zimmers’ which are little spa complexes that are dotted around northern Israel. They have little cabins with Jacuzzis that face out to the magnificent views of the rolling green hills. You can relax in your personal cabin with a splendid glass of wine from the local winery.</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/discover-the-wine-routes/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <div class="wpb_wrapper"><p>The Middle East &amp; Eastern Mediterranean was the cradle of wine production, and the ancient land of Canaan is in fact one of the earliest countries to cultivate wine over 2,000 years before the vine came to Europe.</p><p>There are currently over 25 commercial wineries and over 150 boutique wineries in Israel where wine making has become a personal obsession with wine makers striving to produce world class wines.</p><p>Israel like other 'long' countries such as Chile or Italy enjoys a variety of microclimates. While the northern region gets much rain and even snow in the winter, just a few hours away Israel's southern region is very arid with desert conditions. This range in microclimates supports many grape varieties, which can grow on several different types of soil, yielding excellent results.</p><p>As always in matters of taste, you must visit Israel’s wineries and vineyards and decide for yourself which is your favourite!</p><p></p></div>

  //                         `
  //     }
  //   }
  // },

  {
    id: "Birdtastic_Hula_Lake",
    ctg: "north",
    bgImage: "/posts/bank/north2/1.jpg",
    mobBgImage: "/posts/bank/north2/M.jpg",
    isVid: true,
    vidId: "ImobrsxsKl8",
    title: "ОЗЕРО ХУЛА",
    smltitle: "",
    html: function() {
      return {
        __html: `  
                                   <br/>
                                   <h2 class="ac-align-center ac-margin-top-20">Очарование природы</h2>
						            
								   


								    <p  class="ac-align-center ac-margin-bottom-20"><strong>Одно из лучших в мире мест для наблюдения за птицами</strong></p>
									<p>В сердце живописной долины Хула в Верхней Галилее, что всего в двух часах езды на север от Тель-Авива, между двух величественных горных гряд находится место невероятной красоты — озеро Хула. Это одно из важнейших мест наблюдения за птицами в мире: получивший международное признание экологический водно-болотный заповедник и подлинный оазис как для птиц, так и для любителей природы со всего мира. У вас есть уникальная возможность понаблюдать за природой без заборов и решеток, воспользуйтесь ею!</p>
									 <div class="img-wrapper">
																		   <img src=${getImgUrl() +
                                         "/posts/birdtastic-hula-lake/1.jpg"} class="img-responsive">
																	    </div>
									<p><strong>Наблюдайте за птицами и любуйтесь природой</strong></p>
									<p>Во время каждого сезона миграции (весной и осенью) более 500 миллионов птиц приблизительно 400 видов пролетают через озеро Хула. Этот болотистый рай — идеальный «перевалочный пункт» для бакланов, цапель, пеликанов, аистов и журавлей.</p>
									<p>Озеро Хула (на иврите — <em>Агмон А-Хула) </em>признано журналом BBC Wildlife одним из 10 важнейших мест наблюдения за птицами в мире и привлекает любителей птиц из самых разных стран. Посетите международный фестиваль птиц в долине Хула, который проходит каждый год осенью. Такое уникальное событие просто нельзя пропустить.</p>
									<p>Есть несколько способов понаблюдать за этим невероятным природным феноменом — выберите тот, что вам по душе.</p>
									<p><strong>Прогулка по тропинкам</strong>. Прогуляйтесь по волшебным тропинкам парка. Вы можете пойти пешком или поехать на велосипеде либо же маленьком электромобиле. Ваш путь будет пролегать через фруктовые рощи, а в конце вы сможете увидеть дикую красоту болот.</p>
									<p><strong>Поездка на тракторе</strong>. Закажите экскурсию с гидом на «Сафари-вагоне», прицепленном к трактору, который увезет вас в глубину заповедника. Вагон «спрячет» вас от птиц, и вы сможете поближе познакомиться с этими прекрасными созданиями.</p>
									<p><strong>Экскурсия на рассвете или в ночное время</strong>. Любителям более острых ощущений предлагаются две особые экскурсии. Первая — «Экскурсия на восходе солнца» — подарит незабываемые возможности наблюдения за птицами и фотографирования. «Экскурсия ночной совы» — совершенно иной взгляд на заповедник. При свете звезд и ночного костра вы сможете подсмотреть жизнь диких кошек, ночных хищников и летучих мышей.</p>
									 <div class="img-wrapper">
																		   <img src=${getImgUrl() +
                                         "/posts/birdtastic-hula-lake/2.jpg"} class="img-responsive">
																	    </div>
									<p><strong>Как охраняют природу</strong></p>
									
									<p>Озеро Хула — признанный в мире пример устойчивой экологической системы, где гармонично сочетаются природа, туризм и сельское хозяйство.</p>
									<p>Посетите центр кольцевания в заповеднике и понаблюдайте, как проводится работа по охране природы. Закажите «Экскурсию по острову птиц» и, возможно, вы сможете помочь выпустить птицу обратно в дикую природу. Поверьте, это незабываемое впечатление.</p>
									<p>Богатство животного мира и неустанная работа по охране природы, ведущаяся с использованием творческих экологически безопасных способов, делают посещение озера Хула не просто интересной целью путешествия, но и невероятно сильным эмоциональным переживанием, затрагивающим душу и сердце.</p>
																	  	                     
		                        `,
      };
    },
  },

  {
    id: "The_Kibbutz_Experience",
    ctg: "north",
    bgImage: "/HomeSlider/desktop/4.jpg",
    mobBgImage: "/HomeSlider/M/3.jpg",
    isVid: false,
    title: "THE INCOMPARABLE KIBBUTZ EXPERIENCE",
    smltitle: "",
    html: function() {
      return {
        __html: `  
						           <p>Predominantly based amongst beautiful landscape settings dotted around the country the Kibbutz life is a modern day phenomenon and a totally unique way of living. The movement which started in 1905 is a collective community way of living traditionally based on agriculture. Each kibbutz would sell its own produce.  The people living on them would all collectively work together to preserve it and work the land.</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/kibbutz-experience/1.jpg"} class="img-responsive">
								   </div>
								    <p>The word ‘Kibbutz’ in Hebrew means group.&nbsp;The point being it is a voluntary democratic community where people live and work together to generate economically. It is founded on the principles of communal ownership of property and social equality.</p>
                                   <p>Some would describe the beautiful settings and a life of equality a utopia and why not experience it for yourself?&nbsp; Many of the Kibbutzim are open to visitors whether you would like to stay a few hours or a few months learning what this life is all about.</p>
								   
		                        `,
      };
    },
  },

  {
    id: "National_Parks",
    ctg: "north",
    bgImage: "/HomeSlider/desktop/4.jpg",
    mobBgImage: "/HomeSlider/M/3.jpg",
    isVid: false,
    title: "NATIONAL PARKS",
    smltitle: "",
    html: function() {
      return {
        __html: ` 

						          <p>Despite Israel being small its scenery varies immensely! You will find new cities and old, beaches and lakes, deserts and green mountains. Israel’s National parks and nature reserves make all this possible for you to experience the wondrous landscapes.</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/national-parks/1.jpg"} class="img-responsive">
								   </div>
								   <p>In the south of the country you will find the expanse of the golden and orange plains of the desert. The Negev, Arava and Eilat are the fiery beautiful landscapes of the south that home the Dead Sea, Mitzpe Ramon and the beautiful desert oasis of En gedi not mention some wonderful hiking and cycling trails. When the sun sets the south turns in to a red illuminous sea of magic and when dark the sky turns in to a blanket of sparkles as the vast scenery makes it possible to see every star.</p>
                                   <p>In the North of the country you are welcomed with Luscious green hills and mountains including the snow-capped Mount Hermon.&nbsp; The Golan Heights home to magnificent mountainous scenery and an array of cultures.&nbsp; There are endless forest trails and water fall hikes for all the family to enjoy. The view from the mountain tops is breath taking as your eyes take you all the way out to the Mediterranean. Below the mountains you will find the green slopes of the Galilee home to the famous Kinneret, wineries and some wonderful relaxation spa’s. It really is a wonderland.</p>
								   <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/national-parks/2.jpg"} class="img-responsive">
								   </div>
								   <p>The national parks offer exciting cultural and natural adventures. You have the opportunity to visit magnificent historical sites and follow wonderful nature trails while searching for some of the countries species i.e. The desert ibex and leopards, Eagles in the Golan. The impressive diversity of natural wonders, encounters with unspoiled nature and with plants.</p>
		                        `,
      };
    },
  },

  {
    id: "Tiberias",
    ctg: "north",
    bgImage: "/HomeSlider/desktop/4.jpg",
    mobBgImage: "/HomeSlider/M/3.jpg",
    isVid: false,
    title: "TIBERIAS (TVERYA)",
    smltitle: "",
    html: function() {
      return {
        __html: `  
						           <p>Located at the shores of the Sea of Galilee, Tiberias, the capital of the Galilee, was established in the early Roman period and has served as a religious, administrative and culture center of the Jewish people for many years.</p>
                                  <p>In addition to its rich history and significance, modern day Tiberias is synonymous with holiday in Israel. Here one can enjoy a variety of activities the city has to offer, and experience a wonderful mix of relaxation, nature and history, along with contemporary attractions, active water sports, pilgrimage sites and unique tourist attractions</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/tiberias/1.jpg"} class="img-responsive">
								   </div>
								   <p>A visit to Tiberias is not complete without a visit to its surrounding area, which features many must-see sights, including The city Bet Shean, one of the oldest cities in the world, and one of the country’s largest archaeological sites; Magdala (Migdal) the ancient town on the Sea of Galilee which was home to many of Jesus’s disciples and is said to have been the home of Mary Magdalene; Megiddo, a beautiful and impressive national park and one of the most important archeological sites in Israel from the time of the Bible. Once an ancient city of critical strategic importance, Megiddo is a UNESCO World Heritage Site, and an inspiring location for lovers of history and archeology.</p>
								   
		                        `,
      };
    },
  },

  {
    id: "Privacy_Policy",
    ctg: "telaviv",
    bgImage: "/HomeSlider/desktop/1.jpg",
    mobBgImage: "/HomeSlider/M/3.jpg",
    isVid: false,
    title: "PRIVACY POLICY",
    smltitle: "",
    html: function() {
      return {
        __html: `


                            <p><u><span>Last updated</span></u><span>: March 4, 2020</span></p>
                            
                            <h3><span>OUR COMMITMENT TO YOU</span><span>&nbsp;</span></h3>
                            <p>We, at&nbsp;The Israeli government, the Ministry of Tourism ("<strong>us</strong>", "<strong>we</strong>" or the<strong>&nbsp;"Ministry</strong>") respect the privacy of our users (each, a "<strong>User</strong>" or "<strong>you</strong>") and are committed to protect the privacy of Users who access, download, install, register, use or engage with our website, our mobile application(s), and any other service we provide (the<strong>&nbsp;</strong>"<strong>Website</strong>" and "<strong>App</strong>" respectively, and collectively the "<strong>Service(s)</strong>"). &nbsp;</p>
                            <p>We've prepared this Privacy Policy to outline our practices with respect to collecting, using and disclosing your information when you use the Services. We encourage you to read this Privacy Policy carefully and use it to make informed decisions. By using the Services, you agree to the terms of this Privacy Policy and your continued use of the Services constitutes your ongoing agreement to the Privacy Policy.</p>
                            
                            <h3><span>CONTENTS</span></h3>
                            <p>
                              <a href="#Grounds" style="color:#000"><span>1. </span>GROUNDS FOR DATA COLLECTION</a><br/>

                              <a href="#WhatType" style="color:#000"><span>2. </span>WHAT TYPE OF DATA WE COLLECT?</a><br/>

                              <a href="#HowDoWeUse" style="color:#000"><span>3. </span>HOW DO WE USE THE DATA WE COLLECT?</a><br/>

                              <a href="#Tracking" style="color:#000"><span>4. </span>TRACKING TECHNOLOGIES</a><br/>

                              <a href="#WitWhom" style="color:#000"><span>5. </span>WITH WHOM DO WE SHARE YOUR PERSONAL DATA?</a><br/>

                              <a href="#HowWeProtect" style="color:#000"><span>6. </span>HOW WE PROTECT YOUR INFORMATION</a><br/>

                              <a href="#Retention" style="color:#000"><span>7. </span>RETENTION</a><br/>

                              <a href="#UserRigths" style="color:#000"><span>8. </span>USER RIGHTS</a><br/>

                              <a href="#Transfer" style="color:#000"><span>9. </span>TRANSFER OF DATA OUTSIDE THE EEA</a><br/>

                              <a href="#OurPolicy" style="color:#000"><span>10. </span>OUR POLICY TOWARD CHILDREN</a><br/>

                              <a href="#HowToContactUs" style="color:#000"><span>11. </span>HOW TO CONTACT US?</a><br/>

                              <a href="#Updates" style="color:#000"><span>12. </span>UPDATES TO THIS POLICY</a><br/>
                            </p>

                            
                            <h3 id="Grounds"><span>GROUNDS FOR DATA COLLECTION</span><span>&nbsp;</span></h3>
                            <p><span>Processing of your “<strong>Personal Data</strong>” (meaning any information which may potentially allow your identification, either directly or by using reasonable means) is necessary for the performance of our contractual obligations towards you, for providing you with our Services and the operation of our Website, to protect our legitimate interests and for compliance with legal and regulatory obligations to which we are subject.</span></p>
                            <p><span>When you use our Services, you consent to the collection, storage, use, disclosure and other uses of your Personal Information as described in this Privacy Policy.</span></p>
                            
                            <h3 id="WhatType"><span>WHAT TYPE OF DATA WE COLLECT?</span></h3>
                            <h3><span>Personal Data</span></h3>
                            <p><span>In the course of using the Services, we may collect certain Personal Data to provide and improve the Services, to contact or identify you, to enable you to access certain parts of the Service</span><span>&nbsp;or as otherwise indicated in this Policy. We collect the following Personal Data about you</span><span>:</span></p>
                            <ul style="list-style-type: disc;margin-left:0in;">
                              <li><span>When you send us an email&nbsp;</span><span>or contact us through a contact form on the Website, we will collect your name and email address so we could respond to your inquiry. We may also collect any Personal Data that you choose to include in your inquiry to us.</span></li>
                              <li><span>Our webserver may also automatically collect your IP address, and unique online identifiers. These details are pseudonymized (cannot directly identify you) and are collected for the purpose of delivering relevant content and operating and improving our Service.</span></li>
                            </ul>
                            <h3><span>Non-Personal Data</span></h3>
                            <p><span>We also collect data about the use of our Service and the characteristics and activities of users, in order to operate it and improve it. We may collect the following non-Personal Data:&nbsp;</span><span>Your operating system, device type, session start/stop time, time zone, network connection type (e.g., Wi-Fi, cellular), your general location (city and country), and general information regarding your browser and device.</span></p>
                            <p><span>If we combine Personal Data with non-Personal Data, the combined data will be treated as Personal Data.&nbsp;</span></p>
                            
                            <h3 id="HowDoWeUse"><span>HOW DO WE USE THE DATA WE COLLECT?</span></h3>
                            <ul>
                              <li><strong><span>Provision of the Service</span></strong><em><span>&nbsp;–&nbsp;</span></em><span>we will use the Personal Data you provide us for the provision and improvement of our Service, providing customer support and to respond to your queries.&nbsp;</span></li>
                              <li><strong><span>Service announcements</span></strong><span>&nbsp;- we will use your Personal Data to communicate with you and to keep you informed of our latest updates to our Service and offer you service offers.</span></li>
                              <li><strong><span>Analytics, surveys and research</span></strong><span>&nbsp;- from time to time, we may conduct surveys or test features, and analyze the data we have to develop, evaluate and improve these features, all in order to improve our Services and offerings, and think of new and exciting features for our users.</span></li>
                              <li><strong><span>Protecting our interests</span></strong><em><span>&nbsp;-&nbsp;</span></em><span>we may use your Personal Data when we believe it’s necessary in order to take precautions against liabilities, investigate and defend ourselves against any third party claims or allegations, investigate and protect ourselves from fraud, protect the security or integrity of our services and protect the rights and property of the Ministry, its users and/or partners.&nbsp;</span></li>
                              <li><strong><span>Enforcing of policies</span></strong><span>&nbsp;- we may use your Personal Data in order to enforce our policies, including but not limited to our <a href="https://new.goisrael.com/international/Posts/telaviv/Privacy_Policy" style="text-decoration:underline;color:#000" target="_blank"> Terms </a></span><span style="line-height:115%;font-family:Calibri;font-size:8.0pt;color:windowtext;">
                                 
                                </span><span style="line-height:;font-family:Calibri;line-height:;color:windowtext;">.&nbsp;</span></li>
                              <li><strong><span>Compliance with legal and regulatory requirements</span></strong><span>&nbsp;- we may use your Personal Data to investigate violations, and as required by law, regulation or other governmental authority, or to comply with a subpoena or similar legal process.</span></li>
                              <li><strong><span>Newsletter</span></strong><span>&nbsp;- we may use your Personal Data in order to send you our newsletter, if you subscribed to it. &nbsp;</span>
                                <ol style="list-style-type: circle;">
                                  <li><u><span>Opt-out of receiving our newsletter</span></u><span>&nbsp;- You may choose not to receive our newsletter by clicking on the “unsubscribe” link contained therein. Please note that even if you unsubscribe, we may continue to send you Service-related updates and notifications, or reply to your queries and feedback you provide us.&nbsp;</span></li>
                                </ol>
                              </li>
                            </ul>
                            
                            <h3 id="Tracking"><span>TRACKING TECHNOLOGIES</span></h3>
                            <p><span>When you visit or access our Services we use (and authorize 3<sup>rd</sup> parties to use) pixels, cookies, events and other technologies (collectively, "<strong>Tracking Technologies</strong>"). Those allow us to automatically collect information about you, your device and your online behavior, in order to enhance your navigation in our Services, improve our Services’ performance, perform analytics and customize your experience. In addition, we may merge data we have with data collected through these tracking technologies and data we may obtain from other sources and, as a result, such data may become Personal Data.</span></p>
                            <p>If you do not accept the use of cookies by us, please disable cookies by following the instructions below. However, please note that disabling cookies might seriously affect the function, User experience and other features of our Services.</p>
                            <h3>Types of Tracking Technologies We Use</h3>
                            <p>There are two broad categories of cookies: (a) <strong>First party cookies</strong>, served directly by us to your computer or mobile device, and (b) <strong>Third party cookies</strong>, served by a third party. We use third party cookies for functionality, performance and analytics, and social media purposes.</p>
                            <p>Cookies can remain on your computer or mobile device for different periods of time. Some cookies are "session cookies" and expires upon closing of your browser. Other cookies are "persistent cookies", meaning that they survive after your browser is closed. They can be used by websites to recognize your computer when you open your browser and browse the Internet again.</p>
                            <p>For example, we use a performance tracking technology tool called “<strong>Google Analytics</strong>” to collect information about the use of the Website. Google Analytics collects information such as how often users visit this site, what pages they visit when they do so, and what other sites they used prior to coming to this Site. We use the information we get from Google Analytics to maintain and improve the Site and our products. We do not combine the information collected through the use of Google Analytics with personally identifiable information. Google’s ability to use and share information collected by Google Analytics about your visits to this Site is restricted by the Google Analytics Terms of Service, available at 
                              <a href="//www.google.com/analytics/terms/us.html" target="_blank" style="text-decoration:underline;color:#000">www.google.com/analytics/</a>, and the Google Privacy Policy, available at 
                              <a href="//www.google.com/policies/privacy/" target="_blank" style="text-decoration:underline;color:#000">www.google.com/policies/</a>. You can opt-out of Google's collection of Personal Data through Google Analytics by downloading and installing the Google Analytics Opt-out Browser Add-on, available at 
                              <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" style="text-decoration:underline;color:#000">tools.google.com/dlpage/gaoptout</a>.
                            </p>
                            <h3><span>Interest-Based Advertising &amp; User Choice</span></h3>
                            <p>Through our Services, we may display advertisements that are tailored to you, for example ads or partner services that are based on your recent browsing behavior. In order to tailor advertisements and services in which you might be interested, we as well as certain third parties may use Tracking Technologies to display advertisements based on your visits to the Websites, to target advertisements to you for products and services in which you might be interested, and to measure the effectiveness of the ads. You can turn off certain third party Tracking Technologies used for behavioral advertising purposes by visiting the Network Advertising Initiative&nbsp;or by visiting the&nbsp;DAA opt-out program&nbsp;or the&nbsp;EDAA consumer choice page&nbsp;(if you reside in the EU) using the links provided below. Please note that certain Tracking Technologies operate at the device and browser level, so to fully opt-out across devices, you will need to do so on each device and browser individually, as described below as well.</p>
                            <h3><span>How to Manage Your Tracking Technologies Settings</span></h3>
                            <p>There are various ways in which you can manage and control your Tracking Technologies settings. Please remember that, by deleting or blocking Tracking Technologies, some of the features of the Services may not work properly or as effectively.</p>
                            <p style="margin-bottom:6.0pt;"><strong>Turning off cookies via your web browser
                                <br>&nbsp;
                              </strong>Most web browsers will provide you with some general information about cookies, enable you to see what cookies are stored on your device, allow you to delete them all or on an individual basis, and enable you to block or allow cookies for all websites or individually selected websites. You can also normally turn off third party cookies separately. Please note that the settings offered by a browser or device often only apply to that particular browser or device. Information about cookies is usually found in the "Help" section of the web browser. Below are some links to some commonly used web browsers:</p>
                            <p>
                              <a href="https://support.google.com/chrome/answer/95647?hl=en" target="_blank" style="text-decoration:underline;color:#000"><span>Google Chrome</span></a><br/>

                              <a href="https://support.microsoft.com/en-us/kb/260971" target="_blank" style="text-decoration:underline;color:#000"><span>Internet Explorer</span></a><br/>

                              <a href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer" target="_blank" style="text-decoration:underline;color:#000"><span>Mozilla Firefox</span></a><br/>

                              <a href="https://support.apple.com/kb/PH5042?locale=en_US" target="_blank" style="text-decoration:underline;color:#000"><span>Safari (Desktop)</span></a><br/>

                              <a href="https://support.apple.com/en-us/HT201265" target="_blank" style="text-decoration:underline;color:#000"><span>Safari (Mobile)</span></a><br/>

                              <a href="//support.google.com/ics/nexus/bin/answer.py?hl=en&amp;answer=2425067" target="_blank" style="text-decoration:underline;color:#000"><span>Android Browser</span></a><br/>

                              <a href="//www.opera.com/help" target="_blank" style="text-decoration:underline;color:#000"><span>Opera</span></a><br/>

                              <a href="//www.opera.com/help/mobile/android#privacy" target="_blank" style="text-decoration:underline;color:#000"><span>Opera Mobile</span></a>
                            </p>
                            <p>For other browsers, please consult the documentation that your browser manufacturer provides.</p>
                            <p style="margin-bottom:6.0pt;"><strong>Turning off third party cookies
                                <br>&nbsp;
                              </strong>You can turn off certain third party targeting/advertising cookies by visiting the following link:&nbsp;
                              <a href="//www.networkadvertising.org/choices/" target="_blank" style="text-decoration:underline;color:#000">Network Advertising Initiative</a>.
                            </p>
                            <h3><span>Other helpful resources</span><br/></h3>
                            <p>
                            <span>To learn more about advertisers’ use of cookies the following links may be helpful:</span><br/>
                              <a href="//www.youronlinechoices.eu/" target="_blank" style="text-decoration:underline;color:#000"><span>European Interactive Digital Advertising Alliance (EU)</span></a><br/>

                              <a href="//www.iab.net/" target="_blank" style="text-decoration:underline;color:#000"><span>Internet Advertising Bureau (US)</span></a><br/>

                              <a href="//www.iabeurope.eu/" target="_blank" style="text-decoration:underline;color:#000"><span>Internet Advertising Bureau (EU)</span></a>
                            </p>
                            <p style="margin-top:6.0pt;margin-right:0in;margin-bottom:.0001pt;margin-left:0in;text-align:justify;"><strong>Turning off cookies on a mobile device</strong></h3>
                            <p>You can-opt out of certain types of interest-based advertising, by accessing the “settings” on your device:</p>
                            <ul style="list-style-type: disc;margin-left:undefined;">
                              <li><strong><span>If you're using an Apple device</span></strong><span>&nbsp;you can configure your device to limit ad tracking to by clicking on "settings" &gt; "privacy" &gt; "advertising" and toggling "limit ad tracking" to ‘on.’</span></strong></li>
                              <li><strong><span>If you're using an Android device</span></strong><span>&nbsp;you can opt out of most app-based tracking for advertising by opening the "Google Settings" app on your device, selecting "Ads", and then selecting the option to opt-out of interest-based ads.</span></strong></li>
                            </ul>
                            <p>Please note that the above information may change when manufacturers update their systems. Also note, that your device may use another platform, not described above. In that case, please consult the manufacturer documentation for further instructions.</p>
                            
                            <h3 id="WitWhom"><span>WITH WHOM DO WE SHARE YOUR PERSONAL DATA?</span></h3>
                            <ul>
                              <li><strong><span>Internal concerned parties</span></strong><span>&nbsp;- we may share your information with other</span><span style="color:windowtext;">&nbsp;</span><span>government ministries, as well as our employees, as needed to provide our Services.</span></li>
                              <li><strong><span>Business partners</span></strong><span>&nbsp;- we may share your information with business partners such as storage and analytics providers who help us provide you with our Services. These third parties may have access to your Personal Data so that they may perform these tasks on our behalf, but they are obligated to comply with the highest security standards and applicable data protection legislation, and may not use your Personal Data for any other purpose.</span></li>
                              <li><strong><span>Compliance with laws and law enforcement entities</span></strong><span>&nbsp;- we cooperate with other governmental agencies and law enforcement officials to enforce and comply with the law. We will disclose Personal Data about you to government or law enforcement officials or private parties if we, in our sole discretion, believe necessary or appropriate to respond to claims and legal process (including but not limited to subpoenas), to protect our or a third party's property and rights, to protect the safety of the public or any person, or to prevent or stop any activity we may consider to be, or to pose a risk of being, illegal, unethical, inappropriate or legally actionable.&nbsp;</span></li>
                            </ul>
                            
                            <h3 id="HowWeProtect"><span>HOW WE PROTECT YOUR INFORMATION</span></h3>
                            <p><span>We have implemented administrative, technical, and physical safeguards to help prevent unauthorized access, use, or disclosure of your Personal Data. Your data is stored on secure servers and isn’t publicly available. We limit access of your information only to those employees or partners on a “need to know” basis, in order to enable the carrying out of the agreement between us.&nbsp;</span></p>
                            <p><span>While we seek to protect your information to ensure that it is kept confidential, we cannot absolutely guarantee its security. You should be aware that there is always some risk involved in transmitting information over the internet. While we strive to protect your Personal Data, we cannot ensure or warrant the security and privacy of your Personal Data or other content you transmit using the Service, and you do so at your own risk.&nbsp;</span></p>
                            
                            <h3 id="Retention"><span>RETENTION</span></h3>
                            <p><span>We will retain your Personal Data for as long as necessary to provide our Services, and as necessary to comply with our legal obligations, resolve disputes, and enforce our policies. Retention periods will be determined taking into account the type of information that is collected and the purpose for which it is collected, bearing in mind the requirements applicable to the situation and the need to destroy outdated, unused information at the earliest reasonable time. Under applicable regulations, we will keep records containing Personal Data, communications and anything else as required by applicable laws and regulations.&nbsp;</span></p>
                            
                            <h3  id="UserRigths"><span>USER RIGHTS</span></h3>
                            <h4><strong><span style="font-family:&quot;Calibri&quot;,sans-serif;color:windowtext;font-style:normal;">EU User Rights</span></strong></h4>
                            <p><span>As an EU resident, you may request to:&nbsp;</span></p>
                            <ol start="1" style="list-style-type: lower-alpha;margin-left: 0px;">
                              <li><span>Receive confirmation as to whether or not Personal Data concerning you is being processed, and access your stored Personal Data, together with supplementary information.&nbsp;</span></li>
                              <li><span>Receive a copy of Personal Data you directly volunteer to us in a structured, commonly used and machine-readable format.&nbsp;</span></li>
                              <li><span>Request rectification of your Personal Data that is in our control.</span></li>
                              <li><span>Request erasure of your Personal Data.&nbsp;</span></li>
                              <li><span>Object to the processing of Personal Data by us.&nbsp;</span></li>
                              <li><span>Request to restrict processing of your Personal Data by us.</span></li>
                              <li><span>Lodge a complaint with a supervisory authority.</span></li>
                            </ol>
                            <p><span>Please note that these rights pertain to EU residents only, are not absolute, and may be subject to our own legitimate interests and regulatory requirements.&nbsp;</span></p>
                            <p><span>Users Outside the EU -&nbsp;</span></strong><span>Some of the aforementioned rights are applicable in certain jurisdictions outside the EU as well. Users residing outside the EU are welcome to contact us for any questions or requests by using the details provided below.</span></p>
                            
                            <h3 id="Transfer"><span>TRANSFER OF DATA OUTSIDE THE EEA</span><span>&nbsp;</span></h3>
                            <p><span>If you reside in the European Union ("<strong>EU</strong>"), please note that some data recipients may be located outside the EEA. In such cases we will transfer your data only to such countries as approved by the European Commission as providing adequate level of data protection, or enter into legal agreements ensuring an adequate level of data protection.</span></p>
                            
                            <h3 id="OurPolicy"><span>OUR POLICY TOWARD CHILDREN</span></h3>
                            <p>We do not knowingly collect or solicit personal information from anyone under 18 years of age, (or the age of consent as determined under the applicable laws where the individual resides; “<strong>Age of Consent</strong>”). By accessing, using or interacting with our Services, you certify to us that you are not under the Age of Consent. In the event that we learn that we have collected personal information from an individual under the Age of Consent without verification of parental consent, we will delete that information upon discovery. If you believe that we might have any information from or about an individual under the Age of Consent, then please contact us through the contact details available below.</p>
                            
                            <h3 id="HowToContactUs"><span>HOW TO CONTACT US?</span></h3>
                            <p><span>If you wish to exercise any of the aforementioned rights, or receive more information, please contact us using the details below:</span><br/>Email:<a href="mailto:Dpo@tourism.gov.il" style="text-decoration:underline;color:#000"> Dpo@tourism.gov.il</a>
                            </p>
                            
                            <h3 id="Updates"><span>UPDATES TO THIS POLICY</span></h3>
                            <p>This Privacy Policy is subject to changes from time to time, in our sole discretion. The most current version will always be posted on our Services (as reflected in the "Last Updated" heading). You are advised to check for updates regularly. By continuing to access or use our Services after any revisions become effective, you agree to be bound by the updated Privacy Policy.&nbsp;</p>

                           
                            `,
      };
    },
  },

  {
    id: "Destination_For_All",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: true,
    vidId: "QWA7qwsbbGY",
    title: "НАПРАВЛЕНИЕ ДЛЯ ВСЕХ И КАЖДОГО",
    smltitle: "",
    html: function() {
      return {
        __html: `


			<p>В Израиле наблюдается беспрецедентный рост числа туристов и гостей из других стран. Все больше людей со всего мира решают исполнить свою мечту и посетить Израиль. Министерство туризма стремится предоставить возможность всем желающим посетить страну, включая тех, кто страдает от различных ограничений и проблем со здоровьем.</p>
            <p>Когда речь заходит о создании доступной среды, Израиль по праву считается мировым лидером в области законодательства в данной сфере. Израиль предлагает обширную инфраструктуру и полный набор услуг, которые позволят сделать ваше пребывание предельно комфортным.</p>
            <p>Перед вами список компаний и проектов, которые помогут сделать ваше пребывание в Израиле простым и комфортным. Вам ни в чем не придется себя ограничивать. </p>
            <div class="img-wrapper">
			   <img src=${getImgUrl() +
           "/posts/destination-for-all/1.jpg"} class="img-responsive">
			</div><br>
			<h2 class="ac-margin-bottom-20">НКО и путешествия</h2>
			<p><b>Еврейский национальный фонд (Keren Kayemeth LeIsrael)</b></p>
			<p><u>Удобный доступ в леса, парки и площадки для отдыха в Израиле </u><br/>
			В последние годы Еврейский национальный фонд работает над созданием специальных объектов для людей с ограниченными физическими возможностями на территории действующих парков и лесных массивов. Наша цель состоит в том, чтобы сделать природу доступной для всех слоев населения, создавая среду, в которой люди с ограниченными возможностями могут безопасно и комфортно передвигаться. Кроме того, мы сделали еще один шаг вперед и постарались принести природу на территорию школы, занимаясь уникальными проектами в специальных учебных заведениях. <a href="//www.kkl-jnf.org/tourism-and-recreation/accessible-forests-parks-sites-israel/" target="_blank">www.kkl-jnf.org</a>
		   </p>

		   <p><b>Управление по вопросам природы и парков</b></p>
		   <p>В последние годы Управление по вопросам природы и парков работает над тем, чтобы сделать свои все площадки доступными для людей с ограниченными возможностями. Во всех национальных парках, заповедниках и объектах культурного наследия ведется работа по повышению доступности и обеспечению безопасного доступа к ним.
              Управление по вопросам природы и парков делает все возможное, чтобы увеличить число посетителей с ограниченными возможностями, которые смогут путешествовать и наслаждаться этими местами, принимая участие во всех событиях и мероприятиях.<br/>
              На нашем сайте вы сможете найти дополнительную информацию и подробные карты. <a href="https://www.parks.org.il/en/accessibility/" target="_blank">www.parks.org.il</a></p>
			 
			<div class="img-wrapper">
			<img src=${getImgUrl() +
        "/posts/destination-for-all/2.jpg"} class="img-responsive">
		 </div><br>
			 <p><b>Яд Сара для туристов</b></p>
			 <p>Путешествие за границу представляет собой большую проблему для людей с особыми потребностями и ограниченными возможностями. Проект Яд Сара, предназначенный для туристов предлагает помощь, обеспечивая приятный и спокойный отдых для человека с особыми потребностями и его семьи. После того, как ваши планы будут окончательно согласованы с туристическим бюро, гость страны может расслабиться, зная, что вся работа по подготовке к посещению страны находятся в умелых руках представителя Яд Сара.</p>
		   
				<p> <u>Несколько вариантов доступных услуг</u>:<br/>
				 
				• Аренда необходимого медицинского оборудования. Доставка в отель или к месту проживания может быть организована за отдельную плату.<br/>
				• Специальное оснащение гостиничного номера, позволяющее сделать ваше пребывание более комфортным (включая специальные кровати, стулья и т.д.)<br/>
				• Аренда кислородных баллонов, концентраторов.<br/>
				• Перевозка в микроавтобусах с местами для коляски, включая трансфер в аэропорт и обратно, а также посещение различных достопримечательностей.<br/>
				• Рекомендации гидов-экскурсоводов, специализирующихся на сопровождении туристов с ограниченными физическими возможностями и особыми потребностями, включая консультации по туристическим объектам с легким доступом.

				<br/>
				 По предварительной договоренности с туристическим бюро, для любого туриста с особыми потребностями предоставляется индивидуальное обслуживание в Яд Сара.<br/>

		

		Эта услуга доступна по всему Израилю.<br/>

			Для получения более подробной информации, а также для организации трансфера или тура, пожалуйста, позвоните по телефону <a href="tel:+97226444382">+972-2-6444382</a> или напишите нам по электронной почте: <a href="mailto:chaimvi@yadsarah.org.il">chaimvi@yadsarah.org.il</a></p>
			<div class="img-wrapper">
			<img src=${getImgUrl() +
        "/posts/destination-for-all/3.jpg"} class="img-responsive">
		 </div><br>
			<p><b>Access Israel</b></p>
			<p>Access Israel - некоммерческая организация, которая содействует формированию доступной среды и вовлечению людей с ограниченными возможностями и пожилых людей во все сферы жизни. Проект Access Israel был основан в 1999 году Ювалем Вагнером, бывшим пилотом, который стал инвалидом после падения вертолета и может передвигаться только на коляске. Проект Access Israel проводит различные мероприятия для создания полностью доступного и инклюзивного общества, включая проекты по повышению осведомленности в школах, консультации по вопросам доступности для бизнеса, курсы доступности, курсы языка жестов, а также конференции по различным вопросам и многое другое. Стоит отдельно отметить, что проект Access Israel работает над созданием доступной среды в израильском законодательстве, отвечает за работу центра по приему жалоб и организует информационно-просветительские мероприятия для представителей общественности. Проект Access Israel занимается развитием доступной среды и вовлечением во все сферы жизни, а также отвечает за работу в сфере образования, туризма, культуры, чрезвычайных ситуаций и решает ряд других вопросов. 
				<a href="https://www.aisrael.org/?CategoryID=3030" target="_blank">Доступный туризм на сайте Access Israel</a></p>

				<p><u>LOTEM</u> - это крупнейшая организация в Израиле по обучению детей с особыми потребностями на открытом воздухе, которая проводит образовательные мероприятия на природе, а также организует походы для лиц с ограниченными возможностями. Герой войны Сурин Хершко, который был тяжело ранен в операции "Энтеббе" в 1976 году, стал основателем и председателем компании LOTEM. Он испытывает истинную страсть и черпает вдохновение из самого сердца, чтобы "дать детям право открыть для себя все прелести жизни на открытом воздухе, ведь это цель моей жизни, и она наполняет меня радостью и безграничной любовью." Основной объект, Эмек Ха-Шалом (Долина мира), представляет собой ферму площадью 40 акров, расположенную на севере Израиля, недалеко от города Йокнеам-Илит. Будучи расположенной в центре очаровательной долины, ферма окружена цветущей природой и потоками воды, которые создают умиротворенную обстановку. По сути, проект предоставляет возможность обучения прямо на территории цветущего сада, в котором создана доступная среда с оливковыми и винными прессами, пекарнями и дорожками для инвалидных колясок.</p>
				<p>Проект <u>LOTEM</u> понимает важную роль, которую играет внешний мир в жизни израильтян, и осознает удивительное влияние, которое оказывает доступность общества не только на человека с особыми потребностями, но и на его семью и представителей его окружения. В рамках работы по обеспечению того, чтобы ни один член общества не остался за пределами доступной среды, проект LOTEM предоставляет возможность детям и взрослым с особыми потребностями учиться и участвовать в мероприятиях на свежем воздухе по всей стране. 
				<a href="https://www.lotem.net/?page_id=386" target="_blank">www.lotem.net</a></p>

				<h2 class="ac-margin-bottom-20 ac-margin-top-20"> Транспортные услуги</h2>
				<p><b>Управление аэропортов Израиля</b></p>
				<p>Стоит отметить, что согласно действующему законодательству Управление аэропортов Израиля несет ответственность за обеспечение физической инфраструктуры для деятельности организаций, оказывающих услуги пассажирам, которым требуется особая поддержка. Тем не менее, согласно международным правилам, ответственность за работу с пассажирами, которым оказывается помощь, а также за их багаж с момента их прибытия в здание аэровокзала или высадки из воздушного судна лежит на авиакомпании, с которой летят пассажиры. Фактическое обслуживание в аэропорту Бен-Гурион осуществляется компаниями наземного обслуживания. Эта услуга включает в себя сопровождение и помощь пассажирам с ограниченными физическими возможностями в процессе прилета и отправления в другую страну. 
				<a href="https://www.iaa.gov.il/en-us/airports/bengurion/pages/accessibility.aspx" target="_blank">www.iaa.gov.il</a></p>
				<p><b>Компании наземного обслуживания:</b></p>
				<p>Aero Handling: <a href="//www.aerohandling.com/" target="_blank">www.aerohandling.com</a><br/>
				Laufer Aviation: GHI <a href="//lauferghi.com/" target="_blank">www.lauferghi.com</a><br/>
				QAS: <a href="//www.qasisrael.co.il" target="_blank">www.qasisrael.co.il</a><br/>


				</p>
				<div class="img-wrapper">
				<img src=${getImgUrl() +
          "/posts/destination-for-all/4.jpg"} class="img-responsive">
			 </div><br>

				<p>Справочная линия Министерства транспорта (местный номер)  <a href="tel:5678*">5678*</a></p>
				
				<p><b>Общественный транспорт</b></p>
				<p>Поезда: если вам требуется помощь в посадке и высадке из поезда, пожалуйста, заранее согласуйте свою поездку с компанией Israel Railways на сайте или через горячую линию по телефону <a href="tel:*5770">*5770</a>.</p>
				 
				<p><u>Железные дороги Израиля</u> сделают все возможное, чтобы предоставить высочайшее качество обслуживания, даже в том случае, если вы не согласовали свою поездку заранее.</p>
				<p>Мы убедительно просим вас заранее согласовывать поездки, которые запланированы с 20:00 до 06:00 следующего дня, а также поездки в субботу вечером.</p>
				<p><u>Автобусы</u>: все автобусные маршруты в пределах города оборудованы для обслуживания всех категорий граждан. Междугородние маршруты предлагают частичную доступную среду.</p>
				<p><u>Такси</u>: обратите внимание, что в городе практически невозможно найти такси, оборудованное для людей с ограниченными способностями, без предварительного заказа. Рекомендуется сделать предварительный заказ у компаний из <a href="https://www.aisrael.org/?CategoryID=2657&ArticleID=64179" target="_blank">этого списка.</a>.</p>


				<h2  class="ac-margin-bottom-20 ac-margin-top-20">Жилье и размещение</h2>
				<p>Все виды объектов размещения в Израиле, которые предлагают 7 и более номеров, законодательно обязаны предоставить не менее 1 номера с доступной средой. Все компании, работающие в сфере услуг и имеющие не менее 25 сотрудников, обязаны иметь отдельного сотрудника, отвечающего за доступную среду. Такие законы гарантируют, что в Израиле не будет ни одного места, в котором вы не сможете найти подходящий объект для размещения. Мы настоятельно рекомендуем связываться с каждый объектом по электронной почте, чтобы заранее согласовать ваше посещение.</p>
				<div class="img-wrapper">
				<img src=${getImgUrl() +
          "/posts/destination-for-all/5.jpg"} class="img-responsive">
			 </div><br>
				
				
				<div id="ac-left-nav">
				<h2 class="ac-margin-bottom-20 pr-fs-28 chapter-title inline-block">
									<!-- ngIf: Guide.ShowChaptersIndex -->
									<span class="ng-binding">Accessibility for those with special needs at the beaches:</span>
								</h2>
				<ul id="chaptersList" class="list-unstyled xs-mb-0">
					
						<!-- ngRepeat: chapter in Guide.Chapters -->
						<li data-show="1" class="ac-active ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope light-gray-e7-background blue-border-right-5px" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0">
							<!-- ngIf: Guide.ShowChaptersIndex -->
							<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt nounderline  ng-binding reforma-bold">Northern District</span>						                  
							<img src="${getImgUrl() +
                "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
						
						</li><!-- end ngRepeat: chapter in Guide.Chapters -->
						<li data-show="2" class="ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0" >
							<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt reforma nounderline  ng-binding">Haifa District</span>
							<img src="${getImgUrl() +
                "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
						</li><!-- end ngRepeat: chapter in Guide.Chapters -->
						<li data-show="3" class="ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0" >
							<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt reforma nounderline  ng-binding">Central District</span>
							<img src="${getImgUrl() +
                "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
					
						</li><!-- end ngRepeat: chapter in Guide.Chapters -->
						<div class="clear show-on-mobile"></div>
						<li data-show="4" class="ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0" >
							<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt reforma nounderline  ng-binding">Tel Aviv District</span>
							<img src="${getImgUrl() +
                "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
					
						</li>
						<!-- end ngRepeat: chapter in Guide.Chapters --><li data-show="5" class="ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0" >
							<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt reforma nounderline  ng-binding">Southern District</span>
							<img src="${getImgUrl() +
                "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
					
						</li><!-- end ngRepeat: chapter in Guide.Chapters -->
						<div class="clear"></div>
					</ul>
				</div>

				<div id="res">
					<!-- ac part -->
					<div class="ac-part ac-part-1 ac-part-active">

						<div ng-include="chapterItem" class="row row-gov ng-scope">
							<!-- Sub Title -->
							<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
								<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
									<!-- ngIf: Guide.ShowChaptersIndex -->
									<span class="ng-binding">Northern District</span>
								</h2>
							</div>

							<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
								<!-- IMAGE TAG  ------->
								<!--- Image-->

						<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
							<div class="position-relative col-lg-10 lg-p-0">
								<!-- ngIf: CurrChapter.Image.ClickURLRef -->

								<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
								</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
								<!--Image desc-->
								<div>
									<div class="position-absolute">
										<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
									</div>
									<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
										<span class="small-txt ng-binding"></span>
										<span class="small-txt ng-binding"></span>
									</div><!-- end ngIf: CurrChapter.Image -->
								</div>
							</div>
						</div><!-- end ngIf: CurrChapter.Image -->
													<!-- End IMAGE TAG  ------->

													<div class="row row-gov no-gutters">
														<!--Content Text-->
														<div id="GuidesChapterContent-1" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
							<tbody>
								<tr style="background-color: rgb(255, 255, 255);">
									<td class="rtecenter" colspan="6"><strong>Kineret Municipal Unio</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking&nbsp;&nbsp; &nbsp;</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Tzinbari</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
									<td>No</td>
									<td>No</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Berniki</td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
									<td>At the nearby Shikmim beach</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Shikmim</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Hukok</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
									<td>No</td>
									<td>No</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Amnon</td>
									<td>Yes&nbsp;</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
									<td>No</td>
									<td>No</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Kinar</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Doga</td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
									<td>Closed</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Tze’elon</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Kursi</td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
									<td>At the nearby Levanon beach</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Levanon</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Halukim</td>
									<td>At the nearby Levanon beach</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>At the nearby Levanon beach</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Shizaf</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Dugit – Golan</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Gofra</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td class="rtecenter" colspan="6"><strong>Municipality of Tiberias</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Guy</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Galei Kineret - Rimonim</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Leonardo Pacific</td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
									<td>Closed for renovations</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Coco Hot / Holiday Inn</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td class="rtecenter" colspan="6"><strong>Jordan Valley Regional Council</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Ein Gev Vacation</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Ginnosar</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td class="rtecenter" colspan="6"><strong>Migdal Regional Council</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Restal Magdala</td>
									<td>Yes</td>
									<td>No</td>
									<td>&nbsp;</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td class="rtecenter" colspan="6"><strong>Mateh Asher Regional Council</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Banana Beach Achziv</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td class="rtecenter" colspan="6"><strong>Municipality of Nahariya</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Sokolov</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Galil Central</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td class="rtecenter" colspan="6"><strong>Municipality of Acco</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Argaman Central</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Hatmarim</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
								</tr>
							</tbody>
						</table></div></div>

						<p>&nbsp;</p>
						</div>

														<!--Chapters/Collapse-->
														<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
															<!-- ngRepeat: collapse in CurrChapter.Collapses -->
														</div>

														<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
														<!--End of Chapters/Collapse-->

														<div class="col-12 xs-mb-25 lg-mb-30">
															<!-- Files for Download-->
															<!-- Files for Download-->
						<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->

															<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">

																<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
																	<!-- horizontal line -->
																	<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
																		<div class="horizontal-line"></div>
																	</div>
																</div><!-- end ngIf: Guide.Chapters.length > 1 -->

																<!--arrows subject nav  דפדוף-->
																<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
																	<!--  לדף הקודם -->
																	<!-- ngIf: CurrChapterindex > 0 -->

																	<!--  לדף הבא -->
																	<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="false">
																		<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
																			<span class="small-txt gray-txt width-100">Next page:</span>
																			<span class="reforma description-txt blue-txt width-100 ng-binding">Haifa District</span>
																		</div>
																		<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
																	</div>
																</div>
															</div><!-- end ngIf: !isOnPrintMode -->
														</div>
													</div>
												</div>
											</div>

					</div>
					<!-- ac- part -->

					<!-- ac part 2 -->
					<div class="ac-part ac-part-2">
					<div ng-include="chapterItem" class="row row-gov ng-scope">
					<!-- Sub Title -->
					<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
						<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
							<!-- ngIf: Guide.ShowChaptersIndex -->
							<span class="ng-binding">Haifa District</span>
						</h2>
					</div>

					<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
						<!-- IMAGE TAG  ------->
						<!--- Image-->

<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
<div class="position-relative col-lg-10 lg-p-0">
	<!-- ngIf: CurrChapter.Image.ClickURLRef -->

	<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
	</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
	<!--Image desc-->
	<div>
		<div class="position-absolute">
			<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
		</div>
		<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
			<span class="small-txt ng-binding"></span>
			<span class="small-txt ng-binding"></span>
		</div><!-- end ngIf: CurrChapter.Image -->
	</div>
</div>
</div><!-- end ngIf: CurrChapter.Image -->
						<!-- End IMAGE TAG  ------->

						<div class="row row-gov no-gutters">
							<!--Content Text-->
							<div id="GuidesChapterContent-2" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table align="left" cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
<tbody>
	<tr style="background-color: rgb(255, 255, 255);">
		<td class="rtecenter" colspan="6"><strong>Municipality of Kiryat Yam</strong></td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Zevulun</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td class="rtecenter" colspan="6"><strong>Municipality of Haifa</strong></td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Zamir 1</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Zamir 2</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Neot Kiryat Haim Central</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Bat Galim 1</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Bat Galim 2</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td class="rtecenter" colspan="6"><strong>Hof Hacarmel Regional Council</strong></td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Dor Central 2</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		<td>Yes</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Neve Yam</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		<td>Yes</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Aqueduct</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		<td>Yes</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td class="rtecenter" colspan="6"><strong>Jisr a-Zarka Regional Council</strong></td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Jisr</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td class="rtecenter" colspan="6"><strong>Municipality of Hadera</strong></td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Kfar Yam&nbsp;</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Olga Central 2</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
	</tr>
</tbody>
</table></div></div>

<p>&nbsp;</p>
</div>

							<!--Chapters/Collapse-->
							<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
								<!-- ngRepeat: collapse in CurrChapter.Collapses -->
							</div>

							<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
							<!--End of Chapters/Collapse-->

							<div class="col-12 xs-mb-25 lg-mb-30">
								<!-- Files for Download-->
								<!-- Files for Download-->
<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->

								<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">

									<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
										<!-- horizontal line -->
										<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
											<div class="horizontal-line"></div>
										</div>
									</div><!-- end ngIf: Guide.Chapters.length > 1 -->

									<!--arrows subject nav  דפדוף-->
									<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
										<!--  לדף הקודם -->
										<!-- ngIf: CurrChapterindex > 0 --><div ng-if="CurrChapterindex > 0" class="col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope" ng-click="updateChapterIndex(CurrChapterindex - 1)" role="button" tabindex="0">
											<i class="icon-arrow-right toflipInEng h3 blue-txt" aria-hidden="true"></i>
											<div class="xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100">
												<span class="small-txt gray-txt width-100"> Previous page:</span>
												<span class="reforma description-txt blue-txt width-100 ng-binding">Northern District</span>
											</div>
										</div><!-- end ngIf: CurrChapterindex > 0 -->

										<!--  לדף הבא -->
										<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="false">
											<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
												<span class="small-txt gray-txt width-100">Next page:</span>
												<span class="reforma description-txt blue-txt width-100 ng-binding">Central District</span>
											</div>
											<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
										</div>
									</div>
								</div><!-- end ngIf: !isOnPrintMode -->
							</div>
						</div>
					</div>
				</div>
					</div>
					<!-- end ac part-2 -->

					<!-- ac-part-3 -->
					<div class="ac-part ac-part-3">
												<div ng-include="chapterItem" class="row row-gov ng-scope">
												<!-- Sub Title -->
												<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
													<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
														<!-- ngIf: Guide.ShowChaptersIndex -->
														<span class="ng-binding">Central District</span>
													</h2>
												</div>
						
												<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
													<!-- IMAGE TAG  ------->
													<!--- Image-->
						
						<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
							<div class="position-relative col-lg-10 lg-p-0">
								<!-- ngIf: CurrChapter.Image.ClickURLRef -->
						
								<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
								</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
								<!--Image desc-->
								<div>
									<div class="position-absolute">
										<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
									</div>
									<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
										<span class="small-txt ng-binding"></span>
										<span class="small-txt ng-binding"></span>
									</div><!-- end ngIf: CurrChapter.Image -->
								</div>
							</div>
						</div><!-- end ngIf: CurrChapter.Image -->
													<!-- End IMAGE TAG  ------->
						
													<div class="row row-gov no-gutters">
														<!--Content Text-->
														<div id="GuidesChapterContent-3" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
							<tbody>
								<tr style="background-color: rgb(255, 255, 255);">
									<td class="rtecenter" colspan="6"><strong>Emek Hefer Regional Council</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Michmoret – Station number 1</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Michmoret – Station number 2</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>Joint with number 1</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Beit Yannai</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>NeUrim Beach</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td class="rtecenter" colspan="6"><strong>Municipality of Netanya</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Kiryat Tzanz</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>HaOnot Beach</td>
									<td>Parking</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Ampi Beach</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Herzl</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>No</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Sironit Beach A</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Sironit Beach B</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Argaman Beach</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Poleg Beach</td>
									<td>Yes</td>
									<td>Bathrooms only</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td class="rtecenter" colspan="6"><strong>Hof Hasharon Regional Council</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Shefayim (Ga’ash)</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td class="rtecenter" colspan="6"><strong>Municipality of Rishon Le-Zion</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Beach number 1 – Hakachol (Blue) Beach</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Beach number 2 – Neve Hof Beach</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Beach number 3 – Hofit Beach</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Beach number 4 – Tel Yonah Beach</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Beach number 5 – Hayeladim (Children’s) Beach</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Beach number 6 – separate beach</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td class="rtecenter" colspan="6"><strong>Gan Raveh Regional Council</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Palmahim Beach</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
							</tbody>
						</table></div></div>
						
						<p>&nbsp;</p>
						</div>
						
														<!--Chapters/Collapse-->
														<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
															<!-- ngRepeat: collapse in CurrChapter.Collapses -->
														</div>
						
														<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
														<!--End of Chapters/Collapse-->
						
														<div class="col-12 xs-mb-25 lg-mb-30">
															<!-- Files for Download-->
															<!-- Files for Download-->
						<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->
						
															<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">
						
																<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
																	<!-- horizontal line -->
																	<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
																		<div class="horizontal-line"></div>
																	</div>
																</div><!-- end ngIf: Guide.Chapters.length > 1 -->
						
																<!--arrows subject nav  דפדוף-->
																<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
																	<!--  לדף הקודם -->
																	<!-- ngIf: CurrChapterindex > 0 --><div ng-if="CurrChapterindex > 0" class="col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope" ng-click="updateChapterIndex(CurrChapterindex - 1)" role="button" tabindex="0">
																		<i class="icon-arrow-right toflipInEng h3 blue-txt" aria-hidden="true"></i>
																		<div class="xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100">
																			<span class="small-txt gray-txt width-100"> Previous page:</span>
																			<span class="reforma description-txt blue-txt width-100 ng-binding">Haifa District</span>
																		</div>
																	</div><!-- end ngIf: CurrChapterindex > 0 -->
						
																	<!--  לדף הבא -->
																	<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="false">
																		<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
																			<span class="small-txt gray-txt width-100">Next page:</span>
																			<span class="reforma description-txt blue-txt width-100 ng-binding">Tel Aviv District</span>
																		</div>
																		<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
																	</div>
																</div>
															</div><!-- end ngIf: !isOnPrintMode -->
														</div>
													</div>
												</div>
											</div>
					</div>
					<!-- end ac-part-3 -->

					<!-- ac-part-4 -->
					<div class="ac-part ac-part-4">
					<div ng-include="chapterItem" class="row row-gov ng-scope">
			<!-- Sub Title -->
			<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
				<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
					<!-- ngIf: Guide.ShowChaptersIndex -->
					<span class="ng-binding">Tel Aviv District</span>
				</h2>
			</div>

			<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
				<!-- IMAGE TAG  ------->
				<!--- Image-->

<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
<div class="position-relative col-lg-10 lg-p-0">
<!-- ngIf: CurrChapter.Image.ClickURLRef -->

<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
<!--Image desc-->
<div>
<div class="position-absolute">
	<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
</div>
<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
	<span class="small-txt ng-binding"></span>
	<span class="small-txt ng-binding"></span>
</div><!-- end ngIf: CurrChapter.Image -->
</div>
</div>
</div><!-- end ngIf: CurrChapter.Image -->
				<!-- End IMAGE TAG  ------->

				<div class="row row-gov no-gutters">
					<!--Content Text-->
					<div id="GuidesChapterContent-4" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
<tbody>
<tr style="background-color: rgb(255, 255, 255);">
<td class="rtecenter" colspan="6"><strong>Municipality of Herzliya</strong></td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td><strong>Name of beach</strong></td>
<td><strong>Parking</strong></td>
<td><strong>Bathrooms and showers</strong></td>
<td><strong>Access to shade</strong></td>
<td><strong>Access to water</strong></td>
<td><strong>Bathing chairs for the disabled</strong></td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Nof Yam</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>Hasharon&nbsp;&nbsp; &nbsp;Yes</td>
<td>Yes</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Zevulun</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>Acadia North Beach&nbsp;&nbsp; &nbsp;</td>
<td>Yes</td>
<td>Yes</td>
<td>No</td>
<td>Yes</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Acadia South Beach</td>
<td>Yes</td>
<td>Yes</td>
<td>No</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>Acadia South Beach – Disabled</td>
<td>Yes</td>
<td>Yes</td>
<td>No</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Separate beach</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td class="rtecenter" colspan="6"><strong>Municipality of Tel Aviv - Jaffa</strong></td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td><strong>Name of beach</strong></td>
<td><strong>Parking</strong></td>
<td><strong>Bathrooms and showers</strong></td>
<td><strong>Access to shade</strong></td>
<td><strong>Access to water</strong></td>
<td><strong>Bathing chairs for the disabled</strong></td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>HaTzuk Beach – Station number 1</td>
<td>Yes</td>
<td>Yes</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Tel Baruch Beach – Station number 1</td>
<td>Yes</td>
<td>Yes</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>Nordau (Metzitzim) Beach</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Nordau separate beach</td>
<td>Yes</td>
<td>Bathrooms only</td>
<td>Yes</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>Gordon</td>
<td>No</td>
<td>Bathrooms only</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Bograshov</td>
<td>No</td>
<td>Bathrooms only</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>Allenby (Jerusalem)</td>
<td>No</td>
<td>Yes</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Charles Clore</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>Jaffa – Givat HaAliyah</td>
<td>Yes</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Hilton North</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>HaTzuk Beach – Station number 2</td>
<td>Yes</td>
<td>Bathrooms only</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Frishman</td>
<td>No</td>
<td>Bathrooms only</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>Aviv Beach</td>
<td>No</td>
<td>Bathrooms only</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td class="rtecenter" colspan="6"><strong>Municipality of Bat Yam</strong></td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td><strong>Name of beach</strong></td>
<td><strong>Parking</strong></td>
<td><strong>Bathrooms and showers</strong></td>
<td><strong>Access to shade</strong></td>
<td><strong>Access to water</strong></td>
<td><strong>Bathing chairs for the disabled</strong></td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>HaSela – Station number 1</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>HaSela – Station number 2</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>HaSela – Station number 3</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>Sample Beach</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Riviera</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>Separate beach</td>
<td>Yes</td>
<td>Bathrooms only</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Tayo</td>
<td>Yes</td>
<td>Bathrooms only</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
</tbody>
</table></div></div>

<p>&nbsp;</p>
</div>

					<!--Chapters/Collapse-->
					<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
						<!-- ngRepeat: collapse in CurrChapter.Collapses -->
					</div>

					<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
					<!--End of Chapters/Collapse-->

					<div class="col-12 xs-mb-25 lg-mb-30">
						<!-- Files for Download-->
						<!-- Files for Download-->
<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->

						<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">

							<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
								<!-- horizontal line -->
								<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
									<div class="horizontal-line"></div>
								</div>
							</div><!-- end ngIf: Guide.Chapters.length > 1 -->

							<!--arrows subject nav  דפדוף-->
							<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
								<!--  לדף הקודם -->
								<!-- ngIf: CurrChapterindex > 0 --><div ng-if="CurrChapterindex > 0" class="col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope" ng-click="updateChapterIndex(CurrChapterindex - 1)" role="button" tabindex="0">
									<i class="icon-arrow-right toflipInEng h3 blue-txt" aria-hidden="true"></i>
									<div class="xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100">
										<span class="small-txt gray-txt width-100"> Previous page:</span>
										<span class="reforma description-txt blue-txt width-100 ng-binding">Central District</span>
									</div>
								</div><!-- end ngIf: CurrChapterindex > 0 -->

								<!--  לדף הבא -->
								<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="false">
									<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
										<span class="small-txt gray-txt width-100">Next page:</span>
										<span class="reforma description-txt blue-txt width-100 ng-binding">Southern District</span>
									</div>
									<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
								</div>
							</div>
						</div><!-- end ngIf: !isOnPrintMode -->
					</div>
				</div>
			</div>
		</div>
					</div>
					<!-- end ac-part-4 -->

					<!-- ac-part-5 -->
					<div class="ac-part ac-part-5">
					<div ng-include="chapterItem" class="row row-gov ng-scope">
					<!-- Sub Title -->
					<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
						<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
							<!-- ngIf: Guide.ShowChaptersIndex -->
							<span class="ng-binding">Southern District</span>
						</h2>
					</div>

					<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
						<!-- IMAGE TAG  ------->
						<!--- Image-->

<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
<div class="position-relative col-lg-10 lg-p-0">
	<!-- ngIf: CurrChapter.Image.ClickURLRef -->

	<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
	</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
	<!--Image desc-->
	<div>
		<div class="position-absolute">
			<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
		</div>
		<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
			<span class="small-txt ng-binding"></span>
			<span class="small-txt ng-binding"></span>
		</div><!-- end ngIf: CurrChapter.Image -->
	</div>
</div>
</div><!-- end ngIf: CurrChapter.Image -->
						<!-- End IMAGE TAG  ------->

						<div class="row row-gov no-gutters">
							<!--Content Text-->
							<div id="GuidesChapterContent-5" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
<tbody>
	<tr style="background-color: rgb(255, 255, 255);">
		<td class="rtecenter" colspan="6"><strong>Municipality of Ashdod</strong></td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Mei Ami Beach</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Lido</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>&nbsp;</td>
		<td>&nbsp;</td>
		<td>&nbsp;</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Oranim</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>Yes</td>
		<td>Yes</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Hakshatot</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Separate beach</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Rova K</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Riviera</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td colspan="6" style="text-align: center;"><strong>Hof Ashkelon Regional Council</strong></td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Nitzanim</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Zikim</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td class="rtecenter" colspan="6"><strong>Municipality of Ashkelon</strong></td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Bar Kochva North</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Bar Kochva South</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Delila North</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Delila South</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Ashkelon National Park Beach</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Separate beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>לא</td>
		<td>לא</td>
		<td>לא</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td class="rtecenter" colspan="6"><strong>Tamar Regional Council</strong></td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Mazor Springs</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Meridian Beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Hod Hotel Beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Tzel Harim</td>
		<td>Yes</td>
		<td>Under construction&nbsp;&nbsp; &nbsp;</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Crown Plaza Beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Lot</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Lot’s Wife</td>
		<td>Yes</td>
		<td>Under construction&nbsp;&nbsp; &nbsp;</td>
		<td>Under construction&nbsp;&nbsp; &nbsp;</td>
		<td>Under construction&nbsp;&nbsp; &nbsp;</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Ein Bokek South</td>
		<td>Yes</td>
		<td>Under construction&nbsp;&nbsp; &nbsp;</td>
		<td>Under construction&nbsp;&nbsp; &nbsp;</td>
		<td>Under construction&nbsp;&nbsp; &nbsp;</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Daniel Hotel Beach</td>
		<td>Yes</td>
		<td>Under construction&nbsp;&nbsp; &nbsp;</td>
		<td>Under construction&nbsp;&nbsp; &nbsp;</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Solarium Beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Isrotel Beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>International Beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Leonardo Plaza Beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Zohar Springs (North)</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Separate beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Leonardo Club Beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td class="rtecenter" colspan="6"><strong>Municipality of Eilat&nbsp;&nbsp; &nbsp;</strong></td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td><br>
		Separate beach</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Herod’s beach</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td><br>
		Northwestern Beach</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
	</tr>
</tbody>
</table></div></div>

<p>&nbsp;</p>
</div>

							<!--Chapters/Collapse-->
							<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
								<!-- ngRepeat: collapse in CurrChapter.Collapses -->
							</div>

							<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
							<!--End of Chapters/Collapse-->

							<div class="col-12 xs-mb-25 lg-mb-30">
								<!-- Files for Download-->
								<!-- Files for Download-->
<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->

								<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">

									<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
										<!-- horizontal line -->
										<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
											<div class="horizontal-line"></div>
										</div>
									</div><!-- end ngIf: Guide.Chapters.length > 1 -->

									<!--arrows subject nav  דפדוף-->
									<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-start" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
										<!--  לדף הקודם -->
										<!-- ngIf: CurrChapterindex > 0 --><div ng-if="CurrChapterindex > 0" class="col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope" ng-click="updateChapterIndex(CurrChapterindex - 1)" role="button" tabindex="0">
											<i class="icon-arrow-right toflipInEng h3 blue-txt" aria-hidden="true"></i>
											<div class="xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100">
												<span class="small-txt gray-txt width-100"> Previous page:</span>
												<span class="reforma description-txt blue-txt width-100 ng-binding">Tel Aviv District</span>
											</div>
										</div><!-- end ngIf: CurrChapterindex > 0 -->

										<!--  לדף הבא -->
										<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer ng-hide" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="true">
											<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
												<span class="small-txt gray-txt width-100">Next page:</span>
												<span class="reforma description-txt blue-txt width-100 ng-binding"></span>
											</div>
											<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
										</div>
									</div>
								</div><!-- end ngIf: !isOnPrintMode -->
							</div>
						</div>
					</div>
				</div>
					</div>
					<!-- end ac-part-5 -->

				</div>
				<div class="img-wrapper">
				<img src=${getImgUrl() +
          "/posts/destination-for-all/6.jpg"} class="img-responsive">
			 </div><br>
					
					`,
      };
    },
  },
];



// WEBPACK FOOTER //
// ./src/Posts/PostsData.js